import { jsx, Fragment, jsxs } from 'react/jsx-runtime';

const AlertCircleFill = ({
  className = undefined,
  isFocusable = false,
  filled = undefined,
  title = undefined,
  role = undefined,
  size = 16,
  ...restProps
}) => {
  if (filled) {
    console.warn("<AlertCircleFill filled /> is now deprecated, please use <AlertCircleFillFill /> or refer to https://transferwise.github.io/icons/ for more info.");
  }
  return /*#__PURE__*/jsx("span", {
    className: `tw-icon tw-icon-alert-circle-fill ${className ? className : ''}`,
    "data-testid": restProps['data-testid'] || 'alert-circle-fill-icon',
    children: /*#__PURE__*/jsx("svg", {
      "aria-label": title,
      "aria-hidden": !title ? true : undefined,
      focusable: isFocusable,
      role: role ?? (title ? 'graphics-symbol img' : 'none'),
      width: String(size),
      height: String(size),
      fill: "currentColor",
      viewBox: "0 0 24 24",
      children: (Number(size) === 16 || Number(size) === 24 || Number(size) === 32) && /*#__PURE__*/jsx(Fragment, {
        children: /*#__PURE__*/jsx("path", {
          fillRule: "evenodd",
          d: "M22 12c0 5.523-4.477 10-10 10S2 17.523 2 12 6.477 2 12 2s10 4.477 10 10m-9-6v7h-2V6zm.501 10.5a1.5 1.5 0 1 0-3 0 1.5 1.5 0 0 0 3 0",
          clipRule: "evenodd"
        })
      })
    })
  });
};

const AlertCircle = ({
  className = undefined,
  isFocusable = false,
  filled = undefined,
  title = undefined,
  role = undefined,
  size = 16,
  ...restProps
}) => {
  if (filled) {
    console.warn("<AlertCircle filled /> is now deprecated, please use <AlertCircleFill /> or refer to https://transferwise.github.io/icons/ for more info.");
  }
  return /*#__PURE__*/jsx("span", {
    className: `tw-icon tw-icon-alert-circle ${className ? className : ''}`,
    "data-testid": restProps['data-testid'] || 'alert-circle-icon',
    children: /*#__PURE__*/jsx("svg", {
      "aria-label": title,
      "aria-hidden": !title ? true : undefined,
      focusable: isFocusable,
      role: role ?? (title ? 'graphics-symbol img' : 'none'),
      width: String(size),
      height: String(size),
      fill: "currentColor",
      viewBox: "0 0 24 24",
      children: (Number(size) === 16 || Number(size) === 24 || Number(size) === 32) && /*#__PURE__*/jsx(Fragment, {
        children: /*#__PURE__*/jsx("path", {
          fillRule: "evenodd",
          d: "M12.001 4a8 8 0 1 0 0 16 8 8 0 0 0 0-16m-10 8c0-5.523 4.477-10 10-10s10 4.477 10 10-4.477 10-10 10-10-4.477-10-10M11 6h2v7h-2zm2.501 10.5a1.5 1.5 0 1 0-3 0 1.5 1.5 0 0 0 3 0",
          clipRule: "evenodd"
        })
      })
    })
  });
};

const Alert = ({
  className = undefined,
  isFocusable = false,
  filled = undefined,
  title = undefined,
  role = undefined,
  size = 16,
  ...restProps
}) => {
  if (filled) {
    console.warn("<Alert filled /> is now deprecated, please use <AlertFill /> or refer to https://transferwise.github.io/icons/ for more info.");
  }
  return /*#__PURE__*/jsx("span", {
    className: `tw-icon tw-icon-alert ${className ? className : ''}`,
    "data-testid": restProps['data-testid'] || 'alert-icon',
    children: /*#__PURE__*/jsx("svg", {
      "aria-label": title,
      "aria-hidden": !title ? true : undefined,
      focusable: isFocusable,
      role: role ?? (title ? 'graphics-symbol img' : 'none'),
      width: String(size),
      height: String(size),
      fill: "currentColor",
      viewBox: "0 0 24 24",
      children: (Number(size) === 16 || Number(size) === 24 || Number(size) === 32) && /*#__PURE__*/jsx(Fragment, {
        children: /*#__PURE__*/jsx("path", {
          fillRule: "evenodd",
          d: "M13 4h-2v11h2zm.5 14.5a1.5 1.5 0 1 0-3 0 1.5 1.5 0 0 0 3 0",
          clipRule: "evenodd"
        })
      })
    })
  });
};

const Alipay = ({
  className = undefined,
  isFocusable = false,
  filled = undefined,
  title = undefined,
  role = undefined,
  size = 16,
  ...restProps
}) => {
  if (filled) {
    console.warn("<Alipay filled /> is now deprecated, please use <AlipayFill /> or refer to https://transferwise.github.io/icons/ for more info.");
  }
  return /*#__PURE__*/jsx("span", {
    className: `tw-icon tw-icon-alipay ${className ? className : ''}`,
    "data-testid": restProps['data-testid'] || 'alipay-icon',
    children: /*#__PURE__*/jsx("svg", {
      "aria-label": title,
      "aria-hidden": !title ? true : undefined,
      focusable: isFocusable,
      role: role ?? (title ? 'graphics-symbol img' : 'none'),
      width: String(size),
      height: String(size),
      fill: "currentColor",
      viewBox: "0 0 24 24",
      children: (Number(size) === 16 || Number(size) === 24 || Number(size) === 32) && /*#__PURE__*/jsx(Fragment, {
        children: /*#__PURE__*/jsx("path", {
          fillRule: "evenodd",
          d: "M22.424 15.673s-.668-.067-3.674-1.069a199 199 0 0 1-2.594-.896l-.68-.238a17 17 0 0 0 1.738-4.342h-4.075V7.66h5.01v-.735h-5.01V4.453h-2.005c-.334 0-.334.334-.334.334v2.07H5.723v.802H10.8v1.603H6.658v.801h8.084a13 13 0 0 1-1.136 2.805c-2.605-.868-5.411-1.536-7.148-1.135-1.136.267-1.87.735-2.272 1.269-2.004 2.338-.6 5.944 3.541 5.944 2.472 0 4.81-1.402 6.614-3.606 2.739 1.335 8.083 3.54 8.083 3.54v.133c0 1.803-1.536 3.273-3.34 3.273H5.054c-1.87 0-3.34-1.47-3.34-3.273V4.987c0-1.803 1.537-3.273 3.34-3.273h14.03c1.87 0 3.34 1.47 3.34 3.273zM4.771 13.62c.535-.467 1.47-.668 2.005-.734 1.937-.201 3.674.534 5.812 1.536-1.47 1.87-3.34 3.072-5.211 3.072-3.274 0-4.209-2.47-2.606-3.874",
          clipRule: "evenodd"
        })
      })
    })
  });
};

const AngryEmoji = ({
  className = undefined,
  isFocusable = false,
  filled = undefined,
  title = undefined,
  role = undefined,
  size = 16,
  ...restProps
}) => {
  if (filled) {
    console.warn("<AngryEmoji filled /> is now deprecated, please use <AngryEmojiFill /> or refer to https://transferwise.github.io/icons/ for more info.");
  }
  return /*#__PURE__*/jsx("span", {
    className: `tw-icon tw-icon-angry-emoji ${className ? className : ''}`,
    "data-testid": restProps['data-testid'] || 'angry-emoji-icon',
    children: /*#__PURE__*/jsx("svg", {
      "aria-label": title,
      "aria-hidden": !title ? true : undefined,
      focusable: isFocusable,
      role: role ?? (title ? 'graphics-symbol img' : 'none'),
      width: String(size),
      height: String(size),
      fill: "currentColor",
      viewBox: "0 0 24 24",
      children: (Number(size) === 16 || Number(size) === 24 || Number(size) === 32) && /*#__PURE__*/jsxs(Fragment, {
        children: [/*#__PURE__*/jsx("path", {
          d: "M12 13a6 6 0 0 1 5.196 3l-1.732 1a4 4 0 0 0-6.928 0l-1.732-1A6 6 0 0 1 12 13m-1.701-3.116-1 1.732-2.598-1.5 1-1.732zm7 .232-2.598 1.5-1-1.732 2.598-1.5z"
        }), /*#__PURE__*/jsx("path", {
          fillRule: "evenodd",
          d: "M12 2c5.523 0 10 4.477 10 10s-4.477 10-10 10S2 17.523 2 12 6.477 2 12 2m0 2a8 8 0 1 0 0 16 8 8 0 0 0 0-16",
          clipRule: "evenodd"
        })]
      })
    })
  });
};

const ArrowDiagonalDown = ({
  className = undefined,
  isFocusable = false,
  filled = undefined,
  title = undefined,
  role = undefined,
  size = 16,
  ...restProps
}) => {
  if (filled) {
    console.warn("<ArrowDiagonalDown filled /> is now deprecated, please use <ArrowDiagonalDownFill /> or refer to https://transferwise.github.io/icons/ for more info.");
  }
  return /*#__PURE__*/jsx("span", {
    className: `tw-icon tw-icon-arrow-diagonal-down ${className ? className : ''}`,
    "data-testid": restProps['data-testid'] || 'arrow-diagonal-down-icon',
    children: /*#__PURE__*/jsx("svg", {
      "aria-label": title,
      "aria-hidden": !title ? true : undefined,
      focusable: isFocusable,
      role: role ?? (title ? 'graphics-symbol img' : 'none'),
      width: String(size),
      height: String(size),
      fill: "currentColor",
      viewBox: "0 0 24 24",
      children: (Number(size) === 16 || Number(size) === 24 || Number(size) === 32) && /*#__PURE__*/jsx(Fragment, {
        children: /*#__PURE__*/jsx("path", {
          fillRule: "evenodd",
          d: "M16.586 18 3.879 5.293l1.414-1.414L18 16.586V7h2v11.99A1.01 1.01 0 0 1 18.99 20H7v-2z",
          clipRule: "evenodd"
        })
      })
    })
  });
};

const ArrowDiagonalUp = ({
  className = undefined,
  isFocusable = false,
  filled = undefined,
  title = undefined,
  role = undefined,
  size = 16,
  ...restProps
}) => {
  if (filled) {
    console.warn("<ArrowDiagonalUp filled /> is now deprecated, please use <ArrowDiagonalUpFill /> or refer to https://transferwise.github.io/icons/ for more info.");
  }
  return /*#__PURE__*/jsx("span", {
    className: `tw-icon tw-icon-arrow-diagonal-up ${className ? className : ''}`,
    "data-testid": restProps['data-testid'] || 'arrow-diagonal-up-icon',
    children: /*#__PURE__*/jsx("svg", {
      "aria-label": title,
      "aria-hidden": !title ? true : undefined,
      focusable: isFocusable,
      role: role ?? (title ? 'graphics-symbol img' : 'none'),
      width: String(size),
      height: String(size),
      fill: "currentColor",
      viewBox: "0 0 24 24",
      children: (Number(size) === 16 || Number(size) === 24 || Number(size) === 32) && /*#__PURE__*/jsx(Fragment, {
        children: /*#__PURE__*/jsx("path", {
          fillRule: "evenodd",
          d: "M20 5.01V17h-2V7.414L5.707 19.707l-1.414-1.414L16.586 6H7V4h11.99c.558 0 1.01.452 1.01 1.01",
          clipRule: "evenodd"
        })
      })
    })
  });
};

const ArrowDown = ({
  className = undefined,
  isFocusable = false,
  filled = undefined,
  title = undefined,
  role = undefined,
  size = 16,
  ...restProps
}) => {
  if (filled) {
    console.warn("<ArrowDown filled /> is now deprecated, please use <ArrowDownFill /> or refer to https://transferwise.github.io/icons/ for more info.");
  }
  return /*#__PURE__*/jsx("span", {
    className: `tw-icon tw-icon-arrow-down ${className ? className : ''}`,
    "data-testid": restProps['data-testid'] || 'arrow-down-icon',
    children: /*#__PURE__*/jsx("svg", {
      "aria-label": title,
      "aria-hidden": !title ? true : undefined,
      focusable: isFocusable,
      role: role ?? (title ? 'graphics-symbol img' : 'none'),
      width: String(size),
      height: String(size),
      fill: "currentColor",
      viewBox: "0 0 24 24",
      children: (Number(size) === 16 || Number(size) === 24 || Number(size) === 32) && /*#__PURE__*/jsx(Fragment, {
        children: /*#__PURE__*/jsx("path", {
          fillRule: "evenodd",
          d: "M11 18.586V2h2v16.586l6.293-6.293 1.414 1.414-7.993 7.993a1.01 1.01 0 0 1-1.428 0l-7.993-7.993 1.414-1.414z",
          clipRule: "evenodd"
        })
      })
    })
  });
};

const ArrowLeft = ({
  className = undefined,
  isFocusable = false,
  filled = undefined,
  title = undefined,
  role = undefined,
  size = 16,
  ...restProps
}) => {
  if (filled) {
    console.warn("<ArrowLeft filled /> is now deprecated, please use <ArrowLeftFill /> or refer to https://transferwise.github.io/icons/ for more info.");
  }
  return /*#__PURE__*/jsx("span", {
    className: `tw-icon tw-icon-arrow-left ${className ? className : ''}`,
    "data-testid": restProps['data-testid'] || 'arrow-left-icon',
    children: /*#__PURE__*/jsx("svg", {
      "aria-label": title,
      "aria-hidden": !title ? true : undefined,
      focusable: isFocusable,
      role: role ?? (title ? 'graphics-symbol img' : 'none'),
      width: String(size),
      height: String(size),
      fill: "currentColor",
      viewBox: "0 0 24 24",
      children: (Number(size) === 16 || Number(size) === 24 || Number(size) === 32) && /*#__PURE__*/jsx(Fragment, {
        children: /*#__PURE__*/jsx("path", {
          fillRule: "evenodd",
          d: "m5.414 11 6.293-6.293-1.414-1.414L2.3 11.286a1.01 1.01 0 0 0 0 1.428l7.993 7.993 1.414-1.414L5.414 13H22v-2z",
          clipRule: "evenodd"
        })
      })
    })
  });
};

const ArrowRight = ({
  className = undefined,
  isFocusable = false,
  filled = undefined,
  title = undefined,
  role = undefined,
  size = 16,
  ...restProps
}) => {
  if (filled) {
    console.warn("<ArrowRight filled /> is now deprecated, please use <ArrowRightFill /> or refer to https://transferwise.github.io/icons/ for more info.");
  }
  return /*#__PURE__*/jsx("span", {
    className: `tw-icon tw-icon-arrow-right ${className ? className : ''}`,
    "data-testid": restProps['data-testid'] || 'arrow-right-icon',
    children: /*#__PURE__*/jsx("svg", {
      "aria-label": title,
      "aria-hidden": !title ? true : undefined,
      focusable: isFocusable,
      role: role ?? (title ? 'graphics-symbol img' : 'none'),
      width: String(size),
      height: String(size),
      fill: "currentColor",
      viewBox: "0 0 24 24",
      children: (Number(size) === 16 || Number(size) === 24 || Number(size) === 32) && /*#__PURE__*/jsx(Fragment, {
        children: /*#__PURE__*/jsx("path", {
          fillRule: "evenodd",
          d: "m18.586 11-6.293-6.293 1.414-1.414 7.993 7.993a1.01 1.01 0 0 1 0 1.428l-7.993 7.993-1.414-1.414L18.586 13H2v-2z",
          clipRule: "evenodd"
        })
      })
    })
  });
};

const ArrowUp = ({
  className = undefined,
  isFocusable = false,
  filled = undefined,
  title = undefined,
  role = undefined,
  size = 16,
  ...restProps
}) => {
  if (filled) {
    console.warn("<ArrowUp filled /> is now deprecated, please use <ArrowUpFill /> or refer to https://transferwise.github.io/icons/ for more info.");
  }
  return /*#__PURE__*/jsx("span", {
    className: `tw-icon tw-icon-arrow-up ${className ? className : ''}`,
    "data-testid": restProps['data-testid'] || 'arrow-up-icon',
    children: /*#__PURE__*/jsx("svg", {
      "aria-label": title,
      "aria-hidden": !title ? true : undefined,
      focusable: isFocusable,
      role: role ?? (title ? 'graphics-symbol img' : 'none'),
      width: String(size),
      height: String(size),
      fill: "currentColor",
      viewBox: "0 0 24 24",
      children: (Number(size) === 16 || Number(size) === 24 || Number(size) === 32) && /*#__PURE__*/jsx(Fragment, {
        children: /*#__PURE__*/jsx("path", {
          fillRule: "evenodd",
          d: "m13 5.414 6.293 6.293 1.414-1.414L12.714 2.3a1.01 1.01 0 0 0-1.428 0l-7.993 7.993 1.414 1.414L11 5.414V22h2z",
          clipRule: "evenodd"
        })
      })
    })
  });
};

const AutoConvert = ({
  className = undefined,
  isFocusable = false,
  filled = undefined,
  title = undefined,
  role = undefined,
  size = 16,
  ...restProps
}) => {
  if (filled) {
    console.warn("<AutoConvert filled /> is now deprecated, please use <AutoConvertFill /> or refer to https://transferwise.github.io/icons/ for more info.");
  }
  return /*#__PURE__*/jsx("span", {
    className: `tw-icon tw-icon-auto-convert ${className ? className : ''}`,
    "data-testid": restProps['data-testid'] || 'auto-convert-icon',
    children: /*#__PURE__*/jsx("svg", {
      "aria-label": title,
      "aria-hidden": !title ? true : undefined,
      focusable: isFocusable,
      role: role ?? (title ? 'graphics-symbol img' : 'none'),
      width: String(size),
      height: String(size),
      fill: "currentColor",
      viewBox: "0 0 24 24",
      children: (Number(size) === 16 || Number(size) === 24 || Number(size) === 32) && /*#__PURE__*/jsx(Fragment, {
        children: /*#__PURE__*/jsx("path", {
          fillRule: "evenodd",
          d: "M15 9h2.692l-5.215 5.563L9.714 11.8a1.01 1.01 0 0 0-1.425-.003L2.748 17.29l1.408 1.42 4.84-4.799 2.79 2.789a1.01 1.01 0 0 0 1.45-.024L19 10.53V13h2V8.01A1.01 1.01 0 0 0 19.99 7H15zm-2-2H5v2h8z",
          clipRule: "evenodd"
        })
      })
    })
  });
};

const Backpack = ({
  className = undefined,
  isFocusable = false,
  filled = undefined,
  title = undefined,
  role = undefined,
  size = 16,
  ...restProps
}) => {
  if (filled) {
    console.warn("<Backpack filled /> is now deprecated, please use <BackpackFill /> or refer to https://transferwise.github.io/icons/ for more info.");
  }
  return /*#__PURE__*/jsx("span", {
    className: `tw-icon tw-icon-backpack ${className ? className : ''}`,
    "data-testid": restProps['data-testid'] || 'backpack-icon',
    children: /*#__PURE__*/jsx("svg", {
      "aria-label": title,
      "aria-hidden": !title ? true : undefined,
      focusable: isFocusable,
      role: role ?? (title ? 'graphics-symbol img' : 'none'),
      width: String(size),
      height: String(size),
      fill: "currentColor",
      viewBox: "0 0 24 24",
      children: (Number(size) === 16 || Number(size) === 24 || Number(size) === 32) && /*#__PURE__*/jsx(Fragment, {
        children: /*#__PURE__*/jsx("path", {
          d: "M12 2a4 4 0 0 1 4 4v.418A5 5 0 0 1 19 11v5h1v4h-1v1c0 .5-.5 1-1 1H6a1 1 0 0 1-1-1v-1H4v-4h1v-5a5 5 0 0 1 3-4.584V6a4 4 0 0 1 4-4M7 20h10v-5h-2v2h-2v-2H7zm3-12a3 3 0 0 0-3 3v2h10v-2a3 3 0 0 0-3-3zm2-4a2 2 0 0 0-2 2h4a2 2 0 0 0-2-2"
        })
      })
    })
  });
};

const BackslashCircle = ({
  className = undefined,
  isFocusable = false,
  filled = undefined,
  title = undefined,
  role = undefined,
  size = 16,
  ...restProps
}) => {
  if (filled) {
    console.warn("<BackslashCircle filled /> is now deprecated, please use <BackslashCircleFill /> or refer to https://transferwise.github.io/icons/ for more info.");
  }
  return /*#__PURE__*/jsx("span", {
    className: `tw-icon tw-icon-backslash-circle ${className ? className : ''}`,
    "data-testid": restProps['data-testid'] || 'backslash-circle-icon',
    children: /*#__PURE__*/jsx("svg", {
      "aria-label": title,
      "aria-hidden": !title ? true : undefined,
      focusable: isFocusable,
      role: role ?? (title ? 'graphics-symbol img' : 'none'),
      width: String(size),
      height: String(size),
      fill: "currentColor",
      viewBox: "0 0 24 24",
      children: (Number(size) === 16 || Number(size) === 24 || Number(size) === 32) && /*#__PURE__*/jsx(Fragment, {
        children: /*#__PURE__*/jsx("path", {
          fillRule: "evenodd",
          d: "M12 2C6.477 2 2 6.477 2 12s4.477 10 10 10 10-4.477 10-10S17.523 2 12 2M7.094 5.68A8 8 0 0 1 18.32 16.905zM5.68 7.094A8 8 0 0 0 16.905 18.32z",
          clipRule: "evenodd"
        })
      })
    })
  });
};

const BankStrikethrough = ({
  className = undefined,
  isFocusable = false,
  filled = undefined,
  title = undefined,
  role = undefined,
  size = 16,
  ...restProps
}) => {
  if (filled) {
    console.warn("<BankStrikethrough filled /> is now deprecated, please use <BankStrikethroughFill /> or refer to https://transferwise.github.io/icons/ for more info.");
  }
  return /*#__PURE__*/jsx("span", {
    className: `tw-icon tw-icon-bank-strikethrough ${className ? className : ''}`,
    "data-testid": restProps['data-testid'] || 'bank-strikethrough-icon',
    children: /*#__PURE__*/jsx("svg", {
      "aria-label": title,
      "aria-hidden": !title ? true : undefined,
      focusable: isFocusable,
      role: role ?? (title ? 'graphics-symbol img' : 'none'),
      width: String(size),
      height: String(size),
      fill: "currentColor",
      viewBox: "0 0 24 24",
      children: (Number(size) === 16 || Number(size) === 24 || Number(size) === 32) && /*#__PURE__*/jsx(Fragment, {
        children: /*#__PURE__*/jsx("path", {
          fillRule: "evenodd",
          d: "m1.293 2.707 20 20 1.414-1.414L19 17.586V10h.965c1.015 0 1.396-1.328.535-1.866l-7.965-4.979a1.01 1.01 0 0 0-1.07 0L7.222 5.807 2.707 1.293zM9.414 8l-.741-.741L12 5.179 16.513 8zm2 2L17 15.586V10zm3.52 9 2 2H3v-2h2v-9h-.965C3.02 10 2.639 8.671 3.5 8.134l.35-.219L7 11.065V19h4v-3.934l2 2V19z",
          clipRule: "evenodd"
        })
      })
    })
  });
};

const BankTransfer = ({
  className = undefined,
  isFocusable = false,
  filled = undefined,
  title = undefined,
  role = undefined,
  size = 16,
  ...restProps
}) => {
  if (filled) {
    console.warn("<BankTransfer filled /> is now deprecated, please use <BankTransferFill /> or refer to https://transferwise.github.io/icons/ for more info.");
  }
  return /*#__PURE__*/jsx("span", {
    className: `tw-icon tw-icon-bank-transfer ${className ? className : ''}`,
    "data-testid": restProps['data-testid'] || 'bank-transfer-icon',
    children: /*#__PURE__*/jsx("svg", {
      "aria-label": title,
      "aria-hidden": !title ? true : undefined,
      focusable: isFocusable,
      role: role ?? (title ? 'graphics-symbol img' : 'none'),
      width: String(size),
      height: String(size),
      fill: "currentColor",
      viewBox: "0 0 24 24",
      children: (Number(size) === 16 || Number(size) === 24 || Number(size) === 32) && /*#__PURE__*/jsx(Fragment, {
        children: /*#__PURE__*/jsx("path", {
          fillRule: "evenodd",
          d: "M12 5.18 7.487 8h9.026zm-.535-2.025a1.01 1.01 0 0 1 1.07 0L20.5 8.134c.861.537.48 1.866-.535 1.866H19v3h-2v-3h-4v11H3v-2h2v-9h-.965C3.02 10 2.639 8.671 3.5 8.133zM7 19h4v-9H7zm9-4h3.99c.558 0 1.01.452 1.01 1.01V20h-2v-1.586l-3.293 3.293-1.414-1.414L17.586 17H16z",
          clipRule: "evenodd"
        })
      })
    })
  });
};

const Ach = ({
  className = undefined,
  isFocusable = false,
  filled = undefined,
  title = undefined,
  role = undefined,
  size = 16,
  ...restProps
}) => {
  if (filled) {
    console.warn("<Ach filled /> is now deprecated, please use <AchFill /> or refer to https://transferwise.github.io/icons/ for more info.");
  }
  return /*#__PURE__*/jsx("span", {
    className: `tw-icon tw-icon-ach ${className ? className : ''}`,
    "data-testid": restProps['data-testid'] || 'ach-icon',
    children: /*#__PURE__*/jsx("svg", {
      "aria-label": title,
      "aria-hidden": !title ? true : undefined,
      focusable: isFocusable,
      role: role ?? (title ? 'graphics-symbol img' : 'none'),
      width: String(size),
      height: String(size),
      fill: "currentColor",
      viewBox: "0 0 24 24",
      children: (Number(size) === 16 || Number(size) === 24 || Number(size) === 32) && /*#__PURE__*/jsx(Fragment, {
        children: /*#__PURE__*/jsx("path", {
          fillRule: "evenodd",
          d: "M12 5.18 7.487 8h9.026zm-.535-2.025a1.01 1.01 0 0 1 1.07 0L20.5 8.134c.861.537.48 1.866-.535 1.866H19v3h-2v-3h-4v11H3v-2h2v-9h-.965C3.02 10 2.639 8.671 3.5 8.133zM7 19h4v-9H7zm9-4h3.99c.558 0 1.01.452 1.01 1.01V20h-2v-1.586l-3.293 3.293-1.414-1.414L17.586 17H16z",
          clipRule: "evenodd"
        })
      })
    })
  });
};

const Bank = ({
  className = undefined,
  isFocusable = false,
  filled = undefined,
  title = undefined,
  role = undefined,
  size = 16,
  ...restProps
}) => {
  if (filled) {
    console.warn("<Bank filled /> is now deprecated, please use <BankFill /> or refer to https://transferwise.github.io/icons/ for more info.");
  }
  return /*#__PURE__*/jsx("span", {
    className: `tw-icon tw-icon-bank ${className ? className : ''}`,
    "data-testid": restProps['data-testid'] || 'bank-icon',
    children: /*#__PURE__*/jsx("svg", {
      "aria-label": title,
      "aria-hidden": !title ? true : undefined,
      focusable: isFocusable,
      role: role ?? (title ? 'graphics-symbol img' : 'none'),
      width: String(size),
      height: String(size),
      fill: "currentColor",
      viewBox: "0 0 24 24",
      children: (Number(size) === 16 || Number(size) === 24 || Number(size) === 32) && /*#__PURE__*/jsx(Fragment, {
        children: /*#__PURE__*/jsx("path", {
          fillRule: "evenodd",
          d: "M12 5.18 7.487 8h9.026zm-.535-2.025a1.01 1.01 0 0 1 1.07 0L20.5 8.134c.861.537.48 1.866-.535 1.866H19v9h2v2H3v-2h2v-9h-.965C3.02 10 2.639 8.671 3.5 8.134zM7 19h4v-9H7zm6 0h4v-9h-4z",
          clipRule: "evenodd"
        })
      })
    })
  });
};

const BarChart = ({
  className = undefined,
  isFocusable = false,
  filled = undefined,
  title = undefined,
  role = undefined,
  size = 16,
  ...restProps
}) => {
  if (filled) {
    console.warn("<BarChart filled /> is now deprecated, please use <BarChartFill /> or refer to https://transferwise.github.io/icons/ for more info.");
  }
  return /*#__PURE__*/jsx("span", {
    className: `tw-icon tw-icon-bar-chart ${className ? className : ''}`,
    "data-testid": restProps['data-testid'] || 'bar-chart-icon',
    children: /*#__PURE__*/jsx("svg", {
      "aria-label": title,
      "aria-hidden": !title ? true : undefined,
      focusable: isFocusable,
      role: role ?? (title ? 'graphics-symbol img' : 'none'),
      width: String(size),
      height: String(size),
      fill: "currentColor",
      viewBox: "0 0 24 24",
      children: (Number(size) === 16 || Number(size) === 24 || Number(size) === 32) && /*#__PURE__*/jsx(Fragment, {
        children: /*#__PURE__*/jsx("path", {
          fillRule: "evenodd",
          d: "M16 3v16h-3V8h-2v11H8v-7H6v7H3v2h18v-2h-3V3z",
          clipRule: "evenodd"
        })
      })
    })
  });
};

const Balance = ({
  className = undefined,
  isFocusable = false,
  filled = undefined,
  title = undefined,
  role = undefined,
  size = 16,
  ...restProps
}) => {
  if (filled) {
    console.warn("<Balance filled /> is now deprecated, please use <BalanceFill /> or refer to https://transferwise.github.io/icons/ for more info.");
  }
  return /*#__PURE__*/jsx("span", {
    className: `tw-icon tw-icon-balance ${className ? className : ''}`,
    "data-testid": restProps['data-testid'] || 'balance-icon',
    children: /*#__PURE__*/jsx("svg", {
      "aria-label": title,
      "aria-hidden": !title ? true : undefined,
      focusable: isFocusable,
      role: role ?? (title ? 'graphics-symbol img' : 'none'),
      width: String(size),
      height: String(size),
      fill: "currentColor",
      viewBox: "0 0 24 24",
      children: (Number(size) === 16 || Number(size) === 24 || Number(size) === 32) && /*#__PURE__*/jsx(Fragment, {
        children: /*#__PURE__*/jsx("path", {
          fillRule: "evenodd",
          d: "M16 3v16h-3V8h-2v11H8v-7H6v7H3v2h18v-2h-3V3z",
          clipRule: "evenodd"
        })
      })
    })
  });
};

const Investments = ({
  className = undefined,
  isFocusable = false,
  filled = undefined,
  title = undefined,
  role = undefined,
  size = 16,
  ...restProps
}) => {
  if (filled) {
    console.warn("<Investments filled /> is now deprecated, please use <InvestmentsFill /> or refer to https://transferwise.github.io/icons/ for more info.");
  }
  return /*#__PURE__*/jsx("span", {
    className: `tw-icon tw-icon-investments ${className ? className : ''}`,
    "data-testid": restProps['data-testid'] || 'investments-icon',
    children: /*#__PURE__*/jsx("svg", {
      "aria-label": title,
      "aria-hidden": !title ? true : undefined,
      focusable: isFocusable,
      role: role ?? (title ? 'graphics-symbol img' : 'none'),
      width: String(size),
      height: String(size),
      fill: "currentColor",
      viewBox: "0 0 24 24",
      children: (Number(size) === 16 || Number(size) === 24 || Number(size) === 32) && /*#__PURE__*/jsx(Fragment, {
        children: /*#__PURE__*/jsx("path", {
          fillRule: "evenodd",
          d: "M16 3v16h-3V8h-2v11H8v-7H6v7H3v2h18v-2h-3V3z",
          clipRule: "evenodd"
        })
      })
    })
  });
};

const Barcode = ({
  className = undefined,
  isFocusable = false,
  filled = undefined,
  title = undefined,
  role = undefined,
  size = 16,
  ...restProps
}) => {
  if (filled) {
    console.warn("<Barcode filled /> is now deprecated, please use <BarcodeFill /> or refer to https://transferwise.github.io/icons/ for more info.");
  }
  return /*#__PURE__*/jsx("span", {
    className: `tw-icon tw-icon-barcode ${className ? className : ''}`,
    "data-testid": restProps['data-testid'] || 'barcode-icon',
    children: /*#__PURE__*/jsx("svg", {
      "aria-label": title,
      "aria-hidden": !title ? true : undefined,
      focusable: isFocusable,
      role: role ?? (title ? 'graphics-symbol img' : 'none'),
      width: String(size),
      height: String(size),
      fill: "currentColor",
      viewBox: "0 0 24 24",
      children: (Number(size) === 16 || Number(size) === 24 || Number(size) === 32) && /*#__PURE__*/jsx(Fragment, {
        children: /*#__PURE__*/jsx("path", {
          fillRule: "evenodd",
          d: "M3 4h2v16H3zm8 0h2v14h-2zM9 4H7v14h2zm6 0h2v14h-2zm6 0h-2v16h2z",
          clipRule: "evenodd"
        })
      })
    })
  });
};

const Batch = ({
  className = undefined,
  isFocusable = false,
  filled = undefined,
  title = undefined,
  role = undefined,
  size = 16,
  ...restProps
}) => {
  if (filled) {
    console.warn("<Batch filled /> is now deprecated, please use <BatchFill /> or refer to https://transferwise.github.io/icons/ for more info.");
  }
  return /*#__PURE__*/jsx("span", {
    className: `tw-icon tw-icon-batch ${className ? className : ''}`,
    "data-testid": restProps['data-testid'] || 'batch-icon',
    children: /*#__PURE__*/jsx("svg", {
      "aria-label": title,
      "aria-hidden": !title ? true : undefined,
      focusable: isFocusable,
      role: role ?? (title ? 'graphics-symbol img' : 'none'),
      width: String(size),
      height: String(size),
      fill: "currentColor",
      viewBox: "0 0 24 24",
      children: (Number(size) === 16 || Number(size) === 24 || Number(size) === 32) && /*#__PURE__*/jsx(Fragment, {
        children: /*#__PURE__*/jsx("path", {
          fillRule: "evenodd",
          d: "M5 7a2 2 0 1 1 4 0 2 2 0 0 1-4 0m2-4a4 4 0 0 0-1 7.874v2.252A4.002 4.002 0 0 0 7 21a4 4 0 0 0 3.874-3h2.252A4.002 4.002 0 0 0 21 17a4 4 0 0 0-7.874-1h-2.252a4 4 0 0 0-.428-1.032l4.522-4.522a4 4 0 1 0-1.414-1.414l-4.522 4.522A4 4 0 0 0 8 13.126v-2.252A4.002 4.002 0 0 0 7 3m8 4a2 2 0 1 1 4 0 2 2 0 0 1-4 0m2 8a2 2 0 1 0 0 4 2 2 0 0 0 0-4M7 15a2 2 0 1 0 0 4 2 2 0 0 0 0-4",
          clipRule: "evenodd"
        })
      })
    })
  });
};

const Beach = ({
  className = undefined,
  isFocusable = false,
  filled = undefined,
  title = undefined,
  role = undefined,
  size = 16,
  ...restProps
}) => {
  if (filled) {
    console.warn("<Beach filled /> is now deprecated, please use <BeachFill /> or refer to https://transferwise.github.io/icons/ for more info.");
  }
  return /*#__PURE__*/jsx("span", {
    className: `tw-icon tw-icon-beach ${className ? className : ''}`,
    "data-testid": restProps['data-testid'] || 'beach-icon',
    children: /*#__PURE__*/jsx("svg", {
      "aria-label": title,
      "aria-hidden": !title ? true : undefined,
      focusable: isFocusable,
      role: role ?? (title ? 'graphics-symbol img' : 'none'),
      width: String(size),
      height: String(size),
      fill: "currentColor",
      viewBox: "0 0 24 24",
      children: (Number(size) === 16 || Number(size) === 24 || Number(size) === 32) && /*#__PURE__*/jsx(Fragment, {
        children: /*#__PURE__*/jsx("path", {
          fillRule: "evenodd",
          d: "M5.636 5.636a9 9 0 0 1 12.728 0l.707.707L13.414 12l6.793 6.793-1.414 1.414L12 13.414l-5.657 5.657-.707-.707a9 9 0 0 1 0-12.728m3.43.009q.363.06.747.151c1.437.345 3.146 1.077 4.36 2.617l2.019-2.02a7 7 0 0 0-7.126-.748m-.653 8.528c-1.54-1.214-2.272-2.923-2.617-4.36a11 11 0 0 1-.151-.747 7 7 0 0 0 .749 7.126zm-.672-4.826a10 10 0 0 1-.253-1.859c.497.02 1.155.085 1.859.253 1.261.303 2.553.91 3.396 2.101l-2.9 2.901c-1.191-.843-1.8-2.135-2.102-3.396",
          clipRule: "evenodd"
        })
      })
    })
  });
};

const Holidays = ({
  className = undefined,
  isFocusable = false,
  filled = undefined,
  title = undefined,
  role = undefined,
  size = 16,
  ...restProps
}) => {
  if (filled) {
    console.warn("<Holidays filled /> is now deprecated, please use <HolidaysFill /> or refer to https://transferwise.github.io/icons/ for more info.");
  }
  return /*#__PURE__*/jsx("span", {
    className: `tw-icon tw-icon-holidays ${className ? className : ''}`,
    "data-testid": restProps['data-testid'] || 'holidays-icon',
    children: /*#__PURE__*/jsx("svg", {
      "aria-label": title,
      "aria-hidden": !title ? true : undefined,
      focusable: isFocusable,
      role: role ?? (title ? 'graphics-symbol img' : 'none'),
      width: String(size),
      height: String(size),
      fill: "currentColor",
      viewBox: "0 0 24 24",
      children: (Number(size) === 16 || Number(size) === 24 || Number(size) === 32) && /*#__PURE__*/jsx(Fragment, {
        children: /*#__PURE__*/jsx("path", {
          fillRule: "evenodd",
          d: "M5.636 5.636a9 9 0 0 1 12.728 0l.707.707L13.414 12l6.793 6.793-1.414 1.414L12 13.414l-5.657 5.657-.707-.707a9 9 0 0 1 0-12.728m3.43.009q.363.06.747.151c1.437.345 3.146 1.077 4.36 2.617l2.019-2.02a7 7 0 0 0-7.126-.748m-.653 8.528c-1.54-1.214-2.272-2.923-2.617-4.36a11 11 0 0 1-.151-.747 7 7 0 0 0 .749 7.126zm-.672-4.826a10 10 0 0 1-.253-1.859c.497.02 1.155.085 1.859.253 1.261.303 2.553.91 3.396 2.101l-2.9 2.901c-1.191-.843-1.8-2.135-2.102-3.396",
          clipRule: "evenodd"
        })
      })
    })
  });
};

const BillSplit = ({
  className = undefined,
  isFocusable = false,
  filled = undefined,
  title = undefined,
  role = undefined,
  size = 16,
  ...restProps
}) => {
  if (filled) {
    console.warn("<BillSplit filled /> is now deprecated, please use <BillSplitFill /> or refer to https://transferwise.github.io/icons/ for more info.");
  }
  return /*#__PURE__*/jsx("span", {
    className: `tw-icon tw-icon-bill-split ${className ? className : ''}`,
    "data-testid": restProps['data-testid'] || 'bill-split-icon',
    children: /*#__PURE__*/jsx("svg", {
      "aria-label": title,
      "aria-hidden": !title ? true : undefined,
      focusable: isFocusable,
      role: role ?? (title ? 'graphics-symbol img' : 'none'),
      width: String(size),
      height: String(size),
      fill: "currentColor",
      viewBox: "0 0 24 24",
      children: (Number(size) === 16 || Number(size) === 24 || Number(size) === 32) && /*#__PURE__*/jsx(Fragment, {
        children: /*#__PURE__*/jsx("path", {
          fillRule: "evenodd",
          d: "M10 5H6.414L12 10.586 17.586 5H14V3h5.99c.558 0 1.01.452 1.01 1.01v5.991h-2V6.414l-6 6V21h-2v-8.586l-6-6v3.587H3V4.01C3 3.452 3.452 3 4.01 3H10z",
          clipRule: "evenodd"
        })
      })
    })
  });
};

const Bills = ({
  className = undefined,
  isFocusable = false,
  filled = undefined,
  title = undefined,
  role = undefined,
  size = 16,
  ...restProps
}) => {
  if (filled) {
    console.warn("<Bills filled /> is now deprecated, please use <BillsFill /> or refer to https://transferwise.github.io/icons/ for more info.");
  }
  return /*#__PURE__*/jsx("span", {
    className: `tw-icon tw-icon-bills ${className ? className : ''}`,
    "data-testid": restProps['data-testid'] || 'bills-icon',
    children: /*#__PURE__*/jsx("svg", {
      "aria-label": title,
      "aria-hidden": !title ? true : undefined,
      focusable: isFocusable,
      role: role ?? (title ? 'graphics-symbol img' : 'none'),
      width: String(size),
      height: String(size),
      fill: "currentColor",
      viewBox: "0 0 24 24",
      children: (Number(size) === 16 || Number(size) === 24 || Number(size) === 32) && /*#__PURE__*/jsx(Fragment, {
        children: /*#__PURE__*/jsx("path", {
          fillRule: "evenodd",
          d: "M6 2a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V4a2 2 0 0 0-2-2zm0 2h12v16H6zm2 4h8V6H8zm0 4h8v-2H8zm4 4v-2h4v2z",
          clipRule: "evenodd"
        })
      })
    })
  });
};

const Bin = ({
  className = undefined,
  isFocusable = false,
  filled = undefined,
  title = undefined,
  role = undefined,
  size = 16,
  ...restProps
}) => {
  if (filled) {
    console.warn("<Bin filled /> is now deprecated, please use <BinFill /> or refer to https://transferwise.github.io/icons/ for more info.");
  }
  return /*#__PURE__*/jsx("span", {
    className: `tw-icon tw-icon-bin ${className ? className : ''}`,
    "data-testid": restProps['data-testid'] || 'bin-icon',
    children: /*#__PURE__*/jsx("svg", {
      "aria-label": title,
      "aria-hidden": !title ? true : undefined,
      focusable: isFocusable,
      role: role ?? (title ? 'graphics-symbol img' : 'none'),
      width: String(size),
      height: String(size),
      fill: "currentColor",
      viewBox: "0 0 24 24",
      children: (Number(size) === 16 || Number(size) === 24 || Number(size) === 32) && /*#__PURE__*/jsx(Fragment, {
        children: /*#__PURE__*/jsx("path", {
          fillRule: "evenodd",
          d: "M9 5h6V3H9zm11 4h-2v10a2 2 0 0 1-2 2H8a2 2 0 0 1-2-2V9H4V7h16zM8 9h8v10H8z",
          clipRule: "evenodd"
        })
      })
    })
  });
};

const Book = ({
  className = undefined,
  isFocusable = false,
  filled = undefined,
  title = undefined,
  role = undefined,
  size = 16,
  ...restProps
}) => {
  if (filled) {
    console.warn("<Book filled /> is now deprecated, please use <BookFill /> or refer to https://transferwise.github.io/icons/ for more info.");
  }
  return /*#__PURE__*/jsx("span", {
    className: `tw-icon tw-icon-book ${className ? className : ''}`,
    "data-testid": restProps['data-testid'] || 'book-icon',
    children: /*#__PURE__*/jsx("svg", {
      "aria-label": title,
      "aria-hidden": !title ? true : undefined,
      focusable: isFocusable,
      role: role ?? (title ? 'graphics-symbol img' : 'none'),
      width: String(size),
      height: String(size),
      fill: "currentColor",
      viewBox: "0 0 24 24",
      children: (Number(size) === 16 || Number(size) === 24 || Number(size) === 32) && /*#__PURE__*/jsx(Fragment, {
        children: /*#__PURE__*/jsx("path", {
          fillRule: "evenodd",
          d: "M13 7.989v10.424c.77-.506 1.618-.932 2.489-1.234 1.119-.389 2.34-.594 3.511-.453V5.89c-2.139-.138-4.03.609-6 2.1m-1 13.5a.98.98 0 0 0 .722-.299 9.4 9.4 0 0 1 3.423-2.124c1.301-.452 2.53-.517 3.473-.144A1.01 1.01 0 0 0 21 17.985V5.008a1.01 1.01 0 0 0-.845-.996c-3.1-.514-5.702.426-8.155 2.228-2.453-1.802-5.054-2.742-8.155-2.228A1.01 1.01 0 0 0 3 5.008v12.977c0 .715.72 1.2 1.382.94.943-.374 2.172-.309 3.473.143a9.4 9.4 0 0 1 3.423 2.124.98.98 0 0 0 .722.3m-1-3.078V7.99c-1.97-1.491-3.861-2.238-6-2.1v10.837c1.172-.14 2.392.064 3.511.453.87.302 1.718.728 2.489 1.234",
          clipRule: "evenodd"
        })
      })
    })
  });
};

const Boxes = ({
  className = undefined,
  isFocusable = false,
  filled = undefined,
  title = undefined,
  role = undefined,
  size = 16,
  ...restProps
}) => {
  if (filled) {
    console.warn("<Boxes filled /> is now deprecated, please use <BoxesFill /> or refer to https://transferwise.github.io/icons/ for more info.");
  }
  return /*#__PURE__*/jsx("span", {
    className: `tw-icon tw-icon-boxes ${className ? className : ''}`,
    "data-testid": restProps['data-testid'] || 'boxes-icon',
    children: /*#__PURE__*/jsx("svg", {
      "aria-label": title,
      "aria-hidden": !title ? true : undefined,
      focusable: isFocusable,
      role: role ?? (title ? 'graphics-symbol img' : 'none'),
      width: String(size),
      height: String(size),
      fill: "currentColor",
      viewBox: "0 0 24 24",
      children: (Number(size) === 16 || Number(size) === 24 || Number(size) === 32) && /*#__PURE__*/jsx(Fragment, {
        children: /*#__PURE__*/jsx("path", {
          fillRule: "evenodd",
          d: "M18 5h-1v6h5v2h-1v6.99A1.01 1.01 0 0 1 19.99 21H4.01A1.01 1.01 0 0 1 3 19.99V13H2v-2h5V5H6V3h12zM9 5h6v6H9zm10 8v6h-6v-6zm-8 0v6H5v-6zm0-4h2V7h-2zm-4 8v-2h2v2zm8-2v2h2v-2z",
          clipRule: "evenodd"
        })
      })
    })
  });
};

const CostOfGoodsSold = ({
  className = undefined,
  isFocusable = false,
  filled = undefined,
  title = undefined,
  role = undefined,
  size = 16,
  ...restProps
}) => {
  if (filled) {
    console.warn("<CostOfGoodsSold filled /> is now deprecated, please use <CostOfGoodsSoldFill /> or refer to https://transferwise.github.io/icons/ for more info.");
  }
  return /*#__PURE__*/jsx("span", {
    className: `tw-icon tw-icon-cost-of-goods-sold ${className ? className : ''}`,
    "data-testid": restProps['data-testid'] || 'cost-of-goods-sold-icon',
    children: /*#__PURE__*/jsx("svg", {
      "aria-label": title,
      "aria-hidden": !title ? true : undefined,
      focusable: isFocusable,
      role: role ?? (title ? 'graphics-symbol img' : 'none'),
      width: String(size),
      height: String(size),
      fill: "currentColor",
      viewBox: "0 0 24 24",
      children: (Number(size) === 16 || Number(size) === 24 || Number(size) === 32) && /*#__PURE__*/jsx(Fragment, {
        children: /*#__PURE__*/jsx("path", {
          fillRule: "evenodd",
          d: "M18 5h-1v6h5v2h-1v6.99A1.01 1.01 0 0 1 19.99 21H4.01A1.01 1.01 0 0 1 3 19.99V13H2v-2h5V5H6V3h12zM9 5h6v6H9zm10 8v6h-6v-6zm-8 0v6H5v-6zm0-4h2V7h-2zm-4 8v-2h2v2zm8-2v2h2v-2z",
          clipRule: "evenodd"
        })
      })
    })
  });
};

const Briefcase = ({
  className = undefined,
  isFocusable = false,
  filled = undefined,
  title = undefined,
  role = undefined,
  size = 16,
  ...restProps
}) => {
  if (filled) {
    console.warn("<Briefcase filled /> is now deprecated, please use <BriefcaseFill /> or refer to https://transferwise.github.io/icons/ for more info.");
  }
  return /*#__PURE__*/jsx("span", {
    className: `tw-icon tw-icon-briefcase ${className ? className : ''}`,
    "data-testid": restProps['data-testid'] || 'briefcase-icon',
    children: /*#__PURE__*/jsx("svg", {
      "aria-label": title,
      "aria-hidden": !title ? true : undefined,
      focusable: isFocusable,
      role: role ?? (title ? 'graphics-symbol img' : 'none'),
      width: String(size),
      height: String(size),
      fill: "currentColor",
      viewBox: "0 0 24 24",
      children: (Number(size) === 16 || Number(size) === 24 || Number(size) === 32) && /*#__PURE__*/jsx(Fragment, {
        children: /*#__PURE__*/jsx("path", {
          fillRule: "evenodd",
          d: "M9.01 3A1.01 1.01 0 0 0 8 4.01V7H5a2 2 0 0 0-2 2v9a2 2 0 0 0 2 2h14a2 2 0 0 0 2-2V9a2 2 0 0 0-2-2h-3V4.01A1.01 1.01 0 0 0 14.99 3zM14 7V5h-4v2zm-4 2h4v9h-4zM8 9H5v9h3zm8 9V9h3v9z",
          clipRule: "evenodd"
        })
      })
    })
  });
};

const Building = ({
  className = undefined,
  isFocusable = false,
  filled = undefined,
  title = undefined,
  role = undefined,
  size = 16,
  ...restProps
}) => {
  if (filled) {
    console.warn("<Building filled /> is now deprecated, please use <BuildingFill /> or refer to https://transferwise.github.io/icons/ for more info.");
  }
  return /*#__PURE__*/jsx("span", {
    className: `tw-icon tw-icon-building ${className ? className : ''}`,
    "data-testid": restProps['data-testid'] || 'building-icon',
    children: /*#__PURE__*/jsx("svg", {
      "aria-label": title,
      "aria-hidden": !title ? true : undefined,
      focusable: isFocusable,
      role: role ?? (title ? 'graphics-symbol img' : 'none'),
      width: String(size),
      height: String(size),
      fill: "currentColor",
      viewBox: "0 0 24 24",
      children: (Number(size) === 16 || Number(size) === 24 || Number(size) === 32) && /*#__PURE__*/jsx(Fragment, {
        children: /*#__PURE__*/jsx("path", {
          fillRule: "evenodd",
          d: "M7 20V6.617l10-2.143V20h-2v-2.99A1.01 1.01 0 0 0 13.99 16h-3.98A1.01 1.01 0 0 0 9 17.01V20zm4 0h2v-2h-2zm8-16.763V20h1v2H4v-2h1V5.808a1 1 0 0 1 .79-.977l12-2.572a1 1 0 0 1 1.21.978M9 10h6V8H9zm0 4h6v-2H9z",
          clipRule: "evenodd"
        })
      })
    })
  });
};

const Rent = ({
  className = undefined,
  isFocusable = false,
  filled = undefined,
  title = undefined,
  role = undefined,
  size = 16,
  ...restProps
}) => {
  if (filled) {
    console.warn("<Rent filled /> is now deprecated, please use <RentFill /> or refer to https://transferwise.github.io/icons/ for more info.");
  }
  return /*#__PURE__*/jsx("span", {
    className: `tw-icon tw-icon-rent ${className ? className : ''}`,
    "data-testid": restProps['data-testid'] || 'rent-icon',
    children: /*#__PURE__*/jsx("svg", {
      "aria-label": title,
      "aria-hidden": !title ? true : undefined,
      focusable: isFocusable,
      role: role ?? (title ? 'graphics-symbol img' : 'none'),
      width: String(size),
      height: String(size),
      fill: "currentColor",
      viewBox: "0 0 24 24",
      children: (Number(size) === 16 || Number(size) === 24 || Number(size) === 32) && /*#__PURE__*/jsx(Fragment, {
        children: /*#__PURE__*/jsx("path", {
          fillRule: "evenodd",
          d: "M7 20V6.617l10-2.143V20h-2v-2.99A1.01 1.01 0 0 0 13.99 16h-3.98A1.01 1.01 0 0 0 9 17.01V20zm4 0h2v-2h-2zm8-16.763V20h1v2H4v-2h1V5.808a1 1 0 0 1 .79-.977l12-2.572a1 1 0 0 1 1.21.978M9 10h6V8H9zm0 4h6v-2H9z",
          clipRule: "evenodd"
        })
      })
    })
  });
};

const Bulb = ({
  className = undefined,
  isFocusable = false,
  filled = undefined,
  title = undefined,
  role = undefined,
  size = 16,
  ...restProps
}) => {
  if (filled) {
    console.warn("<Bulb filled /> is now deprecated, please use <BulbFill /> or refer to https://transferwise.github.io/icons/ for more info.");
  }
  return /*#__PURE__*/jsx("span", {
    className: `tw-icon tw-icon-bulb ${className ? className : ''}`,
    "data-testid": restProps['data-testid'] || 'bulb-icon',
    children: /*#__PURE__*/jsx("svg", {
      "aria-label": title,
      "aria-hidden": !title ? true : undefined,
      focusable: isFocusable,
      role: role ?? (title ? 'graphics-symbol img' : 'none'),
      width: String(size),
      height: String(size),
      fill: "currentColor",
      viewBox: "0 0 24 24",
      children: (Number(size) === 16 || Number(size) === 24 || Number(size) === 32) && /*#__PURE__*/jsx(Fragment, {
        children: /*#__PURE__*/jsx("path", {
          fillRule: "evenodd",
          d: "M12 4a1 1 0 1 0 0-2 1 1 0 0 0 0 2M7 5.32a1 1 0 1 0 0-2 1 1 0 0 0 0 2M5 8.37a1 1 0 1 1-2 0 1 1 0 0 1 2 0m12.04-2.98a1 1 0 1 0 0-2 1 1 0 0 0 0 2M21 8.38a1 1 0 1 1-2 0 1 1 0 0 1 2 0M12 7a4 4 0 0 0-2.4 7.2l.4.3V16h4v-1.5l.4-.3A4 4 0 0 0 12 7m2 11h-4a2 2 0 0 0 4 0m-8-7a6 6 0 1 1 10 4.472V18a4 4 0 0 1-8 0v-2.528A6 6 0 0 1 6 11",
          clipRule: "evenodd"
        })
      })
    })
  });
};

const Insights = ({
  className = undefined,
  isFocusable = false,
  filled = undefined,
  title = undefined,
  role = undefined,
  size = 16,
  ...restProps
}) => {
  if (filled) {
    console.warn("<Insights filled /> is now deprecated, please use <InsightsFill /> or refer to https://transferwise.github.io/icons/ for more info.");
  }
  return /*#__PURE__*/jsx("span", {
    className: `tw-icon tw-icon-insights ${className ? className : ''}`,
    "data-testid": restProps['data-testid'] || 'insights-icon',
    children: /*#__PURE__*/jsx("svg", {
      "aria-label": title,
      "aria-hidden": !title ? true : undefined,
      focusable: isFocusable,
      role: role ?? (title ? 'graphics-symbol img' : 'none'),
      width: String(size),
      height: String(size),
      fill: "currentColor",
      viewBox: "0 0 24 24",
      children: (Number(size) === 16 || Number(size) === 24 || Number(size) === 32) && /*#__PURE__*/jsx(Fragment, {
        children: /*#__PURE__*/jsx("path", {
          fillRule: "evenodd",
          d: "M12 4a1 1 0 1 0 0-2 1 1 0 0 0 0 2M7 5.32a1 1 0 1 0 0-2 1 1 0 0 0 0 2M5 8.37a1 1 0 1 1-2 0 1 1 0 0 1 2 0m12.04-2.98a1 1 0 1 0 0-2 1 1 0 0 0 0 2M21 8.38a1 1 0 1 1-2 0 1 1 0 0 1 2 0M12 7a4 4 0 0 0-2.4 7.2l.4.3V16h4v-1.5l.4-.3A4 4 0 0 0 12 7m2 11h-4a2 2 0 0 0 4 0m-8-7a6 6 0 1 1 10 4.472V18a4 4 0 0 1-8 0v-2.528A6 6 0 0 1 6 11",
          clipRule: "evenodd"
        })
      })
    })
  });
};

const CalendarCheck = ({
  className = undefined,
  isFocusable = false,
  filled = undefined,
  title = undefined,
  role = undefined,
  size = 16,
  ...restProps
}) => {
  if (filled) {
    console.warn("<CalendarCheck filled /> is now deprecated, please use <CalendarCheckFill /> or refer to https://transferwise.github.io/icons/ for more info.");
  }
  return /*#__PURE__*/jsx("span", {
    className: `tw-icon tw-icon-calendar-check ${className ? className : ''}`,
    "data-testid": restProps['data-testid'] || 'calendar-check-icon',
    children: /*#__PURE__*/jsx("svg", {
      "aria-label": title,
      "aria-hidden": !title ? true : undefined,
      focusable: isFocusable,
      role: role ?? (title ? 'graphics-symbol img' : 'none'),
      width: String(size),
      height: String(size),
      fill: "currentColor",
      viewBox: "0 0 24 24",
      children: (Number(size) === 16 || Number(size) === 24 || Number(size) === 32) && /*#__PURE__*/jsx(Fragment, {
        children: /*#__PURE__*/jsx("path", {
          fillRule: "evenodd",
          d: "M6 3h2v2h8V3h2v2h2a2 2 0 0 1 2 2v12a2 2 0 0 1-2 2H4a2 2 0 0 1-2-2V7a2 2 0 0 1 2-2h2zm10 4v1h2V7h2v12H4V7h2v1h2V7zm-.707 3.293L11.5 14.086l-1.793-1.793-1.414 1.414 2.493 2.493a1.01 1.01 0 0 0 1.428 0l4.493-4.493z",
          clipRule: "evenodd"
        })
      })
    })
  });
};

const CalendarSuccess = ({
  className = undefined,
  isFocusable = false,
  filled = undefined,
  title = undefined,
  role = undefined,
  size = 16,
  ...restProps
}) => {
  if (filled) {
    console.warn("<CalendarSuccess filled /> is now deprecated, please use <CalendarSuccessFill /> or refer to https://transferwise.github.io/icons/ for more info.");
  }
  return /*#__PURE__*/jsx("span", {
    className: `tw-icon tw-icon-calendar-success ${className ? className : ''}`,
    "data-testid": restProps['data-testid'] || 'calendar-success-icon',
    children: /*#__PURE__*/jsx("svg", {
      "aria-label": title,
      "aria-hidden": !title ? true : undefined,
      focusable: isFocusable,
      role: role ?? (title ? 'graphics-symbol img' : 'none'),
      width: String(size),
      height: String(size),
      fill: "currentColor",
      viewBox: "0 0 24 24",
      children: (Number(size) === 16 || Number(size) === 24 || Number(size) === 32) && /*#__PURE__*/jsx(Fragment, {
        children: /*#__PURE__*/jsx("path", {
          fillRule: "evenodd",
          d: "M6 3h2v2h8V3h2v2h2a2 2 0 0 1 2 2v12a2 2 0 0 1-2 2H4a2 2 0 0 1-2-2V7a2 2 0 0 1 2-2h2zm10 4v1h2V7h2v12H4V7h2v1h2V7zm-.707 3.293L11.5 14.086l-1.793-1.793-1.414 1.414 2.493 2.493a1.01 1.01 0 0 0 1.428 0l4.493-4.493z",
          clipRule: "evenodd"
        })
      })
    })
  });
};

const Calendar = ({
  className = undefined,
  isFocusable = false,
  filled = undefined,
  title = undefined,
  role = undefined,
  size = 16,
  ...restProps
}) => {
  if (filled) {
    console.warn("<Calendar filled /> is now deprecated, please use <CalendarFill /> or refer to https://transferwise.github.io/icons/ for more info.");
  }
  return /*#__PURE__*/jsx("span", {
    className: `tw-icon tw-icon-calendar ${className ? className : ''}`,
    "data-testid": restProps['data-testid'] || 'calendar-icon',
    children: /*#__PURE__*/jsx("svg", {
      "aria-label": title,
      "aria-hidden": !title ? true : undefined,
      focusable: isFocusable,
      role: role ?? (title ? 'graphics-symbol img' : 'none'),
      width: String(size),
      height: String(size),
      fill: "currentColor",
      viewBox: "0 0 24 24",
      children: (Number(size) === 16 || Number(size) === 24 || Number(size) === 32) && /*#__PURE__*/jsx(Fragment, {
        children: /*#__PURE__*/jsx("path", {
          fillRule: "evenodd",
          d: "M6 3h2v2h8V3h2v2h2a2 2 0 0 1 2 2v12a2 2 0 0 1-2 2H4a2 2 0 0 1-2-2V7a2 2 0 0 1 2-2h2zm10 4v1h2V7h2v12H4V7h2v1h2V7zm2 8h-2v2h2z",
          clipRule: "evenodd"
        })
      })
    })
  });
};

const CameraSparkle = ({
  className = undefined,
  isFocusable = false,
  filled = undefined,
  title = undefined,
  role = undefined,
  size = 16,
  ...restProps
}) => {
  if (filled) {
    console.warn("<CameraSparkle filled /> is now deprecated, please use <CameraSparkleFill /> or refer to https://transferwise.github.io/icons/ for more info.");
  }
  return /*#__PURE__*/jsx("span", {
    className: `tw-icon tw-icon-camera-sparkle ${className ? className : ''}`,
    "data-testid": restProps['data-testid'] || 'camera-sparkle-icon',
    children: /*#__PURE__*/jsx("svg", {
      "aria-label": title,
      "aria-hidden": !title ? true : undefined,
      focusable: isFocusable,
      role: role ?? (title ? 'graphics-symbol img' : 'none'),
      width: String(size),
      height: String(size),
      fill: "currentColor",
      viewBox: "0 0 24 24",
      children: (Number(size) === 16 || Number(size) === 24 || Number(size) === 32) && /*#__PURE__*/jsxs(Fragment, {
        children: [/*#__PURE__*/jsx("path", {
          d: "M7.06 3a1 1 0 0 1 1 1H14v2H4v12h16v-7h2v7a2 2 0 0 1-2 2H4a2 2 0 0 1-2-2V6a2 2 0 0 1 2-2h.06a1 1 0 0 1 1-1z"
        }), /*#__PURE__*/jsx("path", {
          fillRule: "evenodd",
          d: "M12 8a4 4 0 1 1 0 8 4 4 0 0 1 0-8m0 2a2 2 0 1 0 0 4 2 2 0 0 0 0-4",
          clipRule: "evenodd"
        }), /*#__PURE__*/jsx("path", {
          d: "M18.272 3.512a.25.25 0 0 1 .457 0l.966 2.166a.25.25 0 0 0 .127.127l2.166.966a.25.25 0 0 1 0 .458l-2.166.966a.25.25 0 0 0-.127.127l-.966 2.166a.25.25 0 0 1-.457 0l-.967-2.166a.25.25 0 0 0-.127-.127l-2.166-.966a.25.25 0 0 1 0-.458l2.166-.966a.25.25 0 0 0 .127-.127z"
        })]
      })
    })
  });
};

const Camera = ({
  className = undefined,
  isFocusable = false,
  filled = undefined,
  title = undefined,
  role = undefined,
  size = 16,
  ...restProps
}) => {
  if (filled) {
    console.warn("<Camera filled /> is now deprecated, please use <CameraFill /> or refer to https://transferwise.github.io/icons/ for more info.");
  }
  return /*#__PURE__*/jsx("span", {
    className: `tw-icon tw-icon-camera ${className ? className : ''}`,
    "data-testid": restProps['data-testid'] || 'camera-icon',
    children: /*#__PURE__*/jsx("svg", {
      "aria-label": title,
      "aria-hidden": !title ? true : undefined,
      focusable: isFocusable,
      role: role ?? (title ? 'graphics-symbol img' : 'none'),
      width: String(size),
      height: String(size),
      fill: "currentColor",
      viewBox: "0 0 24 24",
      children: (Number(size) === 16 || Number(size) === 24 || Number(size) === 32) && /*#__PURE__*/jsxs(Fragment, {
        children: [/*#__PURE__*/jsx("path", {
          fillRule: "evenodd",
          d: "M12 16a4 4 0 1 0 0-8 4 4 0 0 0 0 8m0-2a2 2 0 1 0 0-4 2 2 0 0 0 0 4",
          clipRule: "evenodd"
        }), /*#__PURE__*/jsx("path", {
          d: "M18.002 9.005a1.002 1.002 0 1 0 0-2.005 1.002 1.002 0 0 0 0 2.005"
        }), /*#__PURE__*/jsx("path", {
          fillRule: "evenodd",
          d: "M5 3a1 1 0 0 0-1 1 2 2 0 0 0-2 2v12a2 2 0 0 0 2 2h16a2 2 0 0 0 2-2V6a2 2 0 0 0-2-2H8a1 1 0 0 0-1-1zM4 6h16v12H4z",
          clipRule: "evenodd"
        })]
      })
    })
  });
};

const Car = ({
  className = undefined,
  isFocusable = false,
  filled = undefined,
  title = undefined,
  role = undefined,
  size = 16,
  ...restProps
}) => {
  if (filled) {
    console.warn("<Car filled /> is now deprecated, please use <CarFill /> or refer to https://transferwise.github.io/icons/ for more info.");
  }
  return /*#__PURE__*/jsx("span", {
    className: `tw-icon tw-icon-car ${className ? className : ''}`,
    "data-testid": restProps['data-testid'] || 'car-icon',
    children: /*#__PURE__*/jsx("svg", {
      "aria-label": title,
      "aria-hidden": !title ? true : undefined,
      focusable: isFocusable,
      role: role ?? (title ? 'graphics-symbol img' : 'none'),
      width: String(size),
      height: String(size),
      fill: "currentColor",
      viewBox: "0 0 24 24",
      children: (Number(size) === 16 || Number(size) === 24 || Number(size) === 32) && /*#__PURE__*/jsx(Fragment, {
        children: /*#__PURE__*/jsx("path", {
          fillRule: "evenodd",
          d: "M8.28 3a2 2 0 0 0-1.94 1.515L5.72 7H3v2h1.898a1.01 1.01 0 0 0-1.002.883l-.887 6.98c-.076.6.388 1.13.991 1.137v1a2 2 0 0 0 2 2h1a2 2 0 0 0 2-2v-1h6v1a2 2 0 0 0 2 2h1a2 2 0 0 0 2-2v-1a1.01 1.01 0 0 0 .99-1.137l-.886-6.98A1.01 1.01 0 0 0 19.102 9H21V7h-2.72l-.62-2.485A2 2 0 0 0 15.72 3zM18 18h-1v1h1zm.865-2-.635-5H5.77l-.635 5zM6 19v-1h1v1zm9.72-14H8.28l-1 4h9.44zm-7.718 9.005a1.002 1.002 0 1 0 0-2.005 1.002 1.002 0 0 0 0 2.005m8 0a1.002 1.002 0 1 0 0-2.005 1.002 1.002 0 0 0 0 2.005",
          clipRule: "evenodd"
        })
      })
    })
  });
};

const DriversLicense = ({
  className = undefined,
  isFocusable = false,
  filled = undefined,
  title = undefined,
  role = undefined,
  size = 16,
  ...restProps
}) => {
  if (filled) {
    console.warn("<DriversLicense filled /> is now deprecated, please use <DriversLicenseFill /> or refer to https://transferwise.github.io/icons/ for more info.");
  }
  return /*#__PURE__*/jsx("span", {
    className: `tw-icon tw-icon-drivers-license ${className ? className : ''}`,
    "data-testid": restProps['data-testid'] || 'drivers-license-icon',
    children: /*#__PURE__*/jsx("svg", {
      "aria-label": title,
      "aria-hidden": !title ? true : undefined,
      focusable: isFocusable,
      role: role ?? (title ? 'graphics-symbol img' : 'none'),
      width: String(size),
      height: String(size),
      fill: "currentColor",
      viewBox: "0 0 24 24",
      children: (Number(size) === 16 || Number(size) === 24 || Number(size) === 32) && /*#__PURE__*/jsx(Fragment, {
        children: /*#__PURE__*/jsx("path", {
          fillRule: "evenodd",
          d: "M8.28 3a2 2 0 0 0-1.94 1.515L5.72 7H3v2h1.898a1.01 1.01 0 0 0-1.002.883l-.887 6.98c-.076.6.388 1.13.991 1.137v1a2 2 0 0 0 2 2h1a2 2 0 0 0 2-2v-1h6v1a2 2 0 0 0 2 2h1a2 2 0 0 0 2-2v-1a1.01 1.01 0 0 0 .99-1.137l-.886-6.98A1.01 1.01 0 0 0 19.102 9H21V7h-2.72l-.62-2.485A2 2 0 0 0 15.72 3zM18 18h-1v1h1zm.865-2-.635-5H5.77l-.635 5zM6 19v-1h1v1zm9.72-14H8.28l-1 4h9.44zm-7.718 9.005a1.002 1.002 0 1 0 0-2.005 1.002 1.002 0 0 0 0 2.005m8 0a1.002 1.002 0 1 0 0-2.005 1.002 1.002 0 0 0 0 2.005",
          clipRule: "evenodd"
        })
      })
    })
  });
};

const CardCvc = ({
  className = undefined,
  isFocusable = false,
  filled = undefined,
  title = undefined,
  role = undefined,
  size = 16,
  ...restProps
}) => {
  if (filled) {
    console.warn("<CardCvc filled /> is now deprecated, please use <CardCvcFill /> or refer to https://transferwise.github.io/icons/ for more info.");
  }
  return /*#__PURE__*/jsx("span", {
    className: `tw-icon tw-icon-card-cvc ${className ? className : ''}`,
    "data-testid": restProps['data-testid'] || 'card-cvc-icon',
    children: /*#__PURE__*/jsx("svg", {
      "aria-label": title,
      "aria-hidden": !title ? true : undefined,
      focusable: isFocusable,
      role: role ?? (title ? 'graphics-symbol img' : 'none'),
      width: String(size),
      height: String(size),
      fill: "currentColor",
      viewBox: "0 0 24 24",
      children: (Number(size) === 16 || Number(size) === 24 || Number(size) === 32) && /*#__PURE__*/jsx(Fragment, {
        children: /*#__PURE__*/jsx("path", {
          fillRule: "evenodd",
          d: "M4 4a2 2 0 0 0-2 2v12a2 2 0 0 0 2 2h16a2 2 0 0 0 2-2V6a2 2 0 0 0-2-2zm16 4V6H4v2zM4 10v8h16v-8zm14 4h-4v-2h4z",
          clipRule: "evenodd"
        })
      })
    })
  });
};

const CardDetail = ({
  className = undefined,
  isFocusable = false,
  filled = undefined,
  title = undefined,
  role = undefined,
  size = 16,
  ...restProps
}) => {
  if (filled) {
    console.warn("<CardDetail filled /> is now deprecated, please use <CardDetailFill /> or refer to https://transferwise.github.io/icons/ for more info.");
  }
  return /*#__PURE__*/jsx("span", {
    className: `tw-icon tw-icon-card-detail ${className ? className : ''}`,
    "data-testid": restProps['data-testid'] || 'card-detail-icon',
    children: /*#__PURE__*/jsx("svg", {
      "aria-label": title,
      "aria-hidden": !title ? true : undefined,
      focusable: isFocusable,
      role: role ?? (title ? 'graphics-symbol img' : 'none'),
      width: String(size),
      height: String(size),
      fill: "currentColor",
      viewBox: "0 0 24 24",
      children: (Number(size) === 16 || Number(size) === 24 || Number(size) === 32) && /*#__PURE__*/jsx(Fragment, {
        children: /*#__PURE__*/jsx("path", {
          fillRule: "evenodd",
          d: "M2 6a2 2 0 0 1 2-2h16a2 2 0 0 1 2 2v12a2 2 0 0 1-2 2H4a2 2 0 0 1-2-2zm18 0H4v12h16zM6 10h3v2H6zm12 4H6v2h12z",
          clipRule: "evenodd"
        })
      })
    })
  });
};

const CardNumber = ({
  className = undefined,
  isFocusable = false,
  filled = undefined,
  title = undefined,
  role = undefined,
  size = 16,
  ...restProps
}) => {
  if (filled) {
    console.warn("<CardNumber filled /> is now deprecated, please use <CardNumberFill /> or refer to https://transferwise.github.io/icons/ for more info.");
  }
  return /*#__PURE__*/jsx("span", {
    className: `tw-icon tw-icon-card-number ${className ? className : ''}`,
    "data-testid": restProps['data-testid'] || 'card-number-icon',
    children: /*#__PURE__*/jsx("svg", {
      "aria-label": title,
      "aria-hidden": !title ? true : undefined,
      focusable: isFocusable,
      role: role ?? (title ? 'graphics-symbol img' : 'none'),
      width: String(size),
      height: String(size),
      fill: "currentColor",
      viewBox: "0 0 24 24",
      children: (Number(size) === 16 || Number(size) === 24 || Number(size) === 32) && /*#__PURE__*/jsx(Fragment, {
        children: /*#__PURE__*/jsx("path", {
          fillRule: "evenodd",
          d: "M2 6a2 2 0 0 1 2-2h16a2 2 0 0 1 2 2v12a2 2 0 0 1-2 2H4a2 2 0 0 1-2-2zm18 0H4v12h16zM6 10h3v2H6zm12 4H6v2h12z",
          clipRule: "evenodd"
        })
      })
    })
  });
};

const CardStrikethrough = ({
  className = undefined,
  isFocusable = false,
  filled = undefined,
  title = undefined,
  role = undefined,
  size = 16,
  ...restProps
}) => {
  if (filled) {
    console.warn("<CardStrikethrough filled /> is now deprecated, please use <CardStrikethroughFill /> or refer to https://transferwise.github.io/icons/ for more info.");
  }
  return /*#__PURE__*/jsx("span", {
    className: `tw-icon tw-icon-card-strikethrough ${className ? className : ''}`,
    "data-testid": restProps['data-testid'] || 'card-strikethrough-icon',
    children: /*#__PURE__*/jsx("svg", {
      "aria-label": title,
      "aria-hidden": !title ? true : undefined,
      focusable: isFocusable,
      role: role ?? (title ? 'graphics-symbol img' : 'none'),
      width: String(size),
      height: String(size),
      fill: "currentColor",
      viewBox: "0 0 24 24",
      children: (Number(size) === 16 || Number(size) === 24 || Number(size) === 32) && /*#__PURE__*/jsx(Fragment, {
        children: /*#__PURE__*/jsx("path", {
          fillRule: "evenodd",
          d: "m1.293 2.707 20 20 1.414-1.414-1.616-1.616c.547-.357.91-.975.91-1.677V6a2 2 0 0 0-2-2H5.413L2.707 1.293zM7.414 6l12 12H20V6zm6.523 12 2 2H4a2 2 0 0 1-2-2V6.063l2 2V18z",
          clipRule: "evenodd"
        })
      })
    })
  });
};

const CardWise = ({
  className = undefined,
  isFocusable = false,
  filled = undefined,
  title = undefined,
  role = undefined,
  size = 16,
  ...restProps
}) => {
  if (filled) {
    console.warn("<CardWise filled /> is now deprecated, please use <CardWiseFill /> or refer to https://transferwise.github.io/icons/ for more info.");
  }
  return /*#__PURE__*/jsx("span", {
    className: `tw-icon tw-icon-card-wise ${className ? className : ''}`,
    "data-testid": restProps['data-testid'] || 'card-wise-icon',
    children: /*#__PURE__*/jsx("svg", {
      "aria-label": title,
      "aria-hidden": !title ? true : undefined,
      focusable: isFocusable,
      role: role ?? (title ? 'graphics-symbol img' : 'none'),
      width: String(size),
      height: String(size),
      fill: "currentColor",
      viewBox: "0 0 24 24",
      children: (Number(size) === 16 || Number(size) === 24 || Number(size) === 32) && /*#__PURE__*/jsx(Fragment, {
        children: /*#__PURE__*/jsx("path", {
          fillRule: "evenodd",
          d: "M2 6a2 2 0 0 1 2-2h16a2 2 0 0 1 2 2v5.438c0 .379-.21.71-.518.883-.656.366-.982 1-.982 1.679s.326 1.313.982 1.68c.274.152.518.466.518.881V18a2 2 0 0 1-2 2H4a2 2 0 0 1-2-2zm18 12v-.908A3.88 3.88 0 0 1 18.5 14c0-1.165.501-2.318 1.5-3.091V6H4v12zM6 8h3v2H6z",
          clipRule: "evenodd"
        })
      })
    })
  });
};

const CardTransferwise = ({
  className = undefined,
  isFocusable = false,
  filled = undefined,
  title = undefined,
  role = undefined,
  size = 16,
  ...restProps
}) => {
  if (filled) {
    console.warn("<CardTransferwise filled /> is now deprecated, please use <CardTransferwiseFill /> or refer to https://transferwise.github.io/icons/ for more info.");
  }
  return /*#__PURE__*/jsx("span", {
    className: `tw-icon tw-icon-card-transferwise ${className ? className : ''}`,
    "data-testid": restProps['data-testid'] || 'card-transferwise-icon',
    children: /*#__PURE__*/jsx("svg", {
      "aria-label": title,
      "aria-hidden": !title ? true : undefined,
      focusable: isFocusable,
      role: role ?? (title ? 'graphics-symbol img' : 'none'),
      width: String(size),
      height: String(size),
      fill: "currentColor",
      viewBox: "0 0 24 24",
      children: (Number(size) === 16 || Number(size) === 24 || Number(size) === 32) && /*#__PURE__*/jsx(Fragment, {
        children: /*#__PURE__*/jsx("path", {
          fillRule: "evenodd",
          d: "M2 6a2 2 0 0 1 2-2h16a2 2 0 0 1 2 2v5.438c0 .379-.21.71-.518.883-.656.366-.982 1-.982 1.679s.326 1.313.982 1.68c.274.152.518.466.518.881V18a2 2 0 0 1-2 2H4a2 2 0 0 1-2-2zm18 12v-.908A3.88 3.88 0 0 1 18.5 14c0-1.165.501-2.318 1.5-3.091V6H4v12zM6 8h3v2H6z",
          clipRule: "evenodd"
        })
      })
    })
  });
};

const Card = ({
  className = undefined,
  isFocusable = false,
  filled = undefined,
  title = undefined,
  role = undefined,
  size = 16,
  ...restProps
}) => {
  if (filled) {
    console.warn("<Card filled /> is now deprecated, please use <CardFill /> or refer to https://transferwise.github.io/icons/ for more info.");
  }
  return /*#__PURE__*/jsx("span", {
    className: `tw-icon tw-icon-card ${className ? className : ''}`,
    "data-testid": restProps['data-testid'] || 'card-icon',
    children: /*#__PURE__*/jsx("svg", {
      "aria-label": title,
      "aria-hidden": !title ? true : undefined,
      focusable: isFocusable,
      role: role ?? (title ? 'graphics-symbol img' : 'none'),
      width: String(size),
      height: String(size),
      fill: "currentColor",
      viewBox: "0 0 24 24",
      children: (Number(size) === 16 || Number(size) === 24 || Number(size) === 32) && /*#__PURE__*/jsx(Fragment, {
        children: /*#__PURE__*/jsx("path", {
          fillRule: "evenodd",
          d: "M4 4a2 2 0 0 0-2 2v12a2 2 0 0 0 2 2h16a2 2 0 0 0 2-2V6a2 2 0 0 0-2-2zm16 4V6H4v2zM4 10v8h16v-8z",
          clipRule: "evenodd"
        })
      })
    })
  });
};

const CashApp = ({
  className = undefined,
  isFocusable = false,
  filled = undefined,
  title = undefined,
  role = undefined,
  size = 16,
  ...restProps
}) => {
  if (filled) {
    console.warn("<CashApp filled /> is now deprecated, please use <CashAppFill /> or refer to https://transferwise.github.io/icons/ for more info.");
  }
  return /*#__PURE__*/jsx("span", {
    className: `tw-icon tw-icon-cash-app ${className ? className : ''}`,
    "data-testid": restProps['data-testid'] || 'cash-app-icon',
    children: /*#__PURE__*/jsx("svg", {
      "aria-label": title,
      "aria-hidden": !title ? true : undefined,
      focusable: isFocusable,
      role: role ?? (title ? 'graphics-symbol img' : 'none'),
      width: String(size),
      height: String(size),
      fill: "currentColor",
      viewBox: "0 0 24 24",
      children: (Number(size) === 16 || Number(size) === 24 || Number(size) === 32) && /*#__PURE__*/jsx(Fragment, {
        children: /*#__PURE__*/jsx("path", {
          d: "M6.481 1.714a4.78 4.78 0 0 0-3.37 1.389 4.73 4.73 0 0 0-1.397 3.353v11.088c0 1.258.503 2.464 1.396 3.353a4.78 4.78 0 0 0 3.371 1.389h11.038a4.78 4.78 0 0 0 3.37-1.389 4.73 4.73 0 0 0 1.397-3.353V6.456a4.73 4.73 0 0 0-1.396-3.353 4.78 4.78 0 0 0-3.37-1.389zm8.86 7.667a4.37 4.37 0 0 0-2.807-1.025c-.848 0-1.696.279-1.696 1.053 0 .707.754.985 1.683 1.324l.276.1c1.838.618 3.351 1.373 3.351 3.164 0 1.945-1.517 3.277-4.004 3.426l-.227 1.041a.4.4 0 0 1-.406.331H9.95a.43.43 0 0 1-.404-.331.4.4 0 0 1-.001-.185l.243-1.102a5.75 5.75 0 0 1-2.507-1.364.404.404 0 0 1 0-.601l.868-.843a.405.405 0 0 1 .593 0 4.2 4.2 0 0 0 2.953 1.15c1.132 0 1.898-.476 1.898-1.235 0-.682-.628-.912-1.825-1.348l-.406-.145c-1.533-.545-2.99-1.324-2.99-3.131 0-2.095 1.757-3.116 3.83-3.229l.219-1.06a.4.4 0 0 1 .406-.332h1.557a.41.41 0 0 1 .41.32.4.4 0 0 1-.004.185l-.243 1.186c.793.26 1.527.67 2.162 1.21a.404.404 0 0 1 .02.606l-.811.807a.43.43 0 0 1-.576.012z"
        })
      })
    })
  });
};

const CashRegister = ({
  className = undefined,
  isFocusable = false,
  filled = undefined,
  title = undefined,
  role = undefined,
  size = 16,
  ...restProps
}) => {
  if (filled) {
    console.warn("<CashRegister filled /> is now deprecated, please use <CashRegisterFill /> or refer to https://transferwise.github.io/icons/ for more info.");
  }
  return /*#__PURE__*/jsx("span", {
    className: `tw-icon tw-icon-cash-register ${className ? className : ''}`,
    "data-testid": restProps['data-testid'] || 'cash-register-icon',
    children: /*#__PURE__*/jsx("svg", {
      "aria-label": title,
      "aria-hidden": !title ? true : undefined,
      focusable: isFocusable,
      role: role ?? (title ? 'graphics-symbol img' : 'none'),
      width: String(size),
      height: String(size),
      fill: "currentColor",
      viewBox: "0 0 24 24",
      children: (Number(size) === 16 || Number(size) === 24 || Number(size) === 32) && /*#__PURE__*/jsx(Fragment, {
        children: /*#__PURE__*/jsx("path", {
          fillRule: "evenodd",
          d: "M3 5a2 2 0 0 1 2-2h4a2 2 0 0 1 2 2v.94q.782-.014 1.5.076V5h2v1.543q.531.228.997.546l1.185-1.185 1.414 1.414-1.185 1.185q.464.681.736 1.497H19v2h-.966q.036.486.027 1h1.929c.558 0 1.01.452 1.01 1.01V19a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2zm11.855 4.145c.583.582.994 1.432 1.145 2.604V12h.028c.052.56.048 1.188-.022 1.89A1.01 1.01 0 0 0 17.011 15H19v4H5V5h4v1.989a1.01 1.01 0 0 0 1.11 1.005c2.337-.232 3.855.26 4.745 1.15M8 15.5a.5.5 0 1 1 1 0 .5.5 0 0 1-1 0m.5-2.5a2.5 2.5 0 1 0 0 5 2.5 2.5 0 0 0 0-5",
          clipRule: "evenodd"
        })
      })
    })
  });
};

const SalesAndRoyalties = ({
  className = undefined,
  isFocusable = false,
  filled = undefined,
  title = undefined,
  role = undefined,
  size = 16,
  ...restProps
}) => {
  if (filled) {
    console.warn("<SalesAndRoyalties filled /> is now deprecated, please use <SalesAndRoyaltiesFill /> or refer to https://transferwise.github.io/icons/ for more info.");
  }
  return /*#__PURE__*/jsx("span", {
    className: `tw-icon tw-icon-sales-and-royalties ${className ? className : ''}`,
    "data-testid": restProps['data-testid'] || 'sales-and-royalties-icon',
    children: /*#__PURE__*/jsx("svg", {
      "aria-label": title,
      "aria-hidden": !title ? true : undefined,
      focusable: isFocusable,
      role: role ?? (title ? 'graphics-symbol img' : 'none'),
      width: String(size),
      height: String(size),
      fill: "currentColor",
      viewBox: "0 0 24 24",
      children: (Number(size) === 16 || Number(size) === 24 || Number(size) === 32) && /*#__PURE__*/jsx(Fragment, {
        children: /*#__PURE__*/jsx("path", {
          fillRule: "evenodd",
          d: "M3 5a2 2 0 0 1 2-2h4a2 2 0 0 1 2 2v.94q.782-.014 1.5.076V5h2v1.543q.531.228.997.546l1.185-1.185 1.414 1.414-1.185 1.185q.464.681.736 1.497H19v2h-.966q.036.486.027 1h1.929c.558 0 1.01.452 1.01 1.01V19a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2zm11.855 4.145c.583.582.994 1.432 1.145 2.604V12h.028c.052.56.048 1.188-.022 1.89A1.01 1.01 0 0 0 17.011 15H19v4H5V5h4v1.989a1.01 1.01 0 0 0 1.11 1.005c2.337-.232 3.855.26 4.745 1.15M8 15.5a.5.5 0 1 1 1 0 .5.5 0 0 1-1 0m.5-2.5a2.5 2.5 0 1 0 0 5 2.5 2.5 0 0 0 0-5",
          clipRule: "evenodd"
        })
      })
    })
  });
};

const Charity = ({
  className = undefined,
  isFocusable = false,
  filled = undefined,
  title = undefined,
  role = undefined,
  size = 16,
  ...restProps
}) => {
  if (filled) {
    console.warn("<Charity filled /> is now deprecated, please use <CharityFill /> or refer to https://transferwise.github.io/icons/ for more info.");
  }
  return /*#__PURE__*/jsx("span", {
    className: `tw-icon tw-icon-charity ${className ? className : ''}`,
    "data-testid": restProps['data-testid'] || 'charity-icon',
    children: /*#__PURE__*/jsx("svg", {
      "aria-label": title,
      "aria-hidden": !title ? true : undefined,
      focusable: isFocusable,
      role: role ?? (title ? 'graphics-symbol img' : 'none'),
      width: String(size),
      height: String(size),
      fill: "currentColor",
      viewBox: "0 0 24 24",
      children: (Number(size) === 16 || Number(size) === 24 || Number(size) === 32) && /*#__PURE__*/jsx(Fragment, {
        children: /*#__PURE__*/jsx("path", {
          fillRule: "evenodd",
          d: "M12 5c-1.647 0-3 1.395-3 3 0 .811.12 1.415.434 2.094.333.719.896 1.55 1.858 2.795.198.257.434.533.699.823.273-.294.52-.575.728-.837.99-1.238 1.55-2.064 1.87-2.773C14.893 9.43 15 8.827 15 8c0-1.605-1.353-3-3-3m1.398 10.135c.328-.35.627-.69.883-1.01 1.01-1.262 1.7-2.25 2.13-3.198.446-.986.59-1.883.59-2.927 0-2.69-2.23-5-5-5-2.772 0-5 2.31-5 5 0 1.06.165 1.956.618 2.935.435.938 1.121 1.921 2.09 3.176.249.323.544.666.869 1.018a66 66 0 0 1-1.986 1.806 94 94 0 0 1-2.504 2.112l-.159.129-.05.04-.003.003L6.5 20l.625.78h.001l.003-.003.012-.009.043-.035a54 54 0 0 0 .766-.627c.505-.418 1.2-1.002 1.959-1.666a67 67 0 0 0 2.076-1.889 61 61 0 0 0 2.083 1.891 89 89 0 0 0 2.752 2.295l.045.035.011.01.003.002h.001L17.5 20l.62-.785-.004-.002-.01-.009-.04-.032-.162-.129-.593-.48a86 86 0 0 1-1.93-1.63 60 60 0 0 1-1.983-1.798",
          clipRule: "evenodd"
        })
      })
    })
  });
};

const CheckCircleFill = ({
  className = undefined,
  isFocusable = false,
  filled = undefined,
  title = undefined,
  role = undefined,
  size = 16,
  ...restProps
}) => {
  if (filled) {
    console.warn("<CheckCircleFill filled /> is now deprecated, please use <CheckCircleFillFill /> or refer to https://transferwise.github.io/icons/ for more info.");
  }
  return /*#__PURE__*/jsx("span", {
    className: `tw-icon tw-icon-check-circle-fill ${className ? className : ''}`,
    "data-testid": restProps['data-testid'] || 'check-circle-fill-icon',
    children: /*#__PURE__*/jsx("svg", {
      "aria-label": title,
      "aria-hidden": !title ? true : undefined,
      focusable: isFocusable,
      role: role ?? (title ? 'graphics-symbol img' : 'none'),
      width: String(size),
      height: String(size),
      fill: "currentColor",
      viewBox: "0 0 24 24",
      children: (Number(size) === 16 || Number(size) === 24 || Number(size) === 32) && /*#__PURE__*/jsx(Fragment, {
        children: /*#__PURE__*/jsx("path", {
          fillRule: "evenodd",
          d: "M12 22c5.523 0 10-4.477 10-10S17.523 2 12 2 2 6.477 2 12s4.477 10 10 10m4.293-13.707L10.5 14.086l-2.793-2.793-1.414 1.414L9.786 16.2a1.01 1.01 0 0 0 1.428 0l6.493-6.493z",
          clipRule: "evenodd"
        })
      })
    })
  });
};

const CheckCircle = ({
  className = undefined,
  isFocusable = false,
  filled = undefined,
  title = undefined,
  role = undefined,
  size = 16,
  ...restProps
}) => {
  if (filled) {
    console.warn("<CheckCircle filled /> is now deprecated, please use <CheckCircleFill /> or refer to https://transferwise.github.io/icons/ for more info.");
  }
  return /*#__PURE__*/jsx("span", {
    className: `tw-icon tw-icon-check-circle ${className ? className : ''}`,
    "data-testid": restProps['data-testid'] || 'check-circle-icon',
    children: /*#__PURE__*/jsx("svg", {
      "aria-label": title,
      "aria-hidden": !title ? true : undefined,
      focusable: isFocusable,
      role: role ?? (title ? 'graphics-symbol img' : 'none'),
      width: String(size),
      height: String(size),
      fill: "currentColor",
      viewBox: "0 0 24 24",
      children: (Number(size) === 16 || Number(size) === 24 || Number(size) === 32) && /*#__PURE__*/jsx(Fragment, {
        children: /*#__PURE__*/jsx("path", {
          fillRule: "evenodd",
          d: "M4 12a8 8 0 1 1 16 0 8 8 0 0 1-16 0m8-10C6.477 2 2 6.477 2 12s4.477 10 10 10 10-4.477 10-10S17.523 2 12 2m4.293 6.293L10.5 14.086l-2.793-2.793-1.414 1.414L9.786 16.2a1.01 1.01 0 0 0 1.428 0l6.493-6.493z",
          clipRule: "evenodd"
        })
      })
    })
  });
};

const Check = ({
  className = undefined,
  isFocusable = false,
  filled = undefined,
  title = undefined,
  role = undefined,
  size = 16,
  ...restProps
}) => {
  if (filled) {
    console.warn("<Check filled /> is now deprecated, please use <CheckFill /> or refer to https://transferwise.github.io/icons/ for more info.");
  }
  return /*#__PURE__*/jsx("span", {
    className: `tw-icon tw-icon-check ${className ? className : ''}`,
    "data-testid": restProps['data-testid'] || 'check-icon',
    children: /*#__PURE__*/jsx("svg", {
      "aria-label": title,
      "aria-hidden": !title ? true : undefined,
      focusable: isFocusable,
      role: role ?? (title ? 'graphics-symbol img' : 'none'),
      width: String(size),
      height: String(size),
      fill: "currentColor",
      viewBox: "0 0 24 24",
      children: (Number(size) === 16 || Number(size) === 24 || Number(size) === 32) && /*#__PURE__*/jsx(Fragment, {
        children: /*#__PURE__*/jsx("path", {
          fillRule: "evenodd",
          d: "M9 16.586 20.293 5.293l1.414 1.414L9.714 18.7a1.01 1.01 0 0 1-1.428 0l-5.993-5.993 1.414-1.414z",
          clipRule: "evenodd"
        })
      })
    })
  });
};

const Verified = ({
  className = undefined,
  isFocusable = false,
  filled = undefined,
  title = undefined,
  role = undefined,
  size = 16,
  ...restProps
}) => {
  if (filled) {
    console.warn("<Verified filled /> is now deprecated, please use <VerifiedFill /> or refer to https://transferwise.github.io/icons/ for more info.");
  }
  return /*#__PURE__*/jsx("span", {
    className: `tw-icon tw-icon-verified ${className ? className : ''}`,
    "data-testid": restProps['data-testid'] || 'verified-icon',
    children: /*#__PURE__*/jsx("svg", {
      "aria-label": title,
      "aria-hidden": !title ? true : undefined,
      focusable: isFocusable,
      role: role ?? (title ? 'graphics-symbol img' : 'none'),
      width: String(size),
      height: String(size),
      fill: "currentColor",
      viewBox: "0 0 24 24",
      children: (Number(size) === 16 || Number(size) === 24 || Number(size) === 32) && /*#__PURE__*/jsx(Fragment, {
        children: /*#__PURE__*/jsx("path", {
          fillRule: "evenodd",
          d: "M9 16.586 20.293 5.293l1.414 1.414L9.714 18.7a1.01 1.01 0 0 1-1.428 0l-5.993-5.993 1.414-1.414z",
          clipRule: "evenodd"
        })
      })
    })
  });
};

const ChevronDown = ({
  className = undefined,
  isFocusable = false,
  filled = undefined,
  title = undefined,
  role = undefined,
  size = 16,
  ...restProps
}) => {
  if (filled) {
    console.warn("<ChevronDown filled /> is now deprecated, please use <ChevronDownFill /> or refer to https://transferwise.github.io/icons/ for more info.");
  }
  return /*#__PURE__*/jsx("span", {
    className: `tw-icon tw-icon-chevron-down ${className ? className : ''}`,
    "data-testid": restProps['data-testid'] || 'chevron-down-icon',
    children: /*#__PURE__*/jsx("svg", {
      "aria-label": title,
      "aria-hidden": !title ? true : undefined,
      focusable: isFocusable,
      role: role ?? (title ? 'graphics-symbol img' : 'none'),
      width: String(size),
      height: String(size),
      fill: "currentColor",
      viewBox: "0 0 24 24",
      children: (Number(size) === 16 || Number(size) === 24 || Number(size) === 32) && /*#__PURE__*/jsx(Fragment, {
        children: /*#__PURE__*/jsx("path", {
          fillRule: "evenodd",
          d: "m12 14.586 7.293-7.293 1.414 1.414-7.993 7.993a1.01 1.01 0 0 1-1.428 0L3.293 8.707l1.414-1.414z",
          clipRule: "evenodd"
        })
      })
    })
  });
};

const ChevronLeft = ({
  className = undefined,
  isFocusable = false,
  filled = undefined,
  title = undefined,
  role = undefined,
  size = 16,
  ...restProps
}) => {
  if (filled) {
    console.warn("<ChevronLeft filled /> is now deprecated, please use <ChevronLeftFill /> or refer to https://transferwise.github.io/icons/ for more info.");
  }
  return /*#__PURE__*/jsx("span", {
    className: `tw-icon tw-icon-chevron-left ${className ? className : ''}`,
    "data-testid": restProps['data-testid'] || 'chevron-left-icon',
    children: /*#__PURE__*/jsx("svg", {
      "aria-label": title,
      "aria-hidden": !title ? true : undefined,
      focusable: isFocusable,
      role: role ?? (title ? 'graphics-symbol img' : 'none'),
      width: String(size),
      height: String(size),
      fill: "currentColor",
      viewBox: "0 0 24 24",
      children: (Number(size) === 16 || Number(size) === 24 || Number(size) === 32) && /*#__PURE__*/jsx(Fragment, {
        children: /*#__PURE__*/jsx("path", {
          fillRule: "evenodd",
          d: "m8.414 12 7.293-7.293-1.414-1.414L6.3 11.286a1.01 1.01 0 0 0 0 1.428l7.993 7.993 1.414-1.414z",
          clipRule: "evenodd"
        })
      })
    })
  });
};

const ChevronRight = ({
  className = undefined,
  isFocusable = false,
  filled = undefined,
  title = undefined,
  role = undefined,
  size = 16,
  ...restProps
}) => {
  if (filled) {
    console.warn("<ChevronRight filled /> is now deprecated, please use <ChevronRightFill /> or refer to https://transferwise.github.io/icons/ for more info.");
  }
  return /*#__PURE__*/jsx("span", {
    className: `tw-icon tw-icon-chevron-right ${className ? className : ''}`,
    "data-testid": restProps['data-testid'] || 'chevron-right-icon',
    children: /*#__PURE__*/jsx("svg", {
      "aria-label": title,
      "aria-hidden": !title ? true : undefined,
      focusable: isFocusable,
      role: role ?? (title ? 'graphics-symbol img' : 'none'),
      width: String(size),
      height: String(size),
      fill: "currentColor",
      viewBox: "0 0 24 24",
      children: (Number(size) === 16 || Number(size) === 24 || Number(size) === 32) && /*#__PURE__*/jsx(Fragment, {
        children: /*#__PURE__*/jsx("path", {
          fillRule: "evenodd",
          d: "M15.586 12 8.293 4.707l1.414-1.414 7.993 7.993a1.01 1.01 0 0 1 0 1.428l-7.993 7.993-1.414-1.414z",
          clipRule: "evenodd"
        })
      })
    })
  });
};

const ChevronUp = ({
  className = undefined,
  isFocusable = false,
  filled = undefined,
  title = undefined,
  role = undefined,
  size = 16,
  ...restProps
}) => {
  if (filled) {
    console.warn("<ChevronUp filled /> is now deprecated, please use <ChevronUpFill /> or refer to https://transferwise.github.io/icons/ for more info.");
  }
  return /*#__PURE__*/jsx("span", {
    className: `tw-icon tw-icon-chevron-up ${className ? className : ''}`,
    "data-testid": restProps['data-testid'] || 'chevron-up-icon',
    children: /*#__PURE__*/jsx("svg", {
      "aria-label": title,
      "aria-hidden": !title ? true : undefined,
      focusable: isFocusable,
      role: role ?? (title ? 'graphics-symbol img' : 'none'),
      width: String(size),
      height: String(size),
      fill: "currentColor",
      viewBox: "0 0 24 24",
      children: (Number(size) === 16 || Number(size) === 24 || Number(size) === 32) && /*#__PURE__*/jsx(Fragment, {
        children: /*#__PURE__*/jsx("path", {
          fillRule: "evenodd",
          d: "m12 9.414 7.293 7.293 1.414-1.414L12.714 7.3a1.01 1.01 0 0 0-1.428 0l-7.993 7.993 1.414 1.414z",
          clipRule: "evenodd"
        })
      })
    })
  });
};

const Chip = ({
  className = undefined,
  isFocusable = false,
  filled = undefined,
  title = undefined,
  role = undefined,
  size = 16,
  ...restProps
}) => {
  if (filled) {
    console.warn("<Chip filled /> is now deprecated, please use <ChipFill /> or refer to https://transferwise.github.io/icons/ for more info.");
  }
  return /*#__PURE__*/jsx("span", {
    className: `tw-icon tw-icon-chip ${className ? className : ''}`,
    "data-testid": restProps['data-testid'] || 'chip-icon',
    children: /*#__PURE__*/jsx("svg", {
      "aria-label": title,
      "aria-hidden": !title ? true : undefined,
      focusable: isFocusable,
      role: role ?? (title ? 'graphics-symbol img' : 'none'),
      width: String(size),
      height: String(size),
      fill: "currentColor",
      viewBox: "0 0 24 24",
      children: (Number(size) === 16 || Number(size) === 24 || Number(size) === 32) && /*#__PURE__*/jsx(Fragment, {
        children: /*#__PURE__*/jsx("path", {
          fillRule: "evenodd",
          d: "M4 4a2 2 0 0 0-2 2v12a2 2 0 0 0 2 2h16a2 2 0 0 0 2-2V6a2 2 0 0 0-2-2zm11.283 2H20v3h-4.166a21 21 0 0 0-.551-3m-2.114 0h-2.338C10.336 7.516 10 9.61 10 12s.336 4.484.831 6h2.338c.495-1.516.831-3.61.831-6s-.336-4.484-.831-6m2.114 12H20v-3h-4.166a21 21 0 0 1-.551 3m.7-5H20v-2h-4.018a28 28 0 0 1 0 2m-7.266 5a21 21 0 0 1-.551-3H4v3zm-.7-5a28 28 0 0 1 0-2H4v2zm.149-4c.123-1.084.31-2.094.551-3H4v3z",
          clipRule: "evenodd"
        })
      })
    })
  });
};

const ChipPin = ({
  className = undefined,
  isFocusable = false,
  filled = undefined,
  title = undefined,
  role = undefined,
  size = 16,
  ...restProps
}) => {
  if (filled) {
    console.warn("<ChipPin filled /> is now deprecated, please use <ChipPinFill /> or refer to https://transferwise.github.io/icons/ for more info.");
  }
  return /*#__PURE__*/jsx("span", {
    className: `tw-icon tw-icon-chip-pin ${className ? className : ''}`,
    "data-testid": restProps['data-testid'] || 'chip-pin-icon',
    children: /*#__PURE__*/jsx("svg", {
      "aria-label": title,
      "aria-hidden": !title ? true : undefined,
      focusable: isFocusable,
      role: role ?? (title ? 'graphics-symbol img' : 'none'),
      width: String(size),
      height: String(size),
      fill: "currentColor",
      viewBox: "0 0 24 24",
      children: (Number(size) === 16 || Number(size) === 24 || Number(size) === 32) && /*#__PURE__*/jsx(Fragment, {
        children: /*#__PURE__*/jsx("path", {
          fillRule: "evenodd",
          d: "M4 4a2 2 0 0 0-2 2v12a2 2 0 0 0 2 2h16a2 2 0 0 0 2-2V6a2 2 0 0 0-2-2zm11.283 2H20v3h-4.166a21 21 0 0 0-.551-3m-2.114 0h-2.338C10.336 7.516 10 9.61 10 12s.336 4.484.831 6h2.338c.495-1.516.831-3.61.831-6s-.336-4.484-.831-6m2.114 12H20v-3h-4.166a21 21 0 0 1-.551 3m.7-5H20v-2h-4.018a28 28 0 0 1 0 2m-7.266 5a21 21 0 0 1-.551-3H4v3zm-.7-5a28 28 0 0 1 0-2H4v2zm.149-4c.123-1.084.31-2.094.551-3H4v3z",
          clipRule: "evenodd"
        })
      })
    })
  });
};

const ClickToPay = ({
  className = undefined,
  isFocusable = false,
  filled = undefined,
  title = undefined,
  role = undefined,
  size = 16,
  ...restProps
}) => {
  if (filled) {
    console.warn("<ClickToPay filled /> is now deprecated, please use <ClickToPayFill /> or refer to https://transferwise.github.io/icons/ for more info.");
  }
  return /*#__PURE__*/jsx("span", {
    className: `tw-icon tw-icon-click-to-pay ${className ? className : ''}`,
    "data-testid": restProps['data-testid'] || 'click-to-pay-icon',
    children: /*#__PURE__*/jsx("svg", {
      "aria-label": title,
      "aria-hidden": !title ? true : undefined,
      focusable: isFocusable,
      role: role ?? (title ? 'graphics-symbol img' : 'none'),
      width: String(size),
      height: String(size),
      fill: "currentColor",
      viewBox: "0 0 24 24",
      children: (Number(size) === 16 || Number(size) === 24 || Number(size) === 32) && /*#__PURE__*/jsx(Fragment, {
        children: /*#__PURE__*/jsx("path", {
          d: "M16.702 18.453h-3.428c-.245 0-.54-.147-.637-.392-.098-.245-.098-.539.098-.735l4.408-5.29-4.555-5.044h-1.323l3.919 4.457a.62.62 0 0 1 0 .882l-4.212 4.996c-.294.44-1.03 1.126-2.058 1.126H3.87c-.734-.098-2.155-.735-2.155-2.449V7.922c0-.93.588-2.302 2.253-2.302h3.135a.67.67 0 0 1 .686.686.67.67 0 0 1-.686.686H3.967c-.734 0-.832.637-.832.93v8.033c0 .833.685 1.029.881 1.078h4.898c.588 0 .931-.49.931-.49 0-.05.049-.05.049-.098l3.87-4.604-4.507-5.143a.594.594 0 0 1-.098-.735c.098-.245.343-.392.637-.392h3.184c.196 0 .391.098.49.245l5.142 5.73c.245.246.245.638 0 .931l-3.869 4.605h1.665l4.261-5.045-4.457-5.29a.7.7 0 0 1 .098-.98.7.7 0 0 1 .98.098l4.849 5.73a.735.735 0 0 1 0 .882l-4.85 5.731c-.195.147-.342.245-.587.245"
        })
      })
    })
  });
};

const ClockBorderless = ({
  className = undefined,
  isFocusable = false,
  filled = undefined,
  title = undefined,
  role = undefined,
  size = 16,
  ...restProps
}) => {
  if (filled) {
    console.warn("<ClockBorderless filled /> is now deprecated, please use <ClockBorderlessFill /> or refer to https://transferwise.github.io/icons/ for more info.");
  }
  return /*#__PURE__*/jsx("span", {
    className: `tw-icon tw-icon-clock-borderless ${className ? className : ''}`,
    "data-testid": restProps['data-testid'] || 'clock-borderless-icon',
    children: /*#__PURE__*/jsx("svg", {
      "aria-label": title,
      "aria-hidden": !title ? true : undefined,
      focusable: isFocusable,
      role: role ?? (title ? 'graphics-symbol img' : 'none'),
      width: String(size),
      height: String(size),
      fill: "currentColor",
      viewBox: "0 0 24 24",
      children: (Number(size) === 16 || Number(size) === 24 || Number(size) === 32) && /*#__PURE__*/jsx(Fragment, {
        children: /*#__PURE__*/jsx("path", {
          fillRule: "evenodd",
          d: "M11 3h2v8.586l4.707 4.707-1.414 1.414L11 12.414z",
          clipRule: "evenodd"
        })
      })
    })
  });
};

const ClockFill = ({
  className = undefined,
  isFocusable = false,
  filled = undefined,
  title = undefined,
  role = undefined,
  size = 16,
  ...restProps
}) => {
  if (filled) {
    console.warn("<ClockFill filled /> is now deprecated, please use <ClockFillFill /> or refer to https://transferwise.github.io/icons/ for more info.");
  }
  return /*#__PURE__*/jsx("span", {
    className: `tw-icon tw-icon-clock-fill ${className ? className : ''}`,
    "data-testid": restProps['data-testid'] || 'clock-fill-icon',
    children: /*#__PURE__*/jsx("svg", {
      "aria-label": title,
      "aria-hidden": !title ? true : undefined,
      focusable: isFocusable,
      role: role ?? (title ? 'graphics-symbol img' : 'none'),
      width: String(size),
      height: String(size),
      fill: "currentColor",
      viewBox: "0 0 24 24",
      children: (Number(size) === 16 || Number(size) === 24 || Number(size) === 32) && /*#__PURE__*/jsx(Fragment, {
        children: /*#__PURE__*/jsx("path", {
          fillRule: "evenodd",
          d: "M12 22c5.523 0 10-4.477 10-10S17.523 2 12 2 2 6.477 2 12s4.477 10 10 10M11 6v5.996c0 .268.106.525.296.714l3.497 3.497 1.414-1.414L13 11.586V6z",
          clipRule: "evenodd"
        })
      })
    })
  });
};

const Clock = ({
  className = undefined,
  isFocusable = false,
  filled = undefined,
  title = undefined,
  role = undefined,
  size = 16,
  ...restProps
}) => {
  if (filled) {
    console.warn("<Clock filled /> is now deprecated, please use <ClockFill /> or refer to https://transferwise.github.io/icons/ for more info.");
  }
  return /*#__PURE__*/jsx("span", {
    className: `tw-icon tw-icon-clock ${className ? className : ''}`,
    "data-testid": restProps['data-testid'] || 'clock-icon',
    children: /*#__PURE__*/jsx("svg", {
      "aria-label": title,
      "aria-hidden": !title ? true : undefined,
      focusable: isFocusable,
      role: role ?? (title ? 'graphics-symbol img' : 'none'),
      width: String(size),
      height: String(size),
      fill: "currentColor",
      viewBox: "0 0 24 24",
      children: (Number(size) === 16 || Number(size) === 24 || Number(size) === 32) && /*#__PURE__*/jsx(Fragment, {
        children: /*#__PURE__*/jsx("path", {
          fillRule: "evenodd",
          d: "M4 12a8 8 0 1 1 16 0 8 8 0 0 1-16 0m8-10C6.477 2 2 6.477 2 12s4.477 10 10 10 10-4.477 10-10S17.523 2 12 2m-1 4v5.996c0 .268.106.525.296.714l3.497 3.497 1.414-1.414L13 11.586V6z",
          clipRule: "evenodd"
        })
      })
    })
  });
};

const PendingCircle = ({
  className = undefined,
  isFocusable = false,
  filled = undefined,
  title = undefined,
  role = undefined,
  size = 16,
  ...restProps
}) => {
  if (filled) {
    console.warn("<PendingCircle filled /> is now deprecated, please use <PendingCircleFill /> or refer to https://transferwise.github.io/icons/ for more info.");
  }
  return /*#__PURE__*/jsx("span", {
    className: `tw-icon tw-icon-pending-circle ${className ? className : ''}`,
    "data-testid": restProps['data-testid'] || 'pending-circle-icon',
    children: /*#__PURE__*/jsx("svg", {
      "aria-label": title,
      "aria-hidden": !title ? true : undefined,
      focusable: isFocusable,
      role: role ?? (title ? 'graphics-symbol img' : 'none'),
      width: String(size),
      height: String(size),
      fill: "currentColor",
      viewBox: "0 0 24 24",
      children: (Number(size) === 16 || Number(size) === 24 || Number(size) === 32) && /*#__PURE__*/jsx(Fragment, {
        children: /*#__PURE__*/jsx("path", {
          fillRule: "evenodd",
          d: "M4 12a8 8 0 1 1 16 0 8 8 0 0 1-16 0m8-10C6.477 2 2 6.477 2 12s4.477 10 10 10 10-4.477 10-10S17.523 2 12 2m-1 4v5.996c0 .268.106.525.296.714l3.497 3.497 1.414-1.414L13 11.586V6z",
          clipRule: "evenodd"
        })
      })
    })
  });
};

const Cog = ({
  className = undefined,
  isFocusable = false,
  filled = undefined,
  title = undefined,
  role = undefined,
  size = 16,
  ...restProps
}) => {
  if (filled) {
    console.warn("<Cog filled /> is now deprecated, please use <CogFill /> or refer to https://transferwise.github.io/icons/ for more info.");
  }
  return /*#__PURE__*/jsx("span", {
    className: `tw-icon tw-icon-cog ${className ? className : ''}`,
    "data-testid": restProps['data-testid'] || 'cog-icon',
    children: /*#__PURE__*/jsx("svg", {
      "aria-label": title,
      "aria-hidden": !title ? true : undefined,
      focusable: isFocusable,
      role: role ?? (title ? 'graphics-symbol img' : 'none'),
      width: String(size),
      height: String(size),
      fill: "currentColor",
      viewBox: "0 0 24 24",
      children: (Number(size) === 16 || Number(size) === 24 || Number(size) === 32) && /*#__PURE__*/jsx(Fragment, {
        children: /*#__PURE__*/jsx("path", {
          fillRule: "evenodd",
          d: "m14.96 19.6-.709 1.771a1 1 0 0 1-.928.629h-2.646a1 1 0 0 1-.928-.629l-.709-1.77a2 2 0 0 0-2.142-1.237l-1.888.272a1 1 0 0 1-1.008-.49l-1.323-2.292a1 1 0 0 1 .08-1.118l1.18-1.499a2 2 0 0 0 0-2.473l-1.18-1.5a1 1 0 0 1-.08-1.118L4 5.855a1 1 0 0 1 1.009-.49l1.888.272A2 2 0 0 0 9.04 4.4l.709-1.771A1 1 0 0 1 10.677 2h2.646a1 1 0 0 1 .928.629l.709 1.77a2 2 0 0 0 2.142 1.238l1.888-.272a1 1 0 0 1 1.009.49l1.323 2.29a1 1 0 0 1-.08 1.12l-1.18 1.499a2 2 0 0 0 0 2.473l1.18 1.5a1 1 0 0 1 .08 1.117l-1.323 2.292a1 1 0 0 1-1.009.49l-1.888-.272A2 2 0 0 0 14.96 19.6M10.897 5.143 11.354 4h1.292l.457 1.143a4 4 0 0 0 4.284 2.473l1.218-.175.646 1.118-.76.968a4 4 0 0 0 0 4.947l.76.967-.646 1.119-1.218-.176a4 4 0 0 0-4.284 2.474L12.646 20h-1.292l-.457-1.142a4 4 0 0 0-4.284-2.474l-1.218.175-.646-1.118.76-.967a4 4 0 0 0 0-4.947l-.76-.967.646-1.12 1.218.176a4 4 0 0 0 4.284-2.473M14 12a2 2 0 1 1-4 0 2 2 0 0 1 4 0m2 0a4 4 0 1 1-8 0 4 4 0 0 1 8 0",
          clipRule: "evenodd"
        })
      })
    })
  });
};

const Settings = ({
  className = undefined,
  isFocusable = false,
  filled = undefined,
  title = undefined,
  role = undefined,
  size = 16,
  ...restProps
}) => {
  if (filled) {
    console.warn("<Settings filled /> is now deprecated, please use <SettingsFill /> or refer to https://transferwise.github.io/icons/ for more info.");
  }
  return /*#__PURE__*/jsx("span", {
    className: `tw-icon tw-icon-settings ${className ? className : ''}`,
    "data-testid": restProps['data-testid'] || 'settings-icon',
    children: /*#__PURE__*/jsx("svg", {
      "aria-label": title,
      "aria-hidden": !title ? true : undefined,
      focusable: isFocusable,
      role: role ?? (title ? 'graphics-symbol img' : 'none'),
      width: String(size),
      height: String(size),
      fill: "currentColor",
      viewBox: "0 0 24 24",
      children: (Number(size) === 16 || Number(size) === 24 || Number(size) === 32) && /*#__PURE__*/jsx(Fragment, {
        children: /*#__PURE__*/jsx("path", {
          fillRule: "evenodd",
          d: "m14.96 19.6-.709 1.771a1 1 0 0 1-.928.629h-2.646a1 1 0 0 1-.928-.629l-.709-1.77a2 2 0 0 0-2.142-1.237l-1.888.272a1 1 0 0 1-1.008-.49l-1.323-2.292a1 1 0 0 1 .08-1.118l1.18-1.499a2 2 0 0 0 0-2.473l-1.18-1.5a1 1 0 0 1-.08-1.118L4 5.855a1 1 0 0 1 1.009-.49l1.888.272A2 2 0 0 0 9.04 4.4l.709-1.771A1 1 0 0 1 10.677 2h2.646a1 1 0 0 1 .928.629l.709 1.77a2 2 0 0 0 2.142 1.238l1.888-.272a1 1 0 0 1 1.009.49l1.323 2.29a1 1 0 0 1-.08 1.12l-1.18 1.499a2 2 0 0 0 0 2.473l1.18 1.5a1 1 0 0 1 .08 1.117l-1.323 2.292a1 1 0 0 1-1.009.49l-1.888-.272A2 2 0 0 0 14.96 19.6M10.897 5.143 11.354 4h1.292l.457 1.143a4 4 0 0 0 4.284 2.473l1.218-.175.646 1.118-.76.968a4 4 0 0 0 0 4.947l.76.967-.646 1.119-1.218-.176a4 4 0 0 0-4.284 2.474L12.646 20h-1.292l-.457-1.142a4 4 0 0 0-4.284-2.474l-1.218.175-.646-1.118.76-.967a4 4 0 0 0 0-4.947l-.76-.967.646-1.12 1.218.176a4 4 0 0 0 4.284-2.473M14 12a2 2 0 1 1-4 0 2 2 0 0 1 4 0m2 0a4 4 0 1 1-8 0 4 4 0 0 1 8 0",
          clipRule: "evenodd"
        })
      })
    })
  });
};

const Coins = ({
  className = undefined,
  isFocusable = false,
  filled = undefined,
  title = undefined,
  role = undefined,
  size = 16,
  ...restProps
}) => {
  if (filled) {
    console.warn("<Coins filled /> is now deprecated, please use <CoinsFill /> or refer to https://transferwise.github.io/icons/ for more info.");
  }
  return /*#__PURE__*/jsx("span", {
    className: `tw-icon tw-icon-coins ${className ? className : ''}`,
    "data-testid": restProps['data-testid'] || 'coins-icon',
    children: /*#__PURE__*/jsx("svg", {
      "aria-label": title,
      "aria-hidden": !title ? true : undefined,
      focusable: isFocusable,
      role: role ?? (title ? 'graphics-symbol img' : 'none'),
      width: String(size),
      height: String(size),
      fill: "currentColor",
      viewBox: "0 0 24 24",
      children: (Number(size) === 16 || Number(size) === 24 || Number(size) === 32) && /*#__PURE__*/jsx(Fragment, {
        children: /*#__PURE__*/jsx("path", {
          fillRule: "evenodd",
          d: "M11.441 4.15A7 7 0 0 0 7.47 17.527 7.003 7.003 0 0 0 21 15a7 7 0 0 0-4.473-6.53 7 7 0 0 0-5.086-4.32M14 8a5 5 0 1 0-7 7 7 7 0 0 1 7-7m-5 7a5 5 0 1 1 10 0 5 5 0 0 1-10 0",
          clipRule: "evenodd"
        })
      })
    })
  });
};

const Collapse = ({
  className = undefined,
  isFocusable = false,
  filled = undefined,
  title = undefined,
  role = undefined,
  size = 16,
  ...restProps
}) => {
  if (filled) {
    console.warn("<Collapse filled /> is now deprecated, please use <CollapseFill /> or refer to https://transferwise.github.io/icons/ for more info.");
  }
  return /*#__PURE__*/jsx("span", {
    className: `tw-icon tw-icon-collapse ${className ? className : ''}`,
    "data-testid": restProps['data-testid'] || 'collapse-icon',
    children: /*#__PURE__*/jsx("svg", {
      "aria-label": title,
      "aria-hidden": !title ? true : undefined,
      focusable: isFocusable,
      role: role ?? (title ? 'graphics-symbol img' : 'none'),
      width: String(size),
      height: String(size),
      fill: "currentColor",
      viewBox: "0 0 24 24",
      children: (Number(size) === 16 || Number(size) === 24 || Number(size) === 32) && /*#__PURE__*/jsx(Fragment, {
        children: /*#__PURE__*/jsx("path", {
          fillRule: "evenodd",
          d: "M17.293 2.293 12 7.586 6.707 2.293 5.293 3.707 11.286 9.7a1.01 1.01 0 0 0 1.428 0l5.993-5.993zm0 19.414L12 16.414l-5.293 5.293-1.414-1.414 5.993-5.993a1.01 1.01 0 0 1 1.428 0l5.993 5.993z",
          clipRule: "evenodd"
        })
      })
    })
  });
};

const CompactMore = ({
  className = undefined,
  isFocusable = false,
  filled = undefined,
  title = undefined,
  role = undefined,
  size = 16,
  ...restProps
}) => {
  if (filled) {
    console.warn("<CompactMore filled /> is now deprecated, please use <CompactMoreFill /> or refer to https://transferwise.github.io/icons/ for more info.");
  }
  return /*#__PURE__*/jsx("span", {
    className: `tw-icon tw-icon-compact-more ${className ? className : ''}`,
    "data-testid": restProps['data-testid'] || 'compact-more-icon',
    children: /*#__PURE__*/jsx("svg", {
      "aria-label": title,
      "aria-hidden": !title ? true : undefined,
      focusable: isFocusable,
      role: role ?? (title ? 'graphics-symbol img' : 'none'),
      width: String(size),
      height: String(size),
      fill: "currentColor",
      viewBox: "0 0 24 24",
      children: (Number(size) === 16 || Number(size) === 24 || Number(size) === 32) && /*#__PURE__*/jsx(Fragment, {
        children: /*#__PURE__*/jsx("path", {
          fillRule: "evenodd",
          d: "M10 5a2 2 0 1 0 4 0 2 2 0 0 0-4 0m2 9a2 2 0 1 1 0-4 2 2 0 0 1 0 4m0 7a2 2 0 1 1 0-4 2 2 0 0 1 0 4",
          clipRule: "evenodd"
        })
      })
    })
  });
};

const Confetti = ({
  className = undefined,
  isFocusable = false,
  filled = undefined,
  title = undefined,
  role = undefined,
  size = 16,
  ...restProps
}) => {
  if (filled) {
    console.warn("<Confetti filled /> is now deprecated, please use <ConfettiFill /> or refer to https://transferwise.github.io/icons/ for more info.");
  }
  return /*#__PURE__*/jsx("span", {
    className: `tw-icon tw-icon-confetti ${className ? className : ''}`,
    "data-testid": restProps['data-testid'] || 'confetti-icon',
    children: /*#__PURE__*/jsx("svg", {
      "aria-label": title,
      "aria-hidden": !title ? true : undefined,
      focusable: isFocusable,
      role: role ?? (title ? 'graphics-symbol img' : 'none'),
      width: String(size),
      height: String(size),
      fill: "currentColor",
      viewBox: "0 0 24 24",
      children: (Number(size) === 16 || Number(size) === 24 || Number(size) === 32) && /*#__PURE__*/jsxs(Fragment, {
        children: [/*#__PURE__*/jsx("path", {
          d: "M11.708 8.707c.415-.415.666-.968.816-1.495.155-.54.227-1.134.227-1.712s-.072-1.172-.226-1.712c-.151-.527-.402-1.08-.817-1.495l-1.415 1.414c.086.085.209.282.309.63.095.335.149.74.149 1.163 0 .422-.054.828-.15 1.163-.099.348-.223.545-.308.63zM15.5 7a1.5 1.5 0 1 1 0 3 1.5 1.5 0 0 1 0-3"
        }), /*#__PURE__*/jsx("path", {
          fillRule: "evenodd",
          d: "M8.175 7.513c-1.142-.55-2.351.154-2.648 1.244L3.188 17.33a2 2 0 0 0 .516 1.94l1.025 1.026a2 2 0 0 0 1.94.515l8.574-2.338c1.09-.297 1.795-1.506 1.245-2.648a18 18 0 0 0-3.473-4.84c-1.857-1.858-3.717-2.932-4.84-3.474m-1.549 4.813.805-2.95a16.1 16.1 0 0 1 4.17 3.024 16.1 16.1 0 0 1 3.024 4.17l-2.954.805c-.998-2.324-2.845-4.322-5.045-5.049m-.528 1.936-.98 3.595 1.025 1.026 3.575-.975c-.843-1.807-2.214-3.137-3.62-3.646",
          clipRule: "evenodd"
        }), /*#__PURE__*/jsx("path", {
          d: "M16.788 11.475c-.527.15-1.08.402-1.495.817l1.414 1.414c.085-.085.282-.208.63-.308.335-.095.74-.149 1.163-.149.422 0 .828.053 1.163.15.348.099.545.222.63.307l1.414-1.414c-.415-.415-.968-.666-1.495-.817a6.3 6.3 0 0 0-1.712-.226c-.578 0-1.172.072-1.712.226m3.455 4.283L19.5 15l-.742.758L18 16.5l.758.743.742.757.742-.757L21 16.5zM18.5 4l.743.757.758.742-.758.743-.742.757-.743-.757L17 5.499l.758-.742zM8.242 3.758 7.5 3l-.742.758L6 4.5l.758.743L7.5 6l.742-.757L9 4.5z"
        })]
      })
    })
  });
};

const Contactless = ({
  className = undefined,
  isFocusable = false,
  filled = undefined,
  title = undefined,
  role = undefined,
  size = 16,
  ...restProps
}) => {
  if (filled) {
    console.warn("<Contactless filled /> is now deprecated, please use <ContactlessFill /> or refer to https://transferwise.github.io/icons/ for more info.");
  }
  return /*#__PURE__*/jsx("span", {
    className: `tw-icon tw-icon-contactless ${className ? className : ''}`,
    "data-testid": restProps['data-testid'] || 'contactless-icon',
    children: /*#__PURE__*/jsx("svg", {
      "aria-label": title,
      "aria-hidden": !title ? true : undefined,
      focusable: isFocusable,
      role: role ?? (title ? 'graphics-symbol img' : 'none'),
      width: String(size),
      height: String(size),
      fill: "currentColor",
      viewBox: "0 0 24 24",
      children: (Number(size) === 16 || Number(size) === 24 || Number(size) === 32) && /*#__PURE__*/jsx(Fragment, {
        children: /*#__PURE__*/jsx("path", {
          fillRule: "evenodd",
          d: "M13.071 21.799a13.96 13.96 0 0 0 4.1-9.9c0-3.865-1.566-7.365-4.1-9.899l-1.414 1.414a11.96 11.96 0 0 1 3.515 8.485c0 3.314-1.344 6.314-3.515 8.486zm-2.828-2.828a9.97 9.97 0 0 0 2.929-7.071 9.97 9.97 0 0 0-2.93-7.072L8.829 6.243a7.98 7.98 0 0 1 2.344 5.656c0 2.21-.896 4.21-2.344 5.657zm-2.829-2.829A5.98 5.98 0 0 0 9.172 11.9a5.98 5.98 0 0 0-1.758-4.243L6 9.07a4 4 0 0 1 1.172 2.83A4 4 0 0 1 6 14.728z",
          clipRule: "evenodd"
        })
      })
    })
  });
};

const Convert = ({
  className = undefined,
  isFocusable = false,
  filled = undefined,
  title = undefined,
  role = undefined,
  size = 16,
  ...restProps
}) => {
  if (filled) {
    console.warn("<Convert filled /> is now deprecated, please use <ConvertFill /> or refer to https://transferwise.github.io/icons/ for more info.");
  }
  return /*#__PURE__*/jsx("span", {
    className: `tw-icon tw-icon-convert ${className ? className : ''}`,
    "data-testid": restProps['data-testid'] || 'convert-icon',
    children: /*#__PURE__*/jsx("svg", {
      "aria-label": title,
      "aria-hidden": !title ? true : undefined,
      focusable: isFocusable,
      role: role ?? (title ? 'graphics-symbol img' : 'none'),
      width: String(size),
      height: String(size),
      fill: "currentColor",
      viewBox: "0 0 24 24",
      children: (Number(size) === 16 || Number(size) === 24 || Number(size) === 32) && /*#__PURE__*/jsx(Fragment, {
        children: /*#__PURE__*/jsx("path", {
          fillRule: "evenodd",
          d: "M9.707 6.707 5.414 11h13.172l-4.293-4.293 1.414-1.414 5.993 5.993a1.01 1.01 0 0 1 0 1.428l-5.993 5.993-1.414-1.414L18.586 13H5.414l4.293 4.293-1.414 1.414L2.3 12.714a1.01 1.01 0 0 1 0-1.428l5.993-5.993z",
          clipRule: "evenodd"
        })
      })
    })
  });
};

const CrossCircleFill = ({
  className = undefined,
  isFocusable = false,
  filled = undefined,
  title = undefined,
  role = undefined,
  size = 16,
  ...restProps
}) => {
  if (filled) {
    console.warn("<CrossCircleFill filled /> is now deprecated, please use <CrossCircleFillFill /> or refer to https://transferwise.github.io/icons/ for more info.");
  }
  return /*#__PURE__*/jsx("span", {
    className: `tw-icon tw-icon-cross-circle-fill ${className ? className : ''}`,
    "data-testid": restProps['data-testid'] || 'cross-circle-fill-icon',
    children: /*#__PURE__*/jsx("svg", {
      "aria-label": title,
      "aria-hidden": !title ? true : undefined,
      focusable: isFocusable,
      role: role ?? (title ? 'graphics-symbol img' : 'none'),
      width: String(size),
      height: String(size),
      fill: "currentColor",
      viewBox: "0 0 24 24",
      children: (Number(size) === 16 || Number(size) === 24 || Number(size) === 32) && /*#__PURE__*/jsx(Fragment, {
        children: /*#__PURE__*/jsx("path", {
          fillRule: "evenodd",
          d: "M12 22c5.523 0 10-4.477 10-10S17.523 2 12 2 2 6.477 2 12s4.477 10 10 10m-4.707-6.707L10.586 12 7.293 8.707l1.414-1.414L12 10.586l3.293-3.293 1.414 1.414L13.414 12l3.293 3.293-1.414 1.414L12 13.414l-3.293 3.293z",
          clipRule: "evenodd"
        })
      })
    })
  });
};

const CrossCircle = ({
  className = undefined,
  isFocusable = false,
  filled = undefined,
  title = undefined,
  role = undefined,
  size = 16,
  ...restProps
}) => {
  if (filled) {
    console.warn("<CrossCircle filled /> is now deprecated, please use <CrossCircleFill /> or refer to https://transferwise.github.io/icons/ for more info.");
  }
  return /*#__PURE__*/jsx("span", {
    className: `tw-icon tw-icon-cross-circle ${className ? className : ''}`,
    "data-testid": restProps['data-testid'] || 'cross-circle-icon',
    children: /*#__PURE__*/jsx("svg", {
      "aria-label": title,
      "aria-hidden": !title ? true : undefined,
      focusable: isFocusable,
      role: role ?? (title ? 'graphics-symbol img' : 'none'),
      width: String(size),
      height: String(size),
      fill: "currentColor",
      viewBox: "0 0 24 24",
      children: (Number(size) === 16 || Number(size) === 24 || Number(size) === 32) && /*#__PURE__*/jsx(Fragment, {
        children: /*#__PURE__*/jsx("path", {
          fillRule: "evenodd",
          d: "M4 12a8 8 0 1 1 16 0 8 8 0 0 1-16 0m8-10C6.477 2 2 6.477 2 12s4.477 10 10 10 10-4.477 10-10S17.523 2 12 2M7.293 15.293 10.586 12 7.293 8.707l1.414-1.414L12 10.586l3.293-3.293 1.414 1.414L13.414 12l3.293 3.293-1.414 1.414L12 13.414l-3.293 3.293z",
          clipRule: "evenodd"
        })
      })
    })
  });
};

const Cross = ({
  className = undefined,
  isFocusable = false,
  filled = undefined,
  title = undefined,
  role = undefined,
  size = 16,
  ...restProps
}) => {
  if (filled) {
    console.warn("<Cross filled /> is now deprecated, please use <CrossFill /> or refer to https://transferwise.github.io/icons/ for more info.");
  }
  return /*#__PURE__*/jsx("span", {
    className: `tw-icon tw-icon-cross ${className ? className : ''}`,
    "data-testid": restProps['data-testid'] || 'cross-icon',
    children: /*#__PURE__*/jsx("svg", {
      "aria-label": title,
      "aria-hidden": !title ? true : undefined,
      focusable: isFocusable,
      role: role ?? (title ? 'graphics-symbol img' : 'none'),
      width: String(size),
      height: String(size),
      fill: "currentColor",
      viewBox: "0 0 24 24",
      children: (Number(size) === 16 || Number(size) === 24 || Number(size) === 32) && /*#__PURE__*/jsx(Fragment, {
        children: /*#__PURE__*/jsx("path", {
          d: "m12 13.414-7.293 7.293-1.414-1.414L10.586 12 3.293 4.707l1.414-1.414L12 10.586l7.293-7.293 1.414 1.414L13.414 12l7.293 7.293-1.414 1.414z"
        })
      })
    })
  });
};

const CrystalBall = ({
  className = undefined,
  isFocusable = false,
  filled = undefined,
  title = undefined,
  role = undefined,
  size = 16,
  ...restProps
}) => {
  if (filled) {
    console.warn("<CrystalBall filled /> is now deprecated, please use <CrystalBallFill /> or refer to https://transferwise.github.io/icons/ for more info.");
  }
  return /*#__PURE__*/jsx("span", {
    className: `tw-icon tw-icon-crystal-ball ${className ? className : ''}`,
    "data-testid": restProps['data-testid'] || 'crystal-ball-icon',
    children: /*#__PURE__*/jsx("svg", {
      "aria-label": title,
      "aria-hidden": !title ? true : undefined,
      focusable: isFocusable,
      role: role ?? (title ? 'graphics-symbol img' : 'none'),
      width: String(size),
      height: String(size),
      fill: "currentColor",
      viewBox: "0 0 24 24",
      children: (Number(size) === 16 || Number(size) === 24 || Number(size) === 32) && /*#__PURE__*/jsx(Fragment, {
        children: /*#__PURE__*/jsx("path", {
          fillRule: "evenodd",
          d: "M12 4a6 6 0 1 0 0 12 6 6 0 0 0 0-12m4.454 12.647a8 8 0 1 0-8.908 0l-.005.012-1.474 3.98A1.01 1.01 0 0 0 7.014 22h9.972a1.01 1.01 0 0 0 .947-1.36l-1.474-3.98zM9.177 18l-.74 2h7.126l-.74-2zm5.729-8.75A3 3 0 0 0 12 7V5a5 5 0 0 1 4.842 3.75z",
          clipRule: "evenodd"
        })
      })
    })
  });
};

const Defrost = ({
  className = undefined,
  isFocusable = false,
  filled = undefined,
  title = undefined,
  role = undefined,
  size = 16,
  ...restProps
}) => {
  if (filled) {
    console.warn("<Defrost filled /> is now deprecated, please use <DefrostFill /> or refer to https://transferwise.github.io/icons/ for more info.");
  }
  return /*#__PURE__*/jsx("span", {
    className: `tw-icon tw-icon-defrost ${className ? className : ''}`,
    "data-testid": restProps['data-testid'] || 'defrost-icon',
    children: /*#__PURE__*/jsx("svg", {
      "aria-label": title,
      "aria-hidden": !title ? true : undefined,
      focusable: isFocusable,
      role: role ?? (title ? 'graphics-symbol img' : 'none'),
      width: String(size),
      height: String(size),
      fill: "currentColor",
      viewBox: "0 0 24 24",
      children: (Number(size) === 16 || Number(size) === 24 || Number(size) === 32) && /*#__PURE__*/jsx(Fragment, {
        children: /*#__PURE__*/jsx("path", {
          fillRule: "evenodd",
          d: "M7.76 3.65a6.23 6.23 0 0 0-.942 6.633l1.185 2.607a8.23 8.23 0 0 1-1.244 8.76l-1.518-1.3a6.23 6.23 0 0 0 .941-6.633L4.997 11.11a8.23 8.23 0 0 1 1.244-8.76zm5.058 6.633a6.23 6.23 0 0 1 .941-6.632l-1.518-1.302a8.23 8.23 0 0 0-1.244 8.761l1.185 2.607a6.23 6.23 0 0 1-.941 6.632l1.518 1.302a8.23 8.23 0 0 0 1.244-8.761zm6 0a6.23 6.23 0 0 1 .941-6.632l-1.518-1.302a8.23 8.23 0 0 0-1.244 8.761l1.185 2.607a6.23 6.23 0 0 1-.941 6.632l1.518 1.302a8.23 8.23 0 0 0 1.244-8.761z",
          clipRule: "evenodd"
        })
      })
    })
  });
};

const Delivery = ({
  className = undefined,
  isFocusable = false,
  filled = undefined,
  title = undefined,
  role = undefined,
  size = 16,
  ...restProps
}) => {
  if (filled) {
    console.warn("<Delivery filled /> is now deprecated, please use <DeliveryFill /> or refer to https://transferwise.github.io/icons/ for more info.");
  }
  return /*#__PURE__*/jsx("span", {
    className: `tw-icon tw-icon-delivery ${className ? className : ''}`,
    "data-testid": restProps['data-testid'] || 'delivery-icon',
    children: /*#__PURE__*/jsx("svg", {
      "aria-label": title,
      "aria-hidden": !title ? true : undefined,
      focusable: isFocusable,
      role: role ?? (title ? 'graphics-symbol img' : 'none'),
      width: String(size),
      height: String(size),
      fill: "currentColor",
      viewBox: "0 0 24 24",
      children: (Number(size) === 16 || Number(size) === 24 || Number(size) === 32) && /*#__PURE__*/jsx(Fragment, {
        children: /*#__PURE__*/jsx("path", {
          fillRule: "evenodd",
          d: "M4 16V6h11v8.42A3 3 0 0 0 13.272 16h-3.56a3 3 0 0 0-5.455 0zm9.095 2H9.89a3.001 3.001 0 0 1-5.811 0H3.01A1.01 1.01 0 0 1 2 16.99V5.01C2 4.452 2.452 4 3.01 4h12.98c.558 0 1.01.452 1.01 1.01V7h1.995c.32 0 .621.152.811.409l1.995 2.693c.13.174.199.385.199.601V16a2 2 0 0 1-2 2h-1.094a3.001 3.001 0 0 1-5.811 0m5.633-2H20v-4.97L18.496 9H17v5.42A3 3 0 0 1 18.728 16M6.984 18.25A1 1 0 0 1 6 17.426v-.352a1 1 0 1 1 .984 1.176m8.016-1a1 1 0 1 1 2 0 1 1 0 0 1-2 0",
          clipRule: "evenodd"
        })
      })
    })
  });
};

const Dial = ({
  className = undefined,
  isFocusable = false,
  filled = undefined,
  title = undefined,
  role = undefined,
  size = 16,
  ...restProps
}) => {
  if (filled) {
    console.warn("<Dial filled /> is now deprecated, please use <DialFill /> or refer to https://transferwise.github.io/icons/ for more info.");
  }
  return /*#__PURE__*/jsx("span", {
    className: `tw-icon tw-icon-dial ${className ? className : ''}`,
    "data-testid": restProps['data-testid'] || 'dial-icon',
    children: /*#__PURE__*/jsx("svg", {
      "aria-label": title,
      "aria-hidden": !title ? true : undefined,
      focusable: isFocusable,
      role: role ?? (title ? 'graphics-symbol img' : 'none'),
      width: String(size),
      height: String(size),
      fill: "currentColor",
      viewBox: "0 0 24 24",
      children: (Number(size) === 16 || Number(size) === 24 || Number(size) === 32) && /*#__PURE__*/jsx(Fragment, {
        children: /*#__PURE__*/jsx("path", {
          fillRule: "evenodd",
          d: "M6 3a2 2 0 1 0 0 4 2 2 0 0 0 0-4m0 5a2 2 0 1 0 0 4 2 2 0 0 0 0-4m-2 7a2 2 0 1 1 4 0 2 2 0 0 1-4 0m8-12a2 2 0 1 0 0 4 2 2 0 0 0 0-4m-2 7a2 2 0 1 1 4 0 2 2 0 0 1-4 0m2 3a2 2 0 1 0 0 4 2 2 0 0 0 0-4m-2 7a2 2 0 1 1 4 0 2 2 0 0 1-4 0m8-17a2 2 0 1 0 0 4 2 2 0 0 0 0-4m-2 7a2 2 0 1 1 4 0 2 2 0 0 1-4 0m2 3a2 2 0 1 0 0 4 2 2 0 0 0 0-4",
          clipRule: "evenodd"
        })
      })
    })
  });
};

const PinCode = ({
  className = undefined,
  isFocusable = false,
  filled = undefined,
  title = undefined,
  role = undefined,
  size = 16,
  ...restProps
}) => {
  if (filled) {
    console.warn("<PinCode filled /> is now deprecated, please use <PinCodeFill /> or refer to https://transferwise.github.io/icons/ for more info.");
  }
  return /*#__PURE__*/jsx("span", {
    className: `tw-icon tw-icon-pin-code ${className ? className : ''}`,
    "data-testid": restProps['data-testid'] || 'pin-code-icon',
    children: /*#__PURE__*/jsx("svg", {
      "aria-label": title,
      "aria-hidden": !title ? true : undefined,
      focusable: isFocusable,
      role: role ?? (title ? 'graphics-symbol img' : 'none'),
      width: String(size),
      height: String(size),
      fill: "currentColor",
      viewBox: "0 0 24 24",
      children: (Number(size) === 16 || Number(size) === 24 || Number(size) === 32) && /*#__PURE__*/jsx(Fragment, {
        children: /*#__PURE__*/jsx("path", {
          fillRule: "evenodd",
          d: "M6 3a2 2 0 1 0 0 4 2 2 0 0 0 0-4m0 5a2 2 0 1 0 0 4 2 2 0 0 0 0-4m-2 7a2 2 0 1 1 4 0 2 2 0 0 1-4 0m8-12a2 2 0 1 0 0 4 2 2 0 0 0 0-4m-2 7a2 2 0 1 1 4 0 2 2 0 0 1-4 0m2 3a2 2 0 1 0 0 4 2 2 0 0 0 0-4m-2 7a2 2 0 1 1 4 0 2 2 0 0 1-4 0m8-17a2 2 0 1 0 0 4 2 2 0 0 0 0-4m-2 7a2 2 0 1 1 4 0 2 2 0 0 1-4 0m2 3a2 2 0 1 0 0 4 2 2 0 0 0 0-4",
          clipRule: "evenodd"
        })
      })
    })
  });
};

const DirectDebits = ({
  className = undefined,
  isFocusable = false,
  filled = undefined,
  title = undefined,
  role = undefined,
  size = 16,
  ...restProps
}) => {
  if (filled) {
    console.warn("<DirectDebits filled /> is now deprecated, please use <DirectDebitsFill /> or refer to https://transferwise.github.io/icons/ for more info.");
  }
  return /*#__PURE__*/jsx("span", {
    className: `tw-icon tw-icon-direct-debits ${className ? className : ''}`,
    "data-testid": restProps['data-testid'] || 'direct-debits-icon',
    children: /*#__PURE__*/jsx("svg", {
      "aria-label": title,
      "aria-hidden": !title ? true : undefined,
      focusable: isFocusable,
      role: role ?? (title ? 'graphics-symbol img' : 'none'),
      width: String(size),
      height: String(size),
      fill: "currentColor",
      viewBox: "0 0 24 24",
      children: (Number(size) === 16 || Number(size) === 24 || Number(size) === 32) && /*#__PURE__*/jsx(Fragment, {
        children: /*#__PURE__*/jsx("path", {
          fillRule: "evenodd",
          d: "M17.556 3.685A10 10 0 0 0 2 12h2a8 8 0 0 1 14.928-4H15v2h5.99A1.01 1.01 0 0 0 22 8.99V3h-2v3a10 10 0 0 0-2.444-2.315M2 21v-5.99c0-.558.452-1.01 1.01-1.01H9v2H5.072A8 8 0 0 0 20 12h2a10 10 0 0 1-18 6v3z",
          clipRule: "evenodd"
        })
      })
    })
  });
};

const DiscoBall = ({
  className = undefined,
  isFocusable = false,
  filled = undefined,
  title = undefined,
  role = undefined,
  size = 16,
  ...restProps
}) => {
  if (filled) {
    console.warn("<DiscoBall filled /> is now deprecated, please use <DiscoBallFill /> or refer to https://transferwise.github.io/icons/ for more info.");
  }
  return /*#__PURE__*/jsx("span", {
    className: `tw-icon tw-icon-disco-ball ${className ? className : ''}`,
    "data-testid": restProps['data-testid'] || 'disco-ball-icon',
    children: /*#__PURE__*/jsx("svg", {
      "aria-label": title,
      "aria-hidden": !title ? true : undefined,
      focusable: isFocusable,
      role: role ?? (title ? 'graphics-symbol img' : 'none'),
      width: String(size),
      height: String(size),
      fill: "currentColor",
      viewBox: "0 0 24 24",
      children: (Number(size) === 16 || Number(size) === 24 || Number(size) === 32) && /*#__PURE__*/jsx(Fragment, {
        children: /*#__PURE__*/jsx("path", {
          fillRule: "evenodd",
          d: "M9 2h6v2h-2.998a9 9 0 1 1 .004 18 9 9 0 0 1-.008-18H9zm6.845 16.85A7 7 0 0 0 18.929 14h-1.958c-.107 1.827-.506 3.509-1.126 4.85M14.967 14c-.111 1.673-.497 3.137-1.033 4.21-.306.611-.626 1.037-.934 1.32V14zm2.004-2h1.958a7 7 0 0 0-3.084-4.85c.62 1.341 1.019 3.023 1.126 4.85M13 6.47c.308.283.628.709.934 1.32.536 1.073.922 2.537 1.033 4.21H13zm-4.845.68A7 7 0 0 0 5.071 12h1.958c.107-1.827.506-3.509 1.126-4.85M9.033 12c.111-1.673.497-3.137 1.033-4.21.306-.611.626-1.037.934-1.32V12zm0 2H11v5.53c-.308-.283-.628-.709-.934-1.32-.536-1.073-.922-2.537-1.033-4.21m-2.004 0c.107 1.827.506 3.509 1.126 4.85A7 7 0 0 1 5.071 14zM4.5 3l.742.758L6 4.5l-.758.742L4.5 6l-.742-.758L3 4.5l.758-.742zm16.743 16.758L20.5 19l-.742.758L19 20.5l.758.742.742.758.742-.758L22 20.5z",
          clipRule: "evenodd"
        })
      })
    })
  });
};

const Document = ({
  className = undefined,
  isFocusable = false,
  filled = undefined,
  title = undefined,
  role = undefined,
  size = 16,
  ...restProps
}) => {
  if (filled) {
    console.warn("<Document filled /> is now deprecated, please use <DocumentFill /> or refer to https://transferwise.github.io/icons/ for more info.");
  }
  return /*#__PURE__*/jsx("span", {
    className: `tw-icon tw-icon-document ${className ? className : ''}`,
    "data-testid": restProps['data-testid'] || 'document-icon',
    children: /*#__PURE__*/jsx("svg", {
      "aria-label": title,
      "aria-hidden": !title ? true : undefined,
      focusable: isFocusable,
      role: role ?? (title ? 'graphics-symbol img' : 'none'),
      width: String(size),
      height: String(size),
      fill: "currentColor",
      viewBox: "0 0 24 24",
      children: (Number(size) === 16 || Number(size) === 24 || Number(size) === 32) && /*#__PURE__*/jsx(Fragment, {
        children: /*#__PURE__*/jsx("path", {
          fillRule: "evenodd",
          d: "M6 2a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V9.362a2 2 0 0 0-.464-1.28L15.068 2.72A2 2 0 0 0 13.532 2zm6 2H6v16h12V10h-4.99A1.01 1.01 0 0 1 12 8.99zm4.865 4L14 4.562V8z",
          clipRule: "evenodd"
        })
      })
    })
  });
};

const Documents = ({
  className = undefined,
  isFocusable = false,
  filled = undefined,
  title = undefined,
  role = undefined,
  size = 16,
  ...restProps
}) => {
  if (filled) {
    console.warn("<Documents filled /> is now deprecated, please use <DocumentsFill /> or refer to https://transferwise.github.io/icons/ for more info.");
  }
  return /*#__PURE__*/jsx("span", {
    className: `tw-icon tw-icon-documents ${className ? className : ''}`,
    "data-testid": restProps['data-testid'] || 'documents-icon',
    children: /*#__PURE__*/jsx("svg", {
      "aria-label": title,
      "aria-hidden": !title ? true : undefined,
      focusable: isFocusable,
      role: role ?? (title ? 'graphics-symbol img' : 'none'),
      width: String(size),
      height: String(size),
      fill: "currentColor",
      viewBox: "0 0 24 24",
      children: (Number(size) === 16 || Number(size) === 24 || Number(size) === 32) && /*#__PURE__*/jsx(Fragment, {
        children: /*#__PURE__*/jsx("path", {
          fillRule: "evenodd",
          d: "M8 4a2 2 0 0 1 2-2h4.364a2 2 0 0 1 1.488.664l3.636 4.05A2 2 0 0 1 20 8.05V16a2 2 0 0 1-2 2h-8a2 2 0 0 1-2-2zm5 0h-3v12h8V9h-3.99A1.01 1.01 0 0 1 13 7.99zm2 .709V7h2.057zM4 18V5h2v13a2 2 0 0 0 2 2h9v2H8a4 4 0 0 1-4-4",
          clipRule: "evenodd"
        })
      })
    })
  });
};

const Download = ({
  className = undefined,
  isFocusable = false,
  filled = undefined,
  title = undefined,
  role = undefined,
  size = 16,
  ...restProps
}) => {
  if (filled) {
    console.warn("<Download filled /> is now deprecated, please use <DownloadFill /> or refer to https://transferwise.github.io/icons/ for more info.");
  }
  return /*#__PURE__*/jsx("span", {
    className: `tw-icon tw-icon-download ${className ? className : ''}`,
    "data-testid": restProps['data-testid'] || 'download-icon',
    children: /*#__PURE__*/jsx("svg", {
      "aria-label": title,
      "aria-hidden": !title ? true : undefined,
      focusable: isFocusable,
      role: role ?? (title ? 'graphics-symbol img' : 'none'),
      width: String(size),
      height: String(size),
      fill: "currentColor",
      viewBox: "0 0 24 24",
      children: (Number(size) === 16 || Number(size) === 24 || Number(size) === 32) && /*#__PURE__*/jsx(Fragment, {
        children: /*#__PURE__*/jsx("path", {
          fillRule: "evenodd",
          d: "M13 2v12.586l4.293-4.293 1.414 1.414-5.993 5.993a1.01 1.01 0 0 1-1.428 0l-5.993-5.993 1.414-1.414L11 14.586V2zM4 22h16v-2H4z",
          clipRule: "evenodd"
        })
      })
    })
  });
};

const EatingOut = ({
  className = undefined,
  isFocusable = false,
  filled = undefined,
  title = undefined,
  role = undefined,
  size = 16,
  ...restProps
}) => {
  if (filled) {
    console.warn("<EatingOut filled /> is now deprecated, please use <EatingOutFill /> or refer to https://transferwise.github.io/icons/ for more info.");
  }
  return /*#__PURE__*/jsx("span", {
    className: `tw-icon tw-icon-eating-out ${className ? className : ''}`,
    "data-testid": restProps['data-testid'] || 'eating-out-icon',
    children: /*#__PURE__*/jsx("svg", {
      "aria-label": title,
      "aria-hidden": !title ? true : undefined,
      focusable: isFocusable,
      role: role ?? (title ? 'graphics-symbol img' : 'none'),
      width: String(size),
      height: String(size),
      fill: "currentColor",
      viewBox: "0 0 24 24",
      children: (Number(size) === 16 || Number(size) === 24 || Number(size) === 32) && /*#__PURE__*/jsx(Fragment, {
        children: /*#__PURE__*/jsx("path", {
          fillRule: "evenodd",
          d: "M19.99 9h-3.576l4.793-4.793-1.414-1.414L13.586 9h-2.672l4.793-4.793-1.414-1.414L8.086 9H4.01C3.42 9 3 9.486 3 10.011c.003 3.219 1.203 5.224 2.514 6.422A7 7 0 0 0 7.5 17.71v2.279c0 .558.452 1.01 1.01 1.01h6.98a1.01 1.01 0 0 0 1.01-1.01V17.71a7 7 0 0 0 1.986-1.278c1.31-1.198 2.511-3.203 2.514-6.422A1.01 1.01 0 0 0 19.99 9M5.049 11c.207 2.044 1.037 3.246 1.814 3.956.92.841 1.851 1.067 1.861 1.07a1.01 1.01 0 0 1 .772.889c.004.049.004.09.004.093V19h5v-1.992c0-.003 0-.044.004-.093a1.01 1.01 0 0 1 .772-.89c.01-.002.94-.228 1.861-1.069.777-.71 1.607-1.912 1.814-3.956z",
          clipRule: "evenodd"
        })
      })
    })
  });
};

const Edit = ({
  className = undefined,
  isFocusable = false,
  filled = undefined,
  title = undefined,
  role = undefined,
  size = 16,
  ...restProps
}) => {
  if (filled) {
    console.warn("<Edit filled /> is now deprecated, please use <EditFill /> or refer to https://transferwise.github.io/icons/ for more info.");
  }
  return /*#__PURE__*/jsx("span", {
    className: `tw-icon tw-icon-edit ${className ? className : ''}`,
    "data-testid": restProps['data-testid'] || 'edit-icon',
    children: /*#__PURE__*/jsx("svg", {
      "aria-label": title,
      "aria-hidden": !title ? true : undefined,
      focusable: isFocusable,
      role: role ?? (title ? 'graphics-symbol img' : 'none'),
      width: String(size),
      height: String(size),
      fill: "currentColor",
      viewBox: "0 0 24 24",
      children: (Number(size) === 16 || Number(size) === 24 || Number(size) === 32) && /*#__PURE__*/jsx(Fragment, {
        children: /*#__PURE__*/jsx("path", {
          fillRule: "evenodd",
          d: "M15.707 5.707a1.828 1.828 0 0 1 2.586 2.586l-.793.793L14.914 6.5zM13.5 7.914l-8.5 8.5V19h2.586l8.5-8.5zm6.207-3.621a3.83 3.83 0 0 0-5.414 0L3.296 15.29a1 1 0 0 0-.296.714v3.986c0 .558.452 1.01 1.01 1.01h3.986c.268 0 .525-.107.714-.296L19.707 9.707a3.83 3.83 0 0 0 0-5.414",
          clipRule: "evenodd"
        })
      })
    })
  });
};

const EmailAndMobile = ({
  className = undefined,
  isFocusable = false,
  filled = undefined,
  title = undefined,
  role = undefined,
  size = 16,
  ...restProps
}) => {
  if (filled) {
    console.warn("<EmailAndMobile filled /> is now deprecated, please use <EmailAndMobileFill /> or refer to https://transferwise.github.io/icons/ for more info.");
  }
  return /*#__PURE__*/jsx("span", {
    className: `tw-icon tw-icon-email-and-mobile ${className ? className : ''}`,
    "data-testid": restProps['data-testid'] || 'email-and-mobile-icon',
    children: /*#__PURE__*/jsx("svg", {
      "aria-label": title,
      "aria-hidden": !title ? true : undefined,
      focusable: isFocusable,
      role: role ?? (title ? 'graphics-symbol img' : 'none'),
      width: String(size),
      height: String(size),
      fill: "currentColor",
      viewBox: "0 0 24 24",
      children: (Number(size) === 16 || Number(size) === 24 || Number(size) === 32) && /*#__PURE__*/jsx(Fragment, {
        children: /*#__PURE__*/jsx("path", {
          fillRule: "evenodd",
          d: "M10 3a2 2 0 0 0-2 2v5H5a2 2 0 0 0-2 2v7a2 2 0 0 0 2 2h13a2 2 0 0 0 2-2V5a2 2 0 0 0-2-2zm3.3 9-3.8 2.764L5.7 12zM5 13.964V19h9v-5.036l-3.908 2.842a1.01 1.01 0 0 1-1.184 0zM16 12v7h2V5h-2v1h-4V5h-2v5h4a2 2 0 0 1 2 2",
          clipRule: "evenodd"
        })
      })
    })
  });
};

const EmailAndPhone = ({
  className = undefined,
  isFocusable = false,
  filled = undefined,
  title = undefined,
  role = undefined,
  size = 16,
  ...restProps
}) => {
  if (filled) {
    console.warn("<EmailAndPhone filled /> is now deprecated, please use <EmailAndPhoneFill /> or refer to https://transferwise.github.io/icons/ for more info.");
  }
  return /*#__PURE__*/jsx("span", {
    className: `tw-icon tw-icon-email-and-phone ${className ? className : ''}`,
    "data-testid": restProps['data-testid'] || 'email-and-phone-icon',
    children: /*#__PURE__*/jsx("svg", {
      "aria-label": title,
      "aria-hidden": !title ? true : undefined,
      focusable: isFocusable,
      role: role ?? (title ? 'graphics-symbol img' : 'none'),
      width: String(size),
      height: String(size),
      fill: "currentColor",
      viewBox: "0 0 24 24",
      children: (Number(size) === 16 || Number(size) === 24 || Number(size) === 32) && /*#__PURE__*/jsx(Fragment, {
        children: /*#__PURE__*/jsx("path", {
          fillRule: "evenodd",
          d: "M10 3a2 2 0 0 0-2 2v5H5a2 2 0 0 0-2 2v7a2 2 0 0 0 2 2h13a2 2 0 0 0 2-2V5a2 2 0 0 0-2-2zm3.3 9-3.8 2.764L5.7 12zM5 13.964V19h9v-5.036l-3.908 2.842a1.01 1.01 0 0 1-1.184 0zM16 12v7h2V5h-2v1h-4V5h-2v5h4a2 2 0 0 1 2 2",
          clipRule: "evenodd"
        })
      })
    })
  });
};

const Email = ({
  className = undefined,
  isFocusable = false,
  filled = undefined,
  title = undefined,
  role = undefined,
  size = 16,
  ...restProps
}) => {
  if (filled) {
    console.warn("<Email filled /> is now deprecated, please use <EmailFill /> or refer to https://transferwise.github.io/icons/ for more info.");
  }
  return /*#__PURE__*/jsx("span", {
    className: `tw-icon tw-icon-email ${className ? className : ''}`,
    "data-testid": restProps['data-testid'] || 'email-icon',
    children: /*#__PURE__*/jsx("svg", {
      "aria-label": title,
      "aria-hidden": !title ? true : undefined,
      focusable: isFocusable,
      role: role ?? (title ? 'graphics-symbol img' : 'none'),
      width: String(size),
      height: String(size),
      fill: "currentColor",
      viewBox: "0 0 24 24",
      children: (Number(size) === 16 || Number(size) === 24 || Number(size) === 32) && /*#__PURE__*/jsx(Fragment, {
        children: /*#__PURE__*/jsx("path", {
          fillRule: "evenodd",
          d: "M4 4a2 2 0 0 0-2 2v12a2 2 0 0 0 2 2h16a2 2 0 0 0 2-2V6a2 2 0 0 0-2-2zm15.9 2H4.1l7.9 4.828zM4 8.283V18h16V8.283l-7.473 4.567a1.01 1.01 0 0 1-1.054 0z",
          clipRule: "evenodd"
        })
      })
    })
  });
};

const Entertainment = ({
  className = undefined,
  isFocusable = false,
  filled = undefined,
  title = undefined,
  role = undefined,
  size = 16,
  ...restProps
}) => {
  if (filled) {
    console.warn("<Entertainment filled /> is now deprecated, please use <EntertainmentFill /> or refer to https://transferwise.github.io/icons/ for more info.");
  }
  return /*#__PURE__*/jsx("span", {
    className: `tw-icon tw-icon-entertainment ${className ? className : ''}`,
    "data-testid": restProps['data-testid'] || 'entertainment-icon',
    children: /*#__PURE__*/jsx("svg", {
      "aria-label": title,
      "aria-hidden": !title ? true : undefined,
      focusable: isFocusable,
      role: role ?? (title ? 'graphics-symbol img' : 'none'),
      width: String(size),
      height: String(size),
      fill: "currentColor",
      viewBox: "0 0 24 24",
      children: (Number(size) === 16 || Number(size) === 24 || Number(size) === 32) && /*#__PURE__*/jsx(Fragment, {
        children: /*#__PURE__*/jsx("path", {
          fillRule: "evenodd",
          d: "M3.01 4A1.01 1.01 0 0 0 2 5.01v1.872c0 .759.42 1.356.817 1.72C3.215 8.97 4 9.93 4 12s-.785 3.031-1.183 3.398c-.396.364-.817.961-.817 1.72v1.872c0 .558.452 1.01 1.01 1.01h17.98A1.01 1.01 0 0 0 22 18.99V17c0-.632-.294-1.166-.65-1.533C20.883 14.983 20 13.832 20 12s.882-2.983 1.35-3.467c.356-.367.65-.9.65-1.533V5.01A1.01 1.01 0 0 0 20.99 4zM4 6.882V6h16v1.002l-.001.006-.01.03a.4.4 0 0 1-.075.103C19.228 7.851 18 9.474 18 12s1.228 4.15 1.914 4.858a.4.4 0 0 1 .074.104l.012.036V18H4v-.882a.2.2 0 0 1 .025-.068.7.7 0 0 1 .146-.18C4.958 16.145 6 14.66 6 12S4.958 7.854 4.171 7.13a.7.7 0 0 1-.146-.18A.2.2 0 0 1 4 6.882M13 8h-2v8h2z",
          clipRule: "evenodd"
        })
      })
    })
  });
};

const Equals = ({
  className = undefined,
  isFocusable = false,
  filled = undefined,
  title = undefined,
  role = undefined,
  size = 16,
  ...restProps
}) => {
  if (filled) {
    console.warn("<Equals filled /> is now deprecated, please use <EqualsFill /> or refer to https://transferwise.github.io/icons/ for more info.");
  }
  return /*#__PURE__*/jsx("span", {
    className: `tw-icon tw-icon-equals ${className ? className : ''}`,
    "data-testid": restProps['data-testid'] || 'equals-icon',
    children: /*#__PURE__*/jsx("svg", {
      "aria-label": title,
      "aria-hidden": !title ? true : undefined,
      focusable: isFocusable,
      role: role ?? (title ? 'graphics-symbol img' : 'none'),
      width: String(size),
      height: String(size),
      fill: "currentColor",
      viewBox: "0 0 24 24",
      children: (Number(size) === 16 || Number(size) === 24 || Number(size) === 32) && /*#__PURE__*/jsx(Fragment, {
        children: /*#__PURE__*/jsx("path", {
          fillRule: "evenodd",
          d: "M2 10h20V8H2zm0 6h20v-2H2z",
          clipRule: "evenodd"
        })
      })
    })
  });
};

const Expand = ({
  className = undefined,
  isFocusable = false,
  filled = undefined,
  title = undefined,
  role = undefined,
  size = 16,
  ...restProps
}) => {
  if (filled) {
    console.warn("<Expand filled /> is now deprecated, please use <ExpandFill /> or refer to https://transferwise.github.io/icons/ for more info.");
  }
  return /*#__PURE__*/jsx("span", {
    className: `tw-icon tw-icon-expand ${className ? className : ''}`,
    "data-testid": restProps['data-testid'] || 'expand-icon',
    children: /*#__PURE__*/jsx("svg", {
      "aria-label": title,
      "aria-hidden": !title ? true : undefined,
      focusable: isFocusable,
      role: role ?? (title ? 'graphics-symbol img' : 'none'),
      width: String(size),
      height: String(size),
      fill: "currentColor",
      viewBox: "0 0 24 24",
      children: (Number(size) === 16 || Number(size) === 24 || Number(size) === 32) && /*#__PURE__*/jsx(Fragment, {
        children: /*#__PURE__*/jsx("path", {
          fillRule: "evenodd",
          d: "M17.293 9.707 12 4.414 6.707 9.707 5.293 8.293 11.286 2.3a1.01 1.01 0 0 1 1.428 0l5.993 5.993zm0 4.586L12 19.586l-5.293-5.293-1.414 1.414 5.993 5.993a1.01 1.01 0 0 0 1.428 0l5.993-5.993z",
          clipRule: "evenodd"
        })
      })
    })
  });
};

const EyeShut = ({
  className = undefined,
  isFocusable = false,
  filled = undefined,
  title = undefined,
  role = undefined,
  size = 16,
  ...restProps
}) => {
  if (filled) {
    console.warn("<EyeShut filled /> is now deprecated, please use <EyeShutFill /> or refer to https://transferwise.github.io/icons/ for more info.");
  }
  return /*#__PURE__*/jsx("span", {
    className: `tw-icon tw-icon-eye-shut ${className ? className : ''}`,
    "data-testid": restProps['data-testid'] || 'eye-shut-icon',
    children: /*#__PURE__*/jsx("svg", {
      "aria-label": title,
      "aria-hidden": !title ? true : undefined,
      focusable: isFocusable,
      role: role ?? (title ? 'graphics-symbol img' : 'none'),
      width: String(size),
      height: String(size),
      fill: "currentColor",
      viewBox: "0 0 24 24",
      children: (Number(size) === 16 || Number(size) === 24 || Number(size) === 32) && /*#__PURE__*/jsx(Fragment, {
        children: /*#__PURE__*/jsx("path", {
          fillRule: "evenodd",
          d: "M12.348 14.4c3.286-.178 5.52-2.854 6.859-4.6l1.586 1.218a27 27 0 0 1-1.078 1.333l1.702 1.701-1.415 1.415-1.688-1.689a12 12 0 0 1-1.802 1.34l1.01 1.75-1.733 1-1.097-1.902A8.4 8.4 0 0 1 13 16.35v1.988h-2V16.35a8.4 8.4 0 0 1-1.928-.467l-1.146 1.984-1.732-1 1.084-1.878a12 12 0 0 1-1.627-1.241l-1.559 1.559-1.414-1.415 1.577-1.576a26 26 0 0 1-1.048-1.298l1.586-1.217c1.34 1.745 3.573 4.42 6.859 4.6z",
          clipRule: "evenodd"
        })
      })
    })
  });
};

const Eye = ({
  className = undefined,
  isFocusable = false,
  filled = undefined,
  title = undefined,
  role = undefined,
  size = 16,
  ...restProps
}) => {
  if (filled) {
    console.warn("<Eye filled /> is now deprecated, please use <EyeFill /> or refer to https://transferwise.github.io/icons/ for more info.");
  }
  return /*#__PURE__*/jsx("span", {
    className: `tw-icon tw-icon-eye ${className ? className : ''}`,
    "data-testid": restProps['data-testid'] || 'eye-icon',
    children: /*#__PURE__*/jsx("svg", {
      "aria-label": title,
      "aria-hidden": !title ? true : undefined,
      focusable: isFocusable,
      role: role ?? (title ? 'graphics-symbol img' : 'none'),
      width: String(size),
      height: String(size),
      fill: "currentColor",
      viewBox: "0 0 24 24",
      children: (Number(size) === 16 || Number(size) === 24 || Number(size) === 32) && /*#__PURE__*/jsx(Fragment, {
        children: /*#__PURE__*/jsx("path", {
          fillRule: "evenodd",
          d: "M4.843 13.607C6.222 11.799 8.55 9 12 9s5.778 2.8 7.157 4.607l1.59-1.213C19.428 10.664 16.55 7 12 7s-7.428 3.665-8.747 5.393zM10 15a2 2 0 1 1 4 0 2 2 0 0 1-4 0m2-4a4 4 0 1 0 0 8 4 4 0 0 0 0-8",
          clipRule: "evenodd"
        })
      })
    })
  });
};

const FaceId = ({
  className = undefined,
  isFocusable = false,
  filled = undefined,
  title = undefined,
  role = undefined,
  size = 16,
  ...restProps
}) => {
  if (filled) {
    console.warn("<FaceId filled /> is now deprecated, please use <FaceIdFill /> or refer to https://transferwise.github.io/icons/ for more info.");
  }
  return /*#__PURE__*/jsx("span", {
    className: `tw-icon tw-icon-face-id ${className ? className : ''}`,
    "data-testid": restProps['data-testid'] || 'face-id-icon',
    children: /*#__PURE__*/jsx("svg", {
      "aria-label": title,
      "aria-hidden": !title ? true : undefined,
      focusable: isFocusable,
      role: role ?? (title ? 'graphics-symbol img' : 'none'),
      width: String(size),
      height: String(size),
      fill: "currentColor",
      viewBox: "0 0 24 24",
      children: (Number(size) === 16 || Number(size) === 24 || Number(size) === 32) && /*#__PURE__*/jsx(Fragment, {
        children: /*#__PURE__*/jsx("path", {
          fillRule: "evenodd",
          d: "M5.111 1A4.11 4.11 0 0 0 1 5.111V7a1 1 0 0 0 2 0V5.111A2.11 2.11 0 0 1 5.111 3H7a1 1 0 0 0 0-2zM7.93 16.293a1 1 0 0 1 1.41-.004l.002.002.026.024q.041.037.133.112a4 4 0 0 0 .549.371c.482.276 1.144.535 1.92.535s1.438-.259 1.92-.535a4.3 4.3 0 0 0 .682-.483l.026-.024.002-.002a1 1 0 0 1 1.41 1.418l-.002.002-.003.003-.007.007-.02.02-.066.06a6.3 6.3 0 0 1-1.03.736c-.684.391-1.688.798-2.912.798s-2.228-.407-2.913-.798a6.3 6.3 0 0 1-1.03-.736l-.064-.06-.021-.02-.007-.007-.004-.004c-.002-.001.004.004-.001 0a1 1 0 0 1 0-1.415M1 18.889A4.11 4.11 0 0 0 5.111 23H7a1 1 0 1 0 0-2H5.111A2.11 2.11 0 0 1 3 18.889V17a1 1 0 1 0-2 0zM18.889 1A4.11 4.11 0 0 1 23 5.111V7a1 1 0 1 1-2 0V5.111A2.11 2.11 0 0 0 18.889 3H17a1 1 0 1 1 0-2zM23 18.889A4.11 4.11 0 0 1 18.889 23H17a1 1 0 1 1 0-2h1.889A2.11 2.11 0 0 0 21 18.889V17a1 1 0 1 1 2 0zM16.97 9.11a1 1 0 1 0-2 0v1.334a1 1 0 0 0 2 0zm-9-1a1 1 0 0 1 1 1v1.333a1 1 0 1 1-2 0V9.111a1 1 0 0 1 1-1m5.666 1a1 1 0 1 0-2 0V13h-.334a1 1 0 0 0 0 2h.445a1.89 1.89 0 0 0 1.889-1.889z",
          clipRule: "evenodd"
        })
      })
    })
  });
};

const Facebook = ({
  className = undefined,
  isFocusable = false,
  filled = undefined,
  title = undefined,
  role = undefined,
  size = 16,
  ...restProps
}) => {
  if (filled) {
    console.warn("<Facebook filled /> is now deprecated, please use <FacebookFill /> or refer to https://transferwise.github.io/icons/ for more info.");
  }
  return /*#__PURE__*/jsx("span", {
    className: `tw-icon tw-icon-facebook ${className ? className : ''}`,
    "data-testid": restProps['data-testid'] || 'facebook-icon',
    children: /*#__PURE__*/jsx("svg", {
      "aria-label": title,
      "aria-hidden": !title ? true : undefined,
      focusable: isFocusable,
      role: role ?? (title ? 'graphics-symbol img' : 'none'),
      width: String(size),
      height: String(size),
      fill: "currentColor",
      viewBox: "0 0 24 24",
      children: (Number(size) === 16 || Number(size) === 24 || Number(size) === 32) && /*#__PURE__*/jsx(Fragment, {
        children: /*#__PURE__*/jsx("path", {
          d: "M12 1.715A10.26 10.26 0 0 0 1.714 12c0 5.142 3.772 9.385 8.657 10.157v-7.2H7.757V12h2.614V9.729c0-2.571 1.543-3.986 3.9-3.986 1.115 0 2.315.215 2.315.215v2.528H15.3c-1.286 0-1.672.772-1.672 1.586v1.929H16.5l-.472 2.957h-2.4v7.2c4.886-.772 8.658-5.015 8.658-10.157A10.26 10.26 0 0 0 12 1.715"
        })
      })
    })
  });
};

const FacebookSquare = ({
  className = undefined,
  isFocusable = false,
  filled = undefined,
  title = undefined,
  role = undefined,
  size = 16,
  ...restProps
}) => {
  if (filled) {
    console.warn("<FacebookSquare filled /> is now deprecated, please use <FacebookSquareFill /> or refer to https://transferwise.github.io/icons/ for more info.");
  }
  return /*#__PURE__*/jsx("span", {
    className: `tw-icon tw-icon-facebook-square ${className ? className : ''}`,
    "data-testid": restProps['data-testid'] || 'facebook-square-icon',
    children: /*#__PURE__*/jsx("svg", {
      "aria-label": title,
      "aria-hidden": !title ? true : undefined,
      focusable: isFocusable,
      role: role ?? (title ? 'graphics-symbol img' : 'none'),
      width: String(size),
      height: String(size),
      fill: "currentColor",
      viewBox: "0 0 24 24",
      children: (Number(size) === 16 || Number(size) === 24 || Number(size) === 32) && /*#__PURE__*/jsx(Fragment, {
        children: /*#__PURE__*/jsx("path", {
          d: "M12 1.715A10.26 10.26 0 0 0 1.714 12c0 5.142 3.772 9.385 8.657 10.157v-7.2H7.757V12h2.614V9.729c0-2.571 1.543-3.986 3.9-3.986 1.115 0 2.315.215 2.315.215v2.528H15.3c-1.286 0-1.672.772-1.672 1.586v1.929H16.5l-.472 2.957h-2.4v7.2c4.886-.772 8.658-5.015 8.658-10.157A10.26 10.26 0 0 0 12 1.715"
        })
      })
    })
  });
};

const FastFlag = ({
  className = undefined,
  isFocusable = false,
  filled = undefined,
  title = undefined,
  role = undefined,
  size = 16,
  ...restProps
}) => {
  if (filled) {
    console.warn("<FastFlag filled /> is now deprecated, please use <FastFlagFill /> or refer to https://transferwise.github.io/icons/ for more info.");
  }
  return /*#__PURE__*/jsx("span", {
    className: `tw-icon tw-icon-fast-flag ${className ? className : ''}`,
    "data-testid": restProps['data-testid'] || 'fast-flag-icon',
    children: /*#__PURE__*/jsx("svg", {
      "aria-label": title,
      "aria-hidden": !title ? true : undefined,
      focusable: isFocusable,
      role: role ?? (title ? 'graphics-symbol img' : 'none'),
      width: String(size),
      height: String(size),
      fill: "currentColor",
      viewBox: "0 0 24 24",
      children: (Number(size) === 16 || Number(size) === 24 || Number(size) === 32) && /*#__PURE__*/jsx(Fragment, {
        children: /*#__PURE__*/jsx("path", {
          d: "M1.875 15.28 7.35 8.838h-.002L4.02 3h18.105l-7.008 19.375h-3.97L16.95 6.3H9.463l1.665 2.883-.008.08-2.56 2.979h4.188l-1.098 3.037z"
        })
      })
    })
  });
};

const Female = ({
  className = undefined,
  isFocusable = false,
  filled = undefined,
  title = undefined,
  role = undefined,
  size = 16,
  ...restProps
}) => {
  if (filled) {
    console.warn("<Female filled /> is now deprecated, please use <FemaleFill /> or refer to https://transferwise.github.io/icons/ for more info.");
  }
  return /*#__PURE__*/jsx("span", {
    className: `tw-icon tw-icon-female ${className ? className : ''}`,
    "data-testid": restProps['data-testid'] || 'female-icon',
    children: /*#__PURE__*/jsx("svg", {
      "aria-label": title,
      "aria-hidden": !title ? true : undefined,
      focusable: isFocusable,
      role: role ?? (title ? 'graphics-symbol img' : 'none'),
      width: String(size),
      height: String(size),
      fill: "currentColor",
      viewBox: "0 0 24 24",
      children: (Number(size) === 16 || Number(size) === 24 || Number(size) === 32) && /*#__PURE__*/jsx(Fragment, {
        children: /*#__PURE__*/jsx("path", {
          fillRule: "evenodd",
          d: "M12 4a5 5 0 1 0 0 10 5 5 0 0 0 0-10M5 9a7 7 0 1 1 8 6.93V18h2v2h-2v2h-2v-2H9v-2h2v-2.07A7 7 0 0 1 5 9",
          clipRule: "evenodd"
        })
      })
    })
  });
};

const FidoPasskey = ({
  className = undefined,
  isFocusable = false,
  filled = undefined,
  title = undefined,
  role = undefined,
  size = 16,
  ...restProps
}) => {
  if (filled) {
    console.warn("<FidoPasskey filled /> is now deprecated, please use <FidoPasskeyFill /> or refer to https://transferwise.github.io/icons/ for more info.");
  }
  return /*#__PURE__*/jsx("span", {
    className: `tw-icon tw-icon-fido-passkey ${className ? className : ''}`,
    "data-testid": restProps['data-testid'] || 'fido-passkey-icon',
    children: /*#__PURE__*/jsx("svg", {
      "aria-label": title,
      "aria-hidden": !title ? true : undefined,
      focusable: isFocusable,
      role: role ?? (title ? 'graphics-symbol img' : 'none'),
      width: String(size),
      height: String(size),
      fill: "currentColor",
      viewBox: "0 0 24 24",
      children: (Number(size) === 16 || Number(size) === 24 || Number(size) === 32) && /*#__PURE__*/jsxs(Fragment, {
        children: [/*#__PURE__*/jsx("path", {
          fillRule: "evenodd",
          d: "M16.82 6.574c1.976-.01 3.578 1.673 3.578 3.729 0 1.637-1.006 3.025-2.403 3.533l.845 1.406-1.254 1.54 1.255 1.504L16.82 21l-1.425-1.522v-5.74c-1.264-.578-2.153-1.896-2.153-3.426 0-2.065 1.601-3.738 3.577-3.738m0 2.687c-.48 0-.863.4-.863.9 0 .489.383.898.863.898s.863-.4.863-.899c0-.498-.382-.899-.863-.899",
          clipRule: "evenodd"
        }), /*#__PURE__*/jsx("path", {
          d: "M12.166 10.347c0 1.602.738 3.186 2.056 4.067v1.3c0 .658-.525 1.192-1.175 1.192h-8.25c-.65 0-1.175-.534-1.175-1.192v-2.982c0-1.317 1.05-2.385 2.35-2.385zm-3.694-7.28c.623-.115 1.237-.089 1.843.134.899.338 1.504.979 1.78 1.922.284.952.24 1.914-.187 2.812-.445.944-1.21 1.451-2.19 1.647l-.24.053a3.4 3.4 0 0 1-.854 0c-.285-.053-.57-.107-.846-.222-1.023-.427-1.62-1.22-1.815-2.34-.134-.766-.071-1.532.24-2.244.445-1.023 1.228-1.575 2.27-1.762"
        })]
      })
    })
  });
};

const Fingerprint = ({
  className = undefined,
  isFocusable = false,
  filled = undefined,
  title = undefined,
  role = undefined,
  size = 16,
  ...restProps
}) => {
  if (filled) {
    console.warn("<Fingerprint filled /> is now deprecated, please use <FingerprintFill /> or refer to https://transferwise.github.io/icons/ for more info.");
  }
  return /*#__PURE__*/jsx("span", {
    className: `tw-icon tw-icon-fingerprint ${className ? className : ''}`,
    "data-testid": restProps['data-testid'] || 'fingerprint-icon',
    children: /*#__PURE__*/jsx("svg", {
      "aria-label": title,
      "aria-hidden": !title ? true : undefined,
      focusable: isFocusable,
      role: role ?? (title ? 'graphics-symbol img' : 'none'),
      width: String(size),
      height: String(size),
      fill: "currentColor",
      viewBox: "0 0 24 24",
      children: (Number(size) === 16 || Number(size) === 24 || Number(size) === 32) && /*#__PURE__*/jsx(Fragment, {
        children: /*#__PURE__*/jsx("path", {
          fillRule: "evenodd",
          d: "M8.939 4.609a8 8 0 0 1 8.718 1.734l.453.454a7.7 7.7 0 0 1 1.47 2.553c.407 1.175.513 2.357.308 3.31a2 2 0 0 1-3.67.248 2.2 2.2 0 0 1-.218-.962c-.016-.754-.366-1.692-.97-2.446C14.389 8.697 13.373 8 12 8c-1.27 0-2.301.486-3.004 1.272-.688.768-1.014 1.767-1.014 2.738 0 .849.143 2.773 1.187 4.773 1.062 2.033 3.028 4.089 6.556 5.17l.586-1.913c-2.99-.915-4.542-2.599-5.369-4.182a8.64 8.64 0 0 1-.96-3.848c0-.539.183-1.045.504-1.404.306-.342.785-.606 1.514-.606.628 0 1.112.303 1.47.75.382.478.53 1.013.53 1.25.008.6.15 1.255.436 1.816a4 4 0 0 0 7.368-.58l.014-.043.01-.044c.32-1.408.146-2.998-.359-4.454a9.7 9.7 0 0 0-1.706-3.044l.015-.015-.213-.213q-.292-.325-.615-.613A10 10 0 0 0 2 12v1h2v-1a8 8 0 0 1 4.939-7.391m3.058 6.374a1 1 0 0 1 1 1 5 5 0 0 0 6.068 4.885l.976-.213.428 1.953-.977.214a7 7 0 0 1-7.557-3.339 7 7 0 0 1-.938-3.5 1 1 0 0 1 1-1M12 5a7 7 0 0 0-7 7c0 5.376 2.913 8.318 4.193 9.612l.143.145.701.713 1.426-1.402-.7-.713-.134-.136C9.412 18.99 7 16.55 7 12a5 5 0 1 1 10 0 1 1 0 1 0 2 0 7 7 0 0 0-7-7",
          clipRule: "evenodd"
        })
      })
    })
  });
};

const Fpx = ({
  className = undefined,
  isFocusable = false,
  filled = undefined,
  title = undefined,
  role = undefined,
  size = 16,
  ...restProps
}) => {
  if (filled) {
    console.warn("<Fpx filled /> is now deprecated, please use <FpxFill /> or refer to https://transferwise.github.io/icons/ for more info.");
  }
  return /*#__PURE__*/jsx("span", {
    className: `tw-icon tw-icon-fpx ${className ? className : ''}`,
    "data-testid": restProps['data-testid'] || 'fpx-icon',
    children: /*#__PURE__*/jsx("svg", {
      "aria-label": title,
      "aria-hidden": !title ? true : undefined,
      focusable: isFocusable,
      role: role ?? (title ? 'graphics-symbol img' : 'none'),
      width: String(size),
      height: String(size),
      fill: "currentColor",
      viewBox: "0 0 24 24",
      children: (Number(size) === 16 || Number(size) === 24 || Number(size) === 32) && /*#__PURE__*/jsx(Fragment, {
        children: /*#__PURE__*/jsx("path", {
          fillRule: "evenodd",
          d: "m15.214 2.735 4.457 6c.124.172.265.355.412.545.618.8 1.346 1.742 1.346 2.712 0 .925-.74 1.878-1.366 2.683-.157.201-.306.394-.434.574l-4.458 6c-1.328 1.757-2.4 1.114-2.4-1.457v-3.215a1 1 0 0 0 .3-.3l2.1-2.785.126-.159c.299-.371.689-.856.689-1.341 0-.439-.32-.851-.601-1.216q-.116-.147-.214-.284l-2.057-2.786-.3-.3V4.192c0-2.615 1.072-3.257 2.4-1.457M8.871 13.492l2.057 2.785c.086.172.172.258.3.3v3.215c0 2.614-1.071 3.257-2.4 1.457l-4.457-6c-.128-.18-.278-.372-.434-.574-.625-.805-1.366-1.758-1.366-2.683 0-.97.728-1.911 1.346-2.712.147-.19.288-.372.411-.545l4.5-6c1.329-1.8 2.4-1.115 2.4 1.457v3.214a1 1 0 0 0-.3.3l-2.057 2.786-.126.158c-.298.372-.688.857-.688 1.342 0 .438.319.85.6 1.215q.117.148.214.285",
          clipRule: "evenodd"
        })
      })
    })
  });
};

const Freeze = ({
  className = undefined,
  isFocusable = false,
  filled = undefined,
  title = undefined,
  role = undefined,
  size = 16,
  ...restProps
}) => {
  if (filled) {
    console.warn("<Freeze filled /> is now deprecated, please use <FreezeFill /> or refer to https://transferwise.github.io/icons/ for more info.");
  }
  return /*#__PURE__*/jsx("span", {
    className: `tw-icon tw-icon-freeze ${className ? className : ''}`,
    "data-testid": restProps['data-testid'] || 'freeze-icon',
    children: /*#__PURE__*/jsx("svg", {
      "aria-label": title,
      "aria-hidden": !title ? true : undefined,
      focusable: isFocusable,
      role: role ?? (title ? 'graphics-symbol img' : 'none'),
      width: String(size),
      height: String(size),
      fill: "currentColor",
      viewBox: "0 0 24 24",
      children: (Number(size) === 16 || Number(size) === 24 || Number(size) === 32) && /*#__PURE__*/jsx(Fragment, {
        children: /*#__PURE__*/jsx("path", {
          fillRule: "evenodd",
          d: "M8.293 3.707 11 6.414v3.854L7.663 8.34l-.991-3.698-1.932.518.839 3.132-3.132.839.518 1.932 3.697-.991L10 12l-3.337 1.927-3.698-.991-.518 1.932 3.132.84-.84 3.131 1.933.518.99-3.698L11 13.732v3.854l-2.707 2.707 1.414 1.414L12 19.414l2.293 2.293 1.414-1.414L13 17.586v-3.854l3.337 1.927.991 3.698 1.932-.518-.839-3.132 3.132-.839-.518-1.932-3.697.99L14 12l3.337-1.927 3.698.991.518-1.932-3.132-.84.84-3.131-1.933-.518-.99 3.698L13 10.268V6.414l2.707-2.707-1.414-1.414L12 4.586 9.707 2.293z",
          clipRule: "evenodd"
        })
      })
    })
  });
};

const Gambling = ({
  className = undefined,
  isFocusable = false,
  filled = undefined,
  title = undefined,
  role = undefined,
  size = 16,
  ...restProps
}) => {
  if (filled) {
    console.warn("<Gambling filled /> is now deprecated, please use <GamblingFill /> or refer to https://transferwise.github.io/icons/ for more info.");
  }
  return /*#__PURE__*/jsx("span", {
    className: `tw-icon tw-icon-gambling ${className ? className : ''}`,
    "data-testid": restProps['data-testid'] || 'gambling-icon',
    children: /*#__PURE__*/jsx("svg", {
      "aria-label": title,
      "aria-hidden": !title ? true : undefined,
      focusable: isFocusable,
      role: role ?? (title ? 'graphics-symbol img' : 'none'),
      width: String(size),
      height: String(size),
      fill: "currentColor",
      viewBox: "0 0 24 24",
      children: (Number(size) === 16 || Number(size) === 24 || Number(size) === 32) && /*#__PURE__*/jsx(Fragment, {
        children: /*#__PURE__*/jsx("path", {
          fillRule: "evenodd",
          d: "M11 4.062a8 8 0 0 0-5.24 2.931L7.52 8.01A6 6 0 0 1 11 6.083zM4 12c0-1.178.255-2.296.712-3.303l1.743 1.007A6 6 0 0 0 6 12c0 .659.106 1.292.302 1.885l-1.76 1.016A8 8 0 0 1 4 12m1.496 4.66A8 8 0 0 0 11 19.938v-2.021a6 6 0 0 1-3.76-2.264zm13.007 0A8 8 0 0 1 13 19.938v-2.021a6 6 0 0 0 3.76-2.264zm.955-1.759c.35-.9.542-1.878.542-2.901a8 8 0 0 0-.712-3.303l-1.743 1.006c.293.708.455 1.484.455 2.297 0 .659-.106 1.293-.302 1.885zM13 4.061a8 8 0 0 1 5.24 2.932l-1.76 1.016A6 6 0 0 0 13 6.083zM16 12a4 4 0 1 1-8 0 4 4 0 0 1 8 0M2 12C2 6.477 6.477 2 12 2s10 4.477 10 10-4.477 10-10 10S2 17.523 2 12m10.084-2.872a.1.1 0 0 0-.168 0l-.906 1.387-.972 1.429a.1.1 0 0 0 0 .112l.972 1.43.906 1.386a.1.1 0 0 0 .168 0l.906-1.387.972-1.429a.1.1 0 0 0 0-.112l-.972-1.429z",
          clipRule: "evenodd"
        })
      })
    })
  });
};

const GeneralFill = ({
  className = undefined,
  isFocusable = false,
  filled = undefined,
  title = undefined,
  role = undefined,
  size = 16,
  ...restProps
}) => {
  if (filled) {
    console.warn("<GeneralFill filled /> is now deprecated, please use <GeneralFillFill /> or refer to https://transferwise.github.io/icons/ for more info.");
  }
  return /*#__PURE__*/jsx("span", {
    className: `tw-icon tw-icon-general-fill ${className ? className : ''}`,
    "data-testid": restProps['data-testid'] || 'general-fill-icon',
    children: /*#__PURE__*/jsx("svg", {
      "aria-label": title,
      "aria-hidden": !title ? true : undefined,
      focusable: isFocusable,
      role: role ?? (title ? 'graphics-symbol img' : 'none'),
      width: String(size),
      height: String(size),
      fill: "currentColor",
      viewBox: "0 0 24 24",
      children: (Number(size) === 16 || Number(size) === 24 || Number(size) === 32) && /*#__PURE__*/jsx(Fragment, {
        children: /*#__PURE__*/jsx("path", {
          fillRule: "evenodd",
          d: "M3 4a1 1 0 0 1 1-1h6a1 1 0 0 1 1 1v6a1 1 0 0 1-1 1H4a1 1 0 0 1-1-1zm1 9a1 1 0 0 0-1 1v6a1 1 0 0 0 1 1h6a1 1 0 0 0 1-1v-6a1 1 0 0 0-1-1zm10 0a1 1 0 0 0-1 1v6a1 1 0 0 0 1 1h6a1 1 0 0 0 1-1v-6a1 1 0 0 0-1-1zm0-10a1 1 0 0 0-1 1v6a1 1 0 0 0 1 1h6a1 1 0 0 0 1-1V4a1 1 0 0 0-1-1z",
          clipRule: "evenodd"
        })
      })
    })
  });
};

const General = ({
  className = undefined,
  isFocusable = false,
  filled = undefined,
  title = undefined,
  role = undefined,
  size = 16,
  ...restProps
}) => {
  if (filled) {
    console.warn("<General filled /> is now deprecated, please use <GeneralFill /> or refer to https://transferwise.github.io/icons/ for more info.");
  }
  return /*#__PURE__*/jsx("span", {
    className: `tw-icon tw-icon-general ${className ? className : ''}`,
    "data-testid": restProps['data-testid'] || 'general-icon',
    children: /*#__PURE__*/jsx("svg", {
      "aria-label": title,
      "aria-hidden": !title ? true : undefined,
      focusable: isFocusable,
      role: role ?? (title ? 'graphics-symbol img' : 'none'),
      width: String(size),
      height: String(size),
      fill: "currentColor",
      viewBox: "0 0 24 24",
      children: (Number(size) === 16 || Number(size) === 24 || Number(size) === 32) && /*#__PURE__*/jsx(Fragment, {
        children: /*#__PURE__*/jsx("path", {
          fillRule: "evenodd",
          d: "M4.01 3A1.01 1.01 0 0 0 3 4.01v5.98c0 .558.452 1.01 1.01 1.01h5.98A1.01 1.01 0 0 0 11 9.99V4.01A1.01 1.01 0 0 0 9.99 3zM5 9V5h4v4zm-.99 4A1.01 1.01 0 0 0 3 14.01v5.98c0 .558.452 1.01 1.01 1.01h5.98A1.01 1.01 0 0 0 11 19.99v-5.98A1.01 1.01 0 0 0 9.99 13zM5 19v-4h4v4zm8-14.99c0-.558.452-1.01 1.01-1.01h5.98c.558 0 1.01.452 1.01 1.01v5.98A1.01 1.01 0 0 1 19.99 11h-5.98A1.01 1.01 0 0 1 13 9.99zM15 5v4h4V5zm-.99 8A1.01 1.01 0 0 0 13 14.01v5.98c0 .558.452 1.01 1.01 1.01h5.98A1.01 1.01 0 0 0 21 19.99v-5.98A1.01 1.01 0 0 0 19.99 13zm.99 6v-4h4v4z",
          clipRule: "evenodd"
        })
      })
    })
  });
};

const GiftBox = ({
  className = undefined,
  isFocusable = false,
  filled = undefined,
  title = undefined,
  role = undefined,
  size = 16,
  ...restProps
}) => {
  if (filled) {
    console.warn("<GiftBox filled /> is now deprecated, please use <GiftBoxFill /> or refer to https://transferwise.github.io/icons/ for more info.");
  }
  return /*#__PURE__*/jsx("span", {
    className: `tw-icon tw-icon-gift-box ${className ? className : ''}`,
    "data-testid": restProps['data-testid'] || 'gift-box-icon',
    children: /*#__PURE__*/jsx("svg", {
      "aria-label": title,
      "aria-hidden": !title ? true : undefined,
      focusable: isFocusable,
      role: role ?? (title ? 'graphics-symbol img' : 'none'),
      width: String(size),
      height: String(size),
      fill: "currentColor",
      viewBox: "0 0 24 24",
      children: (Number(size) === 16 || Number(size) === 24 || Number(size) === 32) && /*#__PURE__*/jsx(Fragment, {
        children: /*#__PURE__*/jsx("path", {
          fillRule: "evenodd",
          d: "M7.402 4.503a2.995 2.995 0 0 1 4.095-1.1l.004.001q.271.158.497.36a3 3 0 0 1 3.5-.362A2.99 2.99 0 0 1 16.825 7H20a1 1 0 0 1 1 1v4a1 1 0 0 1-1 1v6.99A1.01 1.01 0 0 1 18.99 21H5.01A1.01 1.01 0 0 1 4 19.99V13a1 1 0 0 1-1-1V8a1 1 0 0 1 1-1h3.171a3.01 3.01 0 0 1 .231-2.497M5 9v2h14V9zm6-2V6a1 1 0 0 0-.499-.863.995.995 0 0 0-1.363.36.995.995 0 0 0 .356 1.363c.176.099.346.14.504.14zm2 0h1.002c.344 0 .676-.18.861-.499a.995.995 0 0 0-.36-1.363.995.995 0 0 0-1.363.356A1.03 1.03 0 0 0 13 6zm-2 6H6v6h5zm2 6v-6h5v6z",
          clipRule: "evenodd"
        })
      })
    })
  });
};

const Invite = ({
  className = undefined,
  isFocusable = false,
  filled = undefined,
  title = undefined,
  role = undefined,
  size = 16,
  ...restProps
}) => {
  if (filled) {
    console.warn("<Invite filled /> is now deprecated, please use <InviteFill /> or refer to https://transferwise.github.io/icons/ for more info.");
  }
  return /*#__PURE__*/jsx("span", {
    className: `tw-icon tw-icon-invite ${className ? className : ''}`,
    "data-testid": restProps['data-testid'] || 'invite-icon',
    children: /*#__PURE__*/jsx("svg", {
      "aria-label": title,
      "aria-hidden": !title ? true : undefined,
      focusable: isFocusable,
      role: role ?? (title ? 'graphics-symbol img' : 'none'),
      width: String(size),
      height: String(size),
      fill: "currentColor",
      viewBox: "0 0 24 24",
      children: (Number(size) === 16 || Number(size) === 24 || Number(size) === 32) && /*#__PURE__*/jsx(Fragment, {
        children: /*#__PURE__*/jsx("path", {
          fillRule: "evenodd",
          d: "M7.402 4.503a2.995 2.995 0 0 1 4.095-1.1l.004.001q.271.158.497.36a3 3 0 0 1 3.5-.362A2.99 2.99 0 0 1 16.825 7H20a1 1 0 0 1 1 1v4a1 1 0 0 1-1 1v6.99A1.01 1.01 0 0 1 18.99 21H5.01A1.01 1.01 0 0 1 4 19.99V13a1 1 0 0 1-1-1V8a1 1 0 0 1 1-1h3.171a3.01 3.01 0 0 1 .231-2.497M5 9v2h14V9zm6-2V6a1 1 0 0 0-.499-.863.995.995 0 0 0-1.363.36.995.995 0 0 0 .356 1.363c.176.099.346.14.504.14zm2 0h1.002c.344 0 .676-.18.861-.499a.995.995 0 0 0-.36-1.363.995.995 0 0 0-1.363.356A1.03 1.03 0 0 0 13 6zm-2 6H6v6h5zm2 6v-6h5v6z",
          clipRule: "evenodd"
        })
      })
    })
  });
};

const Globe = ({
  className = undefined,
  isFocusable = false,
  filled = undefined,
  title = undefined,
  role = undefined,
  size = 16,
  ...restProps
}) => {
  if (filled) {
    console.warn("<Globe filled /> is now deprecated, please use <GlobeFill /> or refer to https://transferwise.github.io/icons/ for more info.");
  }
  return /*#__PURE__*/jsx("span", {
    className: `tw-icon tw-icon-globe ${className ? className : ''}`,
    "data-testid": restProps['data-testid'] || 'globe-icon',
    children: /*#__PURE__*/jsx("svg", {
      "aria-label": title,
      "aria-hidden": !title ? true : undefined,
      focusable: isFocusable,
      role: role ?? (title ? 'graphics-symbol img' : 'none'),
      width: String(size),
      height: String(size),
      fill: "currentColor",
      viewBox: "0 0 24 24",
      children: (Number(size) === 16 || Number(size) === 24 || Number(size) === 32) && /*#__PURE__*/jsx(Fragment, {
        children: /*#__PURE__*/jsx("path", {
          fillRule: "evenodd",
          d: "M12 22C6.477 22 2 17.523 2 12S6.477 2 12 2s10 4.477 10 10-4.477 10-10 10M9.245 4.487A8.01 8.01 0 0 0 4.062 11h3.956c.077-2.174.404-4.156.912-5.68q.144-.435.315-.833M12 4l.015.003a.3.3 0 0 1 .066.032c.07.043.174.13.301.291.26.33.539.87.79 1.626.43 1.29.732 3.05.809 5.048h-3.962c.076-1.997.378-3.757.808-5.048.252-.756.53-1.296.79-1.626.128-.162.232-.248.302-.29a.3.3 0 0 1 .066-.033zm-3.982 9H4.062a8.01 8.01 0 0 0 5.183 6.513 11 11 0 0 1-.315-.833c-.508-1.524-.835-3.506-.912-5.68M12 20l-.015-.003a.3.3 0 0 1-.066-.032 1.2 1.2 0 0 1-.301-.291c-.26-.33-.539-.87-.79-1.626-.43-1.29-.732-3.05-.809-5.048h3.962c-.076 1.997-.378 3.757-.808 5.048-.252.756-.53 1.296-.79 1.626a1.2 1.2 0 0 1-.302.29.3.3 0 0 1-.066.033zm3.982-7c-.077 2.174-.404 4.156-.912 5.68q-.144.435-.315.833A8.01 8.01 0 0 0 19.938 13zm0-2c-.077-2.174-.404-4.156-.912-5.68q-.144-.435-.315-.833A8.01 8.01 0 0 1 19.938 11z",
          clipRule: "evenodd"
        })
      })
    })
  });
};

const GraduationCap = ({
  className = undefined,
  isFocusable = false,
  filled = undefined,
  title = undefined,
  role = undefined,
  size = 16,
  ...restProps
}) => {
  if (filled) {
    console.warn("<GraduationCap filled /> is now deprecated, please use <GraduationCapFill /> or refer to https://transferwise.github.io/icons/ for more info.");
  }
  return /*#__PURE__*/jsx("span", {
    className: `tw-icon tw-icon-graduation-cap ${className ? className : ''}`,
    "data-testid": restProps['data-testid'] || 'graduation-cap-icon',
    children: /*#__PURE__*/jsx("svg", {
      "aria-label": title,
      "aria-hidden": !title ? true : undefined,
      focusable: isFocusable,
      role: role ?? (title ? 'graphics-symbol img' : 'none'),
      width: String(size),
      height: String(size),
      fill: "currentColor",
      viewBox: "0 0 24 24",
      children: (Number(size) === 16 || Number(size) === 24 || Number(size) === 32) && /*#__PURE__*/jsx(Fragment, {
        children: /*#__PURE__*/jsx("path", {
          fillRule: "evenodd",
          d: "M12 5.172 4.918 9.5 12 13.828 19.082 9.5zm-.527-2.022a1.01 1.01 0 0 1 1.054 0l8.98 5.488.047.03c.276.186.446.5.446.838V15h-2v-3.717l-1 .611v4.6c0 .36-.19.692-.501.873l-5.99 3.494a1.01 1.01 0 0 1-1.018 0l-5.99-3.494a1.01 1.01 0 0 1-.5-.873v-4.6l-2.508-1.532a1.01 1.01 0 0 1 0-1.724zm1.054 12.7L17 13.116v2.81l-5 2.916-5-2.916v-2.81l4.473 2.734c.324.198.73.198 1.054 0",
          clipRule: "evenodd"
        })
      })
    })
  });
};

const Graph = ({
  className = undefined,
  isFocusable = false,
  filled = undefined,
  title = undefined,
  role = undefined,
  size = 16,
  ...restProps
}) => {
  if (filled) {
    console.warn("<Graph filled /> is now deprecated, please use <GraphFill /> or refer to https://transferwise.github.io/icons/ for more info.");
  }
  return /*#__PURE__*/jsx("span", {
    className: `tw-icon tw-icon-graph ${className ? className : ''}`,
    "data-testid": restProps['data-testid'] || 'graph-icon',
    children: /*#__PURE__*/jsx("svg", {
      "aria-label": title,
      "aria-hidden": !title ? true : undefined,
      focusable: isFocusable,
      role: role ?? (title ? 'graphics-symbol img' : 'none'),
      width: String(size),
      height: String(size),
      fill: "currentColor",
      viewBox: "0 0 24 24",
      children: (Number(size) === 16 || Number(size) === 24 || Number(size) === 32) && /*#__PURE__*/jsx(Fragment, {
        children: /*#__PURE__*/jsx("path", {
          fillRule: "evenodd",
          d: "M3 4v15.99c0 .558.452 1.01 1.01 1.01H20v-2H5V4zm12.714 10.7 4.993-4.992-1.415-1.415-4.344 4.345-2.79-2.391a1.01 1.01 0 0 0-1.372.052l-4.493 4.494 1.414 1.414 3.845-3.845 2.79 2.391c.4.344.999.32 1.372-.052",
          clipRule: "evenodd"
        })
      })
    })
  });
};

const Groceries = ({
  className = undefined,
  isFocusable = false,
  filled = undefined,
  title = undefined,
  role = undefined,
  size = 16,
  ...restProps
}) => {
  if (filled) {
    console.warn("<Groceries filled /> is now deprecated, please use <GroceriesFill /> or refer to https://transferwise.github.io/icons/ for more info.");
  }
  return /*#__PURE__*/jsx("span", {
    className: `tw-icon tw-icon-groceries ${className ? className : ''}`,
    "data-testid": restProps['data-testid'] || 'groceries-icon',
    children: /*#__PURE__*/jsx("svg", {
      "aria-label": title,
      "aria-hidden": !title ? true : undefined,
      focusable: isFocusable,
      role: role ?? (title ? 'graphics-symbol img' : 'none'),
      width: String(size),
      height: String(size),
      fill: "currentColor",
      viewBox: "0 0 24 24",
      children: (Number(size) === 16 || Number(size) === 24 || Number(size) === 32) && /*#__PURE__*/jsx(Fragment, {
        children: /*#__PURE__*/jsx("path", {
          fillRule: "evenodd",
          d: "M12.834 6.587A5.9 5.9 0 0 1 15.411 6c3.96 0 6.975 3.872 6.114 7.747l-.156.701a11 11 0 0 1-1.493 3.584l-.51.788c-1.597 2.468-4.789 3.154-7.366 1.702-2.577 1.452-5.77.766-7.366-1.702l-.51-.788a11 11 0 0 1-1.493-3.583l-.156-.702c-.755-3.397 1.47-6.792 4.698-7.578a5.5 5.5 0 0 1-.539-1.491 6.5 6.5 0 0 1-.144-1.43c.014-.52.398-.88.812-.963a7.5 7.5 0 0 1 1.648-.117c.806.033 1.98.226 2.818 1.064s1.031 2.012 1.064 2.818a7 7 0 0 1 .002.537m-2-.454q.006.153.004.296l-.05-.01a6 6 0 0 0-.827-.26 2.3 2.3 0 0 1-.668-.452c-.373-.372-.59-.91-.703-1.445l-.02-.1q.144-.002.297.004c.656.027 1.191.185 1.487.48.295.296.453.831.48 1.487m-1.483 1.94A4 4 0 0 0 8.589 8c-2.64 0-4.754 2.648-4.162 5.313l.156.702a9 9 0 0 0 1.22 2.93l.51.789c.993 1.535 3.02 2.02 4.744 1.023q.171-.1.327-.22a1 1 0 0 1 1.232 0q.156.12.327.22c1.724.997 3.75.512 4.744-1.023l.51-.788a9 9 0 0 0 1.22-2.931l.156-.702C20.165 10.648 18.05 8 15.41 8c-1.07 0-2.016.415-2.71 1.097a1 1 0 0 1-1.402 0 3.8 3.8 0 0 0-1.118-.763 6 6 0 0 1-.83-.262",
          clipRule: "evenodd"
        })
      })
    })
  });
};

const Handshake = ({
  className = undefined,
  isFocusable = false,
  filled = undefined,
  title = undefined,
  role = undefined,
  size = 16,
  ...restProps
}) => {
  if (filled) {
    console.warn("<Handshake filled /> is now deprecated, please use <HandshakeFill /> or refer to https://transferwise.github.io/icons/ for more info.");
  }
  return /*#__PURE__*/jsx("span", {
    className: `tw-icon tw-icon-handshake ${className ? className : ''}`,
    "data-testid": restProps['data-testid'] || 'handshake-icon',
    children: /*#__PURE__*/jsx("svg", {
      "aria-label": title,
      "aria-hidden": !title ? true : undefined,
      focusable: isFocusable,
      role: role ?? (title ? 'graphics-symbol img' : 'none'),
      width: String(size),
      height: String(size),
      fill: "currentColor",
      viewBox: "0 0 24 24",
      children: (Number(size) === 16 || Number(size) === 24 || Number(size) === 32) && /*#__PURE__*/jsx(Fragment, {
        children: /*#__PURE__*/jsx("path", {
          fillRule: "evenodd",
          d: "M2 5v14h2v-2.92l1.676 1.341a5 5 0 0 0 4.705.84l2.135-.712 3.464 1.04a3 3 0 0 0 3.12-.899l.9-1.029V19h2V5h-2v2h-.894l-5.53-1.185a4 4 0 0 0-3.293.754l-.114.088-.13-.073a4.82 4.82 0 0 0-5.484.476H4V5zm6.386 3.044a2.83 2.83 0 0 0-2.737.723 1 1 0 0 1-.71.293H4v4.46l2.925 2.34a3 3 0 0 0 2.823.503l4.334-1.445a2.57 2.57 0 0 0 1.279-.944.785.785 0 0 0-.574-1.238l-2.417-.202-.44.343a2.995 2.995 0 1 1-3.678-4.729zm6.166 2.665.402.034c2.153.18 3.29 2.636 2.034 4.394a4.6 4.6 0 0 1-1.36 1.258l.927.277a1 1 0 0 0 1.04-.299L20 13.624V9h-1.106l-5.737-1.23a2 2 0 0 0-1.647.378L9.48 9.727a.995.995 0 1 0 1.222 1.571l2.684-2.087z",
          clipRule: "evenodd"
        })
      })
    })
  });
};

const ContractServices = ({
  className = undefined,
  isFocusable = false,
  filled = undefined,
  title = undefined,
  role = undefined,
  size = 16,
  ...restProps
}) => {
  if (filled) {
    console.warn("<ContractServices filled /> is now deprecated, please use <ContractServicesFill /> or refer to https://transferwise.github.io/icons/ for more info.");
  }
  return /*#__PURE__*/jsx("span", {
    className: `tw-icon tw-icon-contract-services ${className ? className : ''}`,
    "data-testid": restProps['data-testid'] || 'contract-services-icon',
    children: /*#__PURE__*/jsx("svg", {
      "aria-label": title,
      "aria-hidden": !title ? true : undefined,
      focusable: isFocusable,
      role: role ?? (title ? 'graphics-symbol img' : 'none'),
      width: String(size),
      height: String(size),
      fill: "currentColor",
      viewBox: "0 0 24 24",
      children: (Number(size) === 16 || Number(size) === 24 || Number(size) === 32) && /*#__PURE__*/jsx(Fragment, {
        children: /*#__PURE__*/jsx("path", {
          fillRule: "evenodd",
          d: "M2 5v14h2v-2.92l1.676 1.341a5 5 0 0 0 4.705.84l2.135-.712 3.464 1.04a3 3 0 0 0 3.12-.899l.9-1.029V19h2V5h-2v2h-.894l-5.53-1.185a4 4 0 0 0-3.293.754l-.114.088-.13-.073a4.82 4.82 0 0 0-5.484.476H4V5zm6.386 3.044a2.83 2.83 0 0 0-2.737.723 1 1 0 0 1-.71.293H4v4.46l2.925 2.34a3 3 0 0 0 2.823.503l4.334-1.445a2.57 2.57 0 0 0 1.279-.944.785.785 0 0 0-.574-1.238l-2.417-.202-.44.343a2.995 2.995 0 1 1-3.678-4.729zm6.166 2.665.402.034c2.153.18 3.29 2.636 2.034 4.394a4.6 4.6 0 0 1-1.36 1.258l.927.277a1 1 0 0 0 1.04-.299L20 13.624V9h-1.106l-5.737-1.23a2 2 0 0 0-1.647.378L9.48 9.727a.995.995 0 1 0 1.222 1.571l2.684-2.087z",
          clipRule: "evenodd"
        })
      })
    })
  });
};

const HappyEmoji = ({
  className = undefined,
  isFocusable = false,
  filled = undefined,
  title = undefined,
  role = undefined,
  size = 16,
  ...restProps
}) => {
  if (filled) {
    console.warn("<HappyEmoji filled /> is now deprecated, please use <HappyEmojiFill /> or refer to https://transferwise.github.io/icons/ for more info.");
  }
  return /*#__PURE__*/jsx("span", {
    className: `tw-icon tw-icon-happy-emoji ${className ? className : ''}`,
    "data-testid": restProps['data-testid'] || 'happy-emoji-icon',
    children: /*#__PURE__*/jsx("svg", {
      "aria-label": title,
      "aria-hidden": !title ? true : undefined,
      focusable: isFocusable,
      role: role ?? (title ? 'graphics-symbol img' : 'none'),
      width: String(size),
      height: String(size),
      fill: "currentColor",
      viewBox: "0 0 24 24",
      children: (Number(size) === 16 || Number(size) === 24 || Number(size) === 32) && /*#__PURE__*/jsx(Fragment, {
        children: /*#__PURE__*/jsx("path", {
          fillRule: "evenodd",
          d: "M4 12a8 8 0 1 1 16 0 8 8 0 0 1-16 0m8-10C6.477 2 2 6.477 2 12s4.477 10 10 10 10-4.477 10-10S17.523 2 12 2m-1.5 8a1.5 1.5 0 1 0-3 0 1.5 1.5 0 0 0 3 0M15 8.5a1.5 1.5 0 1 1 0 3 1.5 1.5 0 0 1 0-3M12 18a6 6 0 0 0 5.196-3l-1.732-1a4 4 0 0 1-6.928 0l-1.732 1A6 6 0 0 0 12 18",
          clipRule: "evenodd"
        })
      })
    })
  });
};

const Do = ({
  className = undefined,
  isFocusable = false,
  filled = undefined,
  title = undefined,
  role = undefined,
  size = 16,
  ...restProps
}) => {
  if (filled) {
    console.warn("<Do filled /> is now deprecated, please use <DoFill /> or refer to https://transferwise.github.io/icons/ for more info.");
  }
  return /*#__PURE__*/jsx("span", {
    className: `tw-icon tw-icon-do ${className ? className : ''}`,
    "data-testid": restProps['data-testid'] || 'do-icon',
    children: /*#__PURE__*/jsx("svg", {
      "aria-label": title,
      "aria-hidden": !title ? true : undefined,
      focusable: isFocusable,
      role: role ?? (title ? 'graphics-symbol img' : 'none'),
      width: String(size),
      height: String(size),
      fill: "currentColor",
      viewBox: "0 0 24 24",
      children: (Number(size) === 16 || Number(size) === 24 || Number(size) === 32) && /*#__PURE__*/jsx(Fragment, {
        children: /*#__PURE__*/jsx("path", {
          fillRule: "evenodd",
          d: "M4 12a8 8 0 1 1 16 0 8 8 0 0 1-16 0m8-10C6.477 2 2 6.477 2 12s4.477 10 10 10 10-4.477 10-10S17.523 2 12 2m-1.5 8a1.5 1.5 0 1 0-3 0 1.5 1.5 0 0 0 3 0M15 8.5a1.5 1.5 0 1 1 0 3 1.5 1.5 0 0 1 0-3M12 18a6 6 0 0 0 5.196-3l-1.732-1a4 4 0 0 1-6.928 0l-1.732 1A6 6 0 0 0 12 18",
          clipRule: "evenodd"
        })
      })
    })
  });
};

const Emoji = ({
  className = undefined,
  isFocusable = false,
  filled = undefined,
  title = undefined,
  role = undefined,
  size = 16,
  ...restProps
}) => {
  if (filled) {
    console.warn("<Emoji filled /> is now deprecated, please use <EmojiFill /> or refer to https://transferwise.github.io/icons/ for more info.");
  }
  return /*#__PURE__*/jsx("span", {
    className: `tw-icon tw-icon-emoji ${className ? className : ''}`,
    "data-testid": restProps['data-testid'] || 'emoji-icon',
    children: /*#__PURE__*/jsx("svg", {
      "aria-label": title,
      "aria-hidden": !title ? true : undefined,
      focusable: isFocusable,
      role: role ?? (title ? 'graphics-symbol img' : 'none'),
      width: String(size),
      height: String(size),
      fill: "currentColor",
      viewBox: "0 0 24 24",
      children: (Number(size) === 16 || Number(size) === 24 || Number(size) === 32) && /*#__PURE__*/jsx(Fragment, {
        children: /*#__PURE__*/jsx("path", {
          fillRule: "evenodd",
          d: "M4 12a8 8 0 1 1 16 0 8 8 0 0 1-16 0m8-10C6.477 2 2 6.477 2 12s4.477 10 10 10 10-4.477 10-10S17.523 2 12 2m-1.5 8a1.5 1.5 0 1 0-3 0 1.5 1.5 0 0 0 3 0M15 8.5a1.5 1.5 0 1 1 0 3 1.5 1.5 0 0 1 0-3M12 18a6 6 0 0 0 5.196-3l-1.732-1a4 4 0 0 1-6.928 0l-1.732 1A6 6 0 0 0 12 18",
          clipRule: "evenodd"
        })
      })
    })
  });
};

const Headset = ({
  className = undefined,
  isFocusable = false,
  filled = undefined,
  title = undefined,
  role = undefined,
  size = 16,
  ...restProps
}) => {
  if (filled) {
    console.warn("<Headset filled /> is now deprecated, please use <HeadsetFill /> or refer to https://transferwise.github.io/icons/ for more info.");
  }
  return /*#__PURE__*/jsx("span", {
    className: `tw-icon tw-icon-headset ${className ? className : ''}`,
    "data-testid": restProps['data-testid'] || 'headset-icon',
    children: /*#__PURE__*/jsx("svg", {
      "aria-label": title,
      "aria-hidden": !title ? true : undefined,
      focusable: isFocusable,
      role: role ?? (title ? 'graphics-symbol img' : 'none'),
      width: String(size),
      height: String(size),
      fill: "currentColor",
      viewBox: "0 0 24 24",
      children: (Number(size) === 16 || Number(size) === 24 || Number(size) === 32) && /*#__PURE__*/jsx(Fragment, {
        children: /*#__PURE__*/jsx("path", {
          fillRule: "evenodd",
          d: "M5.07 8a7.002 7.002 0 0 1 13.86 0H19a4 4 0 0 1 0 8h-.995C17.45 16 17 15.55 17 14.995V9A5 5 0 0 0 7 9v6a5 5 0 0 0 4.006 4.901A1.01 1.01 0 0 1 12.01 19h1.98c.558 0 1.01.452 1.01 1.01v.98A1.01 1.01 0 0 1 13.99 22H12a7 7 0 0 1-6.93-6H5a4 4 0 0 1 0-8zM5 10a2 2 0 1 0 0 4zm14 0a2 2 0 1 1 0 4z",
          clipRule: "evenodd"
        })
      })
    })
  });
};

const Cs = ({
  className = undefined,
  isFocusable = false,
  filled = undefined,
  title = undefined,
  role = undefined,
  size = 16,
  ...restProps
}) => {
  if (filled) {
    console.warn("<Cs filled /> is now deprecated, please use <CsFill /> or refer to https://transferwise.github.io/icons/ for more info.");
  }
  return /*#__PURE__*/jsx("span", {
    className: `tw-icon tw-icon-cs ${className ? className : ''}`,
    "data-testid": restProps['data-testid'] || 'cs-icon',
    children: /*#__PURE__*/jsx("svg", {
      "aria-label": title,
      "aria-hidden": !title ? true : undefined,
      focusable: isFocusable,
      role: role ?? (title ? 'graphics-symbol img' : 'none'),
      width: String(size),
      height: String(size),
      fill: "currentColor",
      viewBox: "0 0 24 24",
      children: (Number(size) === 16 || Number(size) === 24 || Number(size) === 32) && /*#__PURE__*/jsx(Fragment, {
        children: /*#__PURE__*/jsx("path", {
          fillRule: "evenodd",
          d: "M5.07 8a7.002 7.002 0 0 1 13.86 0H19a4 4 0 0 1 0 8h-.995C17.45 16 17 15.55 17 14.995V9A5 5 0 0 0 7 9v6a5 5 0 0 0 4.006 4.901A1.01 1.01 0 0 1 12.01 19h1.98c.558 0 1.01.452 1.01 1.01v.98A1.01 1.01 0 0 1 13.99 22H12a7 7 0 0 1-6.93-6H5a4 4 0 0 1 0-8zM5 10a2 2 0 1 0 0 4zm14 0a2 2 0 1 1 0 4z",
          clipRule: "evenodd"
        })
      })
    })
  });
};

const Heart = ({
  className = undefined,
  isFocusable = false,
  filled = undefined,
  title = undefined,
  role = undefined,
  size = 16,
  ...restProps
}) => {
  if (filled) {
    console.warn("<Heart filled /> is now deprecated, please use <HeartFill /> or refer to https://transferwise.github.io/icons/ for more info.");
  }
  return /*#__PURE__*/jsx("span", {
    className: `tw-icon tw-icon-heart ${className ? className : ''}`,
    "data-testid": restProps['data-testid'] || 'heart-icon',
    children: /*#__PURE__*/jsx("svg", {
      "aria-label": title,
      "aria-hidden": !title ? true : undefined,
      focusable: isFocusable,
      role: role ?? (title ? 'graphics-symbol img' : 'none'),
      width: String(size),
      height: String(size),
      fill: "currentColor",
      viewBox: "0 0 24 24",
      children: (Number(size) === 16 || Number(size) === 24 || Number(size) === 32) && /*#__PURE__*/jsx(Fragment, {
        children: /*#__PURE__*/jsx("path", {
          fillRule: "evenodd",
          d: "M15.706 6.158c-.862.304-1.873 1.114-2.795 2.841a1.01 1.01 0 0 1-1.783 0c-.92-1.724-1.937-2.534-2.81-2.838-.861-.3-1.719-.159-2.46.298-1.543.951-2.428 3.156-1.438 5.125 1.153 2.297 3.14 4.42 4.904 6.005a35 35 0 0 0 2.703 2.192 33 33 0 0 0 2.746-2.191c1.782-1.584 3.758-3.7 4.841-5.985.94-1.985.044-4.202-1.484-5.151-.733-.455-1.576-.595-2.424-.296m3.479-1.403c2.306 1.432 3.655 4.714 2.236 7.706-1.254 2.648-3.467 4.977-5.32 6.624a33 33 0 0 1-3.512 2.737 1 1 0 0 1-1.149-.007 34 34 0 0 1-3.452-2.738c-1.834-1.648-4.036-3.969-5.356-6.595-1.506-3-.148-6.293 2.176-7.725C6 4.022 7.481 3.75 8.976 4.272c1.106.386 2.14 1.177 3.043 2.393.898-1.214 1.925-2.006 3.022-2.393 1.488-.524 2.96-.253 4.144.483m-8.07 15.819.016-.032-.015.031",
          clipRule: "evenodd"
        })
      })
    })
  });
};

const Family = ({
  className = undefined,
  isFocusable = false,
  filled = undefined,
  title = undefined,
  role = undefined,
  size = 16,
  ...restProps
}) => {
  if (filled) {
    console.warn("<Family filled /> is now deprecated, please use <FamilyFill /> or refer to https://transferwise.github.io/icons/ for more info.");
  }
  return /*#__PURE__*/jsx("span", {
    className: `tw-icon tw-icon-family ${className ? className : ''}`,
    "data-testid": restProps['data-testid'] || 'family-icon',
    children: /*#__PURE__*/jsx("svg", {
      "aria-label": title,
      "aria-hidden": !title ? true : undefined,
      focusable: isFocusable,
      role: role ?? (title ? 'graphics-symbol img' : 'none'),
      width: String(size),
      height: String(size),
      fill: "currentColor",
      viewBox: "0 0 24 24",
      children: (Number(size) === 16 || Number(size) === 24 || Number(size) === 32) && /*#__PURE__*/jsx(Fragment, {
        children: /*#__PURE__*/jsx("path", {
          fillRule: "evenodd",
          d: "M15.706 6.158c-.862.304-1.873 1.114-2.795 2.841a1.01 1.01 0 0 1-1.783 0c-.92-1.724-1.937-2.534-2.81-2.838-.861-.3-1.719-.159-2.46.298-1.543.951-2.428 3.156-1.438 5.125 1.153 2.297 3.14 4.42 4.904 6.005a35 35 0 0 0 2.703 2.192 33 33 0 0 0 2.746-2.191c1.782-1.584 3.758-3.7 4.841-5.985.94-1.985.044-4.202-1.484-5.151-.733-.455-1.576-.595-2.424-.296m3.479-1.403c2.306 1.432 3.655 4.714 2.236 7.706-1.254 2.648-3.467 4.977-5.32 6.624a33 33 0 0 1-3.512 2.737 1 1 0 0 1-1.149-.007 34 34 0 0 1-3.452-2.738c-1.834-1.648-4.036-3.969-5.356-6.595-1.506-3-.148-6.293 2.176-7.725C6 4.022 7.481 3.75 8.976 4.272c1.106.386 2.14 1.177 3.043 2.393.898-1.214 1.925-2.006 3.022-2.393 1.488-.524 2.96-.253 4.144.483m-8.07 15.819.016-.032-.015.031",
          clipRule: "evenodd"
        })
      })
    })
  });
};

const House = ({
  className = undefined,
  isFocusable = false,
  filled = undefined,
  title = undefined,
  role = undefined,
  size = 16,
  ...restProps
}) => {
  if (filled) {
    console.warn("<House filled /> is now deprecated, please use <HouseFill /> or refer to https://transferwise.github.io/icons/ for more info.");
  }
  return /*#__PURE__*/jsx("span", {
    className: `tw-icon tw-icon-house ${className ? className : ''}`,
    "data-testid": restProps['data-testid'] || 'house-icon',
    children: /*#__PURE__*/jsx("svg", {
      "aria-label": title,
      "aria-hidden": !title ? true : undefined,
      focusable: isFocusable,
      role: role ?? (title ? 'graphics-symbol img' : 'none'),
      width: String(size),
      height: String(size),
      fill: "currentColor",
      viewBox: "0 0 24 24",
      children: (Number(size) === 16 || Number(size) === 24 || Number(size) === 32) && /*#__PURE__*/jsx(Fragment, {
        children: /*#__PURE__*/jsx("path", {
          fillRule: "evenodd",
          d: "m19 10.415-7-5.172-7 5.172V19h14zM21 19a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2v-8.585a2 2 0 0 1 .812-1.608L11.4 3.2a1.01 1.01 0 0 1 1.2 0l7.589 5.607A2 2 0 0 1 21 10.415z",
          clipRule: "evenodd"
        })
      })
    })
  });
};

const Home = ({
  className = undefined,
  isFocusable = false,
  filled = undefined,
  title = undefined,
  role = undefined,
  size = 16,
  ...restProps
}) => {
  if (filled) {
    console.warn("<Home filled /> is now deprecated, please use <HomeFill /> or refer to https://transferwise.github.io/icons/ for more info.");
  }
  return /*#__PURE__*/jsx("span", {
    className: `tw-icon tw-icon-home ${className ? className : ''}`,
    "data-testid": restProps['data-testid'] || 'home-icon',
    children: /*#__PURE__*/jsx("svg", {
      "aria-label": title,
      "aria-hidden": !title ? true : undefined,
      focusable: isFocusable,
      role: role ?? (title ? 'graphics-symbol img' : 'none'),
      width: String(size),
      height: String(size),
      fill: "currentColor",
      viewBox: "0 0 24 24",
      children: (Number(size) === 16 || Number(size) === 24 || Number(size) === 32) && /*#__PURE__*/jsx(Fragment, {
        children: /*#__PURE__*/jsx("path", {
          fillRule: "evenodd",
          d: "m19 10.415-7-5.172-7 5.172V19h14zM21 19a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2v-8.585a2 2 0 0 1 .812-1.608L11.4 3.2a1.01 1.01 0 0 1 1.2 0l7.589 5.607A2 2 0 0 1 21 10.415z",
          clipRule: "evenodd"
        })
      })
    })
  });
};

const Id = ({
  className = undefined,
  isFocusable = false,
  filled = undefined,
  title = undefined,
  role = undefined,
  size = 16,
  ...restProps
}) => {
  if (filled) {
    console.warn("<Id filled /> is now deprecated, please use <IdFill /> or refer to https://transferwise.github.io/icons/ for more info.");
  }
  return /*#__PURE__*/jsx("span", {
    className: `tw-icon tw-icon-id ${className ? className : ''}`,
    "data-testid": restProps['data-testid'] || 'id-icon',
    children: /*#__PURE__*/jsx("svg", {
      "aria-label": title,
      "aria-hidden": !title ? true : undefined,
      focusable: isFocusable,
      role: role ?? (title ? 'graphics-symbol img' : 'none'),
      width: String(size),
      height: String(size),
      fill: "currentColor",
      viewBox: "0 0 24 24",
      children: (Number(size) === 16 || Number(size) === 24 || Number(size) === 32) && /*#__PURE__*/jsx(Fragment, {
        children: /*#__PURE__*/jsx("path", {
          fillRule: "evenodd",
          d: "M4 4a2 2 0 0 0-2 2v12a2 2 0 0 0 2 2h16a2 2 0 0 0 2-2V6a2 2 0 0 0-2-2zm0 2h16v12H4zm3.005 3.12C6.45 9.12 6 9.57 6 10.125v3.99c0 .555.45 1.005 1.005 1.005h3.99c.555 0 1.005-.45 1.005-1.005v-3.99c0-.555-.45-1.005-1.005-1.005zm.995 4v-2h2v2zm9-2h-3v-2h3zm-3 3.982h4v-2h-4z",
          clipRule: "evenodd"
        })
      })
    })
  });
};

const Ideal = ({
  className = undefined,
  isFocusable = false,
  filled = undefined,
  title = undefined,
  role = undefined,
  size = 16,
  ...restProps
}) => {
  if (filled) {
    console.warn("<Ideal filled /> is now deprecated, please use <IdealFill /> or refer to https://transferwise.github.io/icons/ for more info.");
  }
  return /*#__PURE__*/jsx("span", {
    className: `tw-icon tw-icon-ideal ${className ? className : ''}`,
    "data-testid": restProps['data-testid'] || 'ideal-icon',
    children: /*#__PURE__*/jsx("svg", {
      "aria-label": title,
      "aria-hidden": !title ? true : undefined,
      focusable: isFocusable,
      role: role ?? (title ? 'graphics-symbol img' : 'none'),
      width: String(size),
      height: String(size),
      fill: "currentColor",
      viewBox: "0 0 24 24",
      children: (Number(size) === 16 || Number(size) === 24 || Number(size) === 32) && /*#__PURE__*/jsxs(Fragment, {
        children: [/*#__PURE__*/jsx("path", {
          fillRule: "evenodd",
          d: "M19.315 18.572c1.44 0 2.28 1.07 2.28 2.24s-.834 2.24-2.28 2.24c-1.44 0-2.274-1.069-2.274-2.24s.834-2.24 2.274-2.24m0 1.154c-.642 0-1.014.522-1.014 1.087 0 .563.379 1.086 1.014 1.086.636 0 1.014-.522 1.014-1.087 0-.564-.372-1.086-1.014-1.086",
          clipRule: "evenodd"
        }), /*#__PURE__*/jsx("path", {
          d: "M10.838 18.57c1.442 0 2.273 1.066 2.273 2.235q0 .218-.039.428h-3.17c.14.373.467.656.934.656h.002v1.151h-.003c-1.437 0-2.27-1.066-2.27-2.235q0-.22.039-.43h3.167c-.14-.372-.464-.654-.933-.655z"
        }), /*#__PURE__*/jsx("path", {
          fillRule: "evenodd",
          d: "M15.346 18.689c.96 0 1.578.728 1.578 1.584 0 .576-.289 1.098-.769 1.372l.841 1.293h-1.47l-.713-1.087h-.235v1.087H13.33v-4.25zm-.768 2.184h.516c.335 0 .558-.273.558-.6 0-.328-.215-.6-.551-.601h-.523z",
          clipRule: "evenodd"
        }), /*#__PURE__*/jsx("path", {
          d: "m4.423 21.216.737-2.532h.994l.73 2.532.749-2.532H8.95l-1.509 4.24h-1.09l-.694-2.308-.7 2.309H3.872l-1.509-4.241h1.318zm17.21-5.112a.175.175 0 0 1 0 .35H2.363a.177.177 0 0 1-.175-.176c0-.096.079-.174.175-.174zM6.892 8.41c.39 0 .7.332.7.75v2.658h-.004c-.776 0-1.398-.67-1.399-1.493V9.16c0-.411.312-.75.703-.75m7.798-1.458h-.536l.27-.782h.006zm-4.487-.909a.7.7 0 0 1 .281.048.46.46 0 0 1 .184.141.6.6 0 0 1 .103.221c.02.084.03.184.03.29 0 .12-.015.215-.045.299a.6.6 0 0 1-.118.2.4.4 0 0 1-.163.11l-.098.023a1 1 0 0 1-.097.008v.005h-.404V6.043z"
        }), /*#__PURE__*/jsx("path", {
          fillRule: "evenodd",
          d: "M12.545 2.257c3.504 0 5.024 1.95 5.024 4.736s-1.52 4.757-5.024 4.757h-3.86V2.923c0-.364.297-.666.668-.666zm.862 5.52h.46l.163-.473h.778l.158.472h.475l-.776-2.131h-.475zm2.32 0h1.467v-.394h-1.011V5.645h-.456zm-4.174-.004h1.574V7.38h-1.12v-.52h1.007v-.363h-1.007V6.04h1.095v-.397h-1.55zm-2.125-.002h.894c.158 0 .296-.032.413-.084a.9.9 0 0 0 .292-.226 1 1 0 0 0 .173-.342q.056-.195.057-.43-.002-.268-.072-.463a1.1 1.1 0 0 0-.2-.327.8.8 0 0 0-.3-.194v.002a1.1 1.1 0 0 0-.373-.063v-.005h-.884z",
          clipRule: "evenodd"
        }), /*#__PURE__*/jsx("path", {
          d: "M6.991 5.802a1.002 1.002 0 1 1 0 2.004 1.002 1.002 0 0 1 0-2.004"
        }), /*#__PURE__*/jsx("path", {
          fillRule: "evenodd",
          d: "M12.201.943c5.918 0 6.8 3.79 6.801 6.046 0 3.915-2.418 6.073-6.8 6.074H5.963a1 1 0 0 1-1.003-.998V1.94A1 1 0 0 1 5.964.943zm-6.238.333a.666.666 0 0 0-.67.665v10.123c0 .37.3.665.67.665H12.2c4.168 0 6.467-2.038 6.467-5.74 0-4.969-4.054-5.713-6.467-5.713z",
          clipRule: "evenodd"
        }), /*#__PURE__*/jsx("path", {
          d: "M10.835 23.04q.074 0 .145-.004.438-.024.793-.17a2.1 2.1 0 0 0 1.056-.939c.102-.186.178-.39.225-.6h-1.322a1 1 0 0 1-.094.16.93.93 0 0 1-.393.32 1 1 0 0 1-.409.082.96.96 0 0 1-.71-.295l-.858.87c.381.352.911.575 1.568.575"
        }), /*#__PURE__*/jsx("path", {
          d: "M10.836 18.568c-1.22 0-2.004.767-2.213 1.713H9.94a.97.97 0 0 1 .896-.562c.34 0 .605.147.777.37l.867-.877c-.387-.392-.944-.644-1.644-.644"
        }), /*#__PURE__*/jsxs("defs", {
          children: [/*#__PURE__*/jsxs("linearGradient", {
            id: "a",
            x1: "12.409",
            x2: "10.438",
            y1: "20.556",
            y2: "22.971",
            gradientUnits: "userSpaceOnUse",
            children: [/*#__PURE__*/jsx("stop", {
              offset: ".02",
              stopColor: "currentColor",
              stopOpacity: "0"
            }), /*#__PURE__*/jsx("stop", {
              offset: ".68",
              stopColor: "currentColor"
            })]
          }), /*#__PURE__*/jsxs("linearGradient", {
            id: "b",
            x1: "8.97",
            x2: "10.992",
            y1: "21.069",
            y2: "19.071",
            gradientUnits: "userSpaceOnUse",
            children: [/*#__PURE__*/jsx("stop", {
              offset: ".02",
              stopColor: "currentColor",
              stopOpacity: "0"
            }), /*#__PURE__*/jsx("stop", {
              offset: ".68",
              stopColor: "currentColor"
            })]
          })]
        })]
      })
    })
  });
};

const Image = ({
  className = undefined,
  isFocusable = false,
  filled = undefined,
  title = undefined,
  role = undefined,
  size = 16,
  ...restProps
}) => {
  if (filled) {
    console.warn("<Image filled /> is now deprecated, please use <ImageFill /> or refer to https://transferwise.github.io/icons/ for more info.");
  }
  return /*#__PURE__*/jsx("span", {
    className: `tw-icon tw-icon-image ${className ? className : ''}`,
    "data-testid": restProps['data-testid'] || 'image-icon',
    children: /*#__PURE__*/jsx("svg", {
      "aria-label": title,
      "aria-hidden": !title ? true : undefined,
      focusable: isFocusable,
      role: role ?? (title ? 'graphics-symbol img' : 'none'),
      width: String(size),
      height: String(size),
      fill: "currentColor",
      viewBox: "0 0 24 24",
      children: (Number(size) === 16 || Number(size) === 24 || Number(size) === 32) && /*#__PURE__*/jsx(Fragment, {
        children: /*#__PURE__*/jsx("path", {
          fillRule: "evenodd",
          d: "M3 5a2 2 0 0 1 2-2h14a2 2 0 0 1 2 2v14a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2zm16 0H5v10.296l2.336-2.043a1.01 1.01 0 0 1 1.225-.08l2.352 1.567 3.916-3.481a1.01 1.01 0 0 1 1.371.027L19 13.98zm0 11.756-3.527-3.394-3.803 3.38a1.01 1.01 0 0 1-1.231.086l-2.357-1.571L5 17.954V19h14zM10 8a1 1 0 1 0 0 2 1 1 0 0 0 0-2M7 9a3 3 0 1 1 6 0 3 3 0 0 1-6 0",
          clipRule: "evenodd"
        })
      })
    })
  });
};

const Picture = ({
  className = undefined,
  isFocusable = false,
  filled = undefined,
  title = undefined,
  role = undefined,
  size = 16,
  ...restProps
}) => {
  if (filled) {
    console.warn("<Picture filled /> is now deprecated, please use <PictureFill /> or refer to https://transferwise.github.io/icons/ for more info.");
  }
  return /*#__PURE__*/jsx("span", {
    className: `tw-icon tw-icon-picture ${className ? className : ''}`,
    "data-testid": restProps['data-testid'] || 'picture-icon',
    children: /*#__PURE__*/jsx("svg", {
      "aria-label": title,
      "aria-hidden": !title ? true : undefined,
      focusable: isFocusable,
      role: role ?? (title ? 'graphics-symbol img' : 'none'),
      width: String(size),
      height: String(size),
      fill: "currentColor",
      viewBox: "0 0 24 24",
      children: (Number(size) === 16 || Number(size) === 24 || Number(size) === 32) && /*#__PURE__*/jsx(Fragment, {
        children: /*#__PURE__*/jsx("path", {
          fillRule: "evenodd",
          d: "M3 5a2 2 0 0 1 2-2h14a2 2 0 0 1 2 2v14a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2zm16 0H5v10.296l2.336-2.043a1.01 1.01 0 0 1 1.225-.08l2.352 1.567 3.916-3.481a1.01 1.01 0 0 1 1.371.027L19 13.98zm0 11.756-3.527-3.394-3.803 3.38a1.01 1.01 0 0 1-1.231.086l-2.357-1.571L5 17.954V19h14zM10 8a1 1 0 1 0 0 2 1 1 0 0 0 0-2M7 9a3 3 0 1 1 6 0 3 3 0 0 1-6 0",
          clipRule: "evenodd"
        })
      })
    })
  });
};

const InfoCircleFill = ({
  className = undefined,
  isFocusable = false,
  filled = undefined,
  title = undefined,
  role = undefined,
  size = 16,
  ...restProps
}) => {
  if (filled) {
    console.warn("<InfoCircleFill filled /> is now deprecated, please use <InfoCircleFillFill /> or refer to https://transferwise.github.io/icons/ for more info.");
  }
  return /*#__PURE__*/jsx("span", {
    className: `tw-icon tw-icon-info-circle-fill ${className ? className : ''}`,
    "data-testid": restProps['data-testid'] || 'info-circle-fill-icon',
    children: /*#__PURE__*/jsx("svg", {
      "aria-label": title,
      "aria-hidden": !title ? true : undefined,
      focusable: isFocusable,
      role: role ?? (title ? 'graphics-symbol img' : 'none'),
      width: String(size),
      height: String(size),
      fill: "currentColor",
      viewBox: "0 0 24 24",
      children: (Number(size) === 16 || Number(size) === 24 || Number(size) === 32) && /*#__PURE__*/jsx(Fragment, {
        children: /*#__PURE__*/jsx("path", {
          fillRule: "evenodd",
          d: "M12.001 2c-5.523 0-10 4.477-10 10s4.477 10 10 10 10-4.477 10-10-4.477-10-10-10M13.5 7.5a1.5 1.5 0 1 0-3 0 1.5 1.5 0 0 0 3 0m-2 4.5v3h-2v2h6v-2h-2v-4a1 1 0 0 0-1-1h-3v2z",
          clipRule: "evenodd"
        })
      })
    })
  });
};

const InfoCircle = ({
  className = undefined,
  isFocusable = false,
  filled = undefined,
  title = undefined,
  role = undefined,
  size = 16,
  ...restProps
}) => {
  if (filled) {
    console.warn("<InfoCircle filled /> is now deprecated, please use <InfoCircleFill /> or refer to https://transferwise.github.io/icons/ for more info.");
  }
  return /*#__PURE__*/jsx("span", {
    className: `tw-icon tw-icon-info-circle ${className ? className : ''}`,
    "data-testid": restProps['data-testid'] || 'info-circle-icon',
    children: /*#__PURE__*/jsx("svg", {
      "aria-label": title,
      "aria-hidden": !title ? true : undefined,
      focusable: isFocusable,
      role: role ?? (title ? 'graphics-symbol img' : 'none'),
      width: String(size),
      height: String(size),
      fill: "currentColor",
      viewBox: "0 0 24 24",
      children: (Number(size) === 16 || Number(size) === 24 || Number(size) === 32) && /*#__PURE__*/jsx(Fragment, {
        children: /*#__PURE__*/jsx("path", {
          fillRule: "evenodd",
          d: "M12.001 4a8 8 0 1 0 0 16 8 8 0 0 0 0-16m-10 8c0-5.523 4.477-10 10-10s10 4.477 10 10-4.477 10-10 10-10-4.477-10-10m9.499 3v-3h-2v-2h3a1 1 0 0 1 1 1v4h2v2h-6v-2zm.5-9a1.5 1.5 0 1 1 0 3 1.5 1.5 0 0 1 0-3",
          clipRule: "evenodd"
        })
      })
    })
  });
};

const Info = ({
  className = undefined,
  isFocusable = false,
  filled = undefined,
  title = undefined,
  role = undefined,
  size = 16,
  ...restProps
}) => {
  if (filled) {
    console.warn("<Info filled /> is now deprecated, please use <InfoFill /> or refer to https://transferwise.github.io/icons/ for more info.");
  }
  return /*#__PURE__*/jsx("span", {
    className: `tw-icon tw-icon-info ${className ? className : ''}`,
    "data-testid": restProps['data-testid'] || 'info-icon',
    children: /*#__PURE__*/jsx("svg", {
      "aria-label": title,
      "aria-hidden": !title ? true : undefined,
      focusable: isFocusable,
      role: role ?? (title ? 'graphics-symbol img' : 'none'),
      width: String(size),
      height: String(size),
      fill: "currentColor",
      viewBox: "0 0 24 24",
      children: (Number(size) === 16 || Number(size) === 24 || Number(size) === 32) && /*#__PURE__*/jsx(Fragment, {
        children: /*#__PURE__*/jsx("path", {
          fillRule: "evenodd",
          d: "M11.5 4a1.5 1.5 0 1 1 0 3 1.5 1.5 0 0 1 0-3m1.5 6a1 1 0 0 0-1-1H9v2h2v7H9v2h6v-2h-2z",
          clipRule: "evenodd"
        })
      })
    })
  });
};

const InsertCard = ({
  className = undefined,
  isFocusable = false,
  filled = undefined,
  title = undefined,
  role = undefined,
  size = 16,
  ...restProps
}) => {
  if (filled) {
    console.warn("<InsertCard filled /> is now deprecated, please use <InsertCardFill /> or refer to https://transferwise.github.io/icons/ for more info.");
  }
  return /*#__PURE__*/jsx("span", {
    className: `tw-icon tw-icon-insert-card ${className ? className : ''}`,
    "data-testid": restProps['data-testid'] || 'insert-card-icon',
    children: /*#__PURE__*/jsx("svg", {
      "aria-label": title,
      "aria-hidden": !title ? true : undefined,
      focusable: isFocusable,
      role: role ?? (title ? 'graphics-symbol img' : 'none'),
      width: String(size),
      height: String(size),
      fill: "currentColor",
      viewBox: "0 0 24 24",
      children: (Number(size) === 16 || Number(size) === 24 || Number(size) === 32) && /*#__PURE__*/jsx(Fragment, {
        children: /*#__PURE__*/jsx("path", {
          fillRule: "evenodd",
          d: "M20 4H4V2h16zm-4 4H8v12h8zM8 6a2 2 0 0 0-2 2v12a2 2 0 0 0 2 2h8a2 2 0 0 0 2-2V8a2 2 0 0 0-2-2zm4 4h-2v3h2z",
          clipRule: "evenodd"
        })
      })
    })
  });
};

const Atm = ({
  className = undefined,
  isFocusable = false,
  filled = undefined,
  title = undefined,
  role = undefined,
  size = 16,
  ...restProps
}) => {
  if (filled) {
    console.warn("<Atm filled /> is now deprecated, please use <AtmFill /> or refer to https://transferwise.github.io/icons/ for more info.");
  }
  return /*#__PURE__*/jsx("span", {
    className: `tw-icon tw-icon-atm ${className ? className : ''}`,
    "data-testid": restProps['data-testid'] || 'atm-icon',
    children: /*#__PURE__*/jsx("svg", {
      "aria-label": title,
      "aria-hidden": !title ? true : undefined,
      focusable: isFocusable,
      role: role ?? (title ? 'graphics-symbol img' : 'none'),
      width: String(size),
      height: String(size),
      fill: "currentColor",
      viewBox: "0 0 24 24",
      children: (Number(size) === 16 || Number(size) === 24 || Number(size) === 32) && /*#__PURE__*/jsx(Fragment, {
        children: /*#__PURE__*/jsx("path", {
          fillRule: "evenodd",
          d: "M20 4H4V2h16zm-4 4H8v12h8zM8 6a2 2 0 0 0-2 2v12a2 2 0 0 0 2 2h8a2 2 0 0 0 2-2V8a2 2 0 0 0-2-2zm4 4h-2v3h2z",
          clipRule: "evenodd"
        })
      })
    })
  });
};

const Instagram = ({
  className = undefined,
  isFocusable = false,
  filled = undefined,
  title = undefined,
  role = undefined,
  size = 16,
  ...restProps
}) => {
  if (filled) {
    console.warn("<Instagram filled /> is now deprecated, please use <InstagramFill /> or refer to https://transferwise.github.io/icons/ for more info.");
  }
  return /*#__PURE__*/jsx("span", {
    className: `tw-icon tw-icon-instagram ${className ? className : ''}`,
    "data-testid": restProps['data-testid'] || 'instagram-icon',
    children: /*#__PURE__*/jsx("svg", {
      "aria-label": title,
      "aria-hidden": !title ? true : undefined,
      focusable: isFocusable,
      role: role ?? (title ? 'graphics-symbol img' : 'none'),
      width: String(size),
      height: String(size),
      fill: "currentColor",
      viewBox: "0 0 24 24",
      children: (Number(size) === 16 || Number(size) === 24 || Number(size) === 32) && /*#__PURE__*/jsx(Fragment, {
        children: /*#__PURE__*/jsx("path", {
          fillRule: "evenodd",
          d: "M12 3.558c2.743 0 3.086 0 4.157.043.986.042 1.543.214 1.929.342.471.172.814.429 1.2.772.342.343.6.686.771 1.2.129.343.3.9.343 1.928.043 1.072.043 1.415.043 4.158 0 2.742 0 3.085-.043 4.157-.043.985-.214 1.543-.343 1.928-.171.472-.429.815-.771 1.2-.343.343-.686.6-1.2.772-.343.128-.9.3-1.929.343-1.071.042-1.414.042-4.157.042s-3.086 0-4.157-.042c-.986-.043-1.543-.215-1.929-.343-.471-.172-.814-.429-1.2-.772-.343-.343-.6-.685-.771-1.2-.129-.343-.3-.9-.343-1.928-.043-1.072-.043-1.415-.043-4.157s0-3.086.043-4.158c.043-.985.214-1.542.343-1.928.171-.472.428-.814.771-1.2.343-.343.686-.6 1.2-.772.343-.128.9-.3 1.929-.342 1.071-.043 1.414-.043 4.157-.043m0-1.843c-2.786 0-3.129 0-4.243.043s-1.843.214-2.486.471c-.685.257-1.243.6-1.843 1.2a5.1 5.1 0 0 0-1.2 1.843c-.257.643-.428 1.414-.471 2.486-.043 1.114-.043 1.457-.043 4.243 0 2.785 0 3.128.043 4.242.043 1.115.214 1.843.471 2.486.258.686.6 1.243 1.2 1.843a5.1 5.1 0 0 0 1.843 1.2c.643.257 1.415.429 2.486.471 1.114.043 1.457.043 4.243.043s3.128 0 4.243-.043c1.114-.042 1.843-.214 2.485-.471.686-.257 1.243-.6 1.843-1.2a5.1 5.1 0 0 0 1.2-1.843c.257-.643.429-1.414.472-2.486.043-1.114.043-1.457.043-4.242s0-3.129-.043-4.243-.215-1.843-.472-2.486c-.257-.686-.6-1.243-1.2-1.843a5.1 5.1 0 0 0-1.843-1.2c-.642-.257-1.414-.428-2.485-.471-1.115-.043-1.457-.043-4.243-.043m0 5.014a5.27 5.27 0 0 0-5.272 5.27A5.27 5.27 0 0 0 12 17.272 5.27 5.27 0 0 0 17.27 12 5.27 5.27 0 0 0 12 6.729m0 8.7a3.44 3.44 0 0 1-3.429-3.43A3.44 3.44 0 0 1 12 8.572 3.44 3.44 0 0 1 15.428 12 3.44 3.44 0 0 1 12 15.428m6.729-8.915a1.243 1.243 0 1 1-2.486 0 1.243 1.243 0 0 1 2.486 0",
          clipRule: "evenodd"
        })
      })
    })
  });
};

const Insurance = ({
  className = undefined,
  isFocusable = false,
  filled = undefined,
  title = undefined,
  role = undefined,
  size = 16,
  ...restProps
}) => {
  if (filled) {
    console.warn("<Insurance filled /> is now deprecated, please use <InsuranceFill /> or refer to https://transferwise.github.io/icons/ for more info.");
  }
  return /*#__PURE__*/jsx("span", {
    className: `tw-icon tw-icon-insurance ${className ? className : ''}`,
    "data-testid": restProps['data-testid'] || 'insurance-icon',
    children: /*#__PURE__*/jsx("svg", {
      "aria-label": title,
      "aria-hidden": !title ? true : undefined,
      focusable: isFocusable,
      role: role ?? (title ? 'graphics-symbol img' : 'none'),
      width: String(size),
      height: String(size),
      fill: "currentColor",
      viewBox: "0 0 24 24",
      children: (Number(size) === 16 || Number(size) === 24 || Number(size) === 32) && /*#__PURE__*/jsx(Fragment, {
        children: /*#__PURE__*/jsx("path", {
          fillRule: "evenodd",
          d: "M12 4.078 6 6.495v8.154a3 3 0 0 0 1.5 2.598l4.5 2.598 4.5-2.598a3 3 0 0 0 1.5-2.598V6.495zm-.377-2.004a1 1 0 0 1 .754 0l6.99 2.816c.383.154.633.525.633.937v8.822a5 5 0 0 1-2.5 4.33l-4.995 2.884a1.01 1.01 0 0 1-1.01 0L6.5 18.979a5 5 0 0 1-2.5-4.33V5.827c0-.412.25-.783.633-.937zM11 11V8h2v3h3v2h-3v3h-2v-3H8v-2z",
          clipRule: "evenodd"
        })
      })
    })
  });
};

const Interac = ({
  className = undefined,
  isFocusable = false,
  filled = undefined,
  title = undefined,
  role = undefined,
  size = 16,
  ...restProps
}) => {
  if (filled) {
    console.warn("<Interac filled /> is now deprecated, please use <InteracFill /> or refer to https://transferwise.github.io/icons/ for more info.");
  }
  return /*#__PURE__*/jsx("span", {
    className: `tw-icon tw-icon-interac ${className ? className : ''}`,
    "data-testid": restProps['data-testid'] || 'interac-icon',
    children: /*#__PURE__*/jsx("svg", {
      "aria-label": title,
      "aria-hidden": !title ? true : undefined,
      focusable: isFocusable,
      role: role ?? (title ? 'graphics-symbol img' : 'none'),
      width: String(size),
      height: String(size),
      fill: "currentColor",
      viewBox: "0 0 24 24",
      children: (Number(size) === 16 || Number(size) === 24 || Number(size) === 32) && /*#__PURE__*/jsx(Fragment, {
        children: /*#__PURE__*/jsx("path", {
          fillRule: "evenodd",
          d: "M20.571 1.714H3.43A1.714 1.714 0 0 0 1.714 3.43v17.143a1.714 1.714 0 0 0 1.714 1.714h17.144a1.714 1.714 0 0 0 1.714-1.714V3.429a1.714 1.714 0 0 0-1.715-1.715m.126 4.483a.631.631 0 1 0 .7-1.05.631.631 0 0 0-.7 1.05m.044-.984a.552.552 0 1 1 .613.918.552.552 0 0 1-.613-.918m-.522 1.566c-1.252.284-1.543 1.174-1.504 2.296.039 1.15.287 1.882 1.554 1.585.92-.214 1.41-.8 1.413-1.732 0-.08-.002-.152-.002-.152l-.977.23-.003.189c-.006.285-.056.61-.427.686-.426.09-.523-.236-.523-.946v-.033l-.001-.293c0-.698.15-1.05.52-1.143.31-.078.43.085.43.514v.136l.98-.233-.002-.066c0-.361-.057-.62-.204-.81-.154-.201-.456-.409-1.254-.228m-7.02 1.76.002 3.683 1.016-.237V9.952q0-.703.534-.914.242-.101.504-.105v-.94a.55.55 0 0 0-.268.018c-.578.148-.827.783-.827.783V8.31zm-5.223 3.818c0 .828.156 1.063.156 1.063l1.093-.26s-.226-.162-.226-1.012v-1.867l.723-.171v-.755l-.723.171v-.823l-1.022.241v.824l-.496.117v.755l.495-.117zm1.853-1.128c0-.655.093-1.133.293-1.5.238-.434.629-.718 1.198-.848 1.121-.255 1.526.41 1.51 1.3q-.006.475-.004.473l-1.976.464v.032c0 .622.13.917.525.833.34-.071.435-.285.462-.548.004-.043.006-.151.006-.151l.926-.222s.002.076 0 .161c-.007.353-.11 1.23-1.397 1.534-1.218.29-1.543-.455-1.543-1.528m1.532-1.661c-.327.074-.5.395-.507.927l.994-.237q.002-.036.002-.16c-.002-.402-.126-.614-.489-.53m3.969 1.077c0-.853.5-1.123 1.252-1.434.677-.28.691-.419.694-.662.004-.205-.091-.38-.428-.294a.51.51 0 0 0-.408.482 2 2 0 0 0-.006.189l-.949.224a1.9 1.9 0 0 1 .066-.56c.152-.51.602-.854 1.378-1.034 1.01-.232 1.346.21 1.347.9v1.63c0 .79.147.905.147.905l-.932.22a2 2 0 0 1-.124-.334s-.204.514-.908.68c-.738.173-1.13-.284-1.13-.912m1.94-1.165q-.236.165-.496.29c-.31.152-.45.339-.45.627 0 .25.154.414.435.344.301-.076.51-.357.51-.748zM2.486 15.918a.6.6 0 0 0 .423.071c.077-.016.454-.103.77-.179l.021-.005V14.75l-1.39.329-.011.003-.007.008a.59.59 0 0 0 .194.83m.301 1.435a.59.59 0 0 1-.495-.911l.007-.01.01-.003 1.391-.328v1.056l-.021.006c-.316.075-.693.163-.77.178a.6.6 0 0 1-.122.012m-.417 1.18a.59.59 0 0 0 .539.161c.067-.015.436-.098.77-.178l.021-.006v-1.056l-1.401.33-.007.01a.59.59 0 0 0 .078.738m.253-3.825v-5.91L3.7 8.545v5.908zm2.489-.973a.67.67 0 0 1 .194.47l.003 2.789v.38a.143.143 0 1 0 .287 0V14.79l1.677 1.138a.87.87 0 0 1 .386.725v4.873l-1.882.002a1.8 1.8 0 0 1-1.799-1.8v-5.522a.665.665 0 0 1 1.134-.47m1.092-3.65a1.45 1.45 0 0 0-.959.741v-.415l-.97.23.001 2.651a.99.99 0 0 1 1.022.179V11.76c0-.41.204-.738.495-.802.22-.049.403.03.403.42v2.499l1.022-.24v-2.642c0-.641-.246-1.09-1.014-.91m14.614-4.79h.272a.178.178 0 0 1 .196.199c0 .1-.045.177-.129.19v.001c.077.008.117.05.121.159l.001.053.003.103a.08.08 0 0 0 .037.067h-.139a.13.13 0 0 1-.02-.069q-.005-.044-.005-.09l-.001-.055c-.002-.084-.028-.12-.112-.12h-.101v.334h-.123zm.221.344a.113.113 0 0 0 .123-.125c0-.082-.035-.125-.116-.125h-.105v.25z",
          clipRule: "evenodd"
        })
      })
    })
  });
};

const Jar = ({
  className = undefined,
  isFocusable = false,
  filled = undefined,
  title = undefined,
  role = undefined,
  size = 16,
  ...restProps
}) => {
  if (filled) {
    console.warn("<Jar filled /> is now deprecated, please use <JarFill /> or refer to https://transferwise.github.io/icons/ for more info.");
  }
  return /*#__PURE__*/jsx("span", {
    className: `tw-icon tw-icon-jar ${className ? className : ''}`,
    "data-testid": restProps['data-testid'] || 'jar-icon',
    children: /*#__PURE__*/jsx("svg", {
      "aria-label": title,
      "aria-hidden": !title ? true : undefined,
      focusable: isFocusable,
      role: role ?? (title ? 'graphics-symbol img' : 'none'),
      width: String(size),
      height: String(size),
      fill: "currentColor",
      viewBox: "0 0 24 24",
      children: (Number(size) === 16 || Number(size) === 24 || Number(size) === 32) && /*#__PURE__*/jsx(Fragment, {
        children: /*#__PURE__*/jsx("path", {
          fillRule: "evenodd",
          d: "M6.01 2A1.01 1.01 0 0 0 5 3.01v3.98A1.01 1.01 0 0 0 6 8v.15L4.438 10.1A2 2 0 0 0 4 11.351V20a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2v-8.65a2 2 0 0 0-.438-1.249L18 8.15V8a1.01 1.01 0 0 0 1-1.01V3.01A1.01 1.01 0 0 0 17.99 2zM16 8H8v.15a2 2 0 0 1-.438 1.249L6 11.35V20h12v-8.65L16.438 9.4A2 2 0 0 1 16 8.149zM7 6V4h10v2z",
          clipRule: "evenodd"
        })
      })
    })
  });
};

const Keep = ({
  className = undefined,
  isFocusable = false,
  filled = undefined,
  title = undefined,
  role = undefined,
  size = 16,
  ...restProps
}) => {
  if (filled) {
    console.warn("<Keep filled /> is now deprecated, please use <KeepFill /> or refer to https://transferwise.github.io/icons/ for more info.");
  }
  return /*#__PURE__*/jsx("span", {
    className: `tw-icon tw-icon-keep ${className ? className : ''}`,
    "data-testid": restProps['data-testid'] || 'keep-icon',
    children: /*#__PURE__*/jsx("svg", {
      "aria-label": title,
      "aria-hidden": !title ? true : undefined,
      focusable: isFocusable,
      role: role ?? (title ? 'graphics-symbol img' : 'none'),
      width: String(size),
      height: String(size),
      fill: "currentColor",
      viewBox: "0 0 24 24",
      children: (Number(size) === 16 || Number(size) === 24 || Number(size) === 32) && /*#__PURE__*/jsx(Fragment, {
        children: /*#__PURE__*/jsx("path", {
          fillRule: "evenodd",
          d: "M4 12a3 3 0 1 1 6 0 3 3 0 0 1-6 0m3-5a5 5 0 1 0 4.9 6H16v4h2v-4h2v4h2v-4.99A1.01 1.01 0 0 0 20.99 11H11.9A5 5 0 0 0 7 7",
          clipRule: "evenodd"
        })
      })
    })
  });
};

const Klarna = ({
  className = undefined,
  isFocusable = false,
  filled = undefined,
  title = undefined,
  role = undefined,
  size = 16,
  ...restProps
}) => {
  if (filled) {
    console.warn("<Klarna filled /> is now deprecated, please use <KlarnaFill /> or refer to https://transferwise.github.io/icons/ for more info.");
  }
  return /*#__PURE__*/jsx("span", {
    className: `tw-icon tw-icon-klarna ${className ? className : ''}`,
    "data-testid": restProps['data-testid'] || 'klarna-icon',
    children: /*#__PURE__*/jsx("svg", {
      "aria-label": title,
      "aria-hidden": !title ? true : undefined,
      focusable: isFocusable,
      role: role ?? (title ? 'graphics-symbol img' : 'none'),
      width: String(size),
      height: String(size),
      fill: "currentColor",
      viewBox: "0 0 24 24",
      children: (Number(size) === 16 || Number(size) === 24 || Number(size) === 32) && /*#__PURE__*/jsx(Fragment, {
        children: /*#__PURE__*/jsx("path", {
          fillRule: "evenodd",
          d: "M5.828 3H1.714v18h4.114zm13.886 13.588c-1.286 0-2.314 1.028-2.314 2.357 0 1.286 1.028 2.357 2.314 2.357s2.314-1.028 2.314-2.357-1.028-2.357-2.314-2.357M11.828 13.2c2.7-2.657 4.2-6.3 4.2-10.2h-3.985c0 3.343-1.543 6.386-4.157 8.357l-1.586 1.2L12.428 21h5.057z",
          clipRule: "evenodd"
        })
      })
    })
  });
};

const Laptop = ({
  className = undefined,
  isFocusable = false,
  filled = undefined,
  title = undefined,
  role = undefined,
  size = 16,
  ...restProps
}) => {
  if (filled) {
    console.warn("<Laptop filled /> is now deprecated, please use <LaptopFill /> or refer to https://transferwise.github.io/icons/ for more info.");
  }
  return /*#__PURE__*/jsx("span", {
    className: `tw-icon tw-icon-laptop ${className ? className : ''}`,
    "data-testid": restProps['data-testid'] || 'laptop-icon',
    children: /*#__PURE__*/jsx("svg", {
      "aria-label": title,
      "aria-hidden": !title ? true : undefined,
      focusable: isFocusable,
      role: role ?? (title ? 'graphics-symbol img' : 'none'),
      width: String(size),
      height: String(size),
      fill: "currentColor",
      viewBox: "0 0 24 24",
      children: (Number(size) === 16 || Number(size) === 24 || Number(size) === 32) && /*#__PURE__*/jsx(Fragment, {
        children: /*#__PURE__*/jsx("path", {
          fillRule: "evenodd",
          d: "M3 6a2 2 0 0 1 2-2h14a2 2 0 0 1 2 2v8c.553.005 1 .456 1 1.01V18a2 2 0 0 1-2 2H4a2 2 0 0 1-2-2v-2.99A1.01 1.01 0 0 1 3 14zm16 0v8H5V6zM4 16h5.5a1 1 0 0 0 1 1h3a1 1 0 0 0 1-1H20v2H4z",
          clipRule: "evenodd"
        })
      })
    })
  });
};

const Leaf = ({
  className = undefined,
  isFocusable = false,
  filled = undefined,
  title = undefined,
  role = undefined,
  size = 16,
  ...restProps
}) => {
  if (filled) {
    console.warn("<Leaf filled /> is now deprecated, please use <LeafFill /> or refer to https://transferwise.github.io/icons/ for more info.");
  }
  return /*#__PURE__*/jsx("span", {
    className: `tw-icon tw-icon-leaf ${className ? className : ''}`,
    "data-testid": restProps['data-testid'] || 'leaf-icon',
    children: /*#__PURE__*/jsx("svg", {
      "aria-label": title,
      "aria-hidden": !title ? true : undefined,
      focusable: isFocusable,
      role: role ?? (title ? 'graphics-symbol img' : 'none'),
      width: String(size),
      height: String(size),
      fill: "currentColor",
      viewBox: "0 0 24 24",
      children: (Number(size) === 16 || Number(size) === 24 || Number(size) === 32) && /*#__PURE__*/jsx(Fragment, {
        children: /*#__PURE__*/jsx("path", {
          fillRule: "evenodd",
          d: "M6.671 15.914 18.848 3.737c-4.218-.276-7.421 1.191-9.477 3.492-2.012 2.25-2.999 5.382-2.7 8.685m-1.764 1.764c-.859-4.353.224-8.707 2.973-11.782 2.884-3.227 7.497-4.933 13.292-3.881.418.076.742.405.815.821 1.046 6.026-.646 10.649-3.892 13.48-3.087 2.694-7.442 3.642-11.774 2.777l-2.114 2.114-1.414-1.414zm3.17-.341c3.325.332 6.46-.57 8.704-2.528 2.297-2.005 3.777-5.22 3.476-9.652z",
          clipRule: "evenodd"
        })
      })
    })
  });
};

const LightningBoltStrikethrough = ({
  className = undefined,
  isFocusable = false,
  filled = undefined,
  title = undefined,
  role = undefined,
  size = 16,
  ...restProps
}) => {
  if (filled) {
    console.warn("<LightningBoltStrikethrough filled /> is now deprecated, please use <LightningBoltStrikethroughFill /> or refer to https://transferwise.github.io/icons/ for more info.");
  }
  return /*#__PURE__*/jsx("span", {
    className: `tw-icon tw-icon-lightning-bolt-strikethrough ${className ? className : ''}`,
    "data-testid": restProps['data-testid'] || 'lightning-bolt-strikethrough-icon',
    children: /*#__PURE__*/jsx("svg", {
      "aria-label": title,
      "aria-hidden": !title ? true : undefined,
      focusable: isFocusable,
      role: role ?? (title ? 'graphics-symbol img' : 'none'),
      width: String(size),
      height: String(size),
      fill: "currentColor",
      viewBox: "0 0 24 24",
      children: (Number(size) === 16 || Number(size) === 24 || Number(size) === 32) && /*#__PURE__*/jsx(Fragment, {
        children: /*#__PURE__*/jsx("path", {
          fillRule: "evenodd",
          d: "m20.895 22.31.398.397 1.414-1.414-6.793-6.793 3.776-3.776c.636-.636.186-1.724-.714-1.724h-4.253l3.137-5.489a1.01 1.01 0 0 0-.877-1.51h-5.977a1.01 1.01 0 0 0-.866.49L7.802 6.386 2.707 1.293 1.293 2.707l.988.988.06-.06 18.615 18.614zM5.748 9.81l-1.596 2.66A1.01 1.01 0 0 0 5.018 14h3.701l-1.68 6.723c-.249.993.97 1.683 1.694.959l4.443-4.443-1.415-1.415-1.915 1.916.766-3.065L7.937 12h-1.17l.438-.732zM16.586 11 14.5 13.086l-5.24-5.24L11.565 4h3.71L12.14 9.49a1.01 1.01 0 0 0 .877 1.51z",
          clipRule: "evenodd"
        })
      })
    })
  });
};

const LightningBolt = ({
  className = undefined,
  isFocusable = false,
  filled = undefined,
  title = undefined,
  role = undefined,
  size = 16,
  ...restProps
}) => {
  if (filled) {
    console.warn("<LightningBolt filled /> is now deprecated, please use <LightningBoltFill /> or refer to https://transferwise.github.io/icons/ for more info.");
  }
  return /*#__PURE__*/jsx("span", {
    className: `tw-icon tw-icon-lightning-bolt ${className ? className : ''}`,
    "data-testid": restProps['data-testid'] || 'lightning-bolt-icon',
    children: /*#__PURE__*/jsx("svg", {
      "aria-label": title,
      "aria-hidden": !title ? true : undefined,
      focusable: isFocusable,
      role: role ?? (title ? 'graphics-symbol img' : 'none'),
      width: String(size),
      height: String(size),
      fill: "currentColor",
      viewBox: "0 0 24 24",
      children: (Number(size) === 16 || Number(size) === 24 || Number(size) === 32) && /*#__PURE__*/jsx(Fragment, {
        children: /*#__PURE__*/jsx("path", {
          fillRule: "evenodd",
          d: "M10.14 2.49a1.01 1.01 0 0 1 .866-.49h5.977c.775 0 1.261.838.877 1.511L14.723 9h4.253c.9 0 1.35 1.088.714 1.724L8.733 21.682c-.725.724-1.943.034-1.694-.96L8.719 14H5.018a1.01 1.01 0 0 1-.866-1.53zM11.566 4l-4.8 8h3.221c.657 0 1.14.617.98 1.255L9.846 17.74l6.74-6.74h-3.569a1.01 1.01 0 0 1-.877-1.511L15.277 4z",
          clipRule: "evenodd"
        })
      })
    })
  });
};

const Lightning = ({
  className = undefined,
  isFocusable = false,
  filled = undefined,
  title = undefined,
  role = undefined,
  size = 16,
  ...restProps
}) => {
  if (filled) {
    console.warn("<Lightning filled /> is now deprecated, please use <LightningFill /> or refer to https://transferwise.github.io/icons/ for more info.");
  }
  return /*#__PURE__*/jsx("span", {
    className: `tw-icon tw-icon-lightning ${className ? className : ''}`,
    "data-testid": restProps['data-testid'] || 'lightning-icon',
    children: /*#__PURE__*/jsx("svg", {
      "aria-label": title,
      "aria-hidden": !title ? true : undefined,
      focusable: isFocusable,
      role: role ?? (title ? 'graphics-symbol img' : 'none'),
      width: String(size),
      height: String(size),
      fill: "currentColor",
      viewBox: "0 0 24 24",
      children: (Number(size) === 16 || Number(size) === 24 || Number(size) === 32) && /*#__PURE__*/jsx(Fragment, {
        children: /*#__PURE__*/jsx("path", {
          fillRule: "evenodd",
          d: "M10.14 2.49a1.01 1.01 0 0 1 .866-.49h5.977c.775 0 1.261.838.877 1.511L14.723 9h4.253c.9 0 1.35 1.088.714 1.724L8.733 21.682c-.725.724-1.943.034-1.694-.96L8.719 14H5.018a1.01 1.01 0 0 1-.866-1.53zM11.566 4l-4.8 8h3.221c.657 0 1.14.617.98 1.255L9.846 17.74l6.74-6.74h-3.569a1.01 1.01 0 0 1-.877-1.511L15.277 4z",
          clipRule: "evenodd"
        })
      })
    })
  });
};

const Limit = ({
  className = undefined,
  isFocusable = false,
  filled = undefined,
  title = undefined,
  role = undefined,
  size = 16,
  ...restProps
}) => {
  if (filled) {
    console.warn("<Limit filled /> is now deprecated, please use <LimitFill /> or refer to https://transferwise.github.io/icons/ for more info.");
  }
  return /*#__PURE__*/jsx("span", {
    className: `tw-icon tw-icon-limit ${className ? className : ''}`,
    "data-testid": restProps['data-testid'] || 'limit-icon',
    children: /*#__PURE__*/jsx("svg", {
      "aria-label": title,
      "aria-hidden": !title ? true : undefined,
      focusable: isFocusable,
      role: role ?? (title ? 'graphics-symbol img' : 'none'),
      width: String(size),
      height: String(size),
      fill: "currentColor",
      viewBox: "0 0 24 24",
      children: (Number(size) === 16 || Number(size) === 24 || Number(size) === 32) && /*#__PURE__*/jsx(Fragment, {
        children: /*#__PURE__*/jsx("path", {
          fillRule: "evenodd",
          d: "M12 5a8 8 0 0 0-5.999 13.293l1-1 1.414 1.414-1.701 1.702a1.01 1.01 0 0 1-1.389.037A9.98 9.98 0 0 1 2 13C2 7.477 6.477 3 12 3s10 4.477 10 10a9.98 9.98 0 0 1-3.325 7.446 1.01 1.01 0 0 1-1.389-.037l-1.701-1.702 1.414-1.414 1 1A7.97 7.97 0 0 0 20 13c0-1.849-.627-3.55-1.68-4.906l-3.612 3.613a3 3 0 1 1-1.414-1.414l3.612-3.613A7.97 7.97 0 0 0 12 5m0 7a1 1 0 1 0 0 2 1 1 0 0 0 0-2",
          clipRule: "evenodd"
        })
      })
    })
  });
};

const Link = ({
  className = undefined,
  isFocusable = false,
  filled = undefined,
  title = undefined,
  role = undefined,
  size = 16,
  ...restProps
}) => {
  if (filled) {
    console.warn("<Link filled /> is now deprecated, please use <LinkFill /> or refer to https://transferwise.github.io/icons/ for more info.");
  }
  return /*#__PURE__*/jsx("span", {
    className: `tw-icon tw-icon-link ${className ? className : ''}`,
    "data-testid": restProps['data-testid'] || 'link-icon',
    children: /*#__PURE__*/jsx("svg", {
      "aria-label": title,
      "aria-hidden": !title ? true : undefined,
      focusable: isFocusable,
      role: role ?? (title ? 'graphics-symbol img' : 'none'),
      width: String(size),
      height: String(size),
      fill: "currentColor",
      viewBox: "0 0 24 24",
      children: (Number(size) === 16 || Number(size) === 24 || Number(size) === 32) && /*#__PURE__*/jsx(Fragment, {
        children: /*#__PURE__*/jsx("path", {
          fillRule: "evenodd",
          d: "M9 7a5 5 0 0 0 0 10h1v2H9A7 7 0 1 1 9 5h1v2zm6 0a5 5 0 0 1 0 10h-1v2h1a7 7 0 1 0 0-14h-1v2zm-7 6h8v-2H8z",
          clipRule: "evenodd"
        })
      })
    })
  });
};

const Linkedin = ({
  className = undefined,
  isFocusable = false,
  filled = undefined,
  title = undefined,
  role = undefined,
  size = 16,
  ...restProps
}) => {
  if (filled) {
    console.warn("<Linkedin filled /> is now deprecated, please use <LinkedinFill /> or refer to https://transferwise.github.io/icons/ for more info.");
  }
  return /*#__PURE__*/jsx("span", {
    className: `tw-icon tw-icon-linkedin ${className ? className : ''}`,
    "data-testid": restProps['data-testid'] || 'linkedin-icon',
    children: /*#__PURE__*/jsx("svg", {
      "aria-label": title,
      "aria-hidden": !title ? true : undefined,
      focusable: isFocusable,
      role: role ?? (title ? 'graphics-symbol img' : 'none'),
      width: String(size),
      height: String(size),
      fill: "currentColor",
      viewBox: "0 0 24 24",
      children: (Number(size) === 16 || Number(size) === 24 || Number(size) === 32) && /*#__PURE__*/jsx(Fragment, {
        children: /*#__PURE__*/jsx("path", {
          d: "M19.243 19.243H16.2v-4.757c0-1.157 0-2.614-1.586-2.614s-1.843 1.243-1.843 2.529v4.842H9.728V9.43h2.915v1.329h.043a3.2 3.2 0 0 1 2.871-1.586c3.086 0 3.643 2.014 3.643 4.671zM6.3 8.101a1.74 1.74 0 0 1-1.757-1.758c0-.985.771-1.757 1.757-1.757s1.757.772 1.757 1.757c0 .943-.771 1.758-1.757 1.758m1.5 11.142H4.757V9.43H7.8zM20.743 1.715H3.214c-.814 0-1.5.643-1.5 1.5v17.614c0 .814.686 1.5 1.5 1.5h17.529c.814 0 1.5-.643 1.543-1.5V3.215c0-.857-.686-1.5-1.543-1.5"
        })
      })
    })
  });
};

const List = ({
  className = undefined,
  isFocusable = false,
  filled = undefined,
  title = undefined,
  role = undefined,
  size = 16,
  ...restProps
}) => {
  if (filled) {
    console.warn("<List filled /> is now deprecated, please use <ListFill /> or refer to https://transferwise.github.io/icons/ for more info.");
  }
  return /*#__PURE__*/jsx("span", {
    className: `tw-icon tw-icon-list ${className ? className : ''}`,
    "data-testid": restProps['data-testid'] || 'list-icon',
    children: /*#__PURE__*/jsx("svg", {
      "aria-label": title,
      "aria-hidden": !title ? true : undefined,
      focusable: isFocusable,
      role: role ?? (title ? 'graphics-symbol img' : 'none'),
      width: String(size),
      height: String(size),
      fill: "currentColor",
      viewBox: "0 0 24 24",
      children: (Number(size) === 16 || Number(size) === 24 || Number(size) === 32) && /*#__PURE__*/jsx(Fragment, {
        children: /*#__PURE__*/jsx("path", {
          fillRule: "evenodd",
          d: "M6 6a1.5 1.5 0 1 0-3 0 1.5 1.5 0 0 0 3 0m2 1h13V5H8zm0 6h13v-2H8zm13 6H8v-2h13zM6 12a1.5 1.5 0 1 0-3 0 1.5 1.5 0 0 0 3 0m-1.5 4.5a1.5 1.5 0 1 1 0 3 1.5 1.5 0 0 1 0-3",
          clipRule: "evenodd"
        })
      })
    })
  });
};

const Activity = ({
  className = undefined,
  isFocusable = false,
  filled = undefined,
  title = undefined,
  role = undefined,
  size = 16,
  ...restProps
}) => {
  if (filled) {
    console.warn("<Activity filled /> is now deprecated, please use <ActivityFill /> or refer to https://transferwise.github.io/icons/ for more info.");
  }
  return /*#__PURE__*/jsx("span", {
    className: `tw-icon tw-icon-activity ${className ? className : ''}`,
    "data-testid": restProps['data-testid'] || 'activity-icon',
    children: /*#__PURE__*/jsx("svg", {
      "aria-label": title,
      "aria-hidden": !title ? true : undefined,
      focusable: isFocusable,
      role: role ?? (title ? 'graphics-symbol img' : 'none'),
      width: String(size),
      height: String(size),
      fill: "currentColor",
      viewBox: "0 0 24 24",
      children: (Number(size) === 16 || Number(size) === 24 || Number(size) === 32) && /*#__PURE__*/jsx(Fragment, {
        children: /*#__PURE__*/jsx("path", {
          fillRule: "evenodd",
          d: "M6 6a1.5 1.5 0 1 0-3 0 1.5 1.5 0 0 0 3 0m2 1h13V5H8zm0 6h13v-2H8zm13 6H8v-2h13zM6 12a1.5 1.5 0 1 0-3 0 1.5 1.5 0 0 0 3 0m-1.5 4.5a1.5 1.5 0 1 1 0 3 1.5 1.5 0 0 1 0-3",
          clipRule: "evenodd"
        })
      })
    })
  });
};

const LocationMarker = ({
  className = undefined,
  isFocusable = false,
  filled = undefined,
  title = undefined,
  role = undefined,
  size = 16,
  ...restProps
}) => {
  if (filled) {
    console.warn("<LocationMarker filled /> is now deprecated, please use <LocationMarkerFill /> or refer to https://transferwise.github.io/icons/ for more info.");
  }
  return /*#__PURE__*/jsx("span", {
    className: `tw-icon tw-icon-location-marker ${className ? className : ''}`,
    "data-testid": restProps['data-testid'] || 'location-marker-icon',
    children: /*#__PURE__*/jsx("svg", {
      "aria-label": title,
      "aria-hidden": !title ? true : undefined,
      focusable: isFocusable,
      role: role ?? (title ? 'graphics-symbol img' : 'none'),
      width: String(size),
      height: String(size),
      fill: "currentColor",
      viewBox: "0 0 24 24",
      children: (Number(size) === 16 || Number(size) === 24 || Number(size) === 32) && /*#__PURE__*/jsx(Fragment, {
        children: /*#__PURE__*/jsx("path", {
          fillRule: "evenodd",
          d: "M6 10a6 6 0 1 1 12 0c0 1.017-.357 2.153-.963 3.332-.602 1.17-1.418 2.32-2.258 3.345A33 33 0 0 1 12 19.648a33 33 0 0 1-2.78-2.971c-.839-1.025-1.655-2.174-2.257-3.345C6.356 12.153 6 11.017 6 10m5.152 10.47v.002zm0 .002-.014.022zm1.696-.001-.016-.025.017.027zM12 2a8 8 0 0 0-8 8c0 1.457.501 2.919 1.185 4.247.688 1.338 1.595 2.606 2.488 3.697a34 34 0 0 0 3.651 3.794 1 1 0 0 0 1.352 0 34 34 0 0 0 3.65-3.794c.894-1.09 1.801-2.36 2.49-3.697C19.498 12.92 20 11.457 20 10a8 8 0 0 0-8-8m.852 19.524.01-.017-.005.008zM10 10a2 2 0 1 1 4 0 2 2 0 0 1-4 0m2-4a4 4 0 1 0 0 8 4 4 0 0 0 0-8",
          clipRule: "evenodd"
        })
      })
    })
  });
};

const LogIn = ({
  className = undefined,
  isFocusable = false,
  filled = undefined,
  title = undefined,
  role = undefined,
  size = 16,
  ...restProps
}) => {
  if (filled) {
    console.warn("<LogIn filled /> is now deprecated, please use <LogInFill /> or refer to https://transferwise.github.io/icons/ for more info.");
  }
  return /*#__PURE__*/jsx("span", {
    className: `tw-icon tw-icon-log-in ${className ? className : ''}`,
    "data-testid": restProps['data-testid'] || 'log-in-icon',
    children: /*#__PURE__*/jsx("svg", {
      "aria-label": title,
      "aria-hidden": !title ? true : undefined,
      focusable: isFocusable,
      role: role ?? (title ? 'graphics-symbol img' : 'none'),
      width: String(size),
      height: String(size),
      fill: "currentColor",
      viewBox: "0 0 24 24",
      children: (Number(size) === 16 || Number(size) === 24 || Number(size) === 32) && /*#__PURE__*/jsx(Fragment, {
        children: /*#__PURE__*/jsx("path", {
          fillRule: "evenodd",
          d: "M6 4h12v16H6v2h12.99A1.01 1.01 0 0 0 20 20.99V3.01A1.01 1.01 0 0 0 18.99 2H6zm-2 9v-2h8.586L8.293 6.707l1.414-1.414 5.993 5.993a1.01 1.01 0 0 1 0 1.428l-5.993 5.993-1.414-1.414L12.586 13z",
          clipRule: "evenodd"
        })
      })
    })
  });
};

const LogOut = ({
  className = undefined,
  isFocusable = false,
  filled = undefined,
  title = undefined,
  role = undefined,
  size = 16,
  ...restProps
}) => {
  if (filled) {
    console.warn("<LogOut filled /> is now deprecated, please use <LogOutFill /> or refer to https://transferwise.github.io/icons/ for more info.");
  }
  return /*#__PURE__*/jsx("span", {
    className: `tw-icon tw-icon-log-out ${className ? className : ''}`,
    "data-testid": restProps['data-testid'] || 'log-out-icon',
    children: /*#__PURE__*/jsx("svg", {
      "aria-label": title,
      "aria-hidden": !title ? true : undefined,
      focusable: isFocusable,
      role: role ?? (title ? 'graphics-symbol img' : 'none'),
      width: String(size),
      height: String(size),
      fill: "currentColor",
      viewBox: "0 0 24 24",
      children: (Number(size) === 16 || Number(size) === 24 || Number(size) === 32) && /*#__PURE__*/jsx(Fragment, {
        children: /*#__PURE__*/jsx("path", {
          fillRule: "evenodd",
          d: "M18 4H6v16h12v2H5.01A1.01 1.01 0 0 1 4 20.99V3.01C4 2.452 4.452 2 5.01 2H18zm-5.707 13.293L16.586 13H8v-2h8.586l-4.293-4.293 1.414-1.414 5.993 5.993a1.01 1.01 0 0 1 0 1.428l-5.993 5.993z",
          clipRule: "evenodd"
        })
      })
    })
  });
};

const Mallet = ({
  className = undefined,
  isFocusable = false,
  filled = undefined,
  title = undefined,
  role = undefined,
  size = 16,
  ...restProps
}) => {
  if (filled) {
    console.warn("<Mallet filled /> is now deprecated, please use <MalletFill /> or refer to https://transferwise.github.io/icons/ for more info.");
  }
  return /*#__PURE__*/jsx("span", {
    className: `tw-icon tw-icon-mallet ${className ? className : ''}`,
    "data-testid": restProps['data-testid'] || 'mallet-icon',
    children: /*#__PURE__*/jsx("svg", {
      "aria-label": title,
      "aria-hidden": !title ? true : undefined,
      focusable: isFocusable,
      role: role ?? (title ? 'graphics-symbol img' : 'none'),
      width: String(size),
      height: String(size),
      fill: "currentColor",
      viewBox: "0 0 24 24",
      children: (Number(size) === 16 || Number(size) === 24 || Number(size) === 32) && /*#__PURE__*/jsx(Fragment, {
        children: /*#__PURE__*/jsx("path", {
          fillRule: "evenodd",
          d: "m8.243 10.765 3.523-3.523 2.828 2.829-3.523 3.523zm4.242 4.243 1.055-1.054 5.753 5.753 1.414-1.414-5.753-5.753 1.054-1.055a1.01 1.01 0 0 0 1.422-.007l2.107-2.107a1.01 1.01 0 0 0 0-1.429L13.894 2.3a1.01 1.01 0 0 0-1.428 0l-2.107 2.107a1.01 1.01 0 0 0-.008 1.421L6.828 9.351a1.01 1.01 0 0 0-1.42.007L3.3 11.466a1.01 1.01 0 0 0 0 1.428l5.643 5.643a1.01 1.01 0 0 0 1.428 0l2.107-2.108a1.01 1.01 0 0 0 .007-1.42m4.938-6.351-.695.694-.007-.007-4.228-4.229-.008-.007.695-.694zm-7.766 7.765L5.414 12.18l.707-.707 4.243 4.242zM3 22h8v-2H3z",
          clipRule: "evenodd"
        })
      })
    })
  });
};

const MassPayout = ({
  className = undefined,
  isFocusable = false,
  filled = undefined,
  title = undefined,
  role = undefined,
  size = 16,
  ...restProps
}) => {
  if (filled) {
    console.warn("<MassPayout filled /> is now deprecated, please use <MassPayoutFill /> or refer to https://transferwise.github.io/icons/ for more info.");
  }
  return /*#__PURE__*/jsx("span", {
    className: `tw-icon tw-icon-mass-payout ${className ? className : ''}`,
    "data-testid": restProps['data-testid'] || 'mass-payout-icon',
    children: /*#__PURE__*/jsx("svg", {
      "aria-label": title,
      "aria-hidden": !title ? true : undefined,
      focusable: isFocusable,
      role: role ?? (title ? 'graphics-symbol img' : 'none'),
      width: String(size),
      height: String(size),
      fill: "currentColor",
      viewBox: "0 0 24 24",
      children: (Number(size) === 16 || Number(size) === 24 || Number(size) === 32) && /*#__PURE__*/jsx(Fragment, {
        children: /*#__PURE__*/jsx("path", {
          fillRule: "evenodd",
          d: "m13 5.414 1.293 1.293 1.414-1.414L12.714 2.3a1.01 1.01 0 0 0-1.428 0L8.293 5.293l1.414 1.414L11 5.414V8h2zm2 9.149V11H9v3.563l3 1.714zm2-2.67 1.058.55c.579.302.942.9.942 1.553v6.54a1.75 1.75 0 0 1-1.75 1.75H6.75A1.75 1.75 0 0 1 5 20.536v-6.54c0-.653.363-1.251.942-1.552L7 11.894v-1.886C7 9.45 7.451 9 8.008 9h7.985C16.549 9 17 9.451 17 10.008zm-4.5 6.402 4.5-2.572v4.563H7v-4.563l4.5 2.572c.31.177.69.177 1 0M7 7H5.414l1.414 1.414-1.414 1.414L4 8.414V10H2V6.01C2 5.452 2.452 5 3.01 5H7zm13 1.535V10h2V6.01A1.01 1.01 0 0 0 20.99 5H17v2h1.707l-1.414 1.414 1.414 1.414z",
          clipRule: "evenodd"
        })
      })
    })
  });
};

const Menu = ({
  className = undefined,
  isFocusable = false,
  filled = undefined,
  title = undefined,
  role = undefined,
  size = 16,
  ...restProps
}) => {
  if (filled) {
    console.warn("<Menu filled /> is now deprecated, please use <MenuFill /> or refer to https://transferwise.github.io/icons/ for more info.");
  }
  return /*#__PURE__*/jsx("span", {
    className: `tw-icon tw-icon-menu ${className ? className : ''}`,
    "data-testid": restProps['data-testid'] || 'menu-icon',
    children: /*#__PURE__*/jsx("svg", {
      "aria-label": title,
      "aria-hidden": !title ? true : undefined,
      focusable: isFocusable,
      role: role ?? (title ? 'graphics-symbol img' : 'none'),
      width: String(size),
      height: String(size),
      fill: "currentColor",
      viewBox: "0 0 24 24",
      children: (Number(size) === 16 || Number(size) === 24 || Number(size) === 32) && /*#__PURE__*/jsx(Fragment, {
        children: /*#__PURE__*/jsx("path", {
          fillRule: "evenodd",
          d: "M20 7H4V5h16zm0 6H4v-2h16zM4 19h16v-2H4z",
          clipRule: "evenodd"
        })
      })
    })
  });
};

const Messenger = ({
  className = undefined,
  isFocusable = false,
  filled = undefined,
  title = undefined,
  role = undefined,
  size = 16,
  ...restProps
}) => {
  if (filled) {
    console.warn("<Messenger filled /> is now deprecated, please use <MessengerFill /> or refer to https://transferwise.github.io/icons/ for more info.");
  }
  return /*#__PURE__*/jsx("span", {
    className: `tw-icon tw-icon-messenger ${className ? className : ''}`,
    "data-testid": restProps['data-testid'] || 'messenger-icon',
    children: /*#__PURE__*/jsx("svg", {
      "aria-label": title,
      "aria-hidden": !title ? true : undefined,
      focusable: isFocusable,
      role: role ?? (title ? 'graphics-symbol img' : 'none'),
      width: String(size),
      height: String(size),
      fill: "currentColor",
      viewBox: "0 0 24 24",
      children: (Number(size) === 16 || Number(size) === 24 || Number(size) === 32) && /*#__PURE__*/jsx(Fragment, {
        children: /*#__PURE__*/jsx("path", {
          d: "M11.871 1.713c-5.614 0-10.157 4.286-10.157 9.6 0 2.957 1.414 5.614 3.686 7.371v3.6l3.471-1.8c.943.3 1.972.429 3 .429 5.615 0 10.157-4.286 10.157-9.6s-4.542-9.6-10.157-9.6m1.072 12.943-2.657-2.829-5.143 2.743 5.528-5.871 2.657 2.657 5.143-2.743z"
        })
      })
    })
  });
};

const MinusCircleFill = ({
  className = undefined,
  isFocusable = false,
  filled = undefined,
  title = undefined,
  role = undefined,
  size = 16,
  ...restProps
}) => {
  if (filled) {
    console.warn("<MinusCircleFill filled /> is now deprecated, please use <MinusCircleFillFill /> or refer to https://transferwise.github.io/icons/ for more info.");
  }
  return /*#__PURE__*/jsx("span", {
    className: `tw-icon tw-icon-minus-circle-fill ${className ? className : ''}`,
    "data-testid": restProps['data-testid'] || 'minus-circle-fill-icon',
    children: /*#__PURE__*/jsx("svg", {
      "aria-label": title,
      "aria-hidden": !title ? true : undefined,
      focusable: isFocusable,
      role: role ?? (title ? 'graphics-symbol img' : 'none'),
      width: String(size),
      height: String(size),
      fill: "currentColor",
      viewBox: "0 0 24 24",
      children: (Number(size) === 16 || Number(size) === 24 || Number(size) === 32) && /*#__PURE__*/jsx(Fragment, {
        children: /*#__PURE__*/jsx("path", {
          fillRule: "evenodd",
          d: "M12 22c5.523 0 10-4.477 10-10S17.523 2 12 2 2 6.477 2 12s4.477 10 10 10m6-11H6v2h12z",
          clipRule: "evenodd"
        })
      })
    })
  });
};

const MinusCircle = ({
  className = undefined,
  isFocusable = false,
  filled = undefined,
  title = undefined,
  role = undefined,
  size = 16,
  ...restProps
}) => {
  if (filled) {
    console.warn("<MinusCircle filled /> is now deprecated, please use <MinusCircleFill /> or refer to https://transferwise.github.io/icons/ for more info.");
  }
  return /*#__PURE__*/jsx("span", {
    className: `tw-icon tw-icon-minus-circle ${className ? className : ''}`,
    "data-testid": restProps['data-testid'] || 'minus-circle-icon',
    children: /*#__PURE__*/jsx("svg", {
      "aria-label": title,
      "aria-hidden": !title ? true : undefined,
      focusable: isFocusable,
      role: role ?? (title ? 'graphics-symbol img' : 'none'),
      width: String(size),
      height: String(size),
      fill: "currentColor",
      viewBox: "0 0 24 24",
      children: (Number(size) === 16 || Number(size) === 24 || Number(size) === 32) && /*#__PURE__*/jsx(Fragment, {
        children: /*#__PURE__*/jsx("path", {
          fillRule: "evenodd",
          d: "M4 12a8 8 0 1 1 16 0 8 8 0 0 1-16 0m8-10C6.477 2 2 6.477 2 12s4.477 10 10 10 10-4.477 10-10S17.523 2 12 2m6 9H6v2h12z",
          clipRule: "evenodd"
        })
      })
    })
  });
};

const Minus = ({
  className = undefined,
  isFocusable = false,
  filled = undefined,
  title = undefined,
  role = undefined,
  size = 16,
  ...restProps
}) => {
  if (filled) {
    console.warn("<Minus filled /> is now deprecated, please use <MinusFill /> or refer to https://transferwise.github.io/icons/ for more info.");
  }
  return /*#__PURE__*/jsx("span", {
    className: `tw-icon tw-icon-minus ${className ? className : ''}`,
    "data-testid": restProps['data-testid'] || 'minus-icon',
    children: /*#__PURE__*/jsx("svg", {
      "aria-label": title,
      "aria-hidden": !title ? true : undefined,
      focusable: isFocusable,
      role: role ?? (title ? 'graphics-symbol img' : 'none'),
      width: String(size),
      height: String(size),
      fill: "currentColor",
      viewBox: "0 0 24 24",
      children: (Number(size) === 16 || Number(size) === 24 || Number(size) === 32) && /*#__PURE__*/jsx(Fragment, {
        children: /*#__PURE__*/jsx("path", {
          d: "M20 12v2H4v-2z"
        })
      })
    })
  });
};

const MobileLock = ({
  className = undefined,
  isFocusable = false,
  filled = undefined,
  title = undefined,
  role = undefined,
  size = 16,
  ...restProps
}) => {
  if (filled) {
    console.warn("<MobileLock filled /> is now deprecated, please use <MobileLockFill /> or refer to https://transferwise.github.io/icons/ for more info.");
  }
  return /*#__PURE__*/jsx("span", {
    className: `tw-icon tw-icon-mobile-lock ${className ? className : ''}`,
    "data-testid": restProps['data-testid'] || 'mobile-lock-icon',
    children: /*#__PURE__*/jsx("svg", {
      "aria-label": title,
      "aria-hidden": !title ? true : undefined,
      focusable: isFocusable,
      role: role ?? (title ? 'graphics-symbol img' : 'none'),
      width: String(size),
      height: String(size),
      fill: "currentColor",
      viewBox: "0 0 24 24",
      children: (Number(size) === 16 || Number(size) === 24 || Number(size) === 32) && /*#__PURE__*/jsx(Fragment, {
        children: /*#__PURE__*/jsx("path", {
          fillRule: "evenodd",
          d: "M8 4a2 2 0 0 1 2-2h10a2 2 0 0 1 2 2v16a2 2 0 0 1-2 2H4a2 2 0 0 1-2-2v-6.99c0-.558.452-1.01 1.01-1.01H4v-1a4 4 0 0 1 4-4zm2 3.535c1.196.692 2 1.984 2 3.465v1h.99c.558 0 1.01.452 1.01 1.01V20h6V4h-3v2h-4V4h-3zM12 20v-6H4v6zM8 9a2 2 0 0 0-2 2v1h4v-1a2 2 0 0 0-2-2m-1 7v2h2v-2z",
          clipRule: "evenodd"
        })
      })
    })
  });
};

const TwoStep = ({
  className = undefined,
  isFocusable = false,
  filled = undefined,
  title = undefined,
  role = undefined,
  size = 16,
  ...restProps
}) => {
  if (filled) {
    console.warn("<TwoStep filled /> is now deprecated, please use <TwoStepFill /> or refer to https://transferwise.github.io/icons/ for more info.");
  }
  return /*#__PURE__*/jsx("span", {
    className: `tw-icon tw-icon-two-step ${className ? className : ''}`,
    "data-testid": restProps['data-testid'] || 'two-step-icon',
    children: /*#__PURE__*/jsx("svg", {
      "aria-label": title,
      "aria-hidden": !title ? true : undefined,
      focusable: isFocusable,
      role: role ?? (title ? 'graphics-symbol img' : 'none'),
      width: String(size),
      height: String(size),
      fill: "currentColor",
      viewBox: "0 0 24 24",
      children: (Number(size) === 16 || Number(size) === 24 || Number(size) === 32) && /*#__PURE__*/jsx(Fragment, {
        children: /*#__PURE__*/jsx("path", {
          fillRule: "evenodd",
          d: "M8 4a2 2 0 0 1 2-2h10a2 2 0 0 1 2 2v16a2 2 0 0 1-2 2H4a2 2 0 0 1-2-2v-6.99c0-.558.452-1.01 1.01-1.01H4v-1a4 4 0 0 1 4-4zm2 3.535c1.196.692 2 1.984 2 3.465v1h.99c.558 0 1.01.452 1.01 1.01V20h6V4h-3v2h-4V4h-3zM12 20v-6H4v6zM8 9a2 2 0 0 0-2 2v1h4v-1a2 2 0 0 0-2-2m-1 7v2h2v-2z",
          clipRule: "evenodd"
        })
      })
    })
  });
};

const Mobile = ({
  className = undefined,
  isFocusable = false,
  filled = undefined,
  title = undefined,
  role = undefined,
  size = 16,
  ...restProps
}) => {
  if (filled) {
    console.warn("<Mobile filled /> is now deprecated, please use <MobileFill /> or refer to https://transferwise.github.io/icons/ for more info.");
  }
  return /*#__PURE__*/jsx("span", {
    className: `tw-icon tw-icon-mobile ${className ? className : ''}`,
    "data-testid": restProps['data-testid'] || 'mobile-icon',
    children: /*#__PURE__*/jsx("svg", {
      "aria-label": title,
      "aria-hidden": !title ? true : undefined,
      focusable: isFocusable,
      role: role ?? (title ? 'graphics-symbol img' : 'none'),
      width: String(size),
      height: String(size),
      fill: "currentColor",
      viewBox: "0 0 24 24",
      children: (Number(size) === 16 || Number(size) === 24 || Number(size) === 32) && /*#__PURE__*/jsx(Fragment, {
        children: /*#__PURE__*/jsx("path", {
          fillRule: "evenodd",
          d: "M7 2a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h10a2 2 0 0 0 2-2V4a2 2 0 0 0-2-2zm7 2h3v16H7V4h3v2h4z",
          clipRule: "evenodd"
        })
      })
    })
  });
};

const MoneyBag = ({
  className = undefined,
  isFocusable = false,
  filled = undefined,
  title = undefined,
  role = undefined,
  size = 16,
  ...restProps
}) => {
  if (filled) {
    console.warn("<MoneyBag filled /> is now deprecated, please use <MoneyBagFill /> or refer to https://transferwise.github.io/icons/ for more info.");
  }
  return /*#__PURE__*/jsx("span", {
    className: `tw-icon tw-icon-money-bag ${className ? className : ''}`,
    "data-testid": restProps['data-testid'] || 'money-bag-icon',
    children: /*#__PURE__*/jsx("svg", {
      "aria-label": title,
      "aria-hidden": !title ? true : undefined,
      focusable: isFocusable,
      role: role ?? (title ? 'graphics-symbol img' : 'none'),
      width: String(size),
      height: String(size),
      fill: "currentColor",
      viewBox: "0 0 24 24",
      children: (Number(size) === 16 || Number(size) === 24 || Number(size) === 32) && /*#__PURE__*/jsx(Fragment, {
        children: /*#__PURE__*/jsx("path", {
          fillRule: "evenodd",
          d: "M8.087 3.408A1.01 1.01 0 0 1 9.015 2h5.97c.725 0 1.214.741.928 1.408L14.803 6H15a1 1 0 0 1 .45 1.894q.056.046.11.096V8h-2.83.27-4.57l.12-.106A1 1 0 0 1 9 6h.198zM11 8H8.44c-3.68 3.18-4.32 7.06-4.42 8.42-.02.21-.02.36-.02.44v.05c0 1.4.57 2.67 1.5 3.59.92.92 2.19 1.5 3.6 1.5h5.79c2.81 0 5.1-2.29 5.11-5.09v-.02c0-.06 0-.21-.02-.42v-.09c-.11-1.39-.77-5.23-4.41-8.38H13c1.09.89 2.85 3.11 3.42 4.04 1.25 1.98 1.51 3.82 1.56 4.54.02.18.02.28.02.31v.01c0 1.71-1.39 3.1-3.11 3.1H9.1C7.39 20 6 18.61 6 16.9c0 0 0-.14.02-.32.05-.72.3-2.57 1.55-4.55h.01C8.16 11.11 9.91 8.89 11 8m2.483-4-.857 2h-1.252l-.857-2zM13 9v1h1v2h-2.5a.5.5 0 0 0 0 1h1a2.5 2.5 0 0 1 .5 4.95V19h-2v-1h-1v-2h2.5a.5.5 0 0 0 0-1h-1a2.5 2.5 0 0 1-.5-4.95V9z",
          clipRule: "evenodd"
        })
      })
    })
  });
};

const Money = ({
  className = undefined,
  isFocusable = false,
  filled = undefined,
  title = undefined,
  role = undefined,
  size = 16,
  ...restProps
}) => {
  if (filled) {
    console.warn("<Money filled /> is now deprecated, please use <MoneyFill /> or refer to https://transferwise.github.io/icons/ for more info.");
  }
  return /*#__PURE__*/jsx("span", {
    className: `tw-icon tw-icon-money ${className ? className : ''}`,
    "data-testid": restProps['data-testid'] || 'money-icon',
    children: /*#__PURE__*/jsx("svg", {
      "aria-label": title,
      "aria-hidden": !title ? true : undefined,
      focusable: isFocusable,
      role: role ?? (title ? 'graphics-symbol img' : 'none'),
      width: String(size),
      height: String(size),
      fill: "currentColor",
      viewBox: "0 0 24 24",
      children: (Number(size) === 16 || Number(size) === 24 || Number(size) === 32) && /*#__PURE__*/jsx(Fragment, {
        children: /*#__PURE__*/jsx("path", {
          fillRule: "evenodd",
          d: "M4 3a2 2 0 0 0-2 2v10a2 2 0 0 0 2 2h16a2 2 0 0 0 2-2V5a2 2 0 0 0-2-2zm0 4a2 2 0 0 0 2-2h12a2 2 0 0 0 2 2v6a2 2 0 0 0-2 2H6a2 2 0 0 0-2-2zm8 1a2 2 0 1 0 0 4 2 2 0 0 0 0-4m-4 2a4 4 0 1 1 8 0 4 4 0 0 1-8 0M2 21v-2h20v2z",
          clipRule: "evenodd"
        })
      })
    })
  });
};

const Moon = ({
  className = undefined,
  isFocusable = false,
  filled = undefined,
  title = undefined,
  role = undefined,
  size = 16,
  ...restProps
}) => {
  if (filled) {
    console.warn("<Moon filled /> is now deprecated, please use <MoonFill /> or refer to https://transferwise.github.io/icons/ for more info.");
  }
  return /*#__PURE__*/jsx("span", {
    className: `tw-icon tw-icon-moon ${className ? className : ''}`,
    "data-testid": restProps['data-testid'] || 'moon-icon',
    children: /*#__PURE__*/jsx("svg", {
      "aria-label": title,
      "aria-hidden": !title ? true : undefined,
      focusable: isFocusable,
      role: role ?? (title ? 'graphics-symbol img' : 'none'),
      width: String(size),
      height: String(size),
      fill: "currentColor",
      viewBox: "0 0 24 24",
      children: (Number(size) === 16 || Number(size) === 24 || Number(size) === 32) && /*#__PURE__*/jsxs(Fragment, {
        children: [/*#__PURE__*/jsx("path", {
          fillRule: "evenodd",
          d: "M8.975 4.163A1.009 1.009 0 0 0 7.522 3.11 10.09 10.09 0 0 0 2 12.13c0 5.567 4.467 10.1 10 10.1 4.177 0 7.747-2.58 9.238-6.246a1.008 1.008 0 0 0-1.22-1.35c-.36.107-1.583.43-3.119.424-1.535-.005-3.315-.335-4.873-1.463l-.002-.001c-1.847-1.33-2.678-3.263-3.012-5.125-.334-1.869-.149-3.58-.037-4.307M4 12.131a8.1 8.1 0 0 1 2.824-6.17c-.014.84.034 1.826.22 2.862.39 2.179 1.405 4.662 3.81 6.394 2.006 1.45 4.242 1.837 6.04 1.842.544.002 1.055-.031 1.515-.082A7.94 7.94 0 0 1 12 20.231c-4.407 0-8-3.617-8-8.1",
          clipRule: "evenodd"
        }), /*#__PURE__*/jsx("path", {
          d: "M16.18 4.309a.4.4 0 0 0-.758 0l-.83 2.433a.4.4 0 0 1-.25.249l-2.433.83a.4.4 0 0 0 0 .758l2.433.83a.4.4 0 0 1 .25.25l.83 2.433a.4.4 0 0 0 .757 0l.831-2.433a.4.4 0 0 1 .25-.25l2.432-.83a.4.4 0 0 0 0-.757L17.26 6.99a.4.4 0 0 1-.249-.25z"
        })]
      })
    })
  });
};

const More = ({
  className = undefined,
  isFocusable = false,
  filled = undefined,
  title = undefined,
  role = undefined,
  size = 16,
  ...restProps
}) => {
  if (filled) {
    console.warn("<More filled /> is now deprecated, please use <MoreFill /> or refer to https://transferwise.github.io/icons/ for more info.");
  }
  return /*#__PURE__*/jsx("span", {
    className: `tw-icon tw-icon-more ${className ? className : ''}`,
    "data-testid": restProps['data-testid'] || 'more-icon',
    children: /*#__PURE__*/jsx("svg", {
      "aria-label": title,
      "aria-hidden": !title ? true : undefined,
      focusable: isFocusable,
      role: role ?? (title ? 'graphics-symbol img' : 'none'),
      width: String(size),
      height: String(size),
      fill: "currentColor",
      viewBox: "0 0 24 24",
      children: (Number(size) === 16 || Number(size) === 24 || Number(size) === 32) && /*#__PURE__*/jsx(Fragment, {
        children: /*#__PURE__*/jsx("path", {
          fillRule: "evenodd",
          d: "M5 15a2 2 0 1 0 0-4 2 2 0 0 0 0 4m9-2a2 2 0 1 1-4 0 2 2 0 0 1 4 0m7 0a2 2 0 1 1-4 0 2 2 0 0 1 4 0",
          clipRule: "evenodd"
        })
      })
    })
  });
};

const MultiCurrency = ({
  className = undefined,
  isFocusable = false,
  filled = undefined,
  title = undefined,
  role = undefined,
  size = 16,
  ...restProps
}) => {
  if (filled) {
    console.warn("<MultiCurrency filled /> is now deprecated, please use <MultiCurrencyFill /> or refer to https://transferwise.github.io/icons/ for more info.");
  }
  return /*#__PURE__*/jsx("span", {
    className: `tw-icon tw-icon-multi-currency ${className ? className : ''}`,
    "data-testid": restProps['data-testid'] || 'multi-currency-icon',
    children: /*#__PURE__*/jsx("svg", {
      "aria-label": title,
      "aria-hidden": !title ? true : undefined,
      focusable: isFocusable,
      role: role ?? (title ? 'graphics-symbol img' : 'none'),
      width: String(size),
      height: String(size),
      fill: "currentColor",
      viewBox: "0 0 24 24",
      children: (Number(size) === 16 || Number(size) === 24 || Number(size) === 32) && /*#__PURE__*/jsx(Fragment, {
        children: /*#__PURE__*/jsx("path", {
          fillRule: "evenodd",
          d: "M12 5.5a1.5 1.5 0 1 1 3 0 1.5 1.5 0 0 1-3 0M13.5 2a3.5 3.5 0 1 0 3.063 5.196 7.5 7.5 0 0 1 3.313 4.945l1.967-.362a9.5 9.5 0 0 0-4.863-6.656A3.5 3.5 0 0 0 13.5 2M4 15.5a1.5 1.5 0 1 1 3 0 1.5 1.5 0 0 1-3 0m-.883-2.563a3.5 3.5 0 1 0 2.018-.918 7.5 7.5 0 0 1 2.611-5.116L6.45 5.381a9.5 9.5 0 0 0-3.332 7.556M18.5 16a1.5 1.5 0 1 0 0 3 1.5 1.5 0 0 0 0-3M15 17.5a3.5 3.5 0 1 1 1.807 3.064 9.5 9.5 0 0 1-8.376.999l.67-1.885a7.5 7.5 0 0 0 6.282-.584A3.5 3.5 0 0 1 15 17.5",
          clipRule: "evenodd"
        })
      })
    })
  });
};

const NavigateAway = ({
  className = undefined,
  isFocusable = false,
  filled = undefined,
  title = undefined,
  role = undefined,
  size = 16,
  ...restProps
}) => {
  if (filled) {
    console.warn("<NavigateAway filled /> is now deprecated, please use <NavigateAwayFill /> or refer to https://transferwise.github.io/icons/ for more info.");
  }
  return /*#__PURE__*/jsx("span", {
    className: `tw-icon tw-icon-navigate-away ${className ? className : ''}`,
    "data-testid": restProps['data-testid'] || 'navigate-away-icon',
    children: /*#__PURE__*/jsx("svg", {
      "aria-label": title,
      "aria-hidden": !title ? true : undefined,
      focusable: isFocusable,
      role: role ?? (title ? 'graphics-symbol img' : 'none'),
      width: String(size),
      height: String(size),
      fill: "currentColor",
      viewBox: "0 0 24 24",
      children: (Number(size) === 16 || Number(size) === 24 || Number(size) === 32) && /*#__PURE__*/jsx(Fragment, {
        children: /*#__PURE__*/jsx("path", {
          fillRule: "evenodd",
          d: "M5 3a2 2 0 0 0-2 2v14a2 2 0 0 0 2 2h14a2 2 0 0 0 2-2v-5h-2v5H5V5h5V3zm16 7V4.01A1.01 1.01 0 0 0 19.99 3H14v2h4l-6.707 6.707 1.414 1.414L19 6.828V10z",
          clipRule: "evenodd"
        })
      })
    })
  });
};

const Nearby = ({
  className = undefined,
  isFocusable = false,
  filled = undefined,
  title = undefined,
  role = undefined,
  size = 16,
  ...restProps
}) => {
  if (filled) {
    console.warn("<Nearby filled /> is now deprecated, please use <NearbyFill /> or refer to https://transferwise.github.io/icons/ for more info.");
  }
  return /*#__PURE__*/jsx("span", {
    className: `tw-icon tw-icon-nearby ${className ? className : ''}`,
    "data-testid": restProps['data-testid'] || 'nearby-icon',
    children: /*#__PURE__*/jsx("svg", {
      "aria-label": title,
      "aria-hidden": !title ? true : undefined,
      focusable: isFocusable,
      role: role ?? (title ? 'graphics-symbol img' : 'none'),
      width: String(size),
      height: String(size),
      fill: "currentColor",
      viewBox: "0 0 24 24",
      children: (Number(size) === 16 || Number(size) === 24 || Number(size) === 32) && /*#__PURE__*/jsx(Fragment, {
        children: /*#__PURE__*/jsx("path", {
          fillRule: "evenodd",
          d: "M4.593 8.973a8 8 0 1 0 3.283-3.83 3 3 0 0 0-1.183-1.62A9.95 9.95 0 0 1 12 2c5.523 0 10 4.477 10 10s-4.477 10-10 10S2 17.523 2 12c0-1.403.289-2.738.81-3.95.46.491 1.083.828 1.783.923M12 8a4 4 0 1 0 4 4c.748 0 1.431-.273 1.957-.726q.042.357.043.726a6 6 0 1 1-3.635-5.516A3 3 0 0 0 13.12 8.16 4 4 0 0 0 12 8m1.5 4a1.5 1.5 0 1 0-3 0 1.5 1.5 0 0 0 3 0M16 7.5a1.5 1.5 0 1 1 0 3 1.5 1.5 0 0 1 0-3M6.5 6a1.5 1.5 0 1 0-3 0 1.5 1.5 0 0 0 3 0",
          clipRule: "evenodd"
        })
      })
    })
  });
};

const NeutralEmoji = ({
  className = undefined,
  isFocusable = false,
  filled = undefined,
  title = undefined,
  role = undefined,
  size = 16,
  ...restProps
}) => {
  if (filled) {
    console.warn("<NeutralEmoji filled /> is now deprecated, please use <NeutralEmojiFill /> or refer to https://transferwise.github.io/icons/ for more info.");
  }
  return /*#__PURE__*/jsx("span", {
    className: `tw-icon tw-icon-neutral-emoji ${className ? className : ''}`,
    "data-testid": restProps['data-testid'] || 'neutral-emoji-icon',
    children: /*#__PURE__*/jsx("svg", {
      "aria-label": title,
      "aria-hidden": !title ? true : undefined,
      focusable: isFocusable,
      role: role ?? (title ? 'graphics-symbol img' : 'none'),
      width: String(size),
      height: String(size),
      fill: "currentColor",
      viewBox: "0 0 24 24",
      children: (Number(size) === 16 || Number(size) === 24 || Number(size) === 32) && /*#__PURE__*/jsxs(Fragment, {
        children: [/*#__PURE__*/jsx("path", {
          d: "M16 16.527H8v-2h8zM8.5 9a1.5 1.5 0 1 1 0 3 1.5 1.5 0 0 1 0-3m7 0a1.5 1.5 0 1 1 0 3 1.5 1.5 0 0 1 0-3"
        }), /*#__PURE__*/jsx("path", {
          fillRule: "evenodd",
          d: "M12 2c5.523 0 10 4.477 10 10s-4.477 10-10 10S2 17.523 2 12 6.477 2 12 2m0 2a8 8 0 1 0 0 16 8 8 0 0 0 0-16",
          clipRule: "evenodd"
        })]
      })
    })
  });
};

const New = ({
  className = undefined,
  isFocusable = false,
  filled = undefined,
  title = undefined,
  role = undefined,
  size = 16,
  ...restProps
}) => {
  if (filled) {
    console.warn("<New filled /> is now deprecated, please use <NewFill /> or refer to https://transferwise.github.io/icons/ for more info.");
  }
  return /*#__PURE__*/jsx("span", {
    className: `tw-icon tw-icon-new ${className ? className : ''}`,
    "data-testid": restProps['data-testid'] || 'new-icon',
    children: /*#__PURE__*/jsx("svg", {
      "aria-label": title,
      "aria-hidden": !title ? true : undefined,
      focusable: isFocusable,
      role: role ?? (title ? 'graphics-symbol img' : 'none'),
      width: String(size),
      height: String(size),
      fill: "currentColor",
      viewBox: "0 0 24 24",
      children: (Number(size) === 16 || Number(size) === 24 || Number(size) === 32) && /*#__PURE__*/jsx(Fragment, {
        children: /*#__PURE__*/jsx("path", {
          fillRule: "evenodd",
          d: "M11.298 2.288a1.01 1.01 0 0 1 1.404 0l1.867 1.806 2.571-.364a1.01 1.01 0 0 1 1.137.826l.448 2.558L21.02 8.33c.481.255.673.846.434 1.336L20.314 12l1.14 2.333a1.01 1.01 0 0 1-.434 1.336l-2.294 1.217-.45 2.558a1.01 1.01 0 0 1-1.136.826l-2.571-.364-1.867 1.806a1.01 1.01 0 0 1-1.404 0L9.43 19.906l-2.571.364a1.01 1.01 0 0 1-1.137-.826l-.448-2.558L2.98 15.67a1.01 1.01 0 0 1-.434-1.336L3.687 12l-1.14-2.333A1.01 1.01 0 0 1 2.98 8.33l2.295-1.217.448-2.558A1.01 1.01 0 0 1 6.86 3.73l2.571.364zM12 4.391l-1.526 1.477a1.01 1.01 0 0 1-.844.274l-2.102-.298-.367 2.092a1.01 1.01 0 0 1-.521.718l-1.876.995.932 1.907c.137.28.137.608 0 .888l-.932 1.907 1.876.995c.275.146.467.411.521.718l.367 2.092 2.102-.298c.309-.044.62.058.844.274L12 19.61l1.526-1.477a1.01 1.01 0 0 1 .844-.274l2.102.297.367-2.09a1.01 1.01 0 0 1 .522-.719l1.875-.995-.932-1.907a1.01 1.01 0 0 1 0-.888l.932-1.907-1.875-.995a1.01 1.01 0 0 1-.522-.718l-.367-2.092-2.102.298a1.01 1.01 0 0 1-.844-.274z",
          clipRule: "evenodd"
        })
      })
    })
  });
};

const NotificationActive = ({
  className = undefined,
  isFocusable = false,
  filled = undefined,
  title = undefined,
  role = undefined,
  size = 16,
  ...restProps
}) => {
  if (filled) {
    console.warn("<NotificationActive filled /> is now deprecated, please use <NotificationActiveFill /> or refer to https://transferwise.github.io/icons/ for more info.");
  }
  return /*#__PURE__*/jsx("span", {
    className: `tw-icon tw-icon-notification-active ${className ? className : ''}`,
    "data-testid": restProps['data-testid'] || 'notification-active-icon',
    children: /*#__PURE__*/jsx("svg", {
      "aria-label": title,
      "aria-hidden": !title ? true : undefined,
      focusable: isFocusable,
      role: role ?? (title ? 'graphics-symbol img' : 'none'),
      width: String(size),
      height: String(size),
      fill: "currentColor",
      viewBox: "0 0 24 24",
      children: (Number(size) === 16 || Number(size) === 24 || Number(size) === 32) && /*#__PURE__*/jsx(Fragment, {
        children: /*#__PURE__*/jsx("path", {
          fillRule: "evenodd",
          d: "M1.837 5.79a11 11 0 0 1 2.385-3.568l1.414 1.414A9 9 0 0 0 3 10H1a11 11 0 0 1 .837-4.21m20.326 0a11 11 0 0 0-2.385-3.568l-1.414 1.414A9 9 0 0 1 21 10h2a11 11 0 0 0-.837-4.21M5 10a7 7 0 1 1 14 0v3c0 .332.082.51.15.61q.11.157.316.255C20.084 14.159 21 14.86 21 16v1a2 2 0 0 1-2 2h-4a3 3 0 1 1-6 0H5a2 2 0 0 1-2-2v-1c0-1.139.916-1.84 1.534-2.136a.8.8 0 0 0 .316-.255c.068-.099.15-.277.15-.609zm6.076 9.383A1 1 0 0 1 11 19h2a1.001 1.001 0 0 1-1.924.383M12 5a5 5 0 0 0-5 5v3c0 .691-.18 1.274-.502 1.742-.316.46-.728.749-1.102.927a1.1 1.1 0 0 0-.34.246.3.3 0 0 0-.056.088V17h14v-.997a.3.3 0 0 0-.056-.088 1.1 1.1 0 0 0-.34-.245 2.77 2.77 0 0 1-1.102-.928C17.18 14.274 17 13.692 17 13v-3a5 5 0 0 0-5-5m7 11.003v.003z",
          clipRule: "evenodd"
        })
      })
    })
  });
};

const Notification = ({
  className = undefined,
  isFocusable = false,
  filled = undefined,
  title = undefined,
  role = undefined,
  size = 16,
  ...restProps
}) => {
  if (filled) {
    console.warn("<Notification filled /> is now deprecated, please use <NotificationFill /> or refer to https://transferwise.github.io/icons/ for more info.");
  }
  return /*#__PURE__*/jsx("span", {
    className: `tw-icon tw-icon-notification ${className ? className : ''}`,
    "data-testid": restProps['data-testid'] || 'notification-icon',
    children: /*#__PURE__*/jsx("svg", {
      "aria-label": title,
      "aria-hidden": !title ? true : undefined,
      focusable: isFocusable,
      role: role ?? (title ? 'graphics-symbol img' : 'none'),
      width: String(size),
      height: String(size),
      fill: "currentColor",
      viewBox: "0 0 24 24",
      children: (Number(size) === 16 || Number(size) === 24 || Number(size) === 32) && /*#__PURE__*/jsx(Fragment, {
        children: /*#__PURE__*/jsx("path", {
          fillRule: "evenodd",
          d: "M12 3a7 7 0 0 0-7 7v3c0 .332-.082.51-.15.61a.8.8 0 0 1-.316.255C3.916 14.159 3 14.86 3 16v1a2 2 0 0 0 2 2h4a3 3 0 0 0 6 0h4a2 2 0 0 0 2-2v-1c0-1.139-.916-1.84-1.534-2.136a.8.8 0 0 1-.316-.255c-.068-.099-.15-.277-.15-.609v-3a7 7 0 0 0-7-7m1 16h-2a1.001 1.001 0 0 0 2 0m-6-9a5 5 0 1 1 10 0v3c0 .691.18 1.274.502 1.742.316.46.728.749 1.102.927.15.072.27.164.34.246a.3.3 0 0 1 .056.088V17H5v-.997a.3.3 0 0 1 .056-.088c.07-.082.19-.174.34-.245a2.77 2.77 0 0 0 1.102-.928C6.82 14.274 7 13.692 7 13z",
          clipRule: "evenodd"
        })
      })
    })
  });
};

const PadlockUnlocked = ({
  className = undefined,
  isFocusable = false,
  filled = undefined,
  title = undefined,
  role = undefined,
  size = 16,
  ...restProps
}) => {
  if (filled) {
    console.warn("<PadlockUnlocked filled /> is now deprecated, please use <PadlockUnlockedFill /> or refer to https://transferwise.github.io/icons/ for more info.");
  }
  return /*#__PURE__*/jsx("span", {
    className: `tw-icon tw-icon-padlock-unlocked ${className ? className : ''}`,
    "data-testid": restProps['data-testid'] || 'padlock-unlocked-icon',
    children: /*#__PURE__*/jsx("svg", {
      "aria-label": title,
      "aria-hidden": !title ? true : undefined,
      focusable: isFocusable,
      role: role ?? (title ? 'graphics-symbol img' : 'none'),
      width: String(size),
      height: String(size),
      fill: "currentColor",
      viewBox: "0 0 24 24",
      children: (Number(size) === 16 || Number(size) === 24 || Number(size) === 32) && /*#__PURE__*/jsx(Fragment, {
        children: /*#__PURE__*/jsx("path", {
          fillRule: "evenodd",
          d: "M12 3a5 5 0 0 0-5 5v1H5.01A1.01 1.01 0 0 0 4 10.01V19a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2v-8.99A1.01 1.01 0 0 0 18.99 9H9V8a3 3 0 0 1 5.905-.75l1.936-.5A5 5 0 0 0 12 3m-6 8v8h12v-8zm5 6v-4h2v4z",
          clipRule: "evenodd"
        })
      })
    })
  });
};

const Unlock = ({
  className = undefined,
  isFocusable = false,
  filled = undefined,
  title = undefined,
  role = undefined,
  size = 16,
  ...restProps
}) => {
  if (filled) {
    console.warn("<Unlock filled /> is now deprecated, please use <UnlockFill /> or refer to https://transferwise.github.io/icons/ for more info.");
  }
  return /*#__PURE__*/jsx("span", {
    className: `tw-icon tw-icon-unlock ${className ? className : ''}`,
    "data-testid": restProps['data-testid'] || 'unlock-icon',
    children: /*#__PURE__*/jsx("svg", {
      "aria-label": title,
      "aria-hidden": !title ? true : undefined,
      focusable: isFocusable,
      role: role ?? (title ? 'graphics-symbol img' : 'none'),
      width: String(size),
      height: String(size),
      fill: "currentColor",
      viewBox: "0 0 24 24",
      children: (Number(size) === 16 || Number(size) === 24 || Number(size) === 32) && /*#__PURE__*/jsx(Fragment, {
        children: /*#__PURE__*/jsx("path", {
          fillRule: "evenodd",
          d: "M12 3a5 5 0 0 0-5 5v1H5.01A1.01 1.01 0 0 0 4 10.01V19a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2v-8.99A1.01 1.01 0 0 0 18.99 9H9V8a3 3 0 0 1 5.905-.75l1.936-.5A5 5 0 0 0 12 3m-6 8v8h12v-8zm5 6v-4h2v4z",
          clipRule: "evenodd"
        })
      })
    })
  });
};

const Padlock = ({
  className = undefined,
  isFocusable = false,
  filled = undefined,
  title = undefined,
  role = undefined,
  size = 16,
  ...restProps
}) => {
  if (filled) {
    console.warn("<Padlock filled /> is now deprecated, please use <PadlockFill /> or refer to https://transferwise.github.io/icons/ for more info.");
  }
  return /*#__PURE__*/jsx("span", {
    className: `tw-icon tw-icon-padlock ${className ? className : ''}`,
    "data-testid": restProps['data-testid'] || 'padlock-icon',
    children: /*#__PURE__*/jsx("svg", {
      "aria-label": title,
      "aria-hidden": !title ? true : undefined,
      focusable: isFocusable,
      role: role ?? (title ? 'graphics-symbol img' : 'none'),
      width: String(size),
      height: String(size),
      fill: "currentColor",
      viewBox: "0 0 24 24",
      children: (Number(size) === 16 || Number(size) === 24 || Number(size) === 32) && /*#__PURE__*/jsx(Fragment, {
        children: /*#__PURE__*/jsx("path", {
          fillRule: "evenodd",
          d: "M12 3a5 5 0 0 0-5 5v1H5.01A1.01 1.01 0 0 0 4 10.01V19a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2v-8.99A1.01 1.01 0 0 0 18.99 9H17V8a5 5 0 0 0-5-5m3 6V8a3 3 0 0 0-6 0v1zm-9 2v8h12v-8zm5 6v-4h2v4z",
          clipRule: "evenodd"
        })
      })
    })
  });
};

const Lock = ({
  className = undefined,
  isFocusable = false,
  filled = undefined,
  title = undefined,
  role = undefined,
  size = 16,
  ...restProps
}) => {
  if (filled) {
    console.warn("<Lock filled /> is now deprecated, please use <LockFill /> or refer to https://transferwise.github.io/icons/ for more info.");
  }
  return /*#__PURE__*/jsx("span", {
    className: `tw-icon tw-icon-lock ${className ? className : ''}`,
    "data-testid": restProps['data-testid'] || 'lock-icon',
    children: /*#__PURE__*/jsx("svg", {
      "aria-label": title,
      "aria-hidden": !title ? true : undefined,
      focusable: isFocusable,
      role: role ?? (title ? 'graphics-symbol img' : 'none'),
      width: String(size),
      height: String(size),
      fill: "currentColor",
      viewBox: "0 0 24 24",
      children: (Number(size) === 16 || Number(size) === 24 || Number(size) === 32) && /*#__PURE__*/jsx(Fragment, {
        children: /*#__PURE__*/jsx("path", {
          fillRule: "evenodd",
          d: "M12 3a5 5 0 0 0-5 5v1H5.01A1.01 1.01 0 0 0 4 10.01V19a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2v-8.99A1.01 1.01 0 0 0 18.99 9H17V8a5 5 0 0 0-5-5m3 6V8a3 3 0 0 0-6 0v1zm-9 2v8h12v-8zm5 6v-4h2v4z",
          clipRule: "evenodd"
        })
      })
    })
  });
};

const Paperclip = ({
  className = undefined,
  isFocusable = false,
  filled = undefined,
  title = undefined,
  role = undefined,
  size = 16,
  ...restProps
}) => {
  if (filled) {
    console.warn("<Paperclip filled /> is now deprecated, please use <PaperclipFill /> or refer to https://transferwise.github.io/icons/ for more info.");
  }
  return /*#__PURE__*/jsx("span", {
    className: `tw-icon tw-icon-paperclip ${className ? className : ''}`,
    "data-testid": restProps['data-testid'] || 'paperclip-icon',
    children: /*#__PURE__*/jsx("svg", {
      "aria-label": title,
      "aria-hidden": !title ? true : undefined,
      focusable: isFocusable,
      role: role ?? (title ? 'graphics-symbol img' : 'none'),
      width: String(size),
      height: String(size),
      fill: "currentColor",
      viewBox: "0 0 24 24",
      children: (Number(size) === 16 || Number(size) === 24 || Number(size) === 32) && /*#__PURE__*/jsx(Fragment, {
        children: /*#__PURE__*/jsx("path", {
          fillRule: "evenodd",
          d: "M19 15a7 7 0 1 1-14 0V7h2v8a5 5 0 0 0 10 0V7a3 3 0 1 0-6 0v8a1 1 0 1 0 2 0V7h2v8a3 3 0 1 1-6 0V7a5 5 0 0 1 10 0z",
          clipRule: "evenodd"
        })
      })
    })
  });
};

const Passport = ({
  className = undefined,
  isFocusable = false,
  filled = undefined,
  title = undefined,
  role = undefined,
  size = 16,
  ...restProps
}) => {
  if (filled) {
    console.warn("<Passport filled /> is now deprecated, please use <PassportFill /> or refer to https://transferwise.github.io/icons/ for more info.");
  }
  return /*#__PURE__*/jsx("span", {
    className: `tw-icon tw-icon-passport ${className ? className : ''}`,
    "data-testid": restProps['data-testid'] || 'passport-icon',
    children: /*#__PURE__*/jsx("svg", {
      "aria-label": title,
      "aria-hidden": !title ? true : undefined,
      focusable: isFocusable,
      role: role ?? (title ? 'graphics-symbol img' : 'none'),
      width: String(size),
      height: String(size),
      fill: "currentColor",
      viewBox: "0 0 24 24",
      children: (Number(size) === 16 || Number(size) === 24 || Number(size) === 32) && /*#__PURE__*/jsx(Fragment, {
        children: /*#__PURE__*/jsx("path", {
          fillRule: "evenodd",
          d: "M6 4v16h11a1 1 0 0 0 1-1V5a1 1 0 0 0-1-1zM5 2a1 1 0 0 0-1 1v18a1 1 0 0 0 1 1h12a3 3 0 0 0 3-3V5a3 3 0 0 0-3-3zm4 16v-2h6v2zm5-8a2 2 0 1 1-4 0 2 2 0 0 1 4 0m2 0a4 4 0 1 1-8 0 4 4 0 0 1 8 0",
          clipRule: "evenodd"
        })
      })
    })
  });
};

const Pause = ({
  className = undefined,
  isFocusable = false,
  filled = undefined,
  title = undefined,
  role = undefined,
  size = 16,
  ...restProps
}) => {
  if (filled) {
    console.warn("<Pause filled /> is now deprecated, please use <PauseFill /> or refer to https://transferwise.github.io/icons/ for more info.");
  }
  return /*#__PURE__*/jsx("span", {
    className: `tw-icon tw-icon-pause ${className ? className : ''}`,
    "data-testid": restProps['data-testid'] || 'pause-icon',
    children: /*#__PURE__*/jsx("svg", {
      "aria-label": title,
      "aria-hidden": !title ? true : undefined,
      focusable: isFocusable,
      role: role ?? (title ? 'graphics-symbol img' : 'none'),
      width: String(size),
      height: String(size),
      fill: "currentColor",
      viewBox: "0 0 24 24",
      children: (Number(size) === 16 || Number(size) === 24 || Number(size) === 32) && /*#__PURE__*/jsx(Fragment, {
        children: /*#__PURE__*/jsx("path", {
          fillRule: "evenodd",
          d: "M12 4a8 8 0 1 0 0 16 8 8 0 0 0 0-16M2 12C2 6.477 6.477 2 12 2s10 4.477 10 10-4.477 10-10 10S2 17.523 2 12m7-3h2v6H9zm6 0h-2v6h2z",
          clipRule: "evenodd"
        })
      })
    })
  });
};

const PayIn = ({
  className = undefined,
  isFocusable = false,
  filled = undefined,
  title = undefined,
  role = undefined,
  size = 16,
  ...restProps
}) => {
  if (filled) {
    console.warn("<PayIn filled /> is now deprecated, please use <PayInFill /> or refer to https://transferwise.github.io/icons/ for more info.");
  }
  return /*#__PURE__*/jsx("span", {
    className: `tw-icon tw-icon-pay-in ${className ? className : ''}`,
    "data-testid": restProps['data-testid'] || 'pay-in-icon',
    children: /*#__PURE__*/jsx("svg", {
      "aria-label": title,
      "aria-hidden": !title ? true : undefined,
      focusable: isFocusable,
      role: role ?? (title ? 'graphics-symbol img' : 'none'),
      width: String(size),
      height: String(size),
      fill: "currentColor",
      viewBox: "0 0 24 24",
      children: (Number(size) === 16 || Number(size) === 24 || Number(size) === 32) && /*#__PURE__*/jsx(Fragment, {
        children: /*#__PURE__*/jsx("path", {
          fillRule: "evenodd",
          d: "M16 10.632V5H8v5.632l4 2.666zm2-1.334 1.08-.72-1.08-.6zm0-3.609 2.971 1.651A2 2 0 0 1 22 9.088V19a2 2 0 0 1-2 2H4a2 2 0 0 1-2-2V9.088A2 2 0 0 1 3.029 7.34L6 5.69V4.01C6 3.452 6.452 3 7.01 3h9.98c.558 0 1.01.452 1.01 1.01zM6 9.3V7.976l-1.08.6zM4 19v-8.631l7.44 4.96a1.01 1.01 0 0 0 1.12 0l7.44-4.96V19z",
          clipRule: "evenodd"
        })
      })
    })
  });
};

const Salary = ({
  className = undefined,
  isFocusable = false,
  filled = undefined,
  title = undefined,
  role = undefined,
  size = 16,
  ...restProps
}) => {
  if (filled) {
    console.warn("<Salary filled /> is now deprecated, please use <SalaryFill /> or refer to https://transferwise.github.io/icons/ for more info.");
  }
  return /*#__PURE__*/jsx("span", {
    className: `tw-icon tw-icon-salary ${className ? className : ''}`,
    "data-testid": restProps['data-testid'] || 'salary-icon',
    children: /*#__PURE__*/jsx("svg", {
      "aria-label": title,
      "aria-hidden": !title ? true : undefined,
      focusable: isFocusable,
      role: role ?? (title ? 'graphics-symbol img' : 'none'),
      width: String(size),
      height: String(size),
      fill: "currentColor",
      viewBox: "0 0 24 24",
      children: (Number(size) === 16 || Number(size) === 24 || Number(size) === 32) && /*#__PURE__*/jsx(Fragment, {
        children: /*#__PURE__*/jsx("path", {
          fillRule: "evenodd",
          d: "M16 10.632V5H8v5.632l4 2.666zm2-1.334 1.08-.72-1.08-.6zm0-3.609 2.971 1.651A2 2 0 0 1 22 9.088V19a2 2 0 0 1-2 2H4a2 2 0 0 1-2-2V9.088A2 2 0 0 1 3.029 7.34L6 5.69V4.01C6 3.452 6.452 3 7.01 3h9.98c.558 0 1.01.452 1.01 1.01zM6 9.3V7.976l-1.08.6zM4 19v-8.631l7.44 4.96a1.01 1.01 0 0 0 1.12 0l7.44-4.96V19z",
          clipRule: "evenodd"
        })
      })
    })
  });
};

const PayNow = ({
  className = undefined,
  isFocusable = false,
  filled = undefined,
  title = undefined,
  role = undefined,
  size = 16,
  ...restProps
}) => {
  if (filled) {
    console.warn("<PayNow filled /> is now deprecated, please use <PayNowFill /> or refer to https://transferwise.github.io/icons/ for more info.");
  }
  return /*#__PURE__*/jsx("span", {
    className: `tw-icon tw-icon-pay-now ${className ? className : ''}`,
    "data-testid": restProps['data-testid'] || 'pay-now-icon',
    children: /*#__PURE__*/jsx("svg", {
      "aria-label": title,
      "aria-hidden": !title ? true : undefined,
      focusable: isFocusable,
      role: role ?? (title ? 'graphics-symbol img' : 'none'),
      width: String(size),
      height: String(size),
      fill: "currentColor",
      viewBox: "0 0 24 24",
      children: (Number(size) === 16 || Number(size) === 24 || Number(size) === 32) && /*#__PURE__*/jsx(Fragment, {
        children: /*#__PURE__*/jsx("path", {
          fillRule: "evenodd",
          d: "M5.143 1.714a3.43 3.43 0 0 0-3.429 3.429v13.714a3.43 3.43 0 0 0 3.429 3.429h13.714a3.43 3.43 0 0 0 3.429-3.429V5.143a3.43 3.43 0 0 0-3.429-3.429zm7.718 10.048c.192-.255.263-.26.49-.04a3.11 3.11 0 0 1 .696 3.438 3.09 3.09 0 0 1-3.01 1.867c-1.46-.069-2.654-1.078-2.912-2.525-.263-1.465.483-2.773 1.743-3.365l.05-.02c.089-.034.187-.071.13-.2a1 1 0 0 1-.042-.132c-.035-.139-.071-.279-.29-.275-.41.005-.822 0-1.232-.005-.131-.003-.2.053-.248.172-.214.526-.217.526-.788.526H7.43c-.268.001-.392.002-.426-.053-.03-.048.006-.136.073-.301l.049-.122q.697-1.76 1.391-3.521l.002-.004c.122-.31.126-.32.466-.312q.178.002.292-.002c.144-.003.225-.005.284.03.075.044.114.148.203.384l.006.017.06.158.215.56q.49 1.27.972 2.549c.075.207.187.3.412.286.103-.008.21.014.314.037h.001l.077.016c.122.025.19-.013.19-.142l.001-.21q.006-.518-.001-1.042a.6.6 0 0 0-.092-.245l-.012-.02q-.298-.533-.597-1.062v-.001q-.3-.53-.597-1.06a2 2 0 0 1-.06-.123l-.056-.12.303-.001c.285-.002.548-.004.81.011.066.005.152.111.19.19q.174.361.344.727l.003.007q.105.227.212.452c.018.038.05.069.082.1l.044.044.035-.04a.5.5 0 0 0 .076-.099c.195-.4.39-.8.575-1.201.06-.134.146-.185.29-.183.23.006.458.005.704.004l.319-.001-.053.1-.011.022-.07.131-.288.498-.001.003-.002.002-.009.016q-.471.812-.932 1.629a.8.8 0 0 0-.097.351c-.015.443-.017.888-.015 1.331.003.175-.055.263-.24.245-.114-.01-.205.023-.24.147q-.006.02-.02.036l-.066.091c-.158.222-.226.317-.314.341-.066.018-.144-.004-.28-.044l-.163-.047a2.27 2.27 0 0 0-2.778 1.518 2.243 2.243 0 0 0 1.422 2.783c.89.311 1.705.126 2.366-.536.66-.663.824-1.47.533-2.36a.4.4 0 0 0-.086-.129q-.027-.03-.05-.062-.03.027-.06.05l-.002.001c-.038.03-.075.059-.103.096q-.78 1.054-1.558 2.11c-.2.27-.263.27-.48.005l-.034-.04-1.15-1.412c-.173-.213-.173-.268-.008-.49l.058-.08q.087-.122.18-.237c.121-.152.205-.154.334-.002a51 51 0 0 1 .66.804c.164.202.18.202.329 0q.374-.505.752-1.009zm-4.088-2.16q.333.015.668 0c.035 0 .103-.091.093-.12-.11-.366-.228-.727-.35-1.104h-.001l-.023-.072-.058.029q-.024.01-.026.017l-.064.178a38 38 0 0 0-.338.955c-.008.028.063.114.099.117m11.118 2.325h-.004q-.205.002-.408-.005c-.162-.008-.253.048-.309.207q-.358 1-.727 1.998l-.004.013-.073.198c-.02.055-.046.108-.077.173v.003q-.03.061-.067.143l-.055-.121-.002-.003a2 2 0 0 1-.06-.14l-.049-.136a5 5 0 0 1-.17-.534.8.8 0 0 1 0-.397c.108-.347.236-.691.364-1.033l.06-.161c.06-.162.005-.22-.154-.218h-.162q-.306.002-.61-.005c-.157-.005-.235.058-.283.21q-.361 1.162-.739 2.32a.3.3 0 0 1-.064.096l-.034.043-.035-.046a.4.4 0 0 1-.062-.095q-.387-1.154-.764-2.31c-.053-.162-.136-.24-.316-.23a7 7 0 0 1-.425.001q-.143-.002-.283-.001c-.197.002-.22.037-.147.225l.678 1.789.046.123.632 1.667.04.11c.091.241.13.347.205.391.058.035.137.033.276.031q.097-.002.238 0c.374.007.382-.005.514-.347q.096-.256.199-.513l.002-.006.004-.012.131-.334.08-.008.055.135.005.013q.092.228.181.457.067.171.106.285c.064.178.094.263.155.303.055.038.136.037.29.037.092 0 .21 0 .365.007.175.008.268-.068.329-.225.177-.453.36-.9.544-1.35q.291-.712.587-1.423l.008-.019.033-.08.389-.94c.101-.25.078-.284-.198-.286zm-12.388-.07c-.203.004-.405.01-.605-.003-.192-.013-.255.065-.255.253 0 .493-.007.987-.013 1.481l-.005.37c0 .055-.01.108-.021.162v.002l-.012.062-.056.01q-.02-.03-.042-.059l-.001-.002q-.043-.057-.08-.116l-.41-.66-.01-.014q-.406-.652-.81-1.307c-.081-.134-.177-.198-.337-.192q-.375.01-.751-.003c-.15-.005-.215.053-.215.205a1011 1011 0 0 1-.023 3.91c0 .153.069.213.215.21.195-.004.39-.01.585.006.205.015.263-.066.263-.263q-.001-.858.011-1.718v-.001l.004-.34c0-.049.009-.097.018-.146q.007-.038.012-.077l.059-.01q.069.098.131.197.643 1.067 1.281 2.134l.004.006.004.007c.067.112.131.219.295.216.257-.008.515-.003.77.003h.001c.134.002.187-.061.187-.19q.009-1.966.023-3.931c0-.157-.073-.208-.217-.203m-3.367-.669q.324-.014.647.003c.175.01.235-.064.235-.23q0-.246.003-.491.005-.285.003-.57c-.003-.166.058-.237.232-.232.256.01.516.013.772-.003.713-.043 1.262-.67 1.25-1.414-.013-.756-.59-1.371-1.308-1.381q-.42-.006-.843-.005h-.001q-.476.001-.95-.008c-.185-.002-.243.069-.24.246q.006.682.003 1.366v.546h-.021v.555q.004.69-.003 1.38c-.007.17.043.246.22.238m.897-3.11c0-.158 0-.24.04-.282.045-.045.138-.043.33-.039q.105.003.25.003c.387 0 .615.392.446.739a.46.46 0 0 1-.425.28H5.55l-.196.001c-.156.002-.237.003-.28-.038-.046-.044-.046-.138-.044-.337l.001-.146.002-.182",
          clipRule: "evenodd"
        })
      })
    })
  });
};

const Payid = ({
  className = undefined,
  isFocusable = false,
  filled = undefined,
  title = undefined,
  role = undefined,
  size = 16,
  ...restProps
}) => {
  if (filled) {
    console.warn("<Payid filled /> is now deprecated, please use <PayidFill /> or refer to https://transferwise.github.io/icons/ for more info.");
  }
  return /*#__PURE__*/jsx("span", {
    className: `tw-icon tw-icon-payid ${className ? className : ''}`,
    "data-testid": restProps['data-testid'] || 'payid-icon',
    children: /*#__PURE__*/jsx("svg", {
      "aria-label": title,
      "aria-hidden": !title ? true : undefined,
      focusable: isFocusable,
      role: role ?? (title ? 'graphics-symbol img' : 'none'),
      width: String(size),
      height: String(size),
      fill: "currentColor",
      viewBox: "0 0 24 24",
      children: (Number(size) === 16 || Number(size) === 24 || Number(size) === 32) && /*#__PURE__*/jsx(Fragment, {
        children: /*#__PURE__*/jsx("path", {
          fillRule: "evenodd",
          d: "M5.143 1.714a3.43 3.43 0 0 0-3.429 3.429v13.714a3.43 3.43 0 0 0 3.429 3.429h13.714a3.43 3.43 0 0 0 3.429-3.429V5.143a3.43 3.43 0 0 0-3.429-3.429zm5.726 4.798-.571.083v.01h.093v7.536h1.38V7.82c1.132 0 3.644.238 4.537 2.346l1.215-.488c-.737-1.62-2.274-2.762-3.976-3-.893-.166-1.786-.25-2.678-.166m-3.81-.083C6.488 6.429 6 6.857 6 7.487s.488 1.084 1.059 1.084c.57 0 1.059-.428 1.059-1.084 0-.655-.488-1.058-1.06-1.058m10.702 6.82h1.381l-1.941-2.43-1.941 2.43h1.131c0 .238-.083.487-.166.726-.644 1.62-2.429 2.43-5.107 2.43H7.63v-6.167H6.25v7.464h4.785c3.322 0 5.512-1.049 6.405-3.239.155-.404.238-.809.321-1.213",
          clipRule: "evenodd"
        })
      })
    })
  });
};

const Payments = ({
  className = undefined,
  isFocusable = false,
  filled = undefined,
  title = undefined,
  role = undefined,
  size = 16,
  ...restProps
}) => {
  if (filled) {
    console.warn("<Payments filled /> is now deprecated, please use <PaymentsFill /> or refer to https://transferwise.github.io/icons/ for more info.");
  }
  return /*#__PURE__*/jsx("span", {
    className: `tw-icon tw-icon-payments ${className ? className : ''}`,
    "data-testid": restProps['data-testid'] || 'payments-icon',
    children: /*#__PURE__*/jsx("svg", {
      "aria-label": title,
      "aria-hidden": !title ? true : undefined,
      focusable: isFocusable,
      role: role ?? (title ? 'graphics-symbol img' : 'none'),
      width: String(size),
      height: String(size),
      fill: "currentColor",
      viewBox: "0 0 24 24",
      children: (Number(size) === 16 || Number(size) === 24 || Number(size) === 32) && /*#__PURE__*/jsx(Fragment, {
        children: /*#__PURE__*/jsx("path", {
          fillRule: "evenodd",
          d: "M8 4h3.586l-8.293 8.293 1.414 1.414L13 5.414V9h2V3.01A1.01 1.01 0 0 0 13.99 2H8zm3 14.586 8.293-8.293 1.414 1.414L12.414 20H16v2h-5.99A1.01 1.01 0 0 1 9 20.99V15h2z",
          clipRule: "evenodd"
        })
      })
    })
  });
};

const Paypal = ({
  className = undefined,
  isFocusable = false,
  filled = undefined,
  title = undefined,
  role = undefined,
  size = 16,
  ...restProps
}) => {
  if (filled) {
    console.warn("<Paypal filled /> is now deprecated, please use <PaypalFill /> or refer to https://transferwise.github.io/icons/ for more info.");
  }
  return /*#__PURE__*/jsx("span", {
    className: `tw-icon tw-icon-paypal ${className ? className : ''}`,
    "data-testid": restProps['data-testid'] || 'paypal-icon',
    children: /*#__PURE__*/jsx("svg", {
      "aria-label": title,
      "aria-hidden": !title ? true : undefined,
      focusable: isFocusable,
      role: role ?? (title ? 'graphics-symbol img' : 'none'),
      width: String(size),
      height: String(size),
      fill: "currentColor",
      viewBox: "0 0 24 24",
      children: (Number(size) === 16 || Number(size) === 24 || Number(size) === 32) && /*#__PURE__*/jsxs(Fragment, {
        children: [/*#__PURE__*/jsx("path", {
          d: "M9.756 5.175q.28-.133.59-.133h5.598a12 12 0 0 1 1.921.14 9 9 0 0 1 .974.215q.114.034.227.07.074.026.144.054l.073.028c.113-1.522-.314-2.584-1.052-3.396C17.149.963 15.243.43 12.783.43h-6.65a1.02 1.02 0 0 0-1.009.858L2.15 20.046a.61.61 0 0 0 .606.705h3.917L8.998 6.188c.07-.441.353-.82.758-1.013"
        }), /*#__PURE__*/jsx("path", {
          d: "M18.77 6.356a6 6 0 0 0-.61-.166 8 8 0 0 0-.444-.084 11 11 0 0 0-1.773-.128h-5.198a.896.896 0 0 0-.883.75l-.939 5.938q.149-.029.32-.03h2.096q1.668 0 2.981-.374c2.219-.633 3.71-2.07 4.458-4.353.166-.505.287-.973.373-1.41a5 5 0 0 0-.381-.143"
        }), /*#__PURE__*/jsx("path", {
          d: "M20.06 6.902c.236.158.455.33.635.534.764.867.994 2.052.823 3.462q-.029.19-.065.377c-.824 4.208-3.643 5.663-7.243 5.663h-.556a.89.89 0 0 0-.883.75l-.782 4.848a.89.89 0 0 1-.883.75H7.882c-.297 0-.58-.263-.531-.588.061-.41 1.31-8.23 1.31-8.23a1.016 1.016 0 0 1 1.005-.858l1.606.005c6.48 0 8.208-3.924 8.788-6.713"
        })]
      })
    })
  });
};

const People = ({
  className = undefined,
  isFocusable = false,
  filled = undefined,
  title = undefined,
  role = undefined,
  size = 16,
  ...restProps
}) => {
  if (filled) {
    console.warn("<People filled /> is now deprecated, please use <PeopleFill /> or refer to https://transferwise.github.io/icons/ for more info.");
  }
  return /*#__PURE__*/jsx("span", {
    className: `tw-icon tw-icon-people ${className ? className : ''}`,
    "data-testid": restProps['data-testid'] || 'people-icon',
    children: /*#__PURE__*/jsx("svg", {
      "aria-label": title,
      "aria-hidden": !title ? true : undefined,
      focusable: isFocusable,
      role: role ?? (title ? 'graphics-symbol img' : 'none'),
      width: String(size),
      height: String(size),
      fill: "currentColor",
      viewBox: "0 0 24 24",
      children: (Number(size) === 16 || Number(size) === 24 || Number(size) === 32) && /*#__PURE__*/jsx(Fragment, {
        children: /*#__PURE__*/jsx("path", {
          fillRule: "evenodd",
          d: "M12.136 7.105A3.001 3.001 0 0 1 18 8a3 3 0 0 1-4.003 2.829 4.99 4.99 0 0 0-1.861-3.724m5.983 4.803a5 5 0 1 0-7.778-5.726A5.005 5.005 0 0 0 4 11a4.99 4.99 0 0 0 1.88 3.908C4.144 16.013 3 18.01 3 20.25V21h2v-.75C5 17.856 6.836 16 9 16s4 1.856 4 4.25V21h2v-.75c0-2.24-1.143-4.237-2.88-5.342a5 5 0 0 0 1.297-1.562A3.8 3.8 0 0 1 15 13c2.164 0 4 1.856 4 4.25V18h2v-.75c0-2.24-1.143-4.237-2.88-5.342M12 11a3 3 0 1 1-6 0 3 3 0 0 1 6 0",
          clipRule: "evenodd"
        })
      })
    })
  });
};

const Recipients = ({
  className = undefined,
  isFocusable = false,
  filled = undefined,
  title = undefined,
  role = undefined,
  size = 16,
  ...restProps
}) => {
  if (filled) {
    console.warn("<Recipients filled /> is now deprecated, please use <RecipientsFill /> or refer to https://transferwise.github.io/icons/ for more info.");
  }
  return /*#__PURE__*/jsx("span", {
    className: `tw-icon tw-icon-recipients ${className ? className : ''}`,
    "data-testid": restProps['data-testid'] || 'recipients-icon',
    children: /*#__PURE__*/jsx("svg", {
      "aria-label": title,
      "aria-hidden": !title ? true : undefined,
      focusable: isFocusable,
      role: role ?? (title ? 'graphics-symbol img' : 'none'),
      width: String(size),
      height: String(size),
      fill: "currentColor",
      viewBox: "0 0 24 24",
      children: (Number(size) === 16 || Number(size) === 24 || Number(size) === 32) && /*#__PURE__*/jsx(Fragment, {
        children: /*#__PURE__*/jsx("path", {
          fillRule: "evenodd",
          d: "M12.136 7.105A3.001 3.001 0 0 1 18 8a3 3 0 0 1-4.003 2.829 4.99 4.99 0 0 0-1.861-3.724m5.983 4.803a5 5 0 1 0-7.778-5.726A5.005 5.005 0 0 0 4 11a4.99 4.99 0 0 0 1.88 3.908C4.144 16.013 3 18.01 3 20.25V21h2v-.75C5 17.856 6.836 16 9 16s4 1.856 4 4.25V21h2v-.75c0-2.24-1.143-4.237-2.88-5.342a5 5 0 0 0 1.297-1.562A3.8 3.8 0 0 1 15 13c2.164 0 4 1.856 4 4.25V18h2v-.75c0-2.24-1.143-4.237-2.88-5.342M12 11a3 3 0 1 1-6 0 3 3 0 0 1 6 0",
          clipRule: "evenodd"
        })
      })
    })
  });
};

const PercentageCircle = ({
  className = undefined,
  isFocusable = false,
  filled = undefined,
  title = undefined,
  role = undefined,
  size = 16,
  ...restProps
}) => {
  if (filled) {
    console.warn("<PercentageCircle filled /> is now deprecated, please use <PercentageCircleFill /> or refer to https://transferwise.github.io/icons/ for more info.");
  }
  return /*#__PURE__*/jsx("span", {
    className: `tw-icon tw-icon-percentage-circle ${className ? className : ''}`,
    "data-testid": restProps['data-testid'] || 'percentage-circle-icon',
    children: /*#__PURE__*/jsx("svg", {
      "aria-label": title,
      "aria-hidden": !title ? true : undefined,
      focusable: isFocusable,
      role: role ?? (title ? 'graphics-symbol img' : 'none'),
      width: String(size),
      height: String(size),
      fill: "currentColor",
      viewBox: "0 0 24 24",
      children: (Number(size) === 16 || Number(size) === 24 || Number(size) === 32) && /*#__PURE__*/jsx(Fragment, {
        children: /*#__PURE__*/jsx("path", {
          fillRule: "evenodd",
          d: "M20 12a8 8 0 1 1-16 0 8 8 0 0 1 16 0m2 0c0 5.523-4.477 10-10 10S2 17.523 2 12 6.477 2 12 2s10 4.477 10 10m-6.515-5L7 15.485 8.414 16.9 16.9 8.414zM10 8.5a1.5 1.5 0 1 1-3 0 1.5 1.5 0 0 1 3 0m5.5 8.5a1.5 1.5 0 1 0 0-3 1.5 1.5 0 0 0 0 3",
          clipRule: "evenodd"
        })
      })
    })
  });
};

const Tax = ({
  className = undefined,
  isFocusable = false,
  filled = undefined,
  title = undefined,
  role = undefined,
  size = 16,
  ...restProps
}) => {
  if (filled) {
    console.warn("<Tax filled /> is now deprecated, please use <TaxFill /> or refer to https://transferwise.github.io/icons/ for more info.");
  }
  return /*#__PURE__*/jsx("span", {
    className: `tw-icon tw-icon-tax ${className ? className : ''}`,
    "data-testid": restProps['data-testid'] || 'tax-icon',
    children: /*#__PURE__*/jsx("svg", {
      "aria-label": title,
      "aria-hidden": !title ? true : undefined,
      focusable: isFocusable,
      role: role ?? (title ? 'graphics-symbol img' : 'none'),
      width: String(size),
      height: String(size),
      fill: "currentColor",
      viewBox: "0 0 24 24",
      children: (Number(size) === 16 || Number(size) === 24 || Number(size) === 32) && /*#__PURE__*/jsx(Fragment, {
        children: /*#__PURE__*/jsx("path", {
          fillRule: "evenodd",
          d: "M20 12a8 8 0 1 1-16 0 8 8 0 0 1 16 0m2 0c0 5.523-4.477 10-10 10S2 17.523 2 12 6.477 2 12 2s10 4.477 10 10m-6.515-5L7 15.485 8.414 16.9 16.9 8.414zM10 8.5a1.5 1.5 0 1 1-3 0 1.5 1.5 0 0 1 3 0m5.5 8.5a1.5 1.5 0 1 0 0-3 1.5 1.5 0 0 0 0 3",
          clipRule: "evenodd"
        })
      })
    })
  });
};

const Person = ({
  className = undefined,
  isFocusable = false,
  filled = undefined,
  title = undefined,
  role = undefined,
  size = 16,
  ...restProps
}) => {
  if (filled) {
    console.warn("<Person filled /> is now deprecated, please use <PersonFill /> or refer to https://transferwise.github.io/icons/ for more info.");
  }
  return /*#__PURE__*/jsx("span", {
    className: `tw-icon tw-icon-person ${className ? className : ''}`,
    "data-testid": restProps['data-testid'] || 'person-icon',
    children: /*#__PURE__*/jsx("svg", {
      "aria-label": title,
      "aria-hidden": !title ? true : undefined,
      focusable: isFocusable,
      role: role ?? (title ? 'graphics-symbol img' : 'none'),
      width: String(size),
      height: String(size),
      fill: "currentColor",
      viewBox: "0 0 24 24",
      children: (Number(size) === 16 || Number(size) === 24 || Number(size) === 32) && /*#__PURE__*/jsx(Fragment, {
        children: /*#__PURE__*/jsx("path", {
          fillRule: "evenodd",
          d: "M8 8a4 4 0 1 1 8 0 4 4 0 0 1-8 0m7.557 4.832a6 6 0 1 0-7.114 0A8 8 0 0 0 4 20v2h2v-2a6 6 0 0 1 12 0v2h2v-2a8 8 0 0 0-4.443-7.168",
          clipRule: "evenodd"
        })
      })
    })
  });
};

const Profile = ({
  className = undefined,
  isFocusable = false,
  filled = undefined,
  title = undefined,
  role = undefined,
  size = 16,
  ...restProps
}) => {
  if (filled) {
    console.warn("<Profile filled /> is now deprecated, please use <ProfileFill /> or refer to https://transferwise.github.io/icons/ for more info.");
  }
  return /*#__PURE__*/jsx("span", {
    className: `tw-icon tw-icon-profile ${className ? className : ''}`,
    "data-testid": restProps['data-testid'] || 'profile-icon',
    children: /*#__PURE__*/jsx("svg", {
      "aria-label": title,
      "aria-hidden": !title ? true : undefined,
      focusable: isFocusable,
      role: role ?? (title ? 'graphics-symbol img' : 'none'),
      width: String(size),
      height: String(size),
      fill: "currentColor",
      viewBox: "0 0 24 24",
      children: (Number(size) === 16 || Number(size) === 24 || Number(size) === 32) && /*#__PURE__*/jsx(Fragment, {
        children: /*#__PURE__*/jsx("path", {
          fillRule: "evenodd",
          d: "M8 8a4 4 0 1 1 8 0 4 4 0 0 1-8 0m7.557 4.832a6 6 0 1 0-7.114 0A8 8 0 0 0 4 20v2h2v-2a6 6 0 0 1 12 0v2h2v-2a8 8 0 0 0-4.443-7.168",
          clipRule: "evenodd"
        })
      })
    })
  });
};

const PersonalCare = ({
  className = undefined,
  isFocusable = false,
  filled = undefined,
  title = undefined,
  role = undefined,
  size = 16,
  ...restProps
}) => {
  if (filled) {
    console.warn("<PersonalCare filled /> is now deprecated, please use <PersonalCareFill /> or refer to https://transferwise.github.io/icons/ for more info.");
  }
  return /*#__PURE__*/jsx("span", {
    className: `tw-icon tw-icon-personal-care ${className ? className : ''}`,
    "data-testid": restProps['data-testid'] || 'personal-care-icon',
    children: /*#__PURE__*/jsx("svg", {
      "aria-label": title,
      "aria-hidden": !title ? true : undefined,
      focusable: isFocusable,
      role: role ?? (title ? 'graphics-symbol img' : 'none'),
      width: String(size),
      height: String(size),
      fill: "currentColor",
      viewBox: "0 0 24 24",
      children: (Number(size) === 16 || Number(size) === 24 || Number(size) === 32) && /*#__PURE__*/jsx(Fragment, {
        children: /*#__PURE__*/jsx("path", {
          fillRule: "evenodd",
          d: "M9 5h2v2.268a2 2 0 0 0-.732.732H8.097a2 2 0 0 0-1.988 1.783l-.982 9A2 2 0 0 0 7.115 21h9.77a2 2 0 0 0 1.988-2.217l-.982-9A2 2 0 0 0 15.903 8h-2.17A2 2 0 0 0 13 7.268V5h2v1h2V5a2 2 0 0 0-2-2H9zm-.903 5-.982 9h9.77l-.982-9z",
          clipRule: "evenodd"
        })
      })
    })
  });
};

const Pets = ({
  className = undefined,
  isFocusable = false,
  filled = undefined,
  title = undefined,
  role = undefined,
  size = 16,
  ...restProps
}) => {
  if (filled) {
    console.warn("<Pets filled /> is now deprecated, please use <PetsFill /> or refer to https://transferwise.github.io/icons/ for more info.");
  }
  return /*#__PURE__*/jsx("span", {
    className: `tw-icon tw-icon-pets ${className ? className : ''}`,
    "data-testid": restProps['data-testid'] || 'pets-icon',
    children: /*#__PURE__*/jsx("svg", {
      "aria-label": title,
      "aria-hidden": !title ? true : undefined,
      focusable: isFocusable,
      role: role ?? (title ? 'graphics-symbol img' : 'none'),
      width: String(size),
      height: String(size),
      fill: "currentColor",
      viewBox: "0 0 24 24",
      children: (Number(size) === 16 || Number(size) === 24 || Number(size) === 32) && /*#__PURE__*/jsx(Fragment, {
        children: /*#__PURE__*/jsx("path", {
          fillRule: "evenodd",
          d: "M15.21 5c-.194 0-.75.311-.75 1.25s.556 1.25.75 1.25c.196 0 .75-.311.75-1.25S15.407 5 15.21 5m-2.75 1.25c0-1.546 1.013-3.25 2.75-3.25 1.739 0 2.75 1.704 2.75 3.25S16.95 9.5 15.21 9.5c-1.737 0-2.75-1.704-2.75-3.25m7.134 4.393c-.195 0-.75.31-.75 1.25 0 .938.555 1.25.75 1.25s.75-.312.75-1.25c0-.94-.555-1.25-.75-1.25m-2.75 1.25c0-1.547 1.012-3.25 2.75-3.25s2.75 1.703 2.75 3.25-1.012 3.25-2.75 3.25-2.75-1.704-2.75-3.25m-13.097 0c0-.94.555-1.25.75-1.25s.75.31.75 1.25c0 .938-.556 1.25-.75 1.25-.195 0-.75-.312-.75-1.25m.75-3.25c-1.739 0-2.75 1.703-2.75 3.25s1.011 3.25 2.75 3.25c1.738 0 2.75-1.704 2.75-3.25s-1.012-3.25-2.75-3.25M8.88 5c-.195 0-.75.311-.75 1.25s.555 1.25.75 1.25.75-.311.75-1.25S9.075 5 8.88 5M6.13 6.25C6.13 4.704 7.142 3 8.88 3s2.75 1.704 2.75 3.25S10.618 9.5 8.88 9.5 6.13 7.796 6.13 6.25m8.657 5.765c-.914-2.65-4.66-2.65-5.574 0l-.787 2.282a.95.95 0 0 1-.243.378L6.96 15.836c-2.148 2.041-.28 5.62 2.622 5.025l2.227-.456a1 1 0 0 1 .38 0l2.227.456c2.902.594 4.77-2.984 2.622-5.025l-1.222-1.161a.95.95 0 0 1-.243-.378zm-3.683.651c.294-.851 1.498-.851 1.792 0l.787 2.283c.154.447.414.85.756 1.176l1.222 1.16c.69.657.09 1.808-.843 1.617l-2.227-.456a2.9 2.9 0 0 0-1.182 0l-2.227.456c-.934.191-1.534-.96-.843-1.616l1.222-1.161c.342-.326.601-.73.756-1.176z",
          clipRule: "evenodd"
        })
      })
    })
  });
};

const PhoneStrikethrough = ({
  className = undefined,
  isFocusable = false,
  filled = undefined,
  title = undefined,
  role = undefined,
  size = 16,
  ...restProps
}) => {
  if (filled) {
    console.warn("<PhoneStrikethrough filled /> is now deprecated, please use <PhoneStrikethroughFill /> or refer to https://transferwise.github.io/icons/ for more info.");
  }
  return /*#__PURE__*/jsx("span", {
    className: `tw-icon tw-icon-phone-strikethrough ${className ? className : ''}`,
    "data-testid": restProps['data-testid'] || 'phone-strikethrough-icon',
    children: /*#__PURE__*/jsx("svg", {
      "aria-label": title,
      "aria-hidden": !title ? true : undefined,
      focusable: isFocusable,
      role: role ?? (title ? 'graphics-symbol img' : 'none'),
      width: String(size),
      height: String(size),
      fill: "currentColor",
      viewBox: "0 0 24 24",
      children: (Number(size) === 16 || Number(size) === 24 || Number(size) === 32) && /*#__PURE__*/jsxs(Fragment, {
        children: [/*#__PURE__*/jsx("path", {
          fillRule: "evenodd",
          d: "m21.41 4.293-8.595 8.594 1.05 1.05a.01.01 0 0 0 .015 0l1.753-1.748a1 1 0 0 1 1.413.001l4.243 4.244a1 1 0 0 1 0 1.414l-1.414 1.414a7 7 0 0 1-9.9 0l-1.767-1.767-4.794 4.794L2 20.875 19.996 2.879zM9.622 16.08l1.768 1.767a5 5 0 0 0 7.07 0l.708-.707-2.828-2.828-1.046 1.038a2.01 2.01 0 0 1-2.843 0l-1.05-1.05z",
          clipRule: "evenodd"
        }), /*#__PURE__*/jsx("path", {
          d: "M5.733 2.293a1 1 0 0 1 1.414 0l4.242 4.24a1 1 0 0 1-.001 1.416L9.637 9.694a.01.01 0 0 0 0 .015l.44.44-1.414 1.414-.44-.44a2.01 2.01 0 0 1 0-2.843l1.046-1.038L6.44 4.414l-.707.707a5 5 0 0 0 0 7.071l1.15 1.15-1.413 1.415-1.152-1.15a7 7 0 0 1 .001-9.901z"
        })]
      })
    })
  });
};

const Phone = ({
  className = undefined,
  isFocusable = false,
  filled = undefined,
  title = undefined,
  role = undefined,
  size = 16,
  ...restProps
}) => {
  if (filled) {
    console.warn("<Phone filled /> is now deprecated, please use <PhoneFill /> or refer to https://transferwise.github.io/icons/ for more info.");
  }
  return /*#__PURE__*/jsx("span", {
    className: `tw-icon tw-icon-phone ${className ? className : ''}`,
    "data-testid": restProps['data-testid'] || 'phone-icon',
    children: /*#__PURE__*/jsx("svg", {
      "aria-label": title,
      "aria-hidden": !title ? true : undefined,
      focusable: isFocusable,
      role: role ?? (title ? 'graphics-symbol img' : 'none'),
      width: String(size),
      height: String(size),
      fill: "currentColor",
      viewBox: "0 0 24 24",
      children: (Number(size) === 16 || Number(size) === 24 || Number(size) === 32) && /*#__PURE__*/jsx(Fragment, {
        children: /*#__PURE__*/jsx("path", {
          fillRule: "evenodd",
          d: "M10.606 19.677a7 7 0 0 0 9.9 0l1.414-1.414a1 1 0 0 0 0-1.414l-4.244-4.244a1 1 0 0 0-1.413 0l-1.753 1.747a.01.01 0 0 1-.014 0l-4.228-4.229a.01.01 0 0 1 0-.014l1.75-1.745a1 1 0 0 0 .002-1.415L7.778 2.707a1 1 0 0 0-1.414 0L4.95 4.121a7 7 0 0 0 0 9.9zM9.9 7.657 7.072 4.828l-.707.707a5 5 0 0 0 0 7.072l5.657 5.656a5 5 0 0 0 7.07 0l.708-.707-2.828-2.828-1.046 1.038a2.01 2.01 0 0 1-2.843 0l-4.228-4.228a2.01 2.01 0 0 1 0-2.843z",
          clipRule: "evenodd"
        })
      })
    })
  });
};

const PieChart = ({
  className = undefined,
  isFocusable = false,
  filled = undefined,
  title = undefined,
  role = undefined,
  size = 16,
  ...restProps
}) => {
  if (filled) {
    console.warn("<PieChart filled /> is now deprecated, please use <PieChartFill /> or refer to https://transferwise.github.io/icons/ for more info.");
  }
  return /*#__PURE__*/jsx("span", {
    className: `tw-icon tw-icon-pie-chart ${className ? className : ''}`,
    "data-testid": restProps['data-testid'] || 'pie-chart-icon',
    children: /*#__PURE__*/jsx("svg", {
      "aria-label": title,
      "aria-hidden": !title ? true : undefined,
      focusable: isFocusable,
      role: role ?? (title ? 'graphics-symbol img' : 'none'),
      width: String(size),
      height: String(size),
      fill: "currentColor",
      viewBox: "0 0 24 24",
      children: (Number(size) === 16 || Number(size) === 24 || Number(size) === 32) && /*#__PURE__*/jsx(Fragment, {
        children: /*#__PURE__*/jsx("path", {
          fillRule: "evenodd",
          d: "M12 20a8 8 0 0 0 6.32-12.906l-5.61 5.61a1 1 0 0 1-.714.296H4.062A8 8 0 0 0 12 20m-1-9H4.062A8.004 8.004 0 0 1 11 4.062zm2-1.414 3.906-3.906A7.96 7.96 0 0 0 13 4.062zM12 22c5.523 0 10-4.477 10-10S17.523 2 12 2 2 6.477 2 12s4.477 10 10 10",
          clipRule: "evenodd"
        })
      })
    })
  });
};

const Expenses = ({
  className = undefined,
  isFocusable = false,
  filled = undefined,
  title = undefined,
  role = undefined,
  size = 16,
  ...restProps
}) => {
  if (filled) {
    console.warn("<Expenses filled /> is now deprecated, please use <ExpensesFill /> or refer to https://transferwise.github.io/icons/ for more info.");
  }
  return /*#__PURE__*/jsx("span", {
    className: `tw-icon tw-icon-expenses ${className ? className : ''}`,
    "data-testid": restProps['data-testid'] || 'expenses-icon',
    children: /*#__PURE__*/jsx("svg", {
      "aria-label": title,
      "aria-hidden": !title ? true : undefined,
      focusable: isFocusable,
      role: role ?? (title ? 'graphics-symbol img' : 'none'),
      width: String(size),
      height: String(size),
      fill: "currentColor",
      viewBox: "0 0 24 24",
      children: (Number(size) === 16 || Number(size) === 24 || Number(size) === 32) && /*#__PURE__*/jsx(Fragment, {
        children: /*#__PURE__*/jsx("path", {
          fillRule: "evenodd",
          d: "M12 20a8 8 0 0 0 6.32-12.906l-5.61 5.61a1 1 0 0 1-.714.296H4.062A8 8 0 0 0 12 20m-1-9H4.062A8.004 8.004 0 0 1 11 4.062zm2-1.414 3.906-3.906A7.96 7.96 0 0 0 13 4.062zM12 22c5.523 0 10-4.477 10-10S17.523 2 12 2 2 6.477 2 12s4.477 10 10 10",
          clipRule: "evenodd"
        })
      })
    })
  });
};

const PiggyBank = ({
  className = undefined,
  isFocusable = false,
  filled = undefined,
  title = undefined,
  role = undefined,
  size = 16,
  ...restProps
}) => {
  if (filled) {
    console.warn("<PiggyBank filled /> is now deprecated, please use <PiggyBankFill /> or refer to https://transferwise.github.io/icons/ for more info.");
  }
  return /*#__PURE__*/jsx("span", {
    className: `tw-icon tw-icon-piggy-bank ${className ? className : ''}`,
    "data-testid": restProps['data-testid'] || 'piggy-bank-icon',
    children: /*#__PURE__*/jsx("svg", {
      "aria-label": title,
      "aria-hidden": !title ? true : undefined,
      focusable: isFocusable,
      role: role ?? (title ? 'graphics-symbol img' : 'none'),
      width: String(size),
      height: String(size),
      fill: "currentColor",
      viewBox: "0 0 24 24",
      children: (Number(size) === 16 || Number(size) === 24 || Number(size) === 32) && /*#__PURE__*/jsx(Fragment, {
        children: /*#__PURE__*/jsx("path", {
          fillRule: "evenodd",
          d: "M6 4.015a1.01 1.01 0 0 1 1.408-.928l3.09 1.324c1.24-.473 3.005-.63 4.771-.264 1.579.327 3.225 1.087 4.547 2.485q.06-.126.089-.25c.088-.351.095-.828.095-1.882h2v.116c0 .893 0 1.63-.155 2.251-.144.578-.409 1.026-.785 1.463.967 1.756.952 3.427.527 4.801-.37 1.2-1.043 2.153-1.587 2.765v4.094A1.01 1.01 0 0 1 18.99 21h-2.483a1.01 1.01 0 0 1-.938-.635l-.746-1.865h-3.646l-.746 1.865a1.01 1.01 0 0 1-.938.635H7.01A1.01 1.01 0 0 1 6 19.99v-4.274a6 6 0 0 1-.768-.465 4.7 4.7 0 0 1-.723-.625 3 3 0 0 1-.108-.126H3.01A1.01 1.01 0 0 1 2 13.49V9.51c0-.558.452-1.01 1.01-1.01h1.165a5.3 5.3 0 0 1 .62-1.245A5.4 5.4 0 0 1 6 5.95zm2 1.501v.978c0 .375-.21.727-.556.902-.292.147-.671.498-.986.97-.321.481-.457.909-.458 1.13A1.01 1.01 0 0 1 4.99 10.5H4v2h.99c.461 0 .865.314.978.757l.019.02c.086.095.227.219.407.347.176.126.36.235.51.308q.115.055.167.07l.003.001c.56.045.926.523.926 1.007V19h.823l.746-1.865a1.01 1.01 0 0 1 .938-.635h4.986c.413 0 .785.252.938.635L17.177 19H18v-3.914l.293-.293c.43-.43 1.07-1.237 1.383-2.252.302-.975.315-2.17-.524-3.511-1.077-1.724-2.69-2.594-4.289-2.925-1.636-.34-3.15-.092-3.913.288a1.01 1.01 0 0 1-.848.024zm-.907 8.493-.004-.002zm3.407-4.51c.707.708.706.709.706.709l-.002.002-.002.002-.003.003-.003.003.008-.008q.021-.019.083-.066c.083-.062.22-.154.41-.25.378-.188.976-.394 1.803-.394s1.425.206 1.803.394a2.7 2.7 0 0 1 .492.316l.01.008-.004-.003-.003-.003-.003-.002v-.002s-.002 0 .705-.708c.707-.707.706-.708.706-.708l-.002-.002-.003-.003-.008-.008-.02-.02-.061-.055a3 3 0 0 0-.2-.16 4.7 4.7 0 0 0-.715-.438c-.622-.312-1.524-.606-2.697-.606s-2.075.294-2.697.606c-.31.154-.548.312-.716.438a3 3 0 0 0-.26.215l-.02.02-.008.008-.003.003-.002.001v.001z",
          clipRule: "evenodd"
        })
      })
    })
  });
};

const Pix = ({
  className = undefined,
  isFocusable = false,
  filled = undefined,
  title = undefined,
  role = undefined,
  size = 16,
  ...restProps
}) => {
  if (filled) {
    console.warn("<Pix filled /> is now deprecated, please use <PixFill /> or refer to https://transferwise.github.io/icons/ for more info.");
  }
  return /*#__PURE__*/jsx("span", {
    className: `tw-icon tw-icon-pix ${className ? className : ''}`,
    "data-testid": restProps['data-testid'] || 'pix-icon',
    children: /*#__PURE__*/jsx("svg", {
      "aria-label": title,
      "aria-hidden": !title ? true : undefined,
      focusable: isFocusable,
      role: role ?? (title ? 'graphics-symbol img' : 'none'),
      width: String(size),
      height: String(size),
      fill: "currentColor",
      viewBox: "0 0 24 24",
      children: (Number(size) === 16 || Number(size) === 24 || Number(size) === 32) && /*#__PURE__*/jsx(Fragment, {
        children: /*#__PURE__*/jsx("path", {
          fillRule: "evenodd",
          d: "M17.51 6.538c-.808 0-1.567.314-2.137.885l-3.097 3.097a.574.574 0 0 1-.81 0L8.38 7.434a3 3 0 0 0-2.137-.885H5.87L9.79 2.63a3.125 3.125 0 0 1 4.42 0l3.907 3.908zM6.243 17.452c.807 0 1.566-.314 2.137-.885l3.085-3.085a.587.587 0 0 1 .811 0l3.097 3.096c.57.57 1.33.885 2.137.885h.608l-3.908 3.908a3.125 3.125 0 0 1-4.42 0l-3.919-3.92zM4.998 7.422 2.63 9.79a3.125 3.125 0 0 0 0 4.42l2.368 2.368a.5.5 0 0 1 .168-.034h1.077c.557 0 1.102-.225 1.495-.62l3.085-3.084c.56-.56 1.535-.56 2.095 0l3.097 3.096c.393.394.938.62 1.495.62h1.324a.5.5 0 0 1 .159.032l2.377-2.378a3.125 3.125 0 0 0 0-4.42l-2.377-2.377a.5.5 0 0 1-.16.032H17.51c-.557 0-1.102.226-1.495.62l-3.097 3.096a1.48 1.48 0 0 1-1.047.433c-.38 0-.759-.144-1.048-.433L7.738 8.076a2.13 2.13 0 0 0-1.495-.62H5.166a.5.5 0 0 1-.168-.034",
          clipRule: "evenodd"
        })
      })
    })
  });
};

const Plane = ({
  className = undefined,
  isFocusable = false,
  filled = undefined,
  title = undefined,
  role = undefined,
  size = 16,
  ...restProps
}) => {
  if (filled) {
    console.warn("<Plane filled /> is now deprecated, please use <PlaneFill /> or refer to https://transferwise.github.io/icons/ for more info.");
  }
  return /*#__PURE__*/jsx("span", {
    className: `tw-icon tw-icon-plane ${className ? className : ''}`,
    "data-testid": restProps['data-testid'] || 'plane-icon',
    children: /*#__PURE__*/jsx("svg", {
      "aria-label": title,
      "aria-hidden": !title ? true : undefined,
      focusable: isFocusable,
      role: role ?? (title ? 'graphics-symbol img' : 'none'),
      width: String(size),
      height: String(size),
      fill: "currentColor",
      viewBox: "0 0 24 24",
      children: (Number(size) === 16 || Number(size) === 24 || Number(size) === 32) && /*#__PURE__*/jsx(Fragment, {
        children: /*#__PURE__*/jsx("path", {
          fillRule: "evenodd",
          d: "M7.467 4.16a1.01 1.01 0 0 1 1-1.16h2.527c.361 0 .695.193.876.506L15.033 9H19a3 3 0 1 1 0 6h-3.967l-3.163 5.494a1.01 1.01 0 0 1-.876.506H8.466a1.01 1.01 0 0 1-.999-1.16L8.192 15h-1.75L5.38 16.17a1 1 0 0 1-.747.33H3.01A1.01 1.01 0 0 1 2 15.49V8.51c0-.558.452-1.01 1.01-1.01h1.622c.284 0 .556.12.747.33L6.442 9h1.75zM9.615 5l.899 6H5.558L4.194 9.5H4v5h.194L5.558 13h4.956l-.899 6h.807l3.454-6H19a1 1 0 1 0 0-2h-5.124l-3.454-6z",
          clipRule: "evenodd"
        })
      })
    })
  });
};

const Play = ({
  className = undefined,
  isFocusable = false,
  filled = undefined,
  title = undefined,
  role = undefined,
  size = 16,
  ...restProps
}) => {
  if (filled) {
    console.warn("<Play filled /> is now deprecated, please use <PlayFill /> or refer to https://transferwise.github.io/icons/ for more info.");
  }
  return /*#__PURE__*/jsx("span", {
    className: `tw-icon tw-icon-play ${className ? className : ''}`,
    "data-testid": restProps['data-testid'] || 'play-icon',
    children: /*#__PURE__*/jsx("svg", {
      "aria-label": title,
      "aria-hidden": !title ? true : undefined,
      focusable: isFocusable,
      role: role ?? (title ? 'graphics-symbol img' : 'none'),
      width: String(size),
      height: String(size),
      fill: "currentColor",
      viewBox: "0 0 24 24",
      children: (Number(size) === 16 || Number(size) === 24 || Number(size) === 32) && /*#__PURE__*/jsx(Fragment, {
        children: /*#__PURE__*/jsx("path", {
          fillRule: "evenodd",
          d: "M4 12a8 8 0 1 1 16 0 8 8 0 0 1-16 0m8-10C6.477 2 2 6.477 2 12s4.477 10 10 10 10-4.477 10-10S17.523 2 12 2m2.197 10L11 14.132V9.869zM10.57 7.178a1.01 1.01 0 0 0-1.57.84v7.963c0 .807.9 1.288 1.57.84l5.972-3.98c.6-.4.6-1.282 0-1.681z",
          clipRule: "evenodd"
        })
      })
    })
  });
};

const PlusCircleFill = ({
  className = undefined,
  isFocusable = false,
  filled = undefined,
  title = undefined,
  role = undefined,
  size = 16,
  ...restProps
}) => {
  if (filled) {
    console.warn("<PlusCircleFill filled /> is now deprecated, please use <PlusCircleFillFill /> or refer to https://transferwise.github.io/icons/ for more info.");
  }
  return /*#__PURE__*/jsx("span", {
    className: `tw-icon tw-icon-plus-circle-fill ${className ? className : ''}`,
    "data-testid": restProps['data-testid'] || 'plus-circle-fill-icon',
    children: /*#__PURE__*/jsx("svg", {
      "aria-label": title,
      "aria-hidden": !title ? true : undefined,
      focusable: isFocusable,
      role: role ?? (title ? 'graphics-symbol img' : 'none'),
      width: String(size),
      height: String(size),
      fill: "currentColor",
      viewBox: "0 0 24 24",
      children: (Number(size) === 16 || Number(size) === 24 || Number(size) === 32) && /*#__PURE__*/jsx(Fragment, {
        children: /*#__PURE__*/jsx("path", {
          fillRule: "evenodd",
          d: "M12 22c5.523 0 10-4.477 10-10S17.523 2 12 2 2 6.477 2 12s4.477 10 10 10m-1-4v-5H6v-2h5V6h2v5h5v2h-5v5z",
          clipRule: "evenodd"
        })
      })
    })
  });
};

const PlusCircle = ({
  className = undefined,
  isFocusable = false,
  filled = undefined,
  title = undefined,
  role = undefined,
  size = 16,
  ...restProps
}) => {
  if (filled) {
    console.warn("<PlusCircle filled /> is now deprecated, please use <PlusCircleFill /> or refer to https://transferwise.github.io/icons/ for more info.");
  }
  return /*#__PURE__*/jsx("span", {
    className: `tw-icon tw-icon-plus-circle ${className ? className : ''}`,
    "data-testid": restProps['data-testid'] || 'plus-circle-icon',
    children: /*#__PURE__*/jsx("svg", {
      "aria-label": title,
      "aria-hidden": !title ? true : undefined,
      focusable: isFocusable,
      role: role ?? (title ? 'graphics-symbol img' : 'none'),
      width: String(size),
      height: String(size),
      fill: "currentColor",
      viewBox: "0 0 24 24",
      children: (Number(size) === 16 || Number(size) === 24 || Number(size) === 32) && /*#__PURE__*/jsx(Fragment, {
        children: /*#__PURE__*/jsx("path", {
          fillRule: "evenodd",
          d: "M12 4a8 8 0 1 0 0 16 8 8 0 0 0 0-16M2 12C2 6.477 6.477 2 12 2s10 4.477 10 10-4.477 10-10 10S2 17.523 2 12m11-1h5v2h-5v5h-2v-5H6v-2h5V6h2z",
          clipRule: "evenodd"
        })
      })
    })
  });
};

const Plus = ({
  className = undefined,
  isFocusable = false,
  filled = undefined,
  title = undefined,
  role = undefined,
  size = 16,
  ...restProps
}) => {
  if (filled) {
    console.warn("<Plus filled /> is now deprecated, please use <PlusFill /> or refer to https://transferwise.github.io/icons/ for more info.");
  }
  return /*#__PURE__*/jsx("span", {
    className: `tw-icon tw-icon-plus ${className ? className : ''}`,
    "data-testid": restProps['data-testid'] || 'plus-icon',
    children: /*#__PURE__*/jsx("svg", {
      "aria-label": title,
      "aria-hidden": !title ? true : undefined,
      focusable: isFocusable,
      role: role ?? (title ? 'graphics-symbol img' : 'none'),
      width: String(size),
      height: String(size),
      fill: "currentColor",
      viewBox: "0 0 24 24",
      children: (Number(size) === 16 || Number(size) === 24 || Number(size) === 32) && /*#__PURE__*/jsx(Fragment, {
        children: /*#__PURE__*/jsx("path", {
          fillRule: "evenodd",
          d: "M13 3h-2v8H3v2h8v8h2v-8h8v-2h-8z",
          clipRule: "evenodd"
        })
      })
    })
  });
};

const QrCode = ({
  className = undefined,
  isFocusable = false,
  filled = undefined,
  title = undefined,
  role = undefined,
  size = 16,
  ...restProps
}) => {
  if (filled) {
    console.warn("<QrCode filled /> is now deprecated, please use <QrCodeFill /> or refer to https://transferwise.github.io/icons/ for more info.");
  }
  return /*#__PURE__*/jsx("span", {
    className: `tw-icon tw-icon-qr-code ${className ? className : ''}`,
    "data-testid": restProps['data-testid'] || 'qr-code-icon',
    children: /*#__PURE__*/jsx("svg", {
      "aria-label": title,
      "aria-hidden": !title ? true : undefined,
      focusable: isFocusable,
      role: role ?? (title ? 'graphics-symbol img' : 'none'),
      width: String(size),
      height: String(size),
      fill: "currentColor",
      viewBox: "0 0 24 24",
      children: (Number(size) === 16 || Number(size) === 24 || Number(size) === 32) && /*#__PURE__*/jsx(Fragment, {
        children: /*#__PURE__*/jsx("path", {
          fillRule: "evenodd",
          d: "M3 3h8v8H3zm2 2v4h4V5zm-2 8h8v8H3zm2 2v4h4v-4zM21 3h-8v8h8zm-6 6V5h4v4zm-2 7v-3h3v3zm0 2v3h3v-3zm5-2v-3h3v3zm0 2v3h3v-3z",
          clipRule: "evenodd"
        })
      })
    })
  });
};

const QuestionMarkCircleFill = ({
  className = undefined,
  isFocusable = false,
  filled = undefined,
  title = undefined,
  role = undefined,
  size = 16,
  ...restProps
}) => {
  if (filled) {
    console.warn("<QuestionMarkCircleFill filled /> is now deprecated, please use <QuestionMarkCircleFillFill /> or refer to https://transferwise.github.io/icons/ for more info.");
  }
  return /*#__PURE__*/jsx("span", {
    className: `tw-icon tw-icon-question-mark-circle-fill ${className ? className : ''}`,
    "data-testid": restProps['data-testid'] || 'question-mark-circle-fill-icon',
    children: /*#__PURE__*/jsx("svg", {
      "aria-label": title,
      "aria-hidden": !title ? true : undefined,
      focusable: isFocusable,
      role: role ?? (title ? 'graphics-symbol img' : 'none'),
      width: String(size),
      height: String(size),
      fill: "currentColor",
      viewBox: "0 0 24 24",
      children: (Number(size) === 16 || Number(size) === 24 || Number(size) === 32) && /*#__PURE__*/jsx(Fragment, {
        children: /*#__PURE__*/jsx("path", {
          fillRule: "evenodd",
          d: "M12 2C6.477 2 2 6.477 2 12s4.477 10 10 10 10-4.477 10-10S17.523 2 12 2m-.77 4.07a4.3 4.3 0 0 1 1.78.053 4.1 4.1 0 0 1 1.59.782 3.28 3.28 0 0 1 1.245 2.749 3.9 3.9 0 0 1-1.142 2.553c-.544.544-1.19.813-1.496.94-.203.084-.212.126-.212.353v.5h-2v-.5c0-.475.078-.93.318-1.325.249-.408.593-.623.86-.757.179-.09.321-.15.443-.202.266-.113.434-.185.672-.423.334-.333.54-.794.559-1.23a1.28 1.28 0 0 0-.5-1.1 2.1 2.1 0 0 0-.814-.398 2.3 2.3 0 0 0-.943-.028 2.1 2.1 0 0 0-.845.35 1.8 1.8 0 0 0-.56.623c-.13.243-.19.461-.19.745v.46h-2v-.46c0-.635.152-1.177.429-1.692a3.8 3.8 0 0 1 1.17-1.311 4.1 4.1 0 0 1 1.637-.683M13.5 16.5a1.5 1.5 0 1 0-3 0 1.5 1.5 0 0 0 3 0",
          clipRule: "evenodd"
        })
      })
    })
  });
};

const QuestionMarkCircle = ({
  className = undefined,
  isFocusable = false,
  filled = undefined,
  title = undefined,
  role = undefined,
  size = 16,
  ...restProps
}) => {
  if (filled) {
    console.warn("<QuestionMarkCircle filled /> is now deprecated, please use <QuestionMarkCircleFill /> or refer to https://transferwise.github.io/icons/ for more info.");
  }
  return /*#__PURE__*/jsx("span", {
    className: `tw-icon tw-icon-question-mark-circle ${className ? className : ''}`,
    "data-testid": restProps['data-testid'] || 'question-mark-circle-icon',
    children: /*#__PURE__*/jsx("svg", {
      "aria-label": title,
      "aria-hidden": !title ? true : undefined,
      focusable: isFocusable,
      role: role ?? (title ? 'graphics-symbol img' : 'none'),
      width: String(size),
      height: String(size),
      fill: "currentColor",
      viewBox: "0 0 24 24",
      children: (Number(size) === 16 || Number(size) === 24 || Number(size) === 32) && /*#__PURE__*/jsx(Fragment, {
        children: /*#__PURE__*/jsx("path", {
          fillRule: "evenodd",
          d: "M12 4a8 8 0 1 0 0 16 8 8 0 0 0 0-16M2 12C2 6.477 6.477 2 12 2s10 4.477 10 10-4.477 10-10 10S2 17.523 2 12m10 3a1.5 1.5 0 1 1 0 3 1.5 1.5 0 0 1 0-3m1.01-8.877a4.3 4.3 0 0 0-1.78-.054c-.59.108-1.15.34-1.637.683a3.8 3.8 0 0 0-1.17 1.311 3.5 3.5 0 0 0-.427 1.692v.46h2v-.46c0-.284.06-.502.19-.745.127-.237.316-.452.56-.623.243-.172.531-.293.844-.35a2.3 2.3 0 0 1 .943.028c.307.075.585.213.813.398.38.305.52.692.5 1.1a1.9 1.9 0 0 1-.558 1.23c-.238.238-.406.31-.672.423a8 8 0 0 0-.443.202c-.267.134-.611.35-.86.757-.24.395-.318.85-.318 1.325v.5h2v-.5c0-.227.009-.269.212-.353.305-.127.952-.396 1.496-.94a3.9 3.9 0 0 0 1.142-2.553 3.28 3.28 0 0 0-1.244-2.75 4.1 4.1 0 0 0-1.59-.781",
          clipRule: "evenodd"
        })
      })
    })
  });
};

const HelpCircle = ({
  className = undefined,
  isFocusable = false,
  filled = undefined,
  title = undefined,
  role = undefined,
  size = 16,
  ...restProps
}) => {
  if (filled) {
    console.warn("<HelpCircle filled /> is now deprecated, please use <HelpCircleFill /> or refer to https://transferwise.github.io/icons/ for more info.");
  }
  return /*#__PURE__*/jsx("span", {
    className: `tw-icon tw-icon-help-circle ${className ? className : ''}`,
    "data-testid": restProps['data-testid'] || 'help-circle-icon',
    children: /*#__PURE__*/jsx("svg", {
      "aria-label": title,
      "aria-hidden": !title ? true : undefined,
      focusable: isFocusable,
      role: role ?? (title ? 'graphics-symbol img' : 'none'),
      width: String(size),
      height: String(size),
      fill: "currentColor",
      viewBox: "0 0 24 24",
      children: (Number(size) === 16 || Number(size) === 24 || Number(size) === 32) && /*#__PURE__*/jsx(Fragment, {
        children: /*#__PURE__*/jsx("path", {
          fillRule: "evenodd",
          d: "M12 4a8 8 0 1 0 0 16 8 8 0 0 0 0-16M2 12C2 6.477 6.477 2 12 2s10 4.477 10 10-4.477 10-10 10S2 17.523 2 12m10 3a1.5 1.5 0 1 1 0 3 1.5 1.5 0 0 1 0-3m1.01-8.877a4.3 4.3 0 0 0-1.78-.054c-.59.108-1.15.34-1.637.683a3.8 3.8 0 0 0-1.17 1.311 3.5 3.5 0 0 0-.427 1.692v.46h2v-.46c0-.284.06-.502.19-.745.127-.237.316-.452.56-.623.243-.172.531-.293.844-.35a2.3 2.3 0 0 1 .943.028c.307.075.585.213.813.398.38.305.52.692.5 1.1a1.9 1.9 0 0 1-.558 1.23c-.238.238-.406.31-.672.423a8 8 0 0 0-.443.202c-.267.134-.611.35-.86.757-.24.395-.318.85-.318 1.325v.5h2v-.5c0-.227.009-.269.212-.353.305-.127.952-.396 1.496-.94a3.9 3.9 0 0 0 1.142-2.553 3.28 3.28 0 0 0-1.244-2.75 4.1 4.1 0 0 0-1.59-.781",
          clipRule: "evenodd"
        })
      })
    })
  });
};

const QuestionMark = ({
  className = undefined,
  isFocusable = false,
  filled = undefined,
  title = undefined,
  role = undefined,
  size = 16,
  ...restProps
}) => {
  if (filled) {
    console.warn("<QuestionMark filled /> is now deprecated, please use <QuestionMarkFill /> or refer to https://transferwise.github.io/icons/ for more info.");
  }
  return /*#__PURE__*/jsx("span", {
    className: `tw-icon tw-icon-question-mark ${className ? className : ''}`,
    "data-testid": restProps['data-testid'] || 'question-mark-icon',
    children: /*#__PURE__*/jsx("svg", {
      "aria-label": title,
      "aria-hidden": !title ? true : undefined,
      focusable: isFocusable,
      role: role ?? (title ? 'graphics-symbol img' : 'none'),
      width: String(size),
      height: String(size),
      fill: "currentColor",
      viewBox: "0 0 24 24",
      children: (Number(size) === 16 || Number(size) === 24 || Number(size) === 32) && /*#__PURE__*/jsx(Fragment, {
        children: /*#__PURE__*/jsx("path", {
          fillRule: "evenodd",
          d: "M13.555 2.207a5.95 5.95 0 0 0-5.211 1.046 6.04 6.04 0 0 0-1.727 2.125A6.1 6.1 0 0 0 6 8.05h2c0-.623.142-1.237.414-1.795A4.04 4.04 0 0 1 9.57 4.834a3.95 3.95 0 0 1 3.464-.697c.591.16 1.14.456 1.6.865a4.08 4.08 0 0 1 1.358 3.313c-.035.549-.375 1.608-1.275 2.315-.176.138-.365.273-.582.43q-.187.134-.405.293c-.379.278-.8.603-1.19.976-.775.738-1.54 1.774-1.54 3.171V17h2v-1.5c0-.604.318-1.15.92-1.725.297-.283.636-.548.992-.81l.34-.246c.243-.174.492-.354.699-.516 1.433-1.126 1.971-2.761 2.036-3.758a6.1 6.1 0 0 0-.442-2.707 6.05 6.05 0 0 0-1.585-2.233 6 6 0 0 0-2.405-1.298M13.5 20.5a1.5 1.5 0 1 0-3 0 1.5 1.5 0 0 0 3 0",
          clipRule: "evenodd"
        })
      })
    })
  });
};

const Help = ({
  className = undefined,
  isFocusable = false,
  filled = undefined,
  title = undefined,
  role = undefined,
  size = 16,
  ...restProps
}) => {
  if (filled) {
    console.warn("<Help filled /> is now deprecated, please use <HelpFill /> or refer to https://transferwise.github.io/icons/ for more info.");
  }
  return /*#__PURE__*/jsx("span", {
    className: `tw-icon tw-icon-help ${className ? className : ''}`,
    "data-testid": restProps['data-testid'] || 'help-icon',
    children: /*#__PURE__*/jsx("svg", {
      "aria-label": title,
      "aria-hidden": !title ? true : undefined,
      focusable: isFocusable,
      role: role ?? (title ? 'graphics-symbol img' : 'none'),
      width: String(size),
      height: String(size),
      fill: "currentColor",
      viewBox: "0 0 24 24",
      children: (Number(size) === 16 || Number(size) === 24 || Number(size) === 32) && /*#__PURE__*/jsx(Fragment, {
        children: /*#__PURE__*/jsx("path", {
          fillRule: "evenodd",
          d: "M13.555 2.207a5.95 5.95 0 0 0-5.211 1.046 6.04 6.04 0 0 0-1.727 2.125A6.1 6.1 0 0 0 6 8.05h2c0-.623.142-1.237.414-1.795A4.04 4.04 0 0 1 9.57 4.834a3.95 3.95 0 0 1 3.464-.697c.591.16 1.14.456 1.6.865a4.08 4.08 0 0 1 1.358 3.313c-.035.549-.375 1.608-1.275 2.315-.176.138-.365.273-.582.43q-.187.134-.405.293c-.379.278-.8.603-1.19.976-.775.738-1.54 1.774-1.54 3.171V17h2v-1.5c0-.604.318-1.15.92-1.725.297-.283.636-.548.992-.81l.34-.246c.243-.174.492-.354.699-.516 1.433-1.126 1.971-2.761 2.036-3.758a6.1 6.1 0 0 0-.442-2.707 6.05 6.05 0 0 0-1.585-2.233 6 6 0 0 0-2.405-1.298M13.5 20.5a1.5 1.5 0 1 0-3 0 1.5 1.5 0 0 0 3 0",
          clipRule: "evenodd"
        })
      })
    })
  });
};

const Rain = ({
  className = undefined,
  isFocusable = false,
  filled = undefined,
  title = undefined,
  role = undefined,
  size = 16,
  ...restProps
}) => {
  if (filled) {
    console.warn("<Rain filled /> is now deprecated, please use <RainFill /> or refer to https://transferwise.github.io/icons/ for more info.");
  }
  return /*#__PURE__*/jsx("span", {
    className: `tw-icon tw-icon-rain ${className ? className : ''}`,
    "data-testid": restProps['data-testid'] || 'rain-icon',
    children: /*#__PURE__*/jsx("svg", {
      "aria-label": title,
      "aria-hidden": !title ? true : undefined,
      focusable: isFocusable,
      role: role ?? (title ? 'graphics-symbol img' : 'none'),
      width: String(size),
      height: String(size),
      fill: "currentColor",
      viewBox: "0 0 24 24",
      children: (Number(size) === 16 || Number(size) === 24 || Number(size) === 32) && /*#__PURE__*/jsx(Fragment, {
        children: /*#__PURE__*/jsx("path", {
          fillRule: "evenodd",
          d: "M6.797 6.312C6.953 4.992 8.047 4 9.333 4c1.149 0 2.142.788 2.455 1.898a1.01 1.01 0 0 0 1.7.427 1.63 1.63 0 0 1 1.179-.507c.897 0 1.663.749 1.666 1.72a1.01 1.01 0 0 0 1.007 1.007c.896.004 1.66.755 1.66 1.728 0 .975-.767 1.727-1.667 1.727l-.09-.002a1 1 0 0 0-.146.002H7.494C6.132 11.965 5 10.82 5 9.363c0-.992.53-1.848 1.302-2.298a1.01 1.01 0 0 0 .495-.754M9.333 2C7.151 2 5.352 3.553 4.892 5.602A4.66 4.66 0 0 0 3 9.364c0 2.487 1.936 4.549 4.4 4.633l.07.003h9.712l.05-.001.1.001C19.38 14 21 12.31 21 10.273c0-1.73-1.168-3.208-2.772-3.616-.39-1.618-1.822-2.839-3.561-2.839a3.6 3.6 0 0 0-1.494.323C12.367 2.859 10.955 2 9.333 2m-3.52 13.573-1.614 2.156 1.602 1.198 1.613-2.156zm4.693 2.156 1.613-2.156 1.601 1.198-1.613 2.156zm7.613-2.156-1.613 2.156 1.601 1.198 1.613-2.156zm-10.92 5.156 1.613-2.156 1.602 1.198L8.8 21.927zm7.613-2.156L13.2 20.729l1.602 1.198 1.613-2.156z",
          clipRule: "evenodd"
        })
      })
    })
  });
};

const Rainbow = ({
  className = undefined,
  isFocusable = false,
  filled = undefined,
  title = undefined,
  role = undefined,
  size = 16,
  ...restProps
}) => {
  if (filled) {
    console.warn("<Rainbow filled /> is now deprecated, please use <RainbowFill /> or refer to https://transferwise.github.io/icons/ for more info.");
  }
  return /*#__PURE__*/jsx("span", {
    className: `tw-icon tw-icon-rainbow ${className ? className : ''}`,
    "data-testid": restProps['data-testid'] || 'rainbow-icon',
    children: /*#__PURE__*/jsx("svg", {
      "aria-label": title,
      "aria-hidden": !title ? true : undefined,
      focusable: isFocusable,
      role: role ?? (title ? 'graphics-symbol img' : 'none'),
      width: String(size),
      height: String(size),
      fill: "currentColor",
      viewBox: "0 0 24 24",
      children: (Number(size) === 16 || Number(size) === 24 || Number(size) === 32) && /*#__PURE__*/jsx(Fragment, {
        children: /*#__PURE__*/jsx("path", {
          fillRule: "evenodd",
          d: "M8.173 7.761A10 10 0 0 1 22 17h-2a7.999 7.999 0 1 0-16 0H2a10 10 0 0 1 6.173-9.239m-1.123 4.29A7 7 0 0 1 19 17h-2a5 5 0 1 0-10 0H5a7 7 0 0 1 2.05-4.95M12 13a4 4 0 0 0-4 4h2a2 2 0 1 1 4 0h2a4 4 0 0 0-4-4",
          clipRule: "evenodd"
        })
      })
    })
  });
};

const Receipt = ({
  className = undefined,
  isFocusable = false,
  filled = undefined,
  title = undefined,
  role = undefined,
  size = 16,
  ...restProps
}) => {
  if (filled) {
    console.warn("<Receipt filled /> is now deprecated, please use <ReceiptFill /> or refer to https://transferwise.github.io/icons/ for more info.");
  }
  return /*#__PURE__*/jsx("span", {
    className: `tw-icon tw-icon-receipt ${className ? className : ''}`,
    "data-testid": restProps['data-testid'] || 'receipt-icon',
    children: /*#__PURE__*/jsx("svg", {
      "aria-label": title,
      "aria-hidden": !title ? true : undefined,
      focusable: isFocusable,
      role: role ?? (title ? 'graphics-symbol img' : 'none'),
      width: String(size),
      height: String(size),
      fill: "currentColor",
      viewBox: "0 0 24 24",
      children: (Number(size) === 16 || Number(size) === 24 || Number(size) === 32) && /*#__PURE__*/jsx(Fragment, {
        children: /*#__PURE__*/jsx("path", {
          fillRule: "evenodd",
          d: "M6 2a2 2 0 0 0-2 2v16.98c0 .846.98 1.317 1.64.788l1.786-1.428 1.36 1.36a1.01 1.01 0 0 0 1.346.075L12 20.281l1.868 1.494c.402.322.982.29 1.345-.074l1.361-1.361 1.785 1.428A1.01 1.01 0 0 0 20 20.979V4a2 2 0 0 0-2-2zm0 2h12v14.92l-.868-.695a1.01 1.01 0 0 0-1.345.074l-1.361 1.361-1.795-1.436a1.01 1.01 0 0 0-1.262 0L9.574 19.66l-1.36-1.36a1.01 1.01 0 0 0-1.346-.075L6 18.919zm10 2H8v2h8zm-8 4h8v2H8zm8 4H8v2h8z",
          clipRule: "evenodd"
        })
      })
    })
  });
};

const Receive = ({
  className = undefined,
  isFocusable = false,
  filled = undefined,
  title = undefined,
  role = undefined,
  size = 16,
  ...restProps
}) => {
  if (filled) {
    console.warn("<Receive filled /> is now deprecated, please use <ReceiveFill /> or refer to https://transferwise.github.io/icons/ for more info.");
  }
  return /*#__PURE__*/jsx("span", {
    className: `tw-icon tw-icon-receive ${className ? className : ''}`,
    "data-testid": restProps['data-testid'] || 'receive-icon',
    children: /*#__PURE__*/jsx("svg", {
      "aria-label": title,
      "aria-hidden": !title ? true : undefined,
      focusable: isFocusable,
      role: role ?? (title ? 'graphics-symbol img' : 'none'),
      width: String(size),
      height: String(size),
      fill: "currentColor",
      viewBox: "0 0 24 24",
      children: (Number(size) === 16 || Number(size) === 24 || Number(size) === 32) && /*#__PURE__*/jsx(Fragment, {
        children: /*#__PURE__*/jsx("path", {
          fillRule: "evenodd",
          d: "M11 18.586V2h2v16.586l6.293-6.293 1.414 1.414-7.993 7.993a1.01 1.01 0 0 1-1.428 0l-7.993-7.993 1.414-1.414z",
          clipRule: "evenodd"
        })
      })
    })
  });
};

const RefundReceive = ({
  className = undefined,
  isFocusable = false,
  filled = undefined,
  title = undefined,
  role = undefined,
  size = 16,
  ...restProps
}) => {
  if (filled) {
    console.warn("<RefundReceive filled /> is now deprecated, please use <RefundReceiveFill /> or refer to https://transferwise.github.io/icons/ for more info.");
  }
  return /*#__PURE__*/jsx("span", {
    className: `tw-icon tw-icon-refund-receive ${className ? className : ''}`,
    "data-testid": restProps['data-testid'] || 'refund-receive-icon',
    children: /*#__PURE__*/jsx("svg", {
      "aria-label": title,
      "aria-hidden": !title ? true : undefined,
      focusable: isFocusable,
      role: role ?? (title ? 'graphics-symbol img' : 'none'),
      width: String(size),
      height: String(size),
      fill: "currentColor",
      viewBox: "0 0 24 24",
      children: (Number(size) === 16 || Number(size) === 24 || Number(size) === 32) && /*#__PURE__*/jsx(Fragment, {
        children: /*#__PURE__*/jsx("path", {
          fillRule: "evenodd",
          d: "M10 2a6 6 0 0 0-6 6v4h2V8a4 4 0 1 1 8 0v10.586l-3.293-3.293-1.414 1.414 4.993 4.993a1.01 1.01 0 0 0 1.428 0l4.993-4.993-1.414-1.414L16 18.586V8a6 6 0 0 0-6-6",
          clipRule: "evenodd"
        })
      })
    })
  });
};

const RefundSent = ({
  className = undefined,
  isFocusable = false,
  filled = undefined,
  title = undefined,
  role = undefined,
  size = 16,
  ...restProps
}) => {
  if (filled) {
    console.warn("<RefundSent filled /> is now deprecated, please use <RefundSentFill /> or refer to https://transferwise.github.io/icons/ for more info.");
  }
  return /*#__PURE__*/jsx("span", {
    className: `tw-icon tw-icon-refund-sent ${className ? className : ''}`,
    "data-testid": restProps['data-testid'] || 'refund-sent-icon',
    children: /*#__PURE__*/jsx("svg", {
      "aria-label": title,
      "aria-hidden": !title ? true : undefined,
      focusable: isFocusable,
      role: role ?? (title ? 'graphics-symbol img' : 'none'),
      width: String(size),
      height: String(size),
      fill: "currentColor",
      viewBox: "0 0 24 24",
      children: (Number(size) === 16 || Number(size) === 24 || Number(size) === 32) && /*#__PURE__*/jsx(Fragment, {
        children: /*#__PURE__*/jsx("path", {
          fillRule: "evenodd",
          d: "m16 5.41 3.293 3.293 1.414-1.414-4.993-4.993a1.01 1.01 0 0 0-1.428 0L9.293 7.289l1.414 1.414L14 5.41v10.586a4 4 0 0 1-8 0v-4H4v4a6 6 0 0 0 12 0z",
          clipRule: "evenodd"
        })
      })
    })
  });
};

const Reload = ({
  className = undefined,
  isFocusable = false,
  filled = undefined,
  title = undefined,
  role = undefined,
  size = 16,
  ...restProps
}) => {
  if (filled) {
    console.warn("<Reload filled /> is now deprecated, please use <ReloadFill /> or refer to https://transferwise.github.io/icons/ for more info.");
  }
  return /*#__PURE__*/jsx("span", {
    className: `tw-icon tw-icon-reload ${className ? className : ''}`,
    "data-testid": restProps['data-testid'] || 'reload-icon',
    children: /*#__PURE__*/jsx("svg", {
      "aria-label": title,
      "aria-hidden": !title ? true : undefined,
      focusable: isFocusable,
      role: role ?? (title ? 'graphics-symbol img' : 'none'),
      width: String(size),
      height: String(size),
      fill: "currentColor",
      viewBox: "0 0 24 24",
      children: (Number(size) === 16 || Number(size) === 24 || Number(size) === 32) && /*#__PURE__*/jsx(Fragment, {
        children: /*#__PURE__*/jsx("path", {
          fillRule: "evenodd",
          d: "M19.99 9H14V7h4.245a8 8 0 1 0-.588 10.657l1.414 1.414A10 10 0 1 1 19 4.86V2h2v5.99A1.01 1.01 0 0 1 19.99 9",
          clipRule: "evenodd"
        })
      })
    })
  });
};

const Refresh = ({
  className = undefined,
  isFocusable = false,
  filled = undefined,
  title = undefined,
  role = undefined,
  size = 16,
  ...restProps
}) => {
  if (filled) {
    console.warn("<Refresh filled /> is now deprecated, please use <RefreshFill /> or refer to https://transferwise.github.io/icons/ for more info.");
  }
  return /*#__PURE__*/jsx("span", {
    className: `tw-icon tw-icon-refresh ${className ? className : ''}`,
    "data-testid": restProps['data-testid'] || 'refresh-icon',
    children: /*#__PURE__*/jsx("svg", {
      "aria-label": title,
      "aria-hidden": !title ? true : undefined,
      focusable: isFocusable,
      role: role ?? (title ? 'graphics-symbol img' : 'none'),
      width: String(size),
      height: String(size),
      fill: "currentColor",
      viewBox: "0 0 24 24",
      children: (Number(size) === 16 || Number(size) === 24 || Number(size) === 32) && /*#__PURE__*/jsx(Fragment, {
        children: /*#__PURE__*/jsx("path", {
          fillRule: "evenodd",
          d: "M19.99 9H14V7h4.245a8 8 0 1 0-.588 10.657l1.414 1.414A10 10 0 1 1 19 4.86V2h2v5.99A1.01 1.01 0 0 1 19.99 9",
          clipRule: "evenodd"
        })
      })
    })
  });
};

const RequestReceive = ({
  className = undefined,
  isFocusable = false,
  filled = undefined,
  title = undefined,
  role = undefined,
  size = 16,
  ...restProps
}) => {
  if (filled) {
    console.warn("<RequestReceive filled /> is now deprecated, please use <RequestReceiveFill /> or refer to https://transferwise.github.io/icons/ for more info.");
  }
  return /*#__PURE__*/jsx("span", {
    className: `tw-icon tw-icon-request-receive ${className ? className : ''}`,
    "data-testid": restProps['data-testid'] || 'request-receive-icon',
    children: /*#__PURE__*/jsx("svg", {
      "aria-label": title,
      "aria-hidden": !title ? true : undefined,
      focusable: isFocusable,
      role: role ?? (title ? 'graphics-symbol img' : 'none'),
      width: String(size),
      height: String(size),
      fill: "currentColor",
      viewBox: "0 0 24 24",
      children: (Number(size) === 16 || Number(size) === 24 || Number(size) === 32) && /*#__PURE__*/jsx(Fragment, {
        children: /*#__PURE__*/jsx("path", {
          fillRule: "evenodd",
          d: "M2 6a2 2 0 0 1 2-2h16a2 2 0 0 1 2 2v7h-2V8a2 2 0 0 1-2-2H6a2 2 0 0 1-2 2v6a2 2 0 0 1 2 2h7v2H4a2 2 0 0 1-2-2zm8 5a2 2 0 1 1 4 0 2 2 0 0 1-4 0m2-4a4 4 0 1 0 0 8 4 4 0 0 0 0-8m6 8v3.586l-1.293-1.293-1.414 1.414 2.993 2.993a1.01 1.01 0 0 0 1.428 0l2.993-2.993-1.414-1.414L20 18.586V15z",
          clipRule: "evenodd"
        })
      })
    })
  });
};

const RequestSend = ({
  className = undefined,
  isFocusable = false,
  filled = undefined,
  title = undefined,
  role = undefined,
  size = 16,
  ...restProps
}) => {
  if (filled) {
    console.warn("<RequestSend filled /> is now deprecated, please use <RequestSendFill /> or refer to https://transferwise.github.io/icons/ for more info.");
  }
  return /*#__PURE__*/jsx("span", {
    className: `tw-icon tw-icon-request-send ${className ? className : ''}`,
    "data-testid": restProps['data-testid'] || 'request-send-icon',
    children: /*#__PURE__*/jsx("svg", {
      "aria-label": title,
      "aria-hidden": !title ? true : undefined,
      focusable: isFocusable,
      role: role ?? (title ? 'graphics-symbol img' : 'none'),
      width: String(size),
      height: String(size),
      fill: "currentColor",
      viewBox: "0 0 24 24",
      children: (Number(size) === 16 || Number(size) === 24 || Number(size) === 32) && /*#__PURE__*/jsx(Fragment, {
        children: /*#__PURE__*/jsx("path", {
          fillRule: "evenodd",
          d: "M4 4a2 2 0 0 0-2 2v10a2 2 0 0 0 2 2h9v-2H6a2 2 0 0 0-2-2V8a2 2 0 0 0 2-2h12a2 2 0 0 0 2 2v5h2V6a2 2 0 0 0-2-2zm6 7a2 2 0 1 1 4 0 2 2 0 0 1-4 0m2-4a4 4 0 1 0 0 8 4 4 0 0 0 0-8m9.293 12.707L20 18.414V22h-2v-3.586l-1.293 1.293-1.414-1.414 2.993-2.993a1.01 1.01 0 0 1 1.428 0l2.993 2.993z",
          clipRule: "evenodd"
        })
      })
    })
  });
};

const Rewards = ({
  className = undefined,
  isFocusable = false,
  filled = undefined,
  title = undefined,
  role = undefined,
  size = 16,
  ...restProps
}) => {
  if (filled) {
    console.warn("<Rewards filled /> is now deprecated, please use <RewardsFill /> or refer to https://transferwise.github.io/icons/ for more info.");
  }
  return /*#__PURE__*/jsx("span", {
    className: `tw-icon tw-icon-rewards ${className ? className : ''}`,
    "data-testid": restProps['data-testid'] || 'rewards-icon',
    children: /*#__PURE__*/jsx("svg", {
      "aria-label": title,
      "aria-hidden": !title ? true : undefined,
      focusable: isFocusable,
      role: role ?? (title ? 'graphics-symbol img' : 'none'),
      width: String(size),
      height: String(size),
      fill: "currentColor",
      viewBox: "0 0 24 24",
      children: (Number(size) === 16 || Number(size) === 24 || Number(size) === 32) && /*#__PURE__*/jsx(Fragment, {
        children: /*#__PURE__*/jsx("path", {
          fillRule: "evenodd",
          d: "M7.958 3.305a7 7 0 0 1 8.569 4.165A7.003 7.003 0 0 1 14 21a7 7 0 0 1-6.53-4.473 7 7 0 0 1 .488-13.222m5.304 2.906A5 5 0 0 1 14 7a7 7 0 0 0-7 7 5 5 0 0 1-1.862-2.833 5 5 0 0 1 8.124-4.956M14 9a5 5 0 1 0 0 10 5 5 0 0 0 0-10m1.041 3.832-.813-1.82a.25.25 0 0 0-.456 0l-.813 1.82a.25.25 0 0 1-.127.127l-1.82.813a.25.25 0 0 0 0 .456l1.82.813a.25.25 0 0 1 .127.127l.813 1.82a.25.25 0 0 0 .456 0l.813-1.82a.25.25 0 0 1 .127-.127l1.82-.813a.25.25 0 0 0 0-.456l-1.82-.813a.25.25 0 0 1-.127-.127",
          clipRule: "evenodd"
        })
      })
    })
  });
};

const SadEmoji = ({
  className = undefined,
  isFocusable = false,
  filled = undefined,
  title = undefined,
  role = undefined,
  size = 16,
  ...restProps
}) => {
  if (filled) {
    console.warn("<SadEmoji filled /> is now deprecated, please use <SadEmojiFill /> or refer to https://transferwise.github.io/icons/ for more info.");
  }
  return /*#__PURE__*/jsx("span", {
    className: `tw-icon tw-icon-sad-emoji ${className ? className : ''}`,
    "data-testid": restProps['data-testid'] || 'sad-emoji-icon',
    children: /*#__PURE__*/jsx("svg", {
      "aria-label": title,
      "aria-hidden": !title ? true : undefined,
      focusable: isFocusable,
      role: role ?? (title ? 'graphics-symbol img' : 'none'),
      width: String(size),
      height: String(size),
      fill: "currentColor",
      viewBox: "0 0 24 24",
      children: (Number(size) === 16 || Number(size) === 24 || Number(size) === 32) && /*#__PURE__*/jsxs(Fragment, {
        children: [/*#__PURE__*/jsx("path", {
          d: "M10.5 10a1.5 1.5 0 1 0-3 0 1.5 1.5 0 0 0 3 0M15 8.5a1.5 1.5 0 1 1 0 3 1.5 1.5 0 0 1 0-3M12 13a6 6 0 0 1 5.196 3l-1.732 1a4 4 0 0 0-6.928 0l-1.732-1A6 6 0 0 1 12 13"
        }), /*#__PURE__*/jsx("path", {
          fillRule: "evenodd",
          d: "M12 2C6.477 2 2 6.477 2 12s4.477 10 10 10 10-4.477 10-10S17.523 2 12 2M4 12a8 8 0 1 1 16 0 8 8 0 0 1-16 0",
          clipRule: "evenodd"
        })]
      })
    })
  });
};

const Dont = ({
  className = undefined,
  isFocusable = false,
  filled = undefined,
  title = undefined,
  role = undefined,
  size = 16,
  ...restProps
}) => {
  if (filled) {
    console.warn("<Dont filled /> is now deprecated, please use <DontFill /> or refer to https://transferwise.github.io/icons/ for more info.");
  }
  return /*#__PURE__*/jsx("span", {
    className: `tw-icon tw-icon-dont ${className ? className : ''}`,
    "data-testid": restProps['data-testid'] || 'dont-icon',
    children: /*#__PURE__*/jsx("svg", {
      "aria-label": title,
      "aria-hidden": !title ? true : undefined,
      focusable: isFocusable,
      role: role ?? (title ? 'graphics-symbol img' : 'none'),
      width: String(size),
      height: String(size),
      fill: "currentColor",
      viewBox: "0 0 24 24",
      children: (Number(size) === 16 || Number(size) === 24 || Number(size) === 32) && /*#__PURE__*/jsxs(Fragment, {
        children: [/*#__PURE__*/jsx("path", {
          d: "M10.5 10a1.5 1.5 0 1 0-3 0 1.5 1.5 0 0 0 3 0M15 8.5a1.5 1.5 0 1 1 0 3 1.5 1.5 0 0 1 0-3M12 13a6 6 0 0 1 5.196 3l-1.732 1a4 4 0 0 0-6.928 0l-1.732-1A6 6 0 0 1 12 13"
        }), /*#__PURE__*/jsx("path", {
          fillRule: "evenodd",
          d: "M12 2C6.477 2 2 6.477 2 12s4.477 10 10 10 10-4.477 10-10S17.523 2 12 2M4 12a8 8 0 1 1 16 0 8 8 0 0 1-16 0",
          clipRule: "evenodd"
        })]
      })
    })
  });
};

const Savings = ({
  className = undefined,
  isFocusable = false,
  filled = undefined,
  title = undefined,
  role = undefined,
  size = 16,
  ...restProps
}) => {
  if (filled) {
    console.warn("<Savings filled /> is now deprecated, please use <SavingsFill /> or refer to https://transferwise.github.io/icons/ for more info.");
  }
  return /*#__PURE__*/jsx("span", {
    className: `tw-icon tw-icon-savings ${className ? className : ''}`,
    "data-testid": restProps['data-testid'] || 'savings-icon',
    children: /*#__PURE__*/jsx("svg", {
      "aria-label": title,
      "aria-hidden": !title ? true : undefined,
      focusable: isFocusable,
      role: role ?? (title ? 'graphics-symbol img' : 'none'),
      width: String(size),
      height: String(size),
      fill: "currentColor",
      viewBox: "0 0 24 24",
      children: (Number(size) === 16 || Number(size) === 24 || Number(size) === 32) && /*#__PURE__*/jsx(Fragment, {
        children: /*#__PURE__*/jsx("path", {
          fillRule: "evenodd",
          d: "M20 6H4v12h16zM4 4a2 2 0 0 0-2 2v12a2 2 0 0 0 2 2h16a2 2 0 0 0 2-2V6a2 2 0 0 0-2-2zm11.488 8a1 1 0 1 0-2 0 1 1 0 0 0 2 0m-1-3c.463 0 .902.105 1.293.293l1.207-1.207L18.402 9.5l-1.207 1.207c.188.391.293.83.293 1.293s-.105.902-.293 1.293l1.207 1.207-1.414 1.414-1.207-1.207a2.998 2.998 0 0 1-2.587.001l-1.206 1.206-1.415-1.414 1.207-1.207A3 3 0 0 1 11.488 12c0-.463.104-.902.292-1.293L10.573 9.5l1.414-1.414 1.207 1.207c.392-.188.83-.293 1.294-.293M8 9v6H6V9z",
          clipRule: "evenodd"
        })
      })
    })
  });
};

const ScanQrCode = ({
  className = undefined,
  isFocusable = false,
  filled = undefined,
  title = undefined,
  role = undefined,
  size = 16,
  ...restProps
}) => {
  if (filled) {
    console.warn("<ScanQrCode filled /> is now deprecated, please use <ScanQrCodeFill /> or refer to https://transferwise.github.io/icons/ for more info.");
  }
  return /*#__PURE__*/jsx("span", {
    className: `tw-icon tw-icon-scan-qr-code ${className ? className : ''}`,
    "data-testid": restProps['data-testid'] || 'scan-qr-code-icon',
    children: /*#__PURE__*/jsx("svg", {
      "aria-label": title,
      "aria-hidden": !title ? true : undefined,
      focusable: isFocusable,
      role: role ?? (title ? 'graphics-symbol img' : 'none'),
      width: String(size),
      height: String(size),
      fill: "currentColor",
      viewBox: "0 0 24 24",
      children: (Number(size) === 16 || Number(size) === 24 || Number(size) === 32) && /*#__PURE__*/jsx(Fragment, {
        children: /*#__PURE__*/jsx("path", {
          fillRule: "evenodd",
          d: "M2 3.01C2 2.452 2.452 2 3.01 2H9v2H4v5H2zM5 5h6v6H5zm2 2v2h2V7zm-2 6h6v6H5zm2 2v2h2v-2zM19 5h-6v6h6zm-4 4V7h2v2zm-2 5.99v-1.98a.01.01 0 0 1 .01-.01h1.98a.01.01 0 0 1 .01.01v1.98a.01.01 0 0 1-.01.01h-1.98a.01.01 0 0 1-.01-.01m0 2.02v1.98q.001.01.01.01h1.98a.01.01 0 0 0 .01-.01v-1.98a.01.01 0 0 0-.01-.01h-1.98a.01.01 0 0 0-.01.01m4-2.02v-1.98a.01.01 0 0 1 .01-.01h1.98a.01.01 0 0 1 .01.01v1.98a.01.01 0 0 1-.01.01h-1.98a.01.01 0 0 1-.01-.01m0 2.02v1.98q.001.01.01.01h1.98a.01.01 0 0 0 .01-.01v-1.98a.01.01 0 0 0-.01-.01h-1.98a.01.01 0 0 0-.01.01M3.01 22A1.01 1.01 0 0 1 2 20.99V15h2v5h5v2zM22 3.01A1.01 1.01 0 0 0 20.99 2H15v2h5v5h2zM20.99 22A1.01 1.01 0 0 0 22 20.99V15h-2v5h-5v2z",
          clipRule: "evenodd"
        })
      })
    })
  });
};

const ScanSparkle = ({
  className = undefined,
  isFocusable = false,
  filled = undefined,
  title = undefined,
  role = undefined,
  size = 16,
  ...restProps
}) => {
  if (filled) {
    console.warn("<ScanSparkle filled /> is now deprecated, please use <ScanSparkleFill /> or refer to https://transferwise.github.io/icons/ for more info.");
  }
  return /*#__PURE__*/jsx("span", {
    className: `tw-icon tw-icon-scan-sparkle ${className ? className : ''}`,
    "data-testid": restProps['data-testid'] || 'scan-sparkle-icon',
    children: /*#__PURE__*/jsx("svg", {
      "aria-label": title,
      "aria-hidden": !title ? true : undefined,
      focusable: isFocusable,
      role: role ?? (title ? 'graphics-symbol img' : 'none'),
      width: String(size),
      height: String(size),
      fill: "currentColor",
      viewBox: "0 0 24 24",
      children: (Number(size) === 16 || Number(size) === 24 || Number(size) === 32) && /*#__PURE__*/jsxs(Fragment, {
        children: [/*#__PURE__*/jsx("path", {
          d: "M5 19h4v2H5a2 2 0 0 1-2-2v-5h2zm16 0a2 2 0 0 1-2 2h-4v-2h4v-5h2z"
        }), /*#__PURE__*/jsx("path", {
          fillRule: "evenodd",
          d: "M14 8a2 2 0 0 1 2 2v4a2 2 0 0 1-2 2h-4a2 2 0 0 1-2-2v-4a2 2 0 0 1 2-2zm-4 6h4v-4h-4z",
          clipRule: "evenodd"
        }), /*#__PURE__*/jsx("path", {
          d: "M9 5H5v5H3V5a2 2 0 0 1 2-2h4zm8.772-3.488a.25.25 0 0 1 .457 0l.966 2.166a.26.26 0 0 0 .127.127l2.166.966a.25.25 0 0 1 0 .457l-2.166.968a.25.25 0 0 0-.127.126L18.23 8.49a.25.25 0 0 1-.457 0l-.967-2.167a.25.25 0 0 0-.127-.126l-2.166-.968a.25.25 0 0 1 0-.457l2.166-.966a.25.25 0 0 0 .127-.127z"
        })]
      })
    })
  });
};

const Search = ({
  className = undefined,
  isFocusable = false,
  filled = undefined,
  title = undefined,
  role = undefined,
  size = 16,
  ...restProps
}) => {
  if (filled) {
    console.warn("<Search filled /> is now deprecated, please use <SearchFill /> or refer to https://transferwise.github.io/icons/ for more info.");
  }
  return /*#__PURE__*/jsx("span", {
    className: `tw-icon tw-icon-search ${className ? className : ''}`,
    "data-testid": restProps['data-testid'] || 'search-icon',
    children: /*#__PURE__*/jsx("svg", {
      "aria-label": title,
      "aria-hidden": !title ? true : undefined,
      focusable: isFocusable,
      role: role ?? (title ? 'graphics-symbol img' : 'none'),
      width: String(size),
      height: String(size),
      fill: "currentColor",
      viewBox: "0 0 24 24",
      children: (Number(size) === 16 || Number(size) === 24 || Number(size) === 32) && /*#__PURE__*/jsx(Fragment, {
        children: /*#__PURE__*/jsx("path", {
          fillRule: "evenodd",
          d: "M17 11a6 6 0 1 1-12 0 6 6 0 0 1 12 0m-1.094 6.32a8 8 0 1 1 1.414-1.414l3.887 3.887-1.414 1.414z",
          clipRule: "evenodd"
        })
      })
    })
  });
};

const Send = ({
  className = undefined,
  isFocusable = false,
  filled = undefined,
  title = undefined,
  role = undefined,
  size = 16,
  ...restProps
}) => {
  if (filled) {
    console.warn("<Send filled /> is now deprecated, please use <SendFill /> or refer to https://transferwise.github.io/icons/ for more info.");
  }
  return /*#__PURE__*/jsx("span", {
    className: `tw-icon tw-icon-send ${className ? className : ''}`,
    "data-testid": restProps['data-testid'] || 'send-icon',
    children: /*#__PURE__*/jsx("svg", {
      "aria-label": title,
      "aria-hidden": !title ? true : undefined,
      focusable: isFocusable,
      role: role ?? (title ? 'graphics-symbol img' : 'none'),
      width: String(size),
      height: String(size),
      fill: "currentColor",
      viewBox: "0 0 24 24",
      children: (Number(size) === 16 || Number(size) === 24 || Number(size) === 32) && /*#__PURE__*/jsx(Fragment, {
        children: /*#__PURE__*/jsx("path", {
          fillRule: "evenodd",
          d: "m13 5.414 6.293 6.293 1.414-1.414L12.714 2.3a1.01 1.01 0 0 0-1.428 0l-7.993 7.993 1.414 1.414L11 5.414V22h2z",
          clipRule: "evenodd"
        })
      })
    })
  });
};

const ShareAndroid = ({
  className = undefined,
  isFocusable = false,
  filled = undefined,
  title = undefined,
  role = undefined,
  size = 16,
  ...restProps
}) => {
  if (filled) {
    console.warn("<ShareAndroid filled /> is now deprecated, please use <ShareAndroidFill /> or refer to https://transferwise.github.io/icons/ for more info.");
  }
  return /*#__PURE__*/jsx("span", {
    className: `tw-icon tw-icon-share-android ${className ? className : ''}`,
    "data-testid": restProps['data-testid'] || 'share-android-icon',
    children: /*#__PURE__*/jsx("svg", {
      "aria-label": title,
      "aria-hidden": !title ? true : undefined,
      focusable: isFocusable,
      role: role ?? (title ? 'graphics-symbol img' : 'none'),
      width: String(size),
      height: String(size),
      fill: "currentColor",
      viewBox: "0 0 24 24",
      children: (Number(size) === 16 || Number(size) === 24 || Number(size) === 32) && /*#__PURE__*/jsx(Fragment, {
        children: /*#__PURE__*/jsx("path", {
          fillRule: "evenodd",
          d: "M22 6a4 4 0 1 0-7.975.448L9.232 9.643a4 4 0 1 0 0 4.713l4.793 3.196a4 4 0 1 0 .743-1.908l-4.793-3.196a4 4 0 0 0 0-.896l4.793-3.195A4 4 0 0 0 22 6m-4-2a2 2 0 1 1 0 4 2 2 0 0 1 0-4M6 10a2 2 0 1 1 0 4 2 2 0 0 1 0-4m14 8a2 2 0 1 0-4 0 2 2 0 0 0 4 0",
          clipRule: "evenodd"
        })
      })
    })
  });
};

const ShareIos = ({
  className = undefined,
  isFocusable = false,
  filled = undefined,
  title = undefined,
  role = undefined,
  size = 16,
  ...restProps
}) => {
  if (filled) {
    console.warn("<ShareIos filled /> is now deprecated, please use <ShareIosFill /> or refer to https://transferwise.github.io/icons/ for more info.");
  }
  return /*#__PURE__*/jsx("span", {
    className: `tw-icon tw-icon-share-ios ${className ? className : ''}`,
    "data-testid": restProps['data-testid'] || 'share-ios-icon',
    children: /*#__PURE__*/jsx("svg", {
      "aria-label": title,
      "aria-hidden": !title ? true : undefined,
      focusable: isFocusable,
      role: role ?? (title ? 'graphics-symbol img' : 'none'),
      width: String(size),
      height: String(size),
      fill: "currentColor",
      viewBox: "0 0 24 24",
      children: (Number(size) === 16 || Number(size) === 24 || Number(size) === 32) && /*#__PURE__*/jsx(Fragment, {
        children: /*#__PURE__*/jsx("path", {
          fillRule: "evenodd",
          d: "M16.293 9.707 13 6.414V16h-2V6.414L7.707 9.707 6.293 8.293 11.286 3.3a1.01 1.01 0 0 1 1.428 0l4.993 4.993zM19 12v7H5v-7H3v7.99c0 .558.452 1.01 1.01 1.01h15.98A1.01 1.01 0 0 0 21 19.99V12z",
          clipRule: "evenodd"
        })
      })
    })
  });
};

const Shield = ({
  className = undefined,
  isFocusable = false,
  filled = undefined,
  title = undefined,
  role = undefined,
  size = 16,
  ...restProps
}) => {
  if (filled) {
    console.warn("<Shield filled /> is now deprecated, please use <ShieldFill /> or refer to https://transferwise.github.io/icons/ for more info.");
  }
  return /*#__PURE__*/jsx("span", {
    className: `tw-icon tw-icon-shield ${className ? className : ''}`,
    "data-testid": restProps['data-testid'] || 'shield-icon',
    children: /*#__PURE__*/jsx("svg", {
      "aria-label": title,
      "aria-hidden": !title ? true : undefined,
      focusable: isFocusable,
      role: role ?? (title ? 'graphics-symbol img' : 'none'),
      width: String(size),
      height: String(size),
      fill: "currentColor",
      viewBox: "0 0 24 24",
      children: (Number(size) === 16 || Number(size) === 24 || Number(size) === 32) && /*#__PURE__*/jsx(Fragment, {
        children: /*#__PURE__*/jsx("path", {
          fillRule: "evenodd",
          d: "M12 4.373c-1.41 1.218-2.814 1.793-4.039 2.046a9.5 9.5 0 0 1-1.96.183c.001 2.115.014 3.771.106 5.13.107 1.567.315 2.653.687 3.521.692 1.613 2.033 2.693 5.206 4.584 3.173-1.89 4.514-2.971 5.206-4.584.372-.868.58-1.954.687-3.521.092-1.359.105-3.015.107-5.13a9.5 9.5 0 0 1-1.961-.183c-1.225-.253-2.63-.828-4.039-2.046m-.724-2.065a1.01 1.01 0 0 1 1.448 0c1.346 1.383 2.657 1.933 3.72 2.152.853.177 1.524.148 2.076.124q.248-.011.467-.014C19.653 4.568 20 5.134 20 5.58v.027c0 2.575 0 4.612-.112 6.26-.112 1.656-.342 3.003-.844 4.174-1.023 2.385-3.075 3.785-6.532 5.817a1.01 1.01 0 0 1-1.024 0c-3.457-2.032-5.51-3.432-6.532-5.817-.502-1.171-.732-2.518-.844-4.174C4 10.219 4 8.182 4 5.607V5.58c0-.446.347-1.012 1.013-1.01q.219.002.467.014c.552.024 1.223.053 2.076-.124 1.063-.22 2.374-.77 3.72-2.152",
          clipRule: "evenodd"
        })
      })
    })
  });
};

const ShoppingBag = ({
  className = undefined,
  isFocusable = false,
  filled = undefined,
  title = undefined,
  role = undefined,
  size = 16,
  ...restProps
}) => {
  if (filled) {
    console.warn("<ShoppingBag filled /> is now deprecated, please use <ShoppingBagFill /> or refer to https://transferwise.github.io/icons/ for more info.");
  }
  return /*#__PURE__*/jsx("span", {
    className: `tw-icon tw-icon-shopping-bag ${className ? className : ''}`,
    "data-testid": restProps['data-testid'] || 'shopping-bag-icon',
    children: /*#__PURE__*/jsx("svg", {
      "aria-label": title,
      "aria-hidden": !title ? true : undefined,
      focusable: isFocusable,
      role: role ?? (title ? 'graphics-symbol img' : 'none'),
      width: String(size),
      height: String(size),
      fill: "currentColor",
      viewBox: "0 0 24 24",
      children: (Number(size) === 16 || Number(size) === 24 || Number(size) === 32) && /*#__PURE__*/jsx(Fragment, {
        children: /*#__PURE__*/jsx("path", {
          fillRule: "evenodd",
          d: "M12 3a4 4 0 0 0-4 4H5a1 1 0 0 0-1 1v11a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V8a1 1 0 0 0-1-1h-3a4 4 0 0 0-4-4m2 4a2 2 0 1 0-4 0zM6 9v10h12V9z",
          clipRule: "evenodd"
        })
      })
    })
  });
};

const ECommerce = ({
  className = undefined,
  isFocusable = false,
  filled = undefined,
  title = undefined,
  role = undefined,
  size = 16,
  ...restProps
}) => {
  if (filled) {
    console.warn("<ECommerce filled /> is now deprecated, please use <ECommerceFill /> or refer to https://transferwise.github.io/icons/ for more info.");
  }
  return /*#__PURE__*/jsx("span", {
    className: `tw-icon tw-icon-e-commerce ${className ? className : ''}`,
    "data-testid": restProps['data-testid'] || 'e-commerce-icon',
    children: /*#__PURE__*/jsx("svg", {
      "aria-label": title,
      "aria-hidden": !title ? true : undefined,
      focusable: isFocusable,
      role: role ?? (title ? 'graphics-symbol img' : 'none'),
      width: String(size),
      height: String(size),
      fill: "currentColor",
      viewBox: "0 0 24 24",
      children: (Number(size) === 16 || Number(size) === 24 || Number(size) === 32) && /*#__PURE__*/jsx(Fragment, {
        children: /*#__PURE__*/jsx("path", {
          fillRule: "evenodd",
          d: "M12 3a4 4 0 0 0-4 4H5a1 1 0 0 0-1 1v11a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V8a1 1 0 0 0-1-1h-3a4 4 0 0 0-4-4m2 4a2 2 0 1 0-4 0zM6 9v10h12V9z",
          clipRule: "evenodd"
        })
      })
    })
  });
};

const Slider = ({
  className = undefined,
  isFocusable = false,
  filled = undefined,
  title = undefined,
  role = undefined,
  size = 16,
  ...restProps
}) => {
  if (filled) {
    console.warn("<Slider filled /> is now deprecated, please use <SliderFill /> or refer to https://transferwise.github.io/icons/ for more info.");
  }
  return /*#__PURE__*/jsx("span", {
    className: `tw-icon tw-icon-slider ${className ? className : ''}`,
    "data-testid": restProps['data-testid'] || 'slider-icon',
    children: /*#__PURE__*/jsx("svg", {
      "aria-label": title,
      "aria-hidden": !title ? true : undefined,
      focusable: isFocusable,
      role: role ?? (title ? 'graphics-symbol img' : 'none'),
      width: String(size),
      height: String(size),
      fill: "currentColor",
      viewBox: "0 0 24 24",
      children: (Number(size) === 16 || Number(size) === 24 || Number(size) === 32) && /*#__PURE__*/jsx(Fragment, {
        children: /*#__PURE__*/jsx("path", {
          fillRule: "evenodd",
          d: "M11 7a3 3 0 1 0-6 0 3 3 0 0 0 6 0m1.9-1A5.002 5.002 0 0 0 3 7a5 5 0 0 0 9.9 1H21V6zM16 22a5 5 0 0 1-4.9-4H3v-2h8.1a5.002 5.002 0 0 1 9.9 1 5 5 0 0 1-5 5m0-8a3 3 0 1 0 0 6 3 3 0 0 0 0-6",
          clipRule: "evenodd"
        })
      })
    })
  });
};

const Sofort = ({
  className = undefined,
  isFocusable = false,
  filled = undefined,
  title = undefined,
  role = undefined,
  size = 16,
  ...restProps
}) => {
  if (filled) {
    console.warn("<Sofort filled /> is now deprecated, please use <SofortFill /> or refer to https://transferwise.github.io/icons/ for more info.");
  }
  return /*#__PURE__*/jsx("span", {
    className: `tw-icon tw-icon-sofort ${className ? className : ''}`,
    "data-testid": restProps['data-testid'] || 'sofort-icon',
    children: /*#__PURE__*/jsx("svg", {
      "aria-label": title,
      "aria-hidden": !title ? true : undefined,
      focusable: isFocusable,
      role: role ?? (title ? 'graphics-symbol img' : 'none'),
      width: String(size),
      height: String(size),
      fill: "currentColor",
      viewBox: "0 0 24 24",
      children: (Number(size) === 16 || Number(size) === 24 || Number(size) === 32) && /*#__PURE__*/jsx(Fragment, {
        children: /*#__PURE__*/jsx("path", {
          fillRule: "evenodd",
          d: "M1.286 16.279h19.841l1.587-8.73H2.794zm4.103-4.624c-.303-.157-.369-.196-.369-.281 0-.105.122-.157.285-.157.191 0 .48.024.766.3.07-.224.186-.424.336-.6q-.604-.35-1.116-.352c-.677 0-1.069.37-1.069.818 0 .386.285.586.621.762.303.157.378.21.378.304 0 .105-.126.162-.294.162-.29 0-.625-.186-.826-.376l-.117.719c.206.152.504.31.957.31.7 0 1.078-.363 1.078-.824 0-.38-.243-.585-.63-.785m2.478-1.09c-.891 0-1.568.67-1.568 1.47 0 .724.556 1.228 1.312 1.228.891 0 1.563-.69 1.563-1.49.005-.728-.55-1.208-1.307-1.208m-.2 2.018c-.341 0-.579-.229-.579-.581 0-.39.294-.761.719-.761.34 0 .578.237.578.59.005.395-.294.752-.718.752m5.563-2.018c-.892 0-1.564.67-1.564 1.47 0 .724.556 1.228 1.312 1.228.891 0 1.563-.69 1.563-1.49.005-.728-.55-1.208-1.311-1.208m-.196 2.018c-.34 0-.579-.229-.579-.581 0-.39.294-.761.719-.761.34 0 .579.237.579.59 0 .395-.294.752-.72.752m3.09-1.961c.672 0 1.04.31 1.04.795 0 .404-.256.732-.69.885l.583.904h-.91l-.42-.814h-.037l-.131.814h-.794l.416-2.584zm-.346 1.223h.117c.27 0 .457-.105.457-.3 0-.166-.13-.243-.378-.243h-.107zm-5.442-.09h.934c-.01.066-.014.128-.019.2l-.07.442h-.943l-.13.814h-.794l.318-1.994c.05-.343.359-.595.723-.595h1.633c-.247.176-.448.41-.578.68h-.999zm6.847-1.133a.96.96 0 0 1 .373.68h.663l-.303 1.904h.793l.303-1.904h.738l.107-.68z",
          clipRule: "evenodd"
        })
      })
    })
  });
};

const SoftwareAndHosting = ({
  className = undefined,
  isFocusable = false,
  filled = undefined,
  title = undefined,
  role = undefined,
  size = 16,
  ...restProps
}) => {
  if (filled) {
    console.warn("<SoftwareAndHosting filled /> is now deprecated, please use <SoftwareAndHostingFill /> or refer to https://transferwise.github.io/icons/ for more info.");
  }
  return /*#__PURE__*/jsx("span", {
    className: `tw-icon tw-icon-software-and-hosting ${className ? className : ''}`,
    "data-testid": restProps['data-testid'] || 'software-and-hosting-icon',
    children: /*#__PURE__*/jsx("svg", {
      "aria-label": title,
      "aria-hidden": !title ? true : undefined,
      focusable: isFocusable,
      role: role ?? (title ? 'graphics-symbol img' : 'none'),
      width: String(size),
      height: String(size),
      fill: "currentColor",
      viewBox: "0 0 24 24",
      children: (Number(size) === 16 || Number(size) === 24 || Number(size) === 32) && /*#__PURE__*/jsx(Fragment, {
        children: /*#__PURE__*/jsx("path", {
          fillRule: "evenodd",
          d: "M12.384 5.53A3 3 0 0 1 15 4a3 3 0 0 1 2.616 1.53l.236.419.474.077A2 2 0 0 1 18 10h-6a2 2 0 0 1-.326-3.974l.474-.077zM15 2a5 5 0 0 0-4.114 2.157c-1 .29-1.84.96-2.35 1.843H6a2 2 0 0 0-2 2v12a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2v-8.535a4.001 4.001 0 0 0-.886-7.308A5 5 0 0 0 15 2m3 10h-6a4 4 0 0 1-4-4H6v12h12zm-8 5a1 1 0 1 0-2 0 1 1 0 0 0 2 0",
          clipRule: "evenodd"
        })
      })
    })
  });
};

const SoftwareAndWebHosting = ({
  className = undefined,
  isFocusable = false,
  filled = undefined,
  title = undefined,
  role = undefined,
  size = 16,
  ...restProps
}) => {
  if (filled) {
    console.warn("<SoftwareAndWebHosting filled /> is now deprecated, please use <SoftwareAndWebHostingFill /> or refer to https://transferwise.github.io/icons/ for more info.");
  }
  return /*#__PURE__*/jsx("span", {
    className: `tw-icon tw-icon-software-and-web-hosting ${className ? className : ''}`,
    "data-testid": restProps['data-testid'] || 'software-and-web-hosting-icon',
    children: /*#__PURE__*/jsx("svg", {
      "aria-label": title,
      "aria-hidden": !title ? true : undefined,
      focusable: isFocusable,
      role: role ?? (title ? 'graphics-symbol img' : 'none'),
      width: String(size),
      height: String(size),
      fill: "currentColor",
      viewBox: "0 0 24 24",
      children: (Number(size) === 16 || Number(size) === 24 || Number(size) === 32) && /*#__PURE__*/jsx(Fragment, {
        children: /*#__PURE__*/jsx("path", {
          fillRule: "evenodd",
          d: "M12.384 5.53A3 3 0 0 1 15 4a3 3 0 0 1 2.616 1.53l.236.419.474.077A2 2 0 0 1 18 10h-6a2 2 0 0 1-.326-3.974l.474-.077zM15 2a5 5 0 0 0-4.114 2.157c-1 .29-1.84.96-2.35 1.843H6a2 2 0 0 0-2 2v12a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2v-8.535a4.001 4.001 0 0 0-.886-7.308A5 5 0 0 0 15 2m3 10h-6a4 4 0 0 1-4-4H6v12h12zm-8 5a1 1 0 1 0-2 0 1 1 0 0 0 2 0",
          clipRule: "evenodd"
        })
      })
    })
  });
};

const SpeechBubbleExclamation = ({
  className = undefined,
  isFocusable = false,
  filled = undefined,
  title = undefined,
  role = undefined,
  size = 16,
  ...restProps
}) => {
  if (filled) {
    console.warn("<SpeechBubbleExclamation filled /> is now deprecated, please use <SpeechBubbleExclamationFill /> or refer to https://transferwise.github.io/icons/ for more info.");
  }
  return /*#__PURE__*/jsx("span", {
    className: `tw-icon tw-icon-speech-bubble-exclamation ${className ? className : ''}`,
    "data-testid": restProps['data-testid'] || 'speech-bubble-exclamation-icon',
    children: /*#__PURE__*/jsx("svg", {
      "aria-label": title,
      "aria-hidden": !title ? true : undefined,
      focusable: isFocusable,
      role: role ?? (title ? 'graphics-symbol img' : 'none'),
      width: String(size),
      height: String(size),
      fill: "currentColor",
      viewBox: "0 0 24 24",
      children: (Number(size) === 16 || Number(size) === 24 || Number(size) === 32) && /*#__PURE__*/jsx(Fragment, {
        children: /*#__PURE__*/jsx("path", {
          fillRule: "evenodd",
          d: "M12 4a8 8 0 0 0-6.97 11.929c.127.226.163.493.099.745l-.758 2.989 3.133-.713a1 1 0 0 1 .703.096A8 8 0 1 0 12 4M2 12C2 6.477 6.477 2 12 2s10 4.477 10 10-4.477 10-10 10a10 10 0 0 1-4.405-1.02l-4.357.991a1.01 1.01 0 0 1-1.203-1.233l1.06-4.183A9.96 9.96 0 0 1 2 12m10 3a1.5 1.5 0 1 1 0 3 1.5 1.5 0 0 1 0-3m1-2V6h-2v7z",
          clipRule: "evenodd"
        })
      })
    })
  });
};

const SpeechBubbleMessage = ({
  className = undefined,
  isFocusable = false,
  filled = undefined,
  title = undefined,
  role = undefined,
  size = 16,
  ...restProps
}) => {
  if (filled) {
    console.warn("<SpeechBubbleMessage filled /> is now deprecated, please use <SpeechBubbleMessageFill /> or refer to https://transferwise.github.io/icons/ for more info.");
  }
  return /*#__PURE__*/jsx("span", {
    className: `tw-icon tw-icon-speech-bubble-message ${className ? className : ''}`,
    "data-testid": restProps['data-testid'] || 'speech-bubble-message-icon',
    children: /*#__PURE__*/jsx("svg", {
      "aria-label": title,
      "aria-hidden": !title ? true : undefined,
      focusable: isFocusable,
      role: role ?? (title ? 'graphics-symbol img' : 'none'),
      width: String(size),
      height: String(size),
      fill: "currentColor",
      viewBox: "0 0 24 24",
      children: (Number(size) === 16 || Number(size) === 24 || Number(size) === 32) && /*#__PURE__*/jsx(Fragment, {
        children: /*#__PURE__*/jsx("path", {
          fillRule: "evenodd",
          d: "M12 4a8 8 0 0 0-6.97 11.929c.127.226.163.493.099.745l-.758 2.989 3.133-.713a1 1 0 0 1 .703.096A8 8 0 1 0 12 4M2 12C2 6.477 6.477 2 12 2s10 4.477 10 10-4.477 10-10 10a10 10 0 0 1-4.405-1.02l-4.357.991a1.01 1.01 0 0 1-1.203-1.233l1.06-4.183A9.96 9.96 0 0 1 2 12m14-3v2H8V9zm-2 4H8v2h6z",
          clipRule: "evenodd"
        })
      })
    })
  });
};

const Feedback = ({
  className = undefined,
  isFocusable = false,
  filled = undefined,
  title = undefined,
  role = undefined,
  size = 16,
  ...restProps
}) => {
  if (filled) {
    console.warn("<Feedback filled /> is now deprecated, please use <FeedbackFill /> or refer to https://transferwise.github.io/icons/ for more info.");
  }
  return /*#__PURE__*/jsx("span", {
    className: `tw-icon tw-icon-feedback ${className ? className : ''}`,
    "data-testid": restProps['data-testid'] || 'feedback-icon',
    children: /*#__PURE__*/jsx("svg", {
      "aria-label": title,
      "aria-hidden": !title ? true : undefined,
      focusable: isFocusable,
      role: role ?? (title ? 'graphics-symbol img' : 'none'),
      width: String(size),
      height: String(size),
      fill: "currentColor",
      viewBox: "0 0 24 24",
      children: (Number(size) === 16 || Number(size) === 24 || Number(size) === 32) && /*#__PURE__*/jsx(Fragment, {
        children: /*#__PURE__*/jsx("path", {
          fillRule: "evenodd",
          d: "M12 4a8 8 0 0 0-6.97 11.929c.127.226.163.493.099.745l-.758 2.989 3.133-.713a1 1 0 0 1 .703.096A8 8 0 1 0 12 4M2 12C2 6.477 6.477 2 12 2s10 4.477 10 10-4.477 10-10 10a10 10 0 0 1-4.405-1.02l-4.357.991a1.01 1.01 0 0 1-1.203-1.233l1.06-4.183A9.96 9.96 0 0 1 2 12m14-3v2H8V9zm-2 4H8v2h6z",
          clipRule: "evenodd"
        })
      })
    })
  });
};

const SpeechBubblePending = ({
  className = undefined,
  isFocusable = false,
  filled = undefined,
  title = undefined,
  role = undefined,
  size = 16,
  ...restProps
}) => {
  if (filled) {
    console.warn("<SpeechBubblePending filled /> is now deprecated, please use <SpeechBubblePendingFill /> or refer to https://transferwise.github.io/icons/ for more info.");
  }
  return /*#__PURE__*/jsx("span", {
    className: `tw-icon tw-icon-speech-bubble-pending ${className ? className : ''}`,
    "data-testid": restProps['data-testid'] || 'speech-bubble-pending-icon',
    children: /*#__PURE__*/jsx("svg", {
      "aria-label": title,
      "aria-hidden": !title ? true : undefined,
      focusable: isFocusable,
      role: role ?? (title ? 'graphics-symbol img' : 'none'),
      width: String(size),
      height: String(size),
      fill: "currentColor",
      viewBox: "0 0 24 24",
      children: (Number(size) === 16 || Number(size) === 24 || Number(size) === 32) && /*#__PURE__*/jsx(Fragment, {
        children: /*#__PURE__*/jsx("path", {
          fillRule: "evenodd",
          d: "M4 12a8 8 0 1 1 4.207 7.046 1 1 0 0 0-.703-.096l-3.133.713.758-2.989a1 1 0 0 0-.1-.745A7.96 7.96 0 0 1 4 12m8-10C6.477 2 2 6.477 2 12c0 1.639.395 3.188 1.096 4.555l-1.061 4.183a1.01 1.01 0 0 0 1.203 1.233l4.357-.991A10 10 0 0 0 12 22c5.523 0 10-4.477 10-10S17.523 2 12 2M8.5 12a1.5 1.5 0 1 0-3 0 1.5 1.5 0 0 0 3 0m5 0a1.5 1.5 0 1 0-3 0 1.5 1.5 0 0 0 3 0m3.5-1.5a1.5 1.5 0 1 1 0 3 1.5 1.5 0 0 1 0-3",
          clipRule: "evenodd"
        })
      })
    })
  });
};

const Pending = ({
  className = undefined,
  isFocusable = false,
  filled = undefined,
  title = undefined,
  role = undefined,
  size = 16,
  ...restProps
}) => {
  if (filled) {
    console.warn("<Pending filled /> is now deprecated, please use <PendingFill /> or refer to https://transferwise.github.io/icons/ for more info.");
  }
  return /*#__PURE__*/jsx("span", {
    className: `tw-icon tw-icon-pending ${className ? className : ''}`,
    "data-testid": restProps['data-testid'] || 'pending-icon',
    children: /*#__PURE__*/jsx("svg", {
      "aria-label": title,
      "aria-hidden": !title ? true : undefined,
      focusable: isFocusable,
      role: role ?? (title ? 'graphics-symbol img' : 'none'),
      width: String(size),
      height: String(size),
      fill: "currentColor",
      viewBox: "0 0 24 24",
      children: (Number(size) === 16 || Number(size) === 24 || Number(size) === 32) && /*#__PURE__*/jsx(Fragment, {
        children: /*#__PURE__*/jsx("path", {
          fillRule: "evenodd",
          d: "M4 12a8 8 0 1 1 4.207 7.046 1 1 0 0 0-.703-.096l-3.133.713.758-2.989a1 1 0 0 0-.1-.745A7.96 7.96 0 0 1 4 12m8-10C6.477 2 2 6.477 2 12c0 1.639.395 3.188 1.096 4.555l-1.061 4.183a1.01 1.01 0 0 0 1.203 1.233l4.357-.991A10 10 0 0 0 12 22c5.523 0 10-4.477 10-10S17.523 2 12 2M8.5 12a1.5 1.5 0 1 0-3 0 1.5 1.5 0 0 0 3 0m5 0a1.5 1.5 0 1 0-3 0 1.5 1.5 0 0 0 3 0m3.5-1.5a1.5 1.5 0 1 1 0 3 1.5 1.5 0 0 1 0-3",
          clipRule: "evenodd"
        })
      })
    })
  });
};

const SpeechBubbleSparkle = ({
  className = undefined,
  isFocusable = false,
  filled = undefined,
  title = undefined,
  role = undefined,
  size = 16,
  ...restProps
}) => {
  if (filled) {
    console.warn("<SpeechBubbleSparkle filled /> is now deprecated, please use <SpeechBubbleSparkleFill /> or refer to https://transferwise.github.io/icons/ for more info.");
  }
  return /*#__PURE__*/jsx("span", {
    className: `tw-icon tw-icon-speech-bubble-sparkle ${className ? className : ''}`,
    "data-testid": restProps['data-testid'] || 'speech-bubble-sparkle-icon',
    children: /*#__PURE__*/jsx("svg", {
      "aria-label": title,
      "aria-hidden": !title ? true : undefined,
      focusable: isFocusable,
      role: role ?? (title ? 'graphics-symbol img' : 'none'),
      width: String(size),
      height: String(size),
      fill: "currentColor",
      viewBox: "0 0 24 24",
      children: (Number(size) === 16 || Number(size) === 24 || Number(size) === 32) && /*#__PURE__*/jsxs(Fragment, {
        children: [/*#__PURE__*/jsx("path", {
          d: "M12 2q.775 0 1.519.114a6 6 0 0 0-1.718 1.89A7.998 7.998 0 0 0 5.029 15.93c.128.226.164.493.1.745l-.758 2.988 3.133-.712a1 1 0 0 1 .703.096A7.96 7.96 0 0 0 12 20a7.997 7.997 0 0 0 7.994-7.802 6 6 0 0 0 1.89-1.718Q22 11.224 22 12c0 5.523-4.477 10-10 10a10 10 0 0 1-4.404-1.02l-4.359.992a1.01 1.01 0 0 1-1.202-1.234l1.06-4.182A9.96 9.96 0 0 1 2 12C2 6.477 6.477 2 12 2"
        }), /*#__PURE__*/jsx("path", {
          d: "M17.295 2.46a.225.225 0 0 1 .41 0l1.149 2.572c.022.05.063.092.114.114l2.572 1.149c.177.08.177.33 0 .41l-2.572 1.149a.23.23 0 0 0-.114.114l-1.149 2.572a.225.225 0 0 1-.41 0l-1.149-2.572a.23.23 0 0 0-.114-.114L13.46 6.705a.225.225 0 0 1 0-.41l2.572-1.149a.23.23 0 0 0 .114-.114z"
        })]
      })
    })
  });
};

const SpeechBubble = ({
  className = undefined,
  isFocusable = false,
  filled = undefined,
  title = undefined,
  role = undefined,
  size = 16,
  ...restProps
}) => {
  if (filled) {
    console.warn("<SpeechBubble filled /> is now deprecated, please use <SpeechBubbleFill /> or refer to https://transferwise.github.io/icons/ for more info.");
  }
  return /*#__PURE__*/jsx("span", {
    className: `tw-icon tw-icon-speech-bubble ${className ? className : ''}`,
    "data-testid": restProps['data-testid'] || 'speech-bubble-icon',
    children: /*#__PURE__*/jsx("svg", {
      "aria-label": title,
      "aria-hidden": !title ? true : undefined,
      focusable: isFocusable,
      role: role ?? (title ? 'graphics-symbol img' : 'none'),
      width: String(size),
      height: String(size),
      fill: "currentColor",
      viewBox: "0 0 24 24",
      children: (Number(size) === 16 || Number(size) === 24 || Number(size) === 32) && /*#__PURE__*/jsx(Fragment, {
        children: /*#__PURE__*/jsx("path", {
          fillRule: "evenodd",
          d: "M12 4a8 8 0 0 0-6.97 11.929c.127.226.163.493.099.745l-.758 2.989 3.133-.713a1 1 0 0 1 .703.096A8 8 0 1 0 12 4M2 12C2 6.477 6.477 2 12 2s10 4.477 10 10-4.477 10-10 10a10 10 0 0 1-4.405-1.02l-4.357.991a1.01 1.01 0 0 1-1.203-1.233l1.06-4.183A9.96 9.96 0 0 1 2 12",
          clipRule: "evenodd"
        })
      })
    })
  });
};

const Chat = ({
  className = undefined,
  isFocusable = false,
  filled = undefined,
  title = undefined,
  role = undefined,
  size = 16,
  ...restProps
}) => {
  if (filled) {
    console.warn("<Chat filled /> is now deprecated, please use <ChatFill /> or refer to https://transferwise.github.io/icons/ for more info.");
  }
  return /*#__PURE__*/jsx("span", {
    className: `tw-icon tw-icon-chat ${className ? className : ''}`,
    "data-testid": restProps['data-testid'] || 'chat-icon',
    children: /*#__PURE__*/jsx("svg", {
      "aria-label": title,
      "aria-hidden": !title ? true : undefined,
      focusable: isFocusable,
      role: role ?? (title ? 'graphics-symbol img' : 'none'),
      width: String(size),
      height: String(size),
      fill: "currentColor",
      viewBox: "0 0 24 24",
      children: (Number(size) === 16 || Number(size) === 24 || Number(size) === 32) && /*#__PURE__*/jsx(Fragment, {
        children: /*#__PURE__*/jsx("path", {
          fillRule: "evenodd",
          d: "M12 4a8 8 0 0 0-6.97 11.929c.127.226.163.493.099.745l-.758 2.989 3.133-.713a1 1 0 0 1 .703.096A8 8 0 1 0 12 4M2 12C2 6.477 6.477 2 12 2s10 4.477 10 10-4.477 10-10 10a10 10 0 0 1-4.405-1.02l-4.357.991a1.01 1.01 0 0 1-1.203-1.233l1.06-4.183A9.96 9.96 0 0 1 2 12",
          clipRule: "evenodd"
        })
      })
    })
  });
};

const SpeechBubbles = ({
  className = undefined,
  isFocusable = false,
  filled = undefined,
  title = undefined,
  role = undefined,
  size = 16,
  ...restProps
}) => {
  if (filled) {
    console.warn("<SpeechBubbles filled /> is now deprecated, please use <SpeechBubblesFill /> or refer to https://transferwise.github.io/icons/ for more info.");
  }
  return /*#__PURE__*/jsx("span", {
    className: `tw-icon tw-icon-speech-bubbles ${className ? className : ''}`,
    "data-testid": restProps['data-testid'] || 'speech-bubbles-icon',
    children: /*#__PURE__*/jsx("svg", {
      "aria-label": title,
      "aria-hidden": !title ? true : undefined,
      focusable: isFocusable,
      role: role ?? (title ? 'graphics-symbol img' : 'none'),
      width: String(size),
      height: String(size),
      fill: "currentColor",
      viewBox: "0 0 24 24",
      children: (Number(size) === 16 || Number(size) === 24 || Number(size) === 32) && /*#__PURE__*/jsx(Fragment, {
        children: /*#__PURE__*/jsx("path", {
          fillRule: "evenodd",
          d: "M20 9a5 5 0 1 0-2.602 4.389l.337-.185 1.897.447-.465-1.859.195-.346A5 5 0 0 0 20 9m-5-7a7 7 0 0 1 6.296 10.062l.671 2.684a1.007 1.007 0 0 1-1.208 1.225l-2.752-.648a7 7 0 0 1-2.07.615 7 7 0 0 1-9.944 5.385l-2.752.648a1.007 1.007 0 0 1-1.208-1.225l.67-2.684a7 7 0 0 1 5.359-10A7 7 0 0 1 15 2m-6.917 8.084a5.002 5.002 0 0 0-3.445 7.362l.195.346-.465 1.859 1.897-.447.337.185a5.002 5.002 0 0 0 7.315-3.472 7.005 7.005 0 0 1-5.834-5.833",
          clipRule: "evenodd"
        })
      })
    })
  });
};

const Comments = ({
  className = undefined,
  isFocusable = false,
  filled = undefined,
  title = undefined,
  role = undefined,
  size = 16,
  ...restProps
}) => {
  if (filled) {
    console.warn("<Comments filled /> is now deprecated, please use <CommentsFill /> or refer to https://transferwise.github.io/icons/ for more info.");
  }
  return /*#__PURE__*/jsx("span", {
    className: `tw-icon tw-icon-comments ${className ? className : ''}`,
    "data-testid": restProps['data-testid'] || 'comments-icon',
    children: /*#__PURE__*/jsx("svg", {
      "aria-label": title,
      "aria-hidden": !title ? true : undefined,
      focusable: isFocusable,
      role: role ?? (title ? 'graphics-symbol img' : 'none'),
      width: String(size),
      height: String(size),
      fill: "currentColor",
      viewBox: "0 0 24 24",
      children: (Number(size) === 16 || Number(size) === 24 || Number(size) === 32) && /*#__PURE__*/jsx(Fragment, {
        children: /*#__PURE__*/jsx("path", {
          fillRule: "evenodd",
          d: "M20 9a5 5 0 1 0-2.602 4.389l.337-.185 1.897.447-.465-1.859.195-.346A5 5 0 0 0 20 9m-5-7a7 7 0 0 1 6.296 10.062l.671 2.684a1.007 1.007 0 0 1-1.208 1.225l-2.752-.648a7 7 0 0 1-2.07.615 7 7 0 0 1-9.944 5.385l-2.752.648a1.007 1.007 0 0 1-1.208-1.225l.67-2.684a7 7 0 0 1 5.359-10A7 7 0 0 1 15 2m-6.917 8.084a5.002 5.002 0 0 0-3.445 7.362l.195.346-.465 1.859 1.897-.447.337.185a5.002 5.002 0 0 0 7.315-3.472 7.005 7.005 0 0 1-5.834-5.833",
          clipRule: "evenodd"
        })
      })
    })
  });
};

const SpendDirham = ({
  className = undefined,
  isFocusable = false,
  filled = undefined,
  title = undefined,
  role = undefined,
  size = 16,
  ...restProps
}) => {
  if (filled) {
    console.warn("<SpendDirham filled /> is now deprecated, please use <SpendDirhamFill /> or refer to https://transferwise.github.io/icons/ for more info.");
  }
  return /*#__PURE__*/jsx("span", {
    className: `tw-icon tw-icon-spend-dirham ${className ? className : ''}`,
    "data-testid": restProps['data-testid'] || 'spend-dirham-icon',
    children: /*#__PURE__*/jsx("svg", {
      "aria-label": title,
      "aria-hidden": !title ? true : undefined,
      focusable: isFocusable,
      role: role ?? (title ? 'graphics-symbol img' : 'none'),
      width: String(size),
      height: String(size),
      fill: "currentColor",
      viewBox: "0 0 24 24",
      children: (Number(size) === 16 || Number(size) === 24 || Number(size) === 32) && /*#__PURE__*/jsx(Fragment, {
        children: /*#__PURE__*/jsx("path", {
          fillRule: "evenodd",
          d: "M20 12a8 8 0 1 1-16 0 8 8 0 0 1 16 0m2 0c0 5.523-4.477 10-10 10S2 17.523 2 12 6.477 2 12 2s10 4.477 10 10M8.5 7v7h2V7zm4.5 6a1 1 0 1 1-2 0 1 1 0 0 1 2 0m-3.5 3a.5.5 0 0 1 .5-.5v-1a1.5 1.5 0 0 0-1.415 2H8v1h3v-1h-1a.5.5 0 0 1-.5-.5m5.483-4-.902-2.106 1.838-.788.903 2.106A2 2 0 0 1 14.984 14H13.5v-2z",
          clipRule: "evenodd"
        })
      })
    })
  });
};

const SpendDollar = ({
  className = undefined,
  isFocusable = false,
  filled = undefined,
  title = undefined,
  role = undefined,
  size = 16,
  ...restProps
}) => {
  if (filled) {
    console.warn("<SpendDollar filled /> is now deprecated, please use <SpendDollarFill /> or refer to https://transferwise.github.io/icons/ for more info.");
  }
  return /*#__PURE__*/jsx("span", {
    className: `tw-icon tw-icon-spend-dollar ${className ? className : ''}`,
    "data-testid": restProps['data-testid'] || 'spend-dollar-icon',
    children: /*#__PURE__*/jsx("svg", {
      "aria-label": title,
      "aria-hidden": !title ? true : undefined,
      focusable: isFocusable,
      role: role ?? (title ? 'graphics-symbol img' : 'none'),
      width: String(size),
      height: String(size),
      fill: "currentColor",
      viewBox: "0 0 24 24",
      children: (Number(size) === 16 || Number(size) === 24 || Number(size) === 32) && /*#__PURE__*/jsx(Fragment, {
        children: /*#__PURE__*/jsx("path", {
          fillRule: "evenodd",
          d: "M20 12a8 8 0 1 1-16 0 8 8 0 0 1 16 0m2 0c0 5.523-4.477 10-10 10S2 17.523 2 12 6.477 2 12 2s10 4.477 10 10M11 7a3 3 0 0 0 0 6h2a1 1 0 1 1 0 2H9v2h2v1h2v-1a3 3 0 1 0 0-6h-2a1 1 0 1 1 0-2h4V7h-2V6h-2z",
          clipRule: "evenodd"
        })
      })
    })
  });
};

const SpendEuro = ({
  className = undefined,
  isFocusable = false,
  filled = undefined,
  title = undefined,
  role = undefined,
  size = 16,
  ...restProps
}) => {
  if (filled) {
    console.warn("<SpendEuro filled /> is now deprecated, please use <SpendEuroFill /> or refer to https://transferwise.github.io/icons/ for more info.");
  }
  return /*#__PURE__*/jsx("span", {
    className: `tw-icon tw-icon-spend-euro ${className ? className : ''}`,
    "data-testid": restProps['data-testid'] || 'spend-euro-icon',
    children: /*#__PURE__*/jsx("svg", {
      "aria-label": title,
      "aria-hidden": !title ? true : undefined,
      focusable: isFocusable,
      role: role ?? (title ? 'graphics-symbol img' : 'none'),
      width: String(size),
      height: String(size),
      fill: "currentColor",
      viewBox: "0 0 24 24",
      children: (Number(size) === 16 || Number(size) === 24 || Number(size) === 32) && /*#__PURE__*/jsx(Fragment, {
        children: /*#__PURE__*/jsx("path", {
          fillRule: "evenodd",
          d: "M20 12a8 8 0 1 1-16 0 8 8 0 0 1 16 0m2 0c0 5.523-4.477 10-10 10S2 17.523 2 12 6.477 2 12 2s10 4.477 10 10M8 12q0-.255.03-.5H13v-2H8.877A4 4 0 0 1 12 8c.901 0 1.73.297 2.4.8l1.2-1.6a6 6 0 0 0-9.057 2.3H5.501v2h.52a6 6 0 0 0 0 1H5.5v2h1.044a6 6 0 0 0 9.057 2.3l-1.202-1.6c-.668.503-1.498.8-2.4.8a4 4 0 0 1-3.122-1.5H13v-2H8.03A4 4 0 0 1 8 12",
          clipRule: "evenodd"
        })
      })
    })
  });
};

const SpendForint = ({
  className = undefined,
  isFocusable = false,
  filled = undefined,
  title = undefined,
  role = undefined,
  size = 16,
  ...restProps
}) => {
  if (filled) {
    console.warn("<SpendForint filled /> is now deprecated, please use <SpendForintFill /> or refer to https://transferwise.github.io/icons/ for more info.");
  }
  return /*#__PURE__*/jsx("span", {
    className: `tw-icon tw-icon-spend-forint ${className ? className : ''}`,
    "data-testid": restProps['data-testid'] || 'spend-forint-icon',
    children: /*#__PURE__*/jsx("svg", {
      "aria-label": title,
      "aria-hidden": !title ? true : undefined,
      focusable: isFocusable,
      role: role ?? (title ? 'graphics-symbol img' : 'none'),
      width: String(size),
      height: String(size),
      fill: "currentColor",
      viewBox: "0 0 24 24",
      children: (Number(size) === 16 || Number(size) === 24 || Number(size) === 32) && /*#__PURE__*/jsx(Fragment, {
        children: /*#__PURE__*/jsx("path", {
          fillRule: "evenodd",
          d: "M20 12a8 8 0 1 1-16 0 8 8 0 0 1 16 0m2 0c0 5.523-4.477 10-10 10S2 17.523 2 12 6.477 2 12 2s10 4.477 10 10M7 7v10h2v-4h2v-2H9V9h3V7zm6 4v-1h2v1h1v2h-1v2h1.5v2H15a2 2 0 0 1-2-2v-2h-1v-2z",
          clipRule: "evenodd"
        })
      })
    })
  });
};

const SpendFranc = ({
  className = undefined,
  isFocusable = false,
  filled = undefined,
  title = undefined,
  role = undefined,
  size = 16,
  ...restProps
}) => {
  if (filled) {
    console.warn("<SpendFranc filled /> is now deprecated, please use <SpendFrancFill /> or refer to https://transferwise.github.io/icons/ for more info.");
  }
  return /*#__PURE__*/jsx("span", {
    className: `tw-icon tw-icon-spend-franc ${className ? className : ''}`,
    "data-testid": restProps['data-testid'] || 'spend-franc-icon',
    children: /*#__PURE__*/jsx("svg", {
      "aria-label": title,
      "aria-hidden": !title ? true : undefined,
      focusable: isFocusable,
      role: role ?? (title ? 'graphics-symbol img' : 'none'),
      width: String(size),
      height: String(size),
      fill: "currentColor",
      viewBox: "0 0 24 24",
      children: (Number(size) === 16 || Number(size) === 24 || Number(size) === 32) && /*#__PURE__*/jsx(Fragment, {
        children: /*#__PURE__*/jsx("path", {
          fillRule: "evenodd",
          d: "M20 12a8 8 0 1 1-16 0 8 8 0 0 1 16 0m2 0c0 5.523-4.477 10-10 10S2 17.523 2 12 6.477 2 12 2s10 4.477 10 10m-6.507-3.504v7h2v-2.333h1v-2h-1v-.667h1v-2zm-5.993 0h2v2.5h1v-2.5h2v7h-2v-2.5h-1v2.5h-2zm-1.002 0a3.5 3.5 0 1 0 0 7v-2a1.5 1.5 0 1 1 0-3z",
          clipRule: "evenodd"
        })
      })
    })
  });
};

const SpendHryvnia = ({
  className = undefined,
  isFocusable = false,
  filled = undefined,
  title = undefined,
  role = undefined,
  size = 16,
  ...restProps
}) => {
  if (filled) {
    console.warn("<SpendHryvnia filled /> is now deprecated, please use <SpendHryvniaFill /> or refer to https://transferwise.github.io/icons/ for more info.");
  }
  return /*#__PURE__*/jsx("span", {
    className: `tw-icon tw-icon-spend-hryvnia ${className ? className : ''}`,
    "data-testid": restProps['data-testid'] || 'spend-hryvnia-icon',
    children: /*#__PURE__*/jsx("svg", {
      "aria-label": title,
      "aria-hidden": !title ? true : undefined,
      focusable: isFocusable,
      role: role ?? (title ? 'graphics-symbol img' : 'none'),
      width: String(size),
      height: String(size),
      fill: "currentColor",
      viewBox: "0 0 24 24",
      children: (Number(size) === 16 || Number(size) === 24 || Number(size) === 32) && /*#__PURE__*/jsx(Fragment, {
        children: /*#__PURE__*/jsx("path", {
          fillRule: "evenodd",
          d: "M20 12a8 8 0 1 1-16 0 8 8 0 0 1 16 0m2 0c0 5.523-4.477 10-10 10S2 17.523 2 12 6.477 2 12 2s10 4.477 10 10M9.954 17.592a3.51 3.51 0 0 0 4.185.586l2.347-1.305-.971-1.748-2.347 1.305a1.509 1.509 0 0 1-2.111-1.934H17v-2h-4.084l1-1H17v-2h-1.974a3.503 3.503 0 0 0-5.144-3.68L7.517 7.124l.968 1.75 2.365-1.308a1.503 1.503 0 0 1 2.1 1.93H7v2h4.088l-1 1H7v2h1.98a3.5 3.5 0 0 0 .974 3.096",
          clipRule: "evenodd"
        })
      })
    })
  });
};

const SpendKoruna = ({
  className = undefined,
  isFocusable = false,
  filled = undefined,
  title = undefined,
  role = undefined,
  size = 16,
  ...restProps
}) => {
  if (filled) {
    console.warn("<SpendKoruna filled /> is now deprecated, please use <SpendKorunaFill /> or refer to https://transferwise.github.io/icons/ for more info.");
  }
  return /*#__PURE__*/jsx("span", {
    className: `tw-icon tw-icon-spend-koruna ${className ? className : ''}`,
    "data-testid": restProps['data-testid'] || 'spend-koruna-icon',
    children: /*#__PURE__*/jsx("svg", {
      "aria-label": title,
      "aria-hidden": !title ? true : undefined,
      focusable: isFocusable,
      role: role ?? (title ? 'graphics-symbol img' : 'none'),
      width: String(size),
      height: String(size),
      fill: "currentColor",
      viewBox: "0 0 24 24",
      children: (Number(size) === 16 || Number(size) === 24 || Number(size) === 32) && /*#__PURE__*/jsx(Fragment, {
        children: /*#__PURE__*/jsx("path", {
          fillRule: "evenodd",
          d: "M12 20a8 8 0 1 0 0-16 8 8 0 0 0 0 16m0 2c5.523 0 10-4.477 10-10S17.523 2 12 2 2 6.477 2 12s4.477 10 10 10m2.099-13-.882-1h2l.323.366.323-.366h2l-.882 1zm-3.822-1L9 10.234V8H7v8h2v-1.734l.408-.714L10.632 16h2.236L10.6 11.465 12.58 8zM17 9.636a3.229 3.229 0 1 0 0 6.27v-2.178a1.227 1.227 0 0 1-1.958-.639A1.229 1.229 0 0 1 17 11.815z",
          clipRule: "evenodd"
        })
      })
    })
  });
};

const SpendKrone = ({
  className = undefined,
  isFocusable = false,
  filled = undefined,
  title = undefined,
  role = undefined,
  size = 16,
  ...restProps
}) => {
  if (filled) {
    console.warn("<SpendKrone filled /> is now deprecated, please use <SpendKroneFill /> or refer to https://transferwise.github.io/icons/ for more info.");
  }
  return /*#__PURE__*/jsx("span", {
    className: `tw-icon tw-icon-spend-krone ${className ? className : ''}`,
    "data-testid": restProps['data-testid'] || 'spend-krone-icon',
    children: /*#__PURE__*/jsx("svg", {
      "aria-label": title,
      "aria-hidden": !title ? true : undefined,
      focusable: isFocusable,
      role: role ?? (title ? 'graphics-symbol img' : 'none'),
      width: String(size),
      height: String(size),
      fill: "currentColor",
      viewBox: "0 0 24 24",
      children: (Number(size) === 16 || Number(size) === 24 || Number(size) === 32) && /*#__PURE__*/jsx(Fragment, {
        children: /*#__PURE__*/jsx("path", {
          fillRule: "evenodd",
          d: "M12 20a8 8 0 1 0 0-16 8 8 0 0 0 0 16m0 2c5.523 0 10-4.477 10-10S17.523 2 12 2 2 6.477 2 12s4.477 10 10 10M6.968 7h2v4.325L9.703 10h2.288L10.2 13.226 11.908 17H9.712l-.721-1.595-.023.041V17h-2zM13 10h4v2h-2v5h-2z",
          clipRule: "evenodd"
        })
      })
    })
  });
};

const SpendKuna = ({
  className = undefined,
  isFocusable = false,
  filled = undefined,
  title = undefined,
  role = undefined,
  size = 16,
  ...restProps
}) => {
  if (filled) {
    console.warn("<SpendKuna filled /> is now deprecated, please use <SpendKunaFill /> or refer to https://transferwise.github.io/icons/ for more info.");
  }
  return /*#__PURE__*/jsx("span", {
    className: `tw-icon tw-icon-spend-kuna ${className ? className : ''}`,
    "data-testid": restProps['data-testid'] || 'spend-kuna-icon',
    children: /*#__PURE__*/jsx("svg", {
      "aria-label": title,
      "aria-hidden": !title ? true : undefined,
      focusable: isFocusable,
      role: role ?? (title ? 'graphics-symbol img' : 'none'),
      width: String(size),
      height: String(size),
      fill: "currentColor",
      viewBox: "0 0 24 24",
      children: (Number(size) === 16 || Number(size) === 24 || Number(size) === 32) && /*#__PURE__*/jsx(Fragment, {
        children: /*#__PURE__*/jsx("path", {
          fillRule: "evenodd",
          d: "M12 20a8 8 0 1 0 0-16 8 8 0 0 0 0 16m0 2c5.523 0 10-4.477 10-10S17.523 2 12 2 2 6.477 2 12s4.477 10 10 10m-4.997-7.096.019-6.907 2 .006-.009 3.1L10.126 9h2.262l-1.8 3.402L12.369 16h-2.23l-.702-1.418-.434.82-.002.6-2-.005.003-1.086L7 14.909zM13 10h5v6h-2v-4h-1v4h-2z",
          clipRule: "evenodd"
        })
      })
    })
  });
};

const SpendLeuLei = ({
  className = undefined,
  isFocusable = false,
  filled = undefined,
  title = undefined,
  role = undefined,
  size = 16,
  ...restProps
}) => {
  if (filled) {
    console.warn("<SpendLeuLei filled /> is now deprecated, please use <SpendLeuLeiFill /> or refer to https://transferwise.github.io/icons/ for more info.");
  }
  return /*#__PURE__*/jsx("span", {
    className: `tw-icon tw-icon-spend-leu-lei ${className ? className : ''}`,
    "data-testid": restProps['data-testid'] || 'spend-leu-lei-icon',
    children: /*#__PURE__*/jsx("svg", {
      "aria-label": title,
      "aria-hidden": !title ? true : undefined,
      focusable: isFocusable,
      role: role ?? (title ? 'graphics-symbol img' : 'none'),
      width: String(size),
      height: String(size),
      fill: "currentColor",
      viewBox: "0 0 24 24",
      children: (Number(size) === 16 || Number(size) === 24 || Number(size) === 32) && /*#__PURE__*/jsx(Fragment, {
        children: /*#__PURE__*/jsx("path", {
          fillRule: "evenodd",
          d: "M12 20a8 8 0 1 0 0-16 8 8 0 0 0 0 16m0 2c5.523 0 10-4.477 10-10S17.523 2 12 2 2 6.477 2 12s4.477 10 10 10m-6-5.003V8h2v8.997zM16 11v5.999h2V11zm2-2a1 1 0 1 1-2 0 1 1 0 0 1 2 0m-5.308.78a3.1 3.1 0 0 0-2.355.402c-.702.437-1.22 1.123-1.5 1.912a4.24 4.24 0 0 0-.105 2.47c.211.812.665 1.545 1.317 2.053.657.512 1.47.758 2.298.663.826-.095 1.566-.517 2.108-1.149l-1.518-1.302c-.244.284-.537.432-.818.464a1.15 1.15 0 0 1-.84-.254 1.7 1.7 0 0 1-.443-.539H15.4v-1a4.1 4.1 0 0 0-.727-2.352c-.48-.681-1.172-1.18-1.98-1.368m.467 2.72h-2.323c.146-.276.344-.487.559-.62.273-.17.568-.216.845-.152.282.066.571.251.797.572q.066.095.122.2",
          clipRule: "evenodd"
        })
      })
    })
  });
};

const SpendLev = ({
  className = undefined,
  isFocusable = false,
  filled = undefined,
  title = undefined,
  role = undefined,
  size = 16,
  ...restProps
}) => {
  if (filled) {
    console.warn("<SpendLev filled /> is now deprecated, please use <SpendLevFill /> or refer to https://transferwise.github.io/icons/ for more info.");
  }
  return /*#__PURE__*/jsx("span", {
    className: `tw-icon tw-icon-spend-lev ${className ? className : ''}`,
    "data-testid": restProps['data-testid'] || 'spend-lev-icon',
    children: /*#__PURE__*/jsx("svg", {
      "aria-label": title,
      "aria-hidden": !title ? true : undefined,
      focusable: isFocusable,
      role: role ?? (title ? 'graphics-symbol img' : 'none'),
      width: String(size),
      height: String(size),
      fill: "currentColor",
      viewBox: "0 0 24 24",
      children: (Number(size) === 16 || Number(size) === 24 || Number(size) === 32) && /*#__PURE__*/jsx(Fragment, {
        children: /*#__PURE__*/jsx("path", {
          fillRule: "evenodd",
          d: "M12 20a8 8 0 1 0 0-16 8 8 0 0 0 0 16m0 2c5.523 0 10-4.477 10-10S17.523 2 12 2 2 6.477 2 12s4.477 10 10 10M6.912 8H12v8h-2v-6H8.912v3.312A2.91 2.91 0 0 1 6 16.224v-2a.91.91 0 0 0 .912-.912zm6.179 0v8h3.393a2.516 2.516 0 0 0 1.422-4.592A2.484 2.484 0 0 0 15.6 8zm2 4.968h1.393a.516.516 0 1 1 0 1.032H15.09zm.51-2h-.51V10h.51a.484.484 0 1 1 0 .968",
          clipRule: "evenodd"
        })
      })
    })
  });
};

const SpendLira = ({
  className = undefined,
  isFocusable = false,
  filled = undefined,
  title = undefined,
  role = undefined,
  size = 16,
  ...restProps
}) => {
  if (filled) {
    console.warn("<SpendLira filled /> is now deprecated, please use <SpendLiraFill /> or refer to https://transferwise.github.io/icons/ for more info.");
  }
  return /*#__PURE__*/jsx("span", {
    className: `tw-icon tw-icon-spend-lira ${className ? className : ''}`,
    "data-testid": restProps['data-testid'] || 'spend-lira-icon',
    children: /*#__PURE__*/jsx("svg", {
      "aria-label": title,
      "aria-hidden": !title ? true : undefined,
      focusable: isFocusable,
      role: role ?? (title ? 'graphics-symbol img' : 'none'),
      width: String(size),
      height: String(size),
      fill: "currentColor",
      viewBox: "0 0 24 24",
      children: (Number(size) === 16 || Number(size) === 24 || Number(size) === 32) && /*#__PURE__*/jsx(Fragment, {
        children: /*#__PURE__*/jsx("path", {
          fillRule: "evenodd",
          d: "M20 12a8 8 0 1 1-16 0 8 8 0 0 1 16 0m2 0c0 5.523-4.477 10-10 10S2 17.523 2 12 6.477 2 12 2s10 4.477 10 10M12 6v2.644l2-.536v2.07l-2 .536v.822L14 11v2.07l-2 .537V16a2 2 0 0 0 2-2h2a4 4 0 0 1-4 4h-.088A1.91 1.91 0 0 1 10 16.088v-1.946l-2 .536v-2.07l2-.536v-.822l-2 .536v-2.07l2-.536V6z",
          clipRule: "evenodd"
        })
      })
    })
  });
};

const SpendPound = ({
  className = undefined,
  isFocusable = false,
  filled = undefined,
  title = undefined,
  role = undefined,
  size = 16,
  ...restProps
}) => {
  if (filled) {
    console.warn("<SpendPound filled /> is now deprecated, please use <SpendPoundFill /> or refer to https://transferwise.github.io/icons/ for more info.");
  }
  return /*#__PURE__*/jsx("span", {
    className: `tw-icon tw-icon-spend-pound ${className ? className : ''}`,
    "data-testid": restProps['data-testid'] || 'spend-pound-icon',
    children: /*#__PURE__*/jsx("svg", {
      "aria-label": title,
      "aria-hidden": !title ? true : undefined,
      focusable: isFocusable,
      role: role ?? (title ? 'graphics-symbol img' : 'none'),
      width: String(size),
      height: String(size),
      fill: "currentColor",
      viewBox: "0 0 24 24",
      children: (Number(size) === 16 || Number(size) === 24 || Number(size) === 32) && /*#__PURE__*/jsx(Fragment, {
        children: /*#__PURE__*/jsx("path", {
          fillRule: "evenodd",
          d: "M20 12a8 8 0 1 1-16 0 8 8 0 0 1 16 0m2 0c0 5.523-4.477 10-10 10S2 17.523 2 12 6.477 2 12 2s10 4.477 10 10M8 17h7.5v-2H11v-2h2.5v-2H11V9.5a1.5 1.5 0 0 1 3 0h2a3.5 3.5 0 1 0-7 0V11H8v2h1v2H8z",
          clipRule: "evenodd"
        })
      })
    })
  });
};

const SpendReal = ({
  className = undefined,
  isFocusable = false,
  filled = undefined,
  title = undefined,
  role = undefined,
  size = 16,
  ...restProps
}) => {
  if (filled) {
    console.warn("<SpendReal filled /> is now deprecated, please use <SpendRealFill /> or refer to https://transferwise.github.io/icons/ for more info.");
  }
  return /*#__PURE__*/jsx("span", {
    className: `tw-icon tw-icon-spend-real ${className ? className : ''}`,
    "data-testid": restProps['data-testid'] || 'spend-real-icon',
    children: /*#__PURE__*/jsx("svg", {
      "aria-label": title,
      "aria-hidden": !title ? true : undefined,
      focusable: isFocusable,
      role: role ?? (title ? 'graphics-symbol img' : 'none'),
      width: String(size),
      height: String(size),
      fill: "currentColor",
      viewBox: "0 0 24 24",
      children: (Number(size) === 16 || Number(size) === 24 || Number(size) === 32) && /*#__PURE__*/jsx(Fragment, {
        children: /*#__PURE__*/jsx("path", {
          fillRule: "evenodd",
          d: "M20 12a8 8 0 1 1-16 0 8 8 0 0 1 16 0m2 0c0 5.523-4.477 10-10 10S2 17.523 2 12 6.477 2 12 2s10 4.477 10 10m-8-4.599A3 3 0 0 0 12.5 10v.25A2.75 2.75 0 0 0 15.25 13a.75.75 0 0 1 .75.75V14a1 1 0 0 1-1 1h-2v2h1v1h2v-1.17A3 3 0 0 0 18 14v-.25A2.75 2.75 0 0 0 15.25 11a.75.75 0 0 1-.75-.75V10a1 1 0 0 1 1-1H17V7h-1V6h-2zM7 7h2a3 3 0 0 1 1.414 5.647L11.887 17H9.775L9 14.709V17H7zm2 4a1 1 0 1 0 0-2z",
          clipRule: "evenodd"
        })
      })
    })
  });
};

const SpendRinggit = ({
  className = undefined,
  isFocusable = false,
  filled = undefined,
  title = undefined,
  role = undefined,
  size = 16,
  ...restProps
}) => {
  if (filled) {
    console.warn("<SpendRinggit filled /> is now deprecated, please use <SpendRinggitFill /> or refer to https://transferwise.github.io/icons/ for more info.");
  }
  return /*#__PURE__*/jsx("span", {
    className: `tw-icon tw-icon-spend-ringgit ${className ? className : ''}`,
    "data-testid": restProps['data-testid'] || 'spend-ringgit-icon',
    children: /*#__PURE__*/jsx("svg", {
      "aria-label": title,
      "aria-hidden": !title ? true : undefined,
      focusable: isFocusable,
      role: role ?? (title ? 'graphics-symbol img' : 'none'),
      width: String(size),
      height: String(size),
      fill: "currentColor",
      viewBox: "0 0 24 24",
      children: (Number(size) === 16 || Number(size) === 24 || Number(size) === 32) && /*#__PURE__*/jsx(Fragment, {
        children: /*#__PURE__*/jsx("path", {
          fillRule: "evenodd",
          d: "M20 12a8 8 0 1 1-16 0 8 8 0 0 1 16 0m2 0c0 5.523-4.477 10-10 10S2 17.523 2 12 6.477 2 12 2s10 4.477 10 10M6 8v8h2v-2.889h.202L8.78 16h2.04l-.703-3.512A2.556 2.556 0 0 0 8.444 8zm2.444 3.111H8V10h.444a.556.556 0 1 1 0 1.111m3.056 4.89V8h2.062L15 11.221 16.438 8H18.5v8h-2v-3.38l-.795 1.781h-1.41L13.5 12.62V16z",
          clipRule: "evenodd"
        })
      })
    })
  });
};

const SpendRupee = ({
  className = undefined,
  isFocusable = false,
  filled = undefined,
  title = undefined,
  role = undefined,
  size = 16,
  ...restProps
}) => {
  if (filled) {
    console.warn("<SpendRupee filled /> is now deprecated, please use <SpendRupeeFill /> or refer to https://transferwise.github.io/icons/ for more info.");
  }
  return /*#__PURE__*/jsx("span", {
    className: `tw-icon tw-icon-spend-rupee ${className ? className : ''}`,
    "data-testid": restProps['data-testid'] || 'spend-rupee-icon',
    children: /*#__PURE__*/jsx("svg", {
      "aria-label": title,
      "aria-hidden": !title ? true : undefined,
      focusable: isFocusable,
      role: role ?? (title ? 'graphics-symbol img' : 'none'),
      width: String(size),
      height: String(size),
      fill: "currentColor",
      viewBox: "0 0 24 24",
      children: (Number(size) === 16 || Number(size) === 24 || Number(size) === 32) && /*#__PURE__*/jsx(Fragment, {
        children: /*#__PURE__*/jsx("path", {
          fillRule: "evenodd",
          d: "M20 12a8 8 0 1 1-16 0 8 8 0 0 1 16 0m2 0c0 5.523-4.477 10-10 10S2 17.523 2 12 6.477 2 12 2s10 4.477 10 10m-6-6H9v2h1a2 2 0 0 1 1.732 1H9v2h2.732A2 2 0 0 1 10 12H9v1.964l-.01.006.01.017V14h.008l2.49 4h2.356l-2.612-4.196A4.01 4.01 0 0 0 13.874 11H16V9h-2.126a4 4 0 0 0-.41-1H16z",
          clipRule: "evenodd"
        })
      })
    })
  });
};

const SpendRupiah = ({
  className = undefined,
  isFocusable = false,
  filled = undefined,
  title = undefined,
  role = undefined,
  size = 16,
  ...restProps
}) => {
  if (filled) {
    console.warn("<SpendRupiah filled /> is now deprecated, please use <SpendRupiahFill /> or refer to https://transferwise.github.io/icons/ for more info.");
  }
  return /*#__PURE__*/jsx("span", {
    className: `tw-icon tw-icon-spend-rupiah ${className ? className : ''}`,
    "data-testid": restProps['data-testid'] || 'spend-rupiah-icon',
    children: /*#__PURE__*/jsx("svg", {
      "aria-label": title,
      "aria-hidden": !title ? true : undefined,
      focusable: isFocusable,
      role: role ?? (title ? 'graphics-symbol img' : 'none'),
      width: String(size),
      height: String(size),
      fill: "currentColor",
      viewBox: "0 0 24 24",
      children: (Number(size) === 16 || Number(size) === 24 || Number(size) === 32) && /*#__PURE__*/jsx(Fragment, {
        children: /*#__PURE__*/jsx("path", {
          fillRule: "evenodd",
          d: "M20 12a8 8 0 1 1-16 0 8 8 0 0 1 16 0m2 0c0 5.523-4.477 10-10 10S2 17.523 2 12 6.477 2 12 2s10 4.477 10 10m-7 2v-2h.5a1 1 0 1 1 0 2zm.5 2H15v2.5h-2V10h2.5a3 3 0 0 1 0 6M7 7h1.944a3.056 3.056 0 0 1 2.126 5.25l.75 3.75H9.78l-.58-2.9a3 3 0 0 1-.2.01V16H7zm2 4.11A1.056 1.056 0 0 0 9 9z",
          clipRule: "evenodd"
        })
      })
    })
  });
};

const SpendYen = ({
  className = undefined,
  isFocusable = false,
  filled = undefined,
  title = undefined,
  role = undefined,
  size = 16,
  ...restProps
}) => {
  if (filled) {
    console.warn("<SpendYen filled /> is now deprecated, please use <SpendYenFill /> or refer to https://transferwise.github.io/icons/ for more info.");
  }
  return /*#__PURE__*/jsx("span", {
    className: `tw-icon tw-icon-spend-yen ${className ? className : ''}`,
    "data-testid": restProps['data-testid'] || 'spend-yen-icon',
    children: /*#__PURE__*/jsx("svg", {
      "aria-label": title,
      "aria-hidden": !title ? true : undefined,
      focusable: isFocusable,
      role: role ?? (title ? 'graphics-symbol img' : 'none'),
      width: String(size),
      height: String(size),
      fill: "currentColor",
      viewBox: "0 0 24 24",
      children: (Number(size) === 16 || Number(size) === 24 || Number(size) === 32) && /*#__PURE__*/jsx(Fragment, {
        children: /*#__PURE__*/jsx("path", {
          fillRule: "evenodd",
          d: "M20 12a8 8 0 1 1-16 0 8 8 0 0 1 16 0m2 0c0 5.523-4.477 10-10 10S2 17.523 2 12 6.477 2 12 2s10 4.477 10 10m-7 1h-2v1h2v2h-2v2h-2v-2H9v-2h2v-1H9v-2h1.323l-2-5h2.154L12 9.807 13.523 6h2.154l-2 5H15z",
          clipRule: "evenodd"
        })
      })
    })
  });
};

const SpendZloty = ({
  className = undefined,
  isFocusable = false,
  filled = undefined,
  title = undefined,
  role = undefined,
  size = 16,
  ...restProps
}) => {
  if (filled) {
    console.warn("<SpendZloty filled /> is now deprecated, please use <SpendZlotyFill /> or refer to https://transferwise.github.io/icons/ for more info.");
  }
  return /*#__PURE__*/jsx("span", {
    className: `tw-icon tw-icon-spend-zloty ${className ? className : ''}`,
    "data-testid": restProps['data-testid'] || 'spend-zloty-icon',
    children: /*#__PURE__*/jsx("svg", {
      "aria-label": title,
      "aria-hidden": !title ? true : undefined,
      focusable: isFocusable,
      role: role ?? (title ? 'graphics-symbol img' : 'none'),
      width: String(size),
      height: String(size),
      fill: "currentColor",
      viewBox: "0 0 24 24",
      children: (Number(size) === 16 || Number(size) === 24 || Number(size) === 32) && /*#__PURE__*/jsx(Fragment, {
        children: /*#__PURE__*/jsx("path", {
          fillRule: "evenodd",
          d: "M20 12a8 8 0 1 1-16 0 8 8 0 0 1 16 0m2 0c0 5.523-4.477 10-10 10S2 17.523 2 12 6.477 2 12 2s10 4.477 10 10M8 11h1.882l-3 6H12v-2h-1.882l3-6H8zm6-4h2v2.536l1-.268v2.07l-1 .269V17h-2v-4.857l-1 .267v-2.07l1-.268z",
          clipRule: "evenodd"
        })
      })
    })
  });
};

const SplitMoney = ({
  className = undefined,
  isFocusable = false,
  filled = undefined,
  title = undefined,
  role = undefined,
  size = 16,
  ...restProps
}) => {
  if (filled) {
    console.warn("<SplitMoney filled /> is now deprecated, please use <SplitMoneyFill /> or refer to https://transferwise.github.io/icons/ for more info.");
  }
  return /*#__PURE__*/jsx("span", {
    className: `tw-icon tw-icon-split-money ${className ? className : ''}`,
    "data-testid": restProps['data-testid'] || 'split-money-icon',
    children: /*#__PURE__*/jsx("svg", {
      "aria-label": title,
      "aria-hidden": !title ? true : undefined,
      focusable: isFocusable,
      role: role ?? (title ? 'graphics-symbol img' : 'none'),
      width: String(size),
      height: String(size),
      fill: "currentColor",
      viewBox: "0 0 24 24",
      children: (Number(size) === 16 || Number(size) === 24 || Number(size) === 32) && /*#__PURE__*/jsx(Fragment, {
        children: /*#__PURE__*/jsx("path", {
          fillRule: "evenodd",
          d: "M4 18h5.77l.563-2H6a2 2 0 0 0-2-2V8a2 2 0 0 0 2-2h7.154l.564-2H4a2 2 0 0 0-2 2v10a2 2 0 0 0 2 2m5.172-4.172a4 4 0 0 0 1.507.947l.545-1.932a2 2 0 0 1 1.077-3.82l.545-1.932a3.999 3.999 0 0 0-3.674 6.737M20.557 6H14.9l-.55 2h4.207a2 2 0 0 0 2 2v6a2 2 0 0 0-2 2H11.6l-.55 2h9.507a2 2 0 0 0 2-2V8a2 2 0 0 0-2-2m-5.171 4.172A4 4 0 0 0 14 9.27l-.536 1.948a1.999 1.999 0 0 1-1.039 3.778l-.536 1.948a4 4 0 0 0 3.496-1.116 4 4 0 0 0 0-5.656",
          clipRule: "evenodd"
        })
      })
    })
  });
};

const StarFill = ({
  className = undefined,
  isFocusable = false,
  filled = undefined,
  title = undefined,
  role = undefined,
  size = 16,
  ...restProps
}) => {
  if (filled) {
    console.warn("<StarFill filled /> is now deprecated, please use <StarFillFill /> or refer to https://transferwise.github.io/icons/ for more info.");
  }
  return /*#__PURE__*/jsx("span", {
    className: `tw-icon tw-icon-star-fill ${className ? className : ''}`,
    "data-testid": restProps['data-testid'] || 'star-fill-icon',
    children: /*#__PURE__*/jsx("svg", {
      "aria-label": title,
      "aria-hidden": !title ? true : undefined,
      focusable: isFocusable,
      role: role ?? (title ? 'graphics-symbol img' : 'none'),
      width: String(size),
      height: String(size),
      fill: "currentColor",
      viewBox: "0 0 24 24",
      children: (Number(size) === 16 || Number(size) === 24 || Number(size) === 32) && /*#__PURE__*/jsx(Fragment, {
        children: /*#__PURE__*/jsx("path", {
          fillRule: "evenodd",
          d: "M11.067 3.638c.345-.83 1.52-.83 1.866 0l2.136 5.137 5.547.445c.895.072 1.258 1.19.576 1.774l-4.226 3.62 1.291 5.412c.209.874-.742 1.564-1.509 1.096L12 18.222l-4.748 2.9c-.767.468-1.718-.223-1.51-1.096l1.292-5.412-4.226-3.62c-.682-.585-.319-1.702.577-1.774l5.546-.445z",
          clipRule: "evenodd"
        })
      })
    })
  });
};

const Star = ({
  className = undefined,
  isFocusable = false,
  filled = undefined,
  title = undefined,
  role = undefined,
  size = 16,
  ...restProps
}) => {
  if (filled) {
    console.warn("<Star filled /> is now deprecated, please use <StarFill /> or refer to https://transferwise.github.io/icons/ for more info.");
  }
  return /*#__PURE__*/jsx("span", {
    className: `tw-icon tw-icon-star ${className ? className : ''}`,
    "data-testid": restProps['data-testid'] || 'star-icon',
    children: /*#__PURE__*/jsx("svg", {
      "aria-label": title,
      "aria-hidden": !title ? true : undefined,
      focusable: isFocusable,
      role: role ?? (title ? 'graphics-symbol img' : 'none'),
      width: String(size),
      height: String(size),
      fill: "currentColor",
      viewBox: "0 0 24 24",
      children: (Number(size) === 16 || Number(size) === 24 || Number(size) === 32) && /*#__PURE__*/jsx(Fragment, {
        children: /*#__PURE__*/jsx("path", {
          fillRule: "evenodd",
          d: "M11.067 3.638c.345-.83 1.52-.83 1.866 0l2.136 5.137 5.547.445c.895.072 1.258 1.19.576 1.774l-4.226 3.62 1.291 5.412c.209.874-.742 1.564-1.509 1.096L12 18.222l-4.748 2.9c-.767.468-1.718-.223-1.51-1.096l1.292-5.412-4.226-3.62c-.682-.585-.319-1.702.577-1.774l5.546-.445zM12 6.604l-1.455 3.498a1.01 1.01 0 0 1-.852.619l-3.776.303 2.877 2.464c.288.247.413.633.326 1.002l-.88 3.684 3.233-1.974a1.01 1.01 0 0 1 1.053 0l3.233 1.974-.879-3.684a1.01 1.01 0 0 1 .326-1.002l2.877-2.464-3.776-.303a1.01 1.01 0 0 1-.852-.62z",
          clipRule: "evenodd"
        })
      })
    })
  });
};

const StarstruckEmoji = ({
  className = undefined,
  isFocusable = false,
  filled = undefined,
  title = undefined,
  role = undefined,
  size = 16,
  ...restProps
}) => {
  if (filled) {
    console.warn("<StarstruckEmoji filled /> is now deprecated, please use <StarstruckEmojiFill /> or refer to https://transferwise.github.io/icons/ for more info.");
  }
  return /*#__PURE__*/jsx("span", {
    className: `tw-icon tw-icon-starstruck-emoji ${className ? className : ''}`,
    "data-testid": restProps['data-testid'] || 'starstruck-emoji-icon',
    children: /*#__PURE__*/jsx("svg", {
      "aria-label": title,
      "aria-hidden": !title ? true : undefined,
      focusable: isFocusable,
      role: role ?? (title ? 'graphics-symbol img' : 'none'),
      width: String(size),
      height: String(size),
      fill: "currentColor",
      viewBox: "0 0 24 24",
      children: (Number(size) === 16 || Number(size) === 24 || Number(size) === 32) && /*#__PURE__*/jsxs(Fragment, {
        children: [/*#__PURE__*/jsx("path", {
          d: "M8.13 13.015a4 4 0 0 0 7.738.003l.968.253.967.255a6 6 0 0 1-11.607-.005l.967-.253zm.126-5.852a.264.264 0 0 1 .488 0l.56 1.346 1.452.116c.234.019.33.31.151.464l-1.106.948.338 1.417a.265.265 0 0 1-.396.287L8.5 10.982l-1.243.76a.265.265 0 0 1-.396-.288l.338-1.417-1.106-.948a.264.264 0 0 1 .151-.464l1.452-.116zm7 0a.264.264 0 0 1 .488 0l.56 1.346 1.452.116c.234.019.33.31.151.464l-1.106.948.338 1.417a.265.265 0 0 1-.396.287l-1.243-.759-1.243.76a.265.265 0 0 1-.396-.288l.338-1.417-1.106-.948a.264.264 0 0 1 .151-.464l1.452-.116z"
        }), /*#__PURE__*/jsx("path", {
          fillRule: "evenodd",
          d: "M12 2c5.523 0 10 4.477 10 10s-4.477 10-10 10S2 17.523 2 12 6.477 2 12 2m0 2a8 8 0 1 0 0 16 8 8 0 0 0 0-16",
          clipRule: "evenodd"
        })]
      })
    })
  });
};

const Stationery = ({
  className = undefined,
  isFocusable = false,
  filled = undefined,
  title = undefined,
  role = undefined,
  size = 16,
  ...restProps
}) => {
  if (filled) {
    console.warn("<Stationery filled /> is now deprecated, please use <StationeryFill /> or refer to https://transferwise.github.io/icons/ for more info.");
  }
  return /*#__PURE__*/jsx("span", {
    className: `tw-icon tw-icon-stationery ${className ? className : ''}`,
    "data-testid": restProps['data-testid'] || 'stationery-icon',
    children: /*#__PURE__*/jsx("svg", {
      "aria-label": title,
      "aria-hidden": !title ? true : undefined,
      focusable: isFocusable,
      role: role ?? (title ? 'graphics-symbol img' : 'none'),
      width: String(size),
      height: String(size),
      fill: "currentColor",
      viewBox: "0 0 24 24",
      children: (Number(size) === 16 || Number(size) === 24 || Number(size) === 32) && /*#__PURE__*/jsx(Fragment, {
        children: /*#__PURE__*/jsx("path", {
          fillRule: "evenodd",
          d: "M10.166 8 12 4.944 13.834 8zM10 10v6h4v-6zm4 8h-4v2h4zM12.866 2.5a1.01 1.01 0 0 0-1.732 0L8.285 7.248A2 2 0 0 0 8 8.278V20a2 2 0 0 0 2 2h4a2 2 0 0 0 2-2V8.277a2 2 0 0 0-.285-1.029z",
          clipRule: "evenodd"
        })
      })
    })
  });
};

const OfficeExpenses = ({
  className = undefined,
  isFocusable = false,
  filled = undefined,
  title = undefined,
  role = undefined,
  size = 16,
  ...restProps
}) => {
  if (filled) {
    console.warn("<OfficeExpenses filled /> is now deprecated, please use <OfficeExpensesFill /> or refer to https://transferwise.github.io/icons/ for more info.");
  }
  return /*#__PURE__*/jsx("span", {
    className: `tw-icon tw-icon-office-expenses ${className ? className : ''}`,
    "data-testid": restProps['data-testid'] || 'office-expenses-icon',
    children: /*#__PURE__*/jsx("svg", {
      "aria-label": title,
      "aria-hidden": !title ? true : undefined,
      focusable: isFocusable,
      role: role ?? (title ? 'graphics-symbol img' : 'none'),
      width: String(size),
      height: String(size),
      fill: "currentColor",
      viewBox: "0 0 24 24",
      children: (Number(size) === 16 || Number(size) === 24 || Number(size) === 32) && /*#__PURE__*/jsx(Fragment, {
        children: /*#__PURE__*/jsx("path", {
          fillRule: "evenodd",
          d: "M10.166 8 12 4.944 13.834 8zM10 10v6h4v-6zm4 8h-4v2h4zM12.866 2.5a1.01 1.01 0 0 0-1.732 0L8.285 7.248A2 2 0 0 0 8 8.278V20a2 2 0 0 0 2 2h4a2 2 0 0 0 2-2V8.277a2 2 0 0 0-.285-1.029z",
          clipRule: "evenodd"
        })
      })
    })
  });
};

const Stop = ({
  className = undefined,
  isFocusable = false,
  filled = undefined,
  title = undefined,
  role = undefined,
  size = 16,
  ...restProps
}) => {
  if (filled) {
    console.warn("<Stop filled /> is now deprecated, please use <StopFill /> or refer to https://transferwise.github.io/icons/ for more info.");
  }
  return /*#__PURE__*/jsx("span", {
    className: `tw-icon tw-icon-stop ${className ? className : ''}`,
    "data-testid": restProps['data-testid'] || 'stop-icon',
    children: /*#__PURE__*/jsx("svg", {
      "aria-label": title,
      "aria-hidden": !title ? true : undefined,
      focusable: isFocusable,
      role: role ?? (title ? 'graphics-symbol img' : 'none'),
      width: String(size),
      height: String(size),
      fill: "currentColor",
      viewBox: "0 0 24 24",
      children: (Number(size) === 16 || Number(size) === 24 || Number(size) === 32) && /*#__PURE__*/jsx(Fragment, {
        children: /*#__PURE__*/jsx("path", {
          fillRule: "evenodd",
          d: "M4 12a8 8 0 1 1 16 0 8 8 0 0 1-16 0m8-10C6.477 2 2 6.477 2 12s4.477 10 10 10 10-4.477 10-10S17.523 2 12 2M9.01 8A1.01 1.01 0 0 0 8 9.01v5.98c0 .558.452 1.01 1.01 1.01h5.98A1.01 1.01 0 0 0 16 14.99V9.01A1.01 1.01 0 0 0 14.99 8zm.99 6v-4h4v4z",
          clipRule: "evenodd"
        })
      })
    })
  });
};

const Suitcase = ({
  className = undefined,
  isFocusable = false,
  filled = undefined,
  title = undefined,
  role = undefined,
  size = 16,
  ...restProps
}) => {
  if (filled) {
    console.warn("<Suitcase filled /> is now deprecated, please use <SuitcaseFill /> or refer to https://transferwise.github.io/icons/ for more info.");
  }
  return /*#__PURE__*/jsx("span", {
    className: `tw-icon tw-icon-suitcase ${className ? className : ''}`,
    "data-testid": restProps['data-testid'] || 'suitcase-icon',
    children: /*#__PURE__*/jsx("svg", {
      "aria-label": title,
      "aria-hidden": !title ? true : undefined,
      focusable: isFocusable,
      role: role ?? (title ? 'graphics-symbol img' : 'none'),
      width: String(size),
      height: String(size),
      fill: "currentColor",
      viewBox: "0 0 24 24",
      children: (Number(size) === 16 || Number(size) === 24 || Number(size) === 32) && /*#__PURE__*/jsx(Fragment, {
        children: /*#__PURE__*/jsx("path", {
          fillRule: "evenodd",
          d: "M8 3.01C8 2.452 8.452 2 9.01 2h5.98c.558 0 1.01.452 1.01 1.01V6h1a2 2 0 0 1 2 2v10a2 2 0 0 1-2 2h-.085q.084.236.085.5a1.5 1.5 0 1 1-2.915-.5h-4.17q.084.236.085.5a1.5 1.5 0 1 1-2.915-.5H7a2 2 0 0 1-2-2V8a2 2 0 0 1 2-2h1zM14 4v2h-4V4zM7 8h10v2H7zm0 4v6h10v-6z",
          clipRule: "evenodd"
        })
      })
    })
  });
};

const Travel = ({
  className = undefined,
  isFocusable = false,
  filled = undefined,
  title = undefined,
  role = undefined,
  size = 16,
  ...restProps
}) => {
  if (filled) {
    console.warn("<Travel filled /> is now deprecated, please use <TravelFill /> or refer to https://transferwise.github.io/icons/ for more info.");
  }
  return /*#__PURE__*/jsx("span", {
    className: `tw-icon tw-icon-travel ${className ? className : ''}`,
    "data-testid": restProps['data-testid'] || 'travel-icon',
    children: /*#__PURE__*/jsx("svg", {
      "aria-label": title,
      "aria-hidden": !title ? true : undefined,
      focusable: isFocusable,
      role: role ?? (title ? 'graphics-symbol img' : 'none'),
      width: String(size),
      height: String(size),
      fill: "currentColor",
      viewBox: "0 0 24 24",
      children: (Number(size) === 16 || Number(size) === 24 || Number(size) === 32) && /*#__PURE__*/jsx(Fragment, {
        children: /*#__PURE__*/jsx("path", {
          fillRule: "evenodd",
          d: "M8 3.01C8 2.452 8.452 2 9.01 2h5.98c.558 0 1.01.452 1.01 1.01V6h1a2 2 0 0 1 2 2v10a2 2 0 0 1-2 2h-.085q.084.236.085.5a1.5 1.5 0 1 1-2.915-.5h-4.17q.084.236.085.5a1.5 1.5 0 1 1-2.915-.5H7a2 2 0 0 1-2-2V8a2 2 0 0 1 2-2h1zM14 4v2h-4V4zM7 8h10v2H7zm0 4v6h10v-6z",
          clipRule: "evenodd"
        })
      })
    })
  });
};

const Sun = ({
  className = undefined,
  isFocusable = false,
  filled = undefined,
  title = undefined,
  role = undefined,
  size = 16,
  ...restProps
}) => {
  if (filled) {
    console.warn("<Sun filled /> is now deprecated, please use <SunFill /> or refer to https://transferwise.github.io/icons/ for more info.");
  }
  return /*#__PURE__*/jsx("span", {
    className: `tw-icon tw-icon-sun ${className ? className : ''}`,
    "data-testid": restProps['data-testid'] || 'sun-icon',
    children: /*#__PURE__*/jsx("svg", {
      "aria-label": title,
      "aria-hidden": !title ? true : undefined,
      focusable: isFocusable,
      role: role ?? (title ? 'graphics-symbol img' : 'none'),
      width: String(size),
      height: String(size),
      fill: "currentColor",
      viewBox: "0 0 24 24",
      children: (Number(size) === 16 || Number(size) === 24 || Number(size) === 32) && /*#__PURE__*/jsxs(Fragment, {
        children: [/*#__PURE__*/jsx("path", {
          d: "M10.996 2.086v2.828h2V2.086zm5.297 4.207 2-2 1.414 1.414-2 2z"
        }), /*#__PURE__*/jsx("path", {
          fillRule: "evenodd",
          d: "M12 17a5 5 0 1 0 0-10 5 5 0 0 0 0 10m0-2a3 3 0 1 0 0-6 3 3 0 0 0 0 6",
          clipRule: "evenodd"
        }), /*#__PURE__*/jsx("path", {
          d: "M10.996 21.996v-2.828h2v2.828zM4.844 11H2.016v2h2.828zm14.312 0h2.829v2h-2.829zm.551 7.293-2-2-1.414 1.414 2 2zm-12-.586-2 2-1.414-1.414 2-2zm-3.414-12 2 2 1.414-1.414-2-2z"
        })]
      })
    })
  });
};

const Sunglasses = ({
  className = undefined,
  isFocusable = false,
  filled = undefined,
  title = undefined,
  role = undefined,
  size = 16,
  ...restProps
}) => {
  if (filled) {
    console.warn("<Sunglasses filled /> is now deprecated, please use <SunglassesFill /> or refer to https://transferwise.github.io/icons/ for more info.");
  }
  return /*#__PURE__*/jsx("span", {
    className: `tw-icon tw-icon-sunglasses ${className ? className : ''}`,
    "data-testid": restProps['data-testid'] || 'sunglasses-icon',
    children: /*#__PURE__*/jsx("svg", {
      "aria-label": title,
      "aria-hidden": !title ? true : undefined,
      focusable: isFocusable,
      role: role ?? (title ? 'graphics-symbol img' : 'none'),
      width: String(size),
      height: String(size),
      fill: "currentColor",
      viewBox: "0 0 24 24",
      children: (Number(size) === 16 || Number(size) === 24 || Number(size) === 32) && /*#__PURE__*/jsx(Fragment, {
        children: /*#__PURE__*/jsx("path", {
          fillRule: "evenodd",
          d: "M12 4a8 8 0 1 0 0 16 8 8 0 0 0 0-16M2 12C2 6.477 6.477 2 12 2s10 4.477 10 10-4.477 10-10 10S2 17.523 2 12m11.553 5.796A6 6 0 0 1 6.803 15l1.733-1a4 4 0 0 0 4.5 1.864zM7 8a1 1 0 0 0-1 1v1a2 2 0 0 0 2 2h2a1 1 0 0 0 .983-.815c.316-.102.683-.185 1.017-.185s.701.083 1.017.185A1 1 0 0 0 14 12h2a2 2 0 0 0 2-2V9a1 1 0 0 0-1-1h-3a1 1 0 0 0-1 1v.112A5 5 0 0 0 12 9c-.352 0-.693.047-1 .112V9a1 1 0 0 0-1-1z",
          clipRule: "evenodd"
        })
      })
    })
  });
};

const SwitchVertical = ({
  className = undefined,
  isFocusable = false,
  filled = undefined,
  title = undefined,
  role = undefined,
  size = 16,
  ...restProps
}) => {
  if (filled) {
    console.warn("<SwitchVertical filled /> is now deprecated, please use <SwitchVerticalFill /> or refer to https://transferwise.github.io/icons/ for more info.");
  }
  return /*#__PURE__*/jsx("span", {
    className: `tw-icon tw-icon-switch-vertical ${className ? className : ''}`,
    "data-testid": restProps['data-testid'] || 'switch-vertical-icon',
    children: /*#__PURE__*/jsx("svg", {
      "aria-label": title,
      "aria-hidden": !title ? true : undefined,
      focusable: isFocusable,
      role: role ?? (title ? 'graphics-symbol img' : 'none'),
      width: String(size),
      height: String(size),
      fill: "currentColor",
      viewBox: "0 0 24 24",
      children: (Number(size) === 16 || Number(size) === 24 || Number(size) === 32) && /*#__PURE__*/jsx(Fragment, {
        children: /*#__PURE__*/jsx("path", {
          fillRule: "evenodd",
          d: "M13.707 15.293 16 17.586V3h2v14.586l2.293-2.293 1.414 1.414-3.993 3.993a1.01 1.01 0 0 1-1.428 0l-3.993-3.993zM8 6.414V21H6V6.414L3.707 8.707 2.293 7.293 6.286 3.3a1.01 1.01 0 0 1 1.428 0l3.993 3.993-1.414 1.414z",
          clipRule: "evenodd"
        })
      })
    })
  });
};

const Switch = ({
  className = undefined,
  isFocusable = false,
  filled = undefined,
  title = undefined,
  role = undefined,
  size = 16,
  ...restProps
}) => {
  if (filled) {
    console.warn("<Switch filled /> is now deprecated, please use <SwitchFill /> or refer to https://transferwise.github.io/icons/ for more info.");
  }
  return /*#__PURE__*/jsx("span", {
    className: `tw-icon tw-icon-switch ${className ? className : ''}`,
    "data-testid": restProps['data-testid'] || 'switch-icon',
    children: /*#__PURE__*/jsx("svg", {
      "aria-label": title,
      "aria-hidden": !title ? true : undefined,
      focusable: isFocusable,
      role: role ?? (title ? 'graphics-symbol img' : 'none'),
      width: String(size),
      height: String(size),
      fill: "currentColor",
      viewBox: "0 0 24 24",
      children: (Number(size) === 16 || Number(size) === 24 || Number(size) === 32) && /*#__PURE__*/jsx(Fragment, {
        children: /*#__PURE__*/jsx("path", {
          fillRule: "evenodd",
          d: "m17.586 8-2.293 2.293 1.414 1.414L20.7 7.714a1.01 1.01 0 0 0 0-1.428l-3.993-3.993-1.414 1.414L17.586 6H3v2zm-8.879 5.707L6.414 16H21v2H6.414l2.293 2.293-1.414 1.414L3.3 17.714a1.01 1.01 0 0 1 0-1.428l3.993-3.993z",
          clipRule: "evenodd"
        })
      })
    })
  });
};

const Tags = ({
  className = undefined,
  isFocusable = false,
  filled = undefined,
  title = undefined,
  role = undefined,
  size = 16,
  ...restProps
}) => {
  if (filled) {
    console.warn("<Tags filled /> is now deprecated, please use <TagsFill /> or refer to https://transferwise.github.io/icons/ for more info.");
  }
  return /*#__PURE__*/jsx("span", {
    className: `tw-icon tw-icon-tags ${className ? className : ''}`,
    "data-testid": restProps['data-testid'] || 'tags-icon',
    children: /*#__PURE__*/jsx("svg", {
      "aria-label": title,
      "aria-hidden": !title ? true : undefined,
      focusable: isFocusable,
      role: role ?? (title ? 'graphics-symbol img' : 'none'),
      width: String(size),
      height: String(size),
      fill: "currentColor",
      viewBox: "0 0 24 24",
      children: (Number(size) === 16 || Number(size) === 24 || Number(size) === 32) && /*#__PURE__*/jsxs(Fragment, {
        children: [/*#__PURE__*/jsx("path", {
          d: "M9.749 8.894a1.5 1.5 0 1 1-.033-3 1.5 1.5 0 0 1 .033 3"
        }), /*#__PURE__*/jsx("path", {
          fillRule: "evenodd",
          d: "M4.27 5.328a2 2 0 0 1 .466-1.318l.718-.86a2 2 0 0 1 1.216-.69l4.056-.656a2 2 0 0 1 1.602.44l6.947 5.809a2 2 0 0 1 .251 2.817l-4.701 5.623a2 2 0 0 1-2.818.251L5.06 10.936a2 2 0 0 1-.716-1.5zm2.719-.894-.719.859.073 4.108 6.947 5.81 4.702-5.624-6.947-5.809z",
          clipRule: "evenodd"
        }), /*#__PURE__*/jsx("path", {
          d: "m10.992 21.134-7.326-6.103 1.28-1.537 7.326 6.104a2 2 0 0 0 2.819-.258l5.257-6.323 1.538 1.279-5.258 6.323a4 4 0 0 1-5.636.515"
        })]
      })
    })
  });
};

const Takeaway = ({
  className = undefined,
  isFocusable = false,
  filled = undefined,
  title = undefined,
  role = undefined,
  size = 16,
  ...restProps
}) => {
  if (filled) {
    console.warn("<Takeaway filled /> is now deprecated, please use <TakeawayFill /> or refer to https://transferwise.github.io/icons/ for more info.");
  }
  return /*#__PURE__*/jsx("span", {
    className: `tw-icon tw-icon-takeaway ${className ? className : ''}`,
    "data-testid": restProps['data-testid'] || 'takeaway-icon',
    children: /*#__PURE__*/jsx("svg", {
      "aria-label": title,
      "aria-hidden": !title ? true : undefined,
      focusable: isFocusable,
      role: role ?? (title ? 'graphics-symbol img' : 'none'),
      width: String(size),
      height: String(size),
      fill: "currentColor",
      viewBox: "0 0 24 24",
      children: (Number(size) === 16 || Number(size) === 24 || Number(size) === 32) && /*#__PURE__*/jsx(Fragment, {
        children: /*#__PURE__*/jsx("path", {
          fillRule: "evenodd",
          d: "m7.72 4-.333 1h9.226l-.334-1zm11 1-.77-2.31a1.01 1.01 0 0 0-.957-.69H7.007c-.435 0-.82.278-.958.69L5.279 5H5a1 1 0 0 0-1 1v5a1 1 0 0 0 1 1h.157l1.57 9.16c.083.486.504.84.996.84h8.554c.492 0 .913-.355.996-.84l1.57-9.16H19a1 1 0 0 0 1-1V6a1 1 0 0 0-1-1zM6 7v3h12V7zm10.814 5H7.186l1.371 8h6.886z",
          clipRule: "evenodd"
        })
      })
    })
  });
};

const Target = ({
  className = undefined,
  isFocusable = false,
  filled = undefined,
  title = undefined,
  role = undefined,
  size = 16,
  ...restProps
}) => {
  if (filled) {
    console.warn("<Target filled /> is now deprecated, please use <TargetFill /> or refer to https://transferwise.github.io/icons/ for more info.");
  }
  return /*#__PURE__*/jsx("span", {
    className: `tw-icon tw-icon-target ${className ? className : ''}`,
    "data-testid": restProps['data-testid'] || 'target-icon',
    children: /*#__PURE__*/jsx("svg", {
      "aria-label": title,
      "aria-hidden": !title ? true : undefined,
      focusable: isFocusable,
      role: role ?? (title ? 'graphics-symbol img' : 'none'),
      width: String(size),
      height: String(size),
      fill: "currentColor",
      viewBox: "0 0 24 24",
      children: (Number(size) === 16 || Number(size) === 24 || Number(size) === 32) && /*#__PURE__*/jsx(Fragment, {
        children: /*#__PURE__*/jsx("path", {
          fillRule: "evenodd",
          d: "M5 12a7 7 0 0 1 9.764-6.433l-.77 1.847a5 5 0 1 0 2.592 2.592l1.847-.77A7 7 0 1 1 5 12m15.28-3.533a9 9 0 1 1-4.747-4.747l.041-.098A1.01 1.01 0 0 1 16.507 3h3.483c.558 0 1.01.452 1.01 1.01v3.483c0 .408-.245.776-.622.933zm-7.055.794-.072.172-1.86 1.86 1.414 1.414 1.86-1.86.172-.072a3 3 0 1 1-1.515-1.515m2.632-1.118L17.167 5H19v1.833z",
          clipRule: "evenodd"
        })
      })
    })
  });
};

const Marketing = ({
  className = undefined,
  isFocusable = false,
  filled = undefined,
  title = undefined,
  role = undefined,
  size = 16,
  ...restProps
}) => {
  if (filled) {
    console.warn("<Marketing filled /> is now deprecated, please use <MarketingFill /> or refer to https://transferwise.github.io/icons/ for more info.");
  }
  return /*#__PURE__*/jsx("span", {
    className: `tw-icon tw-icon-marketing ${className ? className : ''}`,
    "data-testid": restProps['data-testid'] || 'marketing-icon',
    children: /*#__PURE__*/jsx("svg", {
      "aria-label": title,
      "aria-hidden": !title ? true : undefined,
      focusable: isFocusable,
      role: role ?? (title ? 'graphics-symbol img' : 'none'),
      width: String(size),
      height: String(size),
      fill: "currentColor",
      viewBox: "0 0 24 24",
      children: (Number(size) === 16 || Number(size) === 24 || Number(size) === 32) && /*#__PURE__*/jsx(Fragment, {
        children: /*#__PURE__*/jsx("path", {
          fillRule: "evenodd",
          d: "M5 12a7 7 0 0 1 9.764-6.433l-.77 1.847a5 5 0 1 0 2.592 2.592l1.847-.77A7 7 0 1 1 5 12m15.28-3.533a9 9 0 1 1-4.747-4.747l.041-.098A1.01 1.01 0 0 1 16.507 3h3.483c.558 0 1.01.452 1.01 1.01v3.483c0 .408-.245.776-.622.933zm-7.055.794-.072.172-1.86 1.86 1.414 1.414 1.86-1.86.172-.072a3 3 0 1 1-1.515-1.515m2.632-1.118L17.167 5H19v1.833z",
          clipRule: "evenodd"
        })
      })
    })
  });
};

const Taxi = ({
  className = undefined,
  isFocusable = false,
  filled = undefined,
  title = undefined,
  role = undefined,
  size = 16,
  ...restProps
}) => {
  if (filled) {
    console.warn("<Taxi filled /> is now deprecated, please use <TaxiFill /> or refer to https://transferwise.github.io/icons/ for more info.");
  }
  return /*#__PURE__*/jsx("span", {
    className: `tw-icon tw-icon-taxi ${className ? className : ''}`,
    "data-testid": restProps['data-testid'] || 'taxi-icon',
    children: /*#__PURE__*/jsx("svg", {
      "aria-label": title,
      "aria-hidden": !title ? true : undefined,
      focusable: isFocusable,
      role: role ?? (title ? 'graphics-symbol img' : 'none'),
      width: String(size),
      height: String(size),
      fill: "currentColor",
      viewBox: "0 0 24 24",
      children: (Number(size) === 16 || Number(size) === 24 || Number(size) === 32) && /*#__PURE__*/jsx(Fragment, {
        children: /*#__PURE__*/jsx("path", {
          fillRule: "evenodd",
          d: "M14 2h-4v2H8.28a2 2 0 0 0-1.94 1.515L5.72 8H3v2h2.28v.025a1 1 0 0 0-.583.379l-1.495 1.993a1 1 0 0 0-.202.606v2.995c0 .156.037.311.107.451L4 18.236V20a2 2 0 0 0 2 2h1a2 2 0 0 0 2-2v-1h6v1a2 2 0 0 0 2 2h1a2 2 0 0 0 2-2v-1.764l.893-1.787c.07-.14.107-.295.107-.451v-2.995c0-.218-.07-.43-.202-.606l-1.495-1.993a1 1 0 0 0-.583-.379V10H21V8h-2.72l-.62-2.485A2 2 0 0 0 15.72 4H14zm4 17h-1v1h1zm.382-2L19 15.764v-2.43L18 12H6l-1 1.333v2.43L5.618 17zM6 20v-1h1v1zM8.28 6h7.44l1 4H7.28zm.725 8.002a1.002 1.002 0 1 1-2.005 0 1.002 1.002 0 0 1 2.005 0m8 0a1.002 1.002 0 1 1-2.005 0 1.002 1.002 0 0 1 2.005 0",
          clipRule: "evenodd"
        })
      })
    })
  });
};

const Team = ({
  className = undefined,
  isFocusable = false,
  filled = undefined,
  title = undefined,
  role = undefined,
  size = 16,
  ...restProps
}) => {
  if (filled) {
    console.warn("<Team filled /> is now deprecated, please use <TeamFill /> or refer to https://transferwise.github.io/icons/ for more info.");
  }
  return /*#__PURE__*/jsx("span", {
    className: `tw-icon tw-icon-team ${className ? className : ''}`,
    "data-testid": restProps['data-testid'] || 'team-icon',
    children: /*#__PURE__*/jsx("svg", {
      "aria-label": title,
      "aria-hidden": !title ? true : undefined,
      focusable: isFocusable,
      role: role ?? (title ? 'graphics-symbol img' : 'none'),
      width: String(size),
      height: String(size),
      fill: "currentColor",
      viewBox: "0 0 24 24",
      children: (Number(size) === 16 || Number(size) === 24 || Number(size) === 32) && /*#__PURE__*/jsx(Fragment, {
        children: /*#__PURE__*/jsx("path", {
          fillRule: "evenodd",
          d: "M17 4a2 2 0 1 0 0 4 2 2 0 0 0 0-4m-4 2a4 4 0 1 1 6.8 2.857A5 5 0 0 1 22 13v1h-2v-1a3 3 0 0 0-5.288-1.94A4 4 0 0 1 16 14a4 4 0 0 1-1.2 2.857A5 5 0 0 1 17 21v1h-2v-1a3 3 0 0 0-6 0v1H7v-1a5 5 0 0 1 2.2-4.143A4 4 0 0 1 8 14a4 4 0 0 1 1.288-2.94A3 3 0 0 0 4 13v1H2v-1a5 5 0 0 1 2.2-4.143 4 4 0 1 1 5.599 0 5 5 0 0 1 1.279 1.25 4 4 0 0 1 1.844 0 5 5 0 0 1 1.279-1.25A4 4 0 0 1 13 6m-3 8a2 2 0 1 1 4 0 2 2 0 0 1-4 0M5 6a2 2 0 1 1 4 0 2 2 0 0 1-4 0",
          clipRule: "evenodd"
        })
      })
    })
  });
};

const Theme = ({
  className = undefined,
  isFocusable = false,
  filled = undefined,
  title = undefined,
  role = undefined,
  size = 16,
  ...restProps
}) => {
  if (filled) {
    console.warn("<Theme filled /> is now deprecated, please use <ThemeFill /> or refer to https://transferwise.github.io/icons/ for more info.");
  }
  return /*#__PURE__*/jsx("span", {
    className: `tw-icon tw-icon-theme ${className ? className : ''}`,
    "data-testid": restProps['data-testid'] || 'theme-icon',
    children: /*#__PURE__*/jsx("svg", {
      "aria-label": title,
      "aria-hidden": !title ? true : undefined,
      focusable: isFocusable,
      role: role ?? (title ? 'graphics-symbol img' : 'none'),
      width: String(size),
      height: String(size),
      fill: "currentColor",
      viewBox: "0 0 24 24",
      children: (Number(size) === 16 || Number(size) === 24 || Number(size) === 32) && /*#__PURE__*/jsx(Fragment, {
        children: /*#__PURE__*/jsx("path", {
          fillRule: "evenodd",
          d: "M12 2C6.477 2 2 6.477 2 12s4.477 10 10 10 10-4.477 10-10S17.523 2 12 2M4 12a8 8 0 0 1 8-8v16a8 8 0 0 1-8-8",
          clipRule: "evenodd"
        })
      })
    })
  });
};

const Transfer = ({
  className = undefined,
  isFocusable = false,
  filled = undefined,
  title = undefined,
  role = undefined,
  size = 16,
  ...restProps
}) => {
  if (filled) {
    console.warn("<Transfer filled /> is now deprecated, please use <TransferFill /> or refer to https://transferwise.github.io/icons/ for more info.");
  }
  return /*#__PURE__*/jsx("span", {
    className: `tw-icon tw-icon-transfer ${className ? className : ''}`,
    "data-testid": restProps['data-testid'] || 'transfer-icon',
    children: /*#__PURE__*/jsx("svg", {
      "aria-label": title,
      "aria-hidden": !title ? true : undefined,
      focusable: isFocusable,
      role: role ?? (title ? 'graphics-symbol img' : 'none'),
      width: String(size),
      height: String(size),
      fill: "currentColor",
      viewBox: "0 0 24 24",
      children: (Number(size) === 16 || Number(size) === 24 || Number(size) === 32) && /*#__PURE__*/jsx(Fragment, {
        children: /*#__PURE__*/jsx("path", {
          fillRule: "evenodd",
          d: "M8 4h3.586l-8.293 8.293 1.414 1.414L13 5.414V9h2V3.01A1.01 1.01 0 0 0 13.99 2H8zm8.586 9H13v-2h5.99c.558 0 1.01.452 1.01 1.01V18h-2v-3.586l-8.293 8.293-1.414-1.414z",
          clipRule: "evenodd"
        })
      })
    })
  });
};

const Transport = ({
  className = undefined,
  isFocusable = false,
  filled = undefined,
  title = undefined,
  role = undefined,
  size = 16,
  ...restProps
}) => {
  if (filled) {
    console.warn("<Transport filled /> is now deprecated, please use <TransportFill /> or refer to https://transferwise.github.io/icons/ for more info.");
  }
  return /*#__PURE__*/jsx("span", {
    className: `tw-icon tw-icon-transport ${className ? className : ''}`,
    "data-testid": restProps['data-testid'] || 'transport-icon',
    children: /*#__PURE__*/jsx("svg", {
      "aria-label": title,
      "aria-hidden": !title ? true : undefined,
      focusable: isFocusable,
      role: role ?? (title ? 'graphics-symbol img' : 'none'),
      width: String(size),
      height: String(size),
      fill: "currentColor",
      viewBox: "0 0 24 24",
      children: (Number(size) === 16 || Number(size) === 24 || Number(size) === 32) && /*#__PURE__*/jsx(Fragment, {
        children: /*#__PURE__*/jsx("path", {
          fillRule: "evenodd",
          d: "M6 4h12v7H6zm0 9v4h12v-4zm-1 6a1 1 0 0 1-1-1V4a2 2 0 0 1 2-2h12a2 2 0 0 1 2 2v14a1 1 0 0 1-1 1v1a2 2 0 0 1-2 2h-1a2 2 0 0 1-2-2v-1h-4v1a2 2 0 0 1-2 2H7a2 2 0 0 1-2-2zm2 0v1h1v-1zm9 0v1h1v-1zm-7.998-2.995a1.002 1.002 0 1 0 0-2.005 1.002 1.002 0 0 0 0 2.005m9.003-1.003a1.002 1.002 0 1 1-2.005 0 1.002 1.002 0 0 1 2.005 0",
          clipRule: "evenodd"
        })
      })
    })
  });
};

const Trustly = ({
  className = undefined,
  isFocusable = false,
  filled = undefined,
  title = undefined,
  role = undefined,
  size = 16,
  ...restProps
}) => {
  if (filled) {
    console.warn("<Trustly filled /> is now deprecated, please use <TrustlyFill /> or refer to https://transferwise.github.io/icons/ for more info.");
  }
  return /*#__PURE__*/jsx("span", {
    className: `tw-icon tw-icon-trustly ${className ? className : ''}`,
    "data-testid": restProps['data-testid'] || 'trustly-icon',
    children: /*#__PURE__*/jsx("svg", {
      "aria-label": title,
      "aria-hidden": !title ? true : undefined,
      focusable: isFocusable,
      role: role ?? (title ? 'graphics-symbol img' : 'none'),
      width: String(size),
      height: String(size),
      fill: "currentColor",
      viewBox: "0 0 24 24",
      children: (Number(size) === 16 || Number(size) === 24 || Number(size) === 32) && /*#__PURE__*/jsx(Fragment, {
        children: /*#__PURE__*/jsx("path", {
          d: "M1.714 11.057h7.2V5.314l5.743 5.743-5.743 5.742v2.915H15.9v-8.657h6.386V4.285H1.714z"
        })
      })
    })
  });
};

const Twitter = ({
  className = undefined,
  isFocusable = false,
  filled = undefined,
  title = undefined,
  role = undefined,
  size = 16,
  ...restProps
}) => {
  if (filled) {
    console.warn("<Twitter filled /> is now deprecated, please use <TwitterFill /> or refer to https://transferwise.github.io/icons/ for more info.");
  }
  return /*#__PURE__*/jsx("span", {
    className: `tw-icon tw-icon-twitter ${className ? className : ''}`,
    "data-testid": restProps['data-testid'] || 'twitter-icon',
    children: /*#__PURE__*/jsx("svg", {
      "aria-label": title,
      "aria-hidden": !title ? true : undefined,
      focusable: isFocusable,
      role: role ?? (title ? 'graphics-symbol img' : 'none'),
      width: String(size),
      height: String(size),
      fill: "currentColor",
      viewBox: "0 0 24 24",
      children: (Number(size) === 16 || Number(size) === 24 || Number(size) === 32) && /*#__PURE__*/jsx(Fragment, {
        children: /*#__PURE__*/jsx("path", {
          d: "m14.123 10.425 7.493-8.71H19.84l-6.506 7.563-5.197-7.564H2.143l7.859 11.437-7.859 9.135H3.92l6.871-7.987 5.488 7.987h5.994zM4.559 3.05h2.727l12.555 17.96h-2.727z"
        })
      })
    })
  });
};

const Upi = ({
  className = undefined,
  isFocusable = false,
  filled = undefined,
  title = undefined,
  role = undefined,
  size = 16,
  ...restProps
}) => {
  if (filled) {
    console.warn("<Upi filled /> is now deprecated, please use <UpiFill /> or refer to https://transferwise.github.io/icons/ for more info.");
  }
  return /*#__PURE__*/jsx("span", {
    className: `tw-icon tw-icon-upi ${className ? className : ''}`,
    "data-testid": restProps['data-testid'] || 'upi-icon',
    children: /*#__PURE__*/jsx("svg", {
      "aria-label": title,
      "aria-hidden": !title ? true : undefined,
      focusable: isFocusable,
      role: role ?? (title ? 'graphics-symbol img' : 'none'),
      width: String(size),
      height: String(size),
      fill: "currentColor",
      viewBox: "0 0 24 24",
      children: (Number(size) === 16 || Number(size) === 24 || Number(size) === 32) && /*#__PURE__*/jsx(Fragment, {
        children: /*#__PURE__*/jsx("path", {
          d: "M19.431 11.815 14.96 1.977a.446.446 0 0 0-.838.068L12.946 6.39l-2.002-4.413a.446.446 0 0 0-.839.067L4.73 21.72a.447.447 0 0 0 .748.435l4.395-4.395-1.071 3.962a.448.448 0 0 0 .749.432l9.791-9.838a.45.45 0 0 0 .09-.501m-8.79-8.34 3.823 8.428-8.427 8.428zm-.537 16.854 1.038-3.839 4.174-4.174a.45.45 0 0 0 .091-.5l-1.894-4.177.02.006 1.127-4.166 3.83 8.425z"
        })
      })
    })
  });
};

const Upload = ({
  className = undefined,
  isFocusable = false,
  filled = undefined,
  title = undefined,
  role = undefined,
  size = 16,
  ...restProps
}) => {
  if (filled) {
    console.warn("<Upload filled /> is now deprecated, please use <UploadFill /> or refer to https://transferwise.github.io/icons/ for more info.");
  }
  return /*#__PURE__*/jsx("span", {
    className: `tw-icon tw-icon-upload ${className ? className : ''}`,
    "data-testid": restProps['data-testid'] || 'upload-icon',
    children: /*#__PURE__*/jsx("svg", {
      "aria-label": title,
      "aria-hidden": !title ? true : undefined,
      focusable: isFocusable,
      role: role ?? (title ? 'graphics-symbol img' : 'none'),
      width: String(size),
      height: String(size),
      fill: "currentColor",
      viewBox: "0 0 24 24",
      children: (Number(size) === 16 || Number(size) === 24 || Number(size) === 32) && /*#__PURE__*/jsx(Fragment, {
        children: /*#__PURE__*/jsx("path", {
          fillRule: "evenodd",
          d: "M20 2H4v2h16zm-2.707 11.707L13 9.414V22h-2V9.414l-4.293 4.293-1.414-1.414L11.286 6.3a1.01 1.01 0 0 1 1.428 0l5.993 5.993z",
          clipRule: "evenodd"
        })
      })
    })
  });
};

const UpwardGraph = ({
  className = undefined,
  isFocusable = false,
  filled = undefined,
  title = undefined,
  role = undefined,
  size = 16,
  ...restProps
}) => {
  if (filled) {
    console.warn("<UpwardGraph filled /> is now deprecated, please use <UpwardGraphFill /> or refer to https://transferwise.github.io/icons/ for more info.");
  }
  return /*#__PURE__*/jsx("span", {
    className: `tw-icon tw-icon-upward-graph ${className ? className : ''}`,
    "data-testid": restProps['data-testid'] || 'upward-graph-icon',
    children: /*#__PURE__*/jsx("svg", {
      "aria-label": title,
      "aria-hidden": !title ? true : undefined,
      focusable: isFocusable,
      role: role ?? (title ? 'graphics-symbol img' : 'none'),
      width: String(size),
      height: String(size),
      fill: "currentColor",
      viewBox: "0 0 24 24",
      children: (Number(size) === 16 || Number(size) === 24 || Number(size) === 32) && /*#__PURE__*/jsx(Fragment, {
        children: /*#__PURE__*/jsx("path", {
          fillRule: "evenodd",
          d: "M17.692 9H14V7h5.99c.558 0 1.01.452 1.01 1.01V14h-2v-3.471l-5.763 6.147a1.01 1.01 0 0 1-1.451.024l-2.79-2.789-4.84 4.8-1.408-1.421 5.54-5.493a1.01 1.01 0 0 1 1.426.003l2.763 2.763z",
          clipRule: "evenodd"
        })
      })
    })
  });
};

const ExchangeRate = ({
  className = undefined,
  isFocusable = false,
  filled = undefined,
  title = undefined,
  role = undefined,
  size = 16,
  ...restProps
}) => {
  if (filled) {
    console.warn("<ExchangeRate filled /> is now deprecated, please use <ExchangeRateFill /> or refer to https://transferwise.github.io/icons/ for more info.");
  }
  return /*#__PURE__*/jsx("span", {
    className: `tw-icon tw-icon-exchange-rate ${className ? className : ''}`,
    "data-testid": restProps['data-testid'] || 'exchange-rate-icon',
    children: /*#__PURE__*/jsx("svg", {
      "aria-label": title,
      "aria-hidden": !title ? true : undefined,
      focusable: isFocusable,
      role: role ?? (title ? 'graphics-symbol img' : 'none'),
      width: String(size),
      height: String(size),
      fill: "currentColor",
      viewBox: "0 0 24 24",
      children: (Number(size) === 16 || Number(size) === 24 || Number(size) === 32) && /*#__PURE__*/jsx(Fragment, {
        children: /*#__PURE__*/jsx("path", {
          fillRule: "evenodd",
          d: "M17.692 9H14V7h5.99c.558 0 1.01.452 1.01 1.01V14h-2v-3.471l-5.763 6.147a1.01 1.01 0 0 1-1.451.024l-2.79-2.789-4.84 4.8-1.408-1.421 5.54-5.493a1.01 1.01 0 0 1 1.426.003l2.763 2.763z",
          clipRule: "evenodd"
        })
      })
    })
  });
};

const Venmo = ({
  className = undefined,
  isFocusable = false,
  filled = undefined,
  title = undefined,
  role = undefined,
  size = 16,
  ...restProps
}) => {
  if (filled) {
    console.warn("<Venmo filled /> is now deprecated, please use <VenmoFill /> or refer to https://transferwise.github.io/icons/ for more info.");
  }
  return /*#__PURE__*/jsx("span", {
    className: `tw-icon tw-icon-venmo ${className ? className : ''}`,
    "data-testid": restProps['data-testid'] || 'venmo-icon',
    children: /*#__PURE__*/jsx("svg", {
      "aria-label": title,
      "aria-hidden": !title ? true : undefined,
      focusable: isFocusable,
      role: role ?? (title ? 'graphics-symbol img' : 'none'),
      width: String(size),
      height: String(size),
      fill: "currentColor",
      viewBox: "0 0 24 24",
      children: (Number(size) === 16 || Number(size) === 24 || Number(size) === 32) && /*#__PURE__*/jsx(Fragment, {
        children: /*#__PURE__*/jsx("path", {
          fillRule: "evenodd",
          d: "M4.146 1.714h15.708a2.43 2.43 0 0 1 2.432 2.432v15.708a2.43 2.43 0 0 1-2.432 2.432H4.146a2.43 2.43 0 0 1-2.432-2.432V4.146a2.43 2.43 0 0 1 2.432-2.432m13.565 6.618c0-.95-.199-1.702-.641-2.432l-3.817.775c.243.509.399 1.126.399 2.034 0 1.656-1.173 4.088-2.122 5.636l-1.02-8.18-4.199.4L8.233 18.06h4.792c2.1-2.763 4.686-6.698 4.686-9.728",
          clipRule: "evenodd"
        })
      })
    })
  });
};

const Wallet = ({
  className = undefined,
  isFocusable = false,
  filled = undefined,
  title = undefined,
  role = undefined,
  size = 16,
  ...restProps
}) => {
  if (filled) {
    console.warn("<Wallet filled /> is now deprecated, please use <WalletFill /> or refer to https://transferwise.github.io/icons/ for more info.");
  }
  return /*#__PURE__*/jsx("span", {
    className: `tw-icon tw-icon-wallet ${className ? className : ''}`,
    "data-testid": restProps['data-testid'] || 'wallet-icon',
    children: /*#__PURE__*/jsx("svg", {
      "aria-label": title,
      "aria-hidden": !title ? true : undefined,
      focusable: isFocusable,
      role: role ?? (title ? 'graphics-symbol img' : 'none'),
      width: String(size),
      height: String(size),
      fill: "currentColor",
      viewBox: "0 0 24 24",
      children: (Number(size) === 16 || Number(size) === 24 || Number(size) === 32) && /*#__PURE__*/jsx(Fragment, {
        children: /*#__PURE__*/jsx("path", {
          fillRule: "evenodd",
          d: "M5 6a1 1 0 0 1 1-1h10v2H5.997A.997.997 0 0 1 5 6m13 1h1.001A2 2 0 0 1 21 9v10a2 2 0 0 1-2 2H6a3 3 0 0 1-3-3V6a3 3 0 0 1 3-3h10a2 2 0 0 1 2 2zM5 18V8.83c.312.11.647.17.997.17H19v10H6a1 1 0 0 1-1-1m12-4a1 1 0 1 0-2 0 1 1 0 0 0 2 0",
          clipRule: "evenodd"
        })
      })
    })
  });
};

const Warning = ({
  className = undefined,
  isFocusable = false,
  filled = undefined,
  title = undefined,
  role = undefined,
  size = 16,
  ...restProps
}) => {
  if (filled) {
    console.warn("<Warning filled /> is now deprecated, please use <WarningFill /> or refer to https://transferwise.github.io/icons/ for more info.");
  }
  return /*#__PURE__*/jsx("span", {
    className: `tw-icon tw-icon-warning ${className ? className : ''}`,
    "data-testid": restProps['data-testid'] || 'warning-icon',
    children: /*#__PURE__*/jsx("svg", {
      "aria-label": title,
      "aria-hidden": !title ? true : undefined,
      focusable: isFocusable,
      role: role ?? (title ? 'graphics-symbol img' : 'none'),
      width: String(size),
      height: String(size),
      fill: "currentColor",
      viewBox: "0 0 24 24",
      children: (Number(size) === 16 || Number(size) === 24 || Number(size) === 32) && /*#__PURE__*/jsx(Fragment, {
        children: /*#__PURE__*/jsx("path", {
          fillRule: "evenodd",
          d: "M11.107 3.549a1.01 1.01 0 0 1 1.786 0l8.983 16.969A1.01 1.01 0 0 1 20.983 22H3.017a1.01 1.01 0 0 1-.893-1.483zM19.34 20 12 6.137 4.662 20zM12 16.006a1.5 1.5 0 1 1 0 3 1.5 1.5 0 0 1 0-3M13 10h-2v5h2z",
          clipRule: "evenodd"
        })
      })
    })
  });
};

const Water = ({
  className = undefined,
  isFocusable = false,
  filled = undefined,
  title = undefined,
  role = undefined,
  size = 16,
  ...restProps
}) => {
  if (filled) {
    console.warn("<Water filled /> is now deprecated, please use <WaterFill /> or refer to https://transferwise.github.io/icons/ for more info.");
  }
  return /*#__PURE__*/jsx("span", {
    className: `tw-icon tw-icon-water ${className ? className : ''}`,
    "data-testid": restProps['data-testid'] || 'water-icon',
    children: /*#__PURE__*/jsx("svg", {
      "aria-label": title,
      "aria-hidden": !title ? true : undefined,
      focusable: isFocusable,
      role: role ?? (title ? 'graphics-symbol img' : 'none'),
      width: String(size),
      height: String(size),
      fill: "currentColor",
      viewBox: "0 0 24 24",
      children: (Number(size) === 16 || Number(size) === 24 || Number(size) === 32) && /*#__PURE__*/jsx(Fragment, {
        children: /*#__PURE__*/jsx("path", {
          fillRule: "evenodd",
          d: "M12.878 2.521a1.005 1.005 0 0 0-1.756 0l-5.273 9.47C3.303 16.565 6.767 22 12 22s8.697-5.436 6.151-10.008zM7.596 12.965 12 5.054l4.404 7.91C18.149 16.098 15.83 20 12 20s-6.149-3.902-4.404-7.036M12 17c-.424 0-.93-.222-1.35-.643s-.643-.93-.643-1.357h-2c0 1.074.524 2.065 1.226 2.768C9.934 18.473 10.924 19 12 19z",
          clipRule: "evenodd"
        })
      })
    })
  });
};

const Whatsapp = ({
  className = undefined,
  isFocusable = false,
  filled = undefined,
  title = undefined,
  role = undefined,
  size = 16,
  ...restProps
}) => {
  if (filled) {
    console.warn("<Whatsapp filled /> is now deprecated, please use <WhatsappFill /> or refer to https://transferwise.github.io/icons/ for more info.");
  }
  return /*#__PURE__*/jsx("span", {
    className: `tw-icon tw-icon-whatsapp ${className ? className : ''}`,
    "data-testid": restProps['data-testid'] || 'whatsapp-icon',
    children: /*#__PURE__*/jsx("svg", {
      "aria-label": title,
      "aria-hidden": !title ? true : undefined,
      focusable: isFocusable,
      role: role ?? (title ? 'graphics-symbol img' : 'none'),
      width: String(size),
      height: String(size),
      fill: "currentColor",
      viewBox: "0 0 24 24",
      children: (Number(size) === 16 || Number(size) === 24 || Number(size) === 32) && /*#__PURE__*/jsx(Fragment, {
        children: /*#__PURE__*/jsx("path", {
          fillRule: "evenodd",
          d: "M19.2 4.715c-1.929-1.929-4.5-3-7.2-3-5.614 0-10.2 4.586-10.2 10.2 0 1.8.471 3.557 1.371 5.1l-1.457 5.271 5.4-1.414A10.2 10.2 0 0 0 12 22.115c5.614 0 10.2-4.586 10.2-10.2 0-2.743-1.072-5.272-3-7.2M12 20.4c-1.543 0-3-.429-4.329-1.2l-.3-.172-3.214.857.857-3.128-.214-.3c-.857-1.329-1.286-2.915-1.286-4.5 0-4.672 3.814-8.486 8.486-8.486 2.271 0 4.371.9 6 2.486a8.46 8.46 0 0 1 2.486 6c0 4.628-3.815 8.443-8.486 8.443m4.628-6.343c-.257-.129-1.5-.729-1.757-.815-.214-.085-.385-.128-.557.129a10 10 0 0 1-.814.986c-.129.171-.3.171-.557.043-.257-.129-1.072-.386-2.057-1.243-.772-.686-1.286-1.5-1.415-1.757-.128-.258 0-.386.129-.515.128-.128.257-.3.386-.428.128-.129.171-.257.257-.429s.043-.3 0-.428c-.043-.129-.557-1.372-.772-1.886s-.428-.429-.557-.429h-.471a.94.94 0 0 0-.686.3c-.214.257-.9.857-.9 2.143 0 1.243.9 2.486 1.029 2.614.128.172 1.8 2.743 4.371 3.858.6.257 1.071.428 1.457.557.6.214 1.157.171 1.586.085.471-.085 1.5-.6 1.714-1.2s.214-1.114.129-1.2c-.086-.214-.257-.257-.515-.385",
          clipRule: "evenodd"
        })
      })
    })
  });
};

const Withdrawal = ({
  className = undefined,
  isFocusable = false,
  filled = undefined,
  title = undefined,
  role = undefined,
  size = 16,
  ...restProps
}) => {
  if (filled) {
    console.warn("<Withdrawal filled /> is now deprecated, please use <WithdrawalFill /> or refer to https://transferwise.github.io/icons/ for more info.");
  }
  return /*#__PURE__*/jsx("span", {
    className: `tw-icon tw-icon-withdrawal ${className ? className : ''}`,
    "data-testid": restProps['data-testid'] || 'withdrawal-icon',
    children: /*#__PURE__*/jsx("svg", {
      "aria-label": title,
      "aria-hidden": !title ? true : undefined,
      focusable: isFocusable,
      role: role ?? (title ? 'graphics-symbol img' : 'none'),
      width: String(size),
      height: String(size),
      fill: "currentColor",
      viewBox: "0 0 24 24",
      children: (Number(size) === 16 || Number(size) === 24 || Number(size) === 32) && /*#__PURE__*/jsx(Fragment, {
        children: /*#__PURE__*/jsx("path", {
          fillRule: "evenodd",
          d: "M11 2v12.586l-4.293-4.293-1.414 1.414 5.993 5.993a1.01 1.01 0 0 0 1.428 0l5.993-5.993-1.414-1.414L13 14.586V2zm9 20H4v-2h16z",
          clipRule: "evenodd"
        })
      })
    })
  });
};

const OwnersWithdrawal = ({
  className = undefined,
  isFocusable = false,
  filled = undefined,
  title = undefined,
  role = undefined,
  size = 16,
  ...restProps
}) => {
  if (filled) {
    console.warn("<OwnersWithdrawal filled /> is now deprecated, please use <OwnersWithdrawalFill /> or refer to https://transferwise.github.io/icons/ for more info.");
  }
  return /*#__PURE__*/jsx("span", {
    className: `tw-icon tw-icon-owners-withdrawal ${className ? className : ''}`,
    "data-testid": restProps['data-testid'] || 'owners-withdrawal-icon',
    children: /*#__PURE__*/jsx("svg", {
      "aria-label": title,
      "aria-hidden": !title ? true : undefined,
      focusable: isFocusable,
      role: role ?? (title ? 'graphics-symbol img' : 'none'),
      width: String(size),
      height: String(size),
      fill: "currentColor",
      viewBox: "0 0 24 24",
      children: (Number(size) === 16 || Number(size) === 24 || Number(size) === 32) && /*#__PURE__*/jsx(Fragment, {
        children: /*#__PURE__*/jsx("path", {
          fillRule: "evenodd",
          d: "M11 2v12.586l-4.293-4.293-1.414 1.414 5.993 5.993a1.01 1.01 0 0 0 1.428 0l5.993-5.993-1.414-1.414L13 14.586V2zm9 20H4v-2h16z",
          clipRule: "evenodd"
        })
      })
    })
  });
};

const X = ({
  className = undefined,
  isFocusable = false,
  filled = undefined,
  title = undefined,
  role = undefined,
  size = 16,
  ...restProps
}) => {
  if (filled) {
    console.warn("<X filled /> is now deprecated, please use <XFill /> or refer to https://transferwise.github.io/icons/ for more info.");
  }
  return /*#__PURE__*/jsx("span", {
    className: `tw-icon tw-icon-x ${className ? className : ''}`,
    "data-testid": restProps['data-testid'] || 'x-icon',
    children: /*#__PURE__*/jsx("svg", {
      "aria-label": title,
      "aria-hidden": !title ? true : undefined,
      focusable: isFocusable,
      role: role ?? (title ? 'graphics-symbol img' : 'none'),
      width: String(size),
      height: String(size),
      fill: "currentColor",
      viewBox: "0 0 24 24",
      children: (Number(size) === 16 || Number(size) === 24 || Number(size) === 32) && /*#__PURE__*/jsx(Fragment, {
        children: /*#__PURE__*/jsx("path", {
          d: "m14.123 10.425 7.493-8.71H19.84l-6.506 7.563-5.197-7.564H2.143l7.859 11.437-7.859 9.135H3.92l6.871-7.988 5.488 7.988h5.994zM4.559 3.05h2.727l12.555 17.96h-2.727z"
        })
      })
    })
  });
};

const Youtube = ({
  className = undefined,
  isFocusable = false,
  filled = undefined,
  title = undefined,
  role = undefined,
  size = 16,
  ...restProps
}) => {
  if (filled) {
    console.warn("<Youtube filled /> is now deprecated, please use <YoutubeFill /> or refer to https://transferwise.github.io/icons/ for more info.");
  }
  return /*#__PURE__*/jsx("span", {
    className: `tw-icon tw-icon-youtube ${className ? className : ''}`,
    "data-testid": restProps['data-testid'] || 'youtube-icon',
    children: /*#__PURE__*/jsx("svg", {
      "aria-label": title,
      "aria-hidden": !title ? true : undefined,
      focusable: isFocusable,
      role: role ?? (title ? 'graphics-symbol img' : 'none'),
      width: String(size),
      height: String(size),
      fill: "currentColor",
      viewBox: "0 0 24 24",
      children: (Number(size) === 16 || Number(size) === 24 || Number(size) === 32) && /*#__PURE__*/jsx(Fragment, {
        children: /*#__PURE__*/jsx("path", {
          fillRule: "evenodd",
          d: "M19.809 18.483c-1.554.414-7.82.414-7.82.414s-6.25 0-7.798-.414a2.57 2.57 0 0 1-1.778-1.745C2 15.207 2 11.986 2 11.986s0-3.2.413-4.717a2.52 2.52 0 0 1 1.778-1.745c1.547-.42 7.799-.42 7.799-.42s6.265 0 7.819.42c.875.228 1.533.89 1.764 1.745C22 8.786 22 11.986 22 11.986s0 3.221-.427 4.752a2.5 2.5 0 0 1-1.764 1.745M9.93 9.069 15.103 12l-5.172 2.931z",
          clipRule: "evenodd"
        })
      })
    })
  });
};

export { Ach, Activity, Alert, AlertCircle, AlertCircleFill, Alipay, AngryEmoji, ArrowDiagonalDown, ArrowDiagonalUp, ArrowDown, ArrowLeft, ArrowRight, ArrowUp, Atm, AutoConvert, Backpack, BackslashCircle, Balance, Bank, BankStrikethrough, BankTransfer, BarChart, Barcode, Batch, Beach, BillSplit, Bills, Bin, Book, Boxes, Briefcase, Building, Bulb, Calendar, CalendarCheck, CalendarSuccess, Camera, CameraSparkle, Car, Card, CardCvc, CardDetail, CardNumber, CardStrikethrough, CardTransferwise, CardWise, CashApp, CashRegister, Charity, Chat, Check, CheckCircle, CheckCircleFill, ChevronDown, ChevronLeft, ChevronRight, ChevronUp, Chip, ChipPin, ClickToPay, Clock, ClockBorderless, ClockFill, Cog, Coins, Collapse, Comments, CompactMore, Confetti, Contactless, ContractServices, Convert, CostOfGoodsSold, Cross, CrossCircle, CrossCircleFill, CrystalBall, Cs, Defrost, Delivery, Dial, DirectDebits, DiscoBall, Do, Document, Documents, Dont, Download, DriversLicense, ECommerce, EatingOut, Edit, Email, EmailAndMobile, EmailAndPhone, Emoji, Entertainment, Equals, ExchangeRate, Expand, Expenses, Eye, EyeShut, FaceId, Facebook, FacebookSquare, Family, FastFlag, Feedback, Female, FidoPasskey, Fingerprint, Fpx, Freeze, Gambling, General, GeneralFill, GiftBox, Globe, GraduationCap, Graph, Groceries, Handshake, HappyEmoji, Headset, Heart, Help, HelpCircle, Holidays, Home, House, Id, Ideal, Image, Info, InfoCircle, InfoCircleFill, InsertCard, Insights, Instagram, Insurance, Interac, Investments, Invite, Jar, Keep, Klarna, Laptop, Leaf, Lightning, LightningBolt, LightningBoltStrikethrough, Limit, Link, Linkedin, List, LocationMarker, Lock, LogIn, LogOut, Mallet, Marketing, MassPayout, Menu, Messenger, Minus, MinusCircle, MinusCircleFill, Mobile, MobileLock, Money, MoneyBag, Moon, More, MultiCurrency, NavigateAway, Nearby, NeutralEmoji, New, Notification, NotificationActive, OfficeExpenses, OwnersWithdrawal, Padlock, PadlockUnlocked, Paperclip, Passport, Pause, PayIn, PayNow, Payid, Payments, Paypal, Pending, PendingCircle, People, PercentageCircle, Person, PersonalCare, Pets, Phone, PhoneStrikethrough, Picture, PieChart, PiggyBank, PinCode, Pix, Plane, Play, Plus, PlusCircle, PlusCircleFill, Profile, QrCode, QuestionMark, QuestionMarkCircle, QuestionMarkCircleFill, Rain, Rainbow, Receipt, Receive, Recipients, Refresh, RefundReceive, RefundSent, Reload, Rent, RequestReceive, RequestSend, Rewards, SadEmoji, Salary, SalesAndRoyalties, Savings, ScanQrCode, ScanSparkle, Search, Send, Settings, ShareAndroid, ShareIos, Shield, ShoppingBag, Slider, Sofort, SoftwareAndHosting, SoftwareAndWebHosting, SpeechBubble, SpeechBubbleExclamation, SpeechBubbleMessage, SpeechBubblePending, SpeechBubbleSparkle, SpeechBubbles, SpendDirham, SpendDollar, SpendEuro, SpendForint, SpendFranc, SpendHryvnia, SpendKoruna, SpendKrone, SpendKuna, SpendLeuLei, SpendLev, SpendLira, SpendPound, SpendReal, SpendRinggit, SpendRupee, SpendRupiah, SpendYen, SpendZloty, SplitMoney, Star, StarFill, StarstruckEmoji, Stationery, Stop, Suitcase, Sun, Sunglasses, Switch, SwitchVertical, Tags, Takeaway, Target, Tax, Taxi, Team, Theme, Transfer, Transport, Travel, Trustly, Twitter, TwoStep, Unlock, Upi, Upload, UpwardGraph, Venmo, Verified, Wallet, Warning, Water, Whatsapp, Withdrawal, X, Youtube };
//# sourceMappingURL=index.esm.js.map
